var colorLib = {
    aliceblue: '#f0f8ff',
    antiquewhite: '#faebd7',
    aqua: '#00ffff',
    aquamarine: '#7fffd4',
    azure: '#f0ffff',
    beige: '#f5f5dc',
    bisque: '#ffe4c4',
    black: '#000000',
    blanchedalmond: '#ffebcd',
    blue: '#0000ff',
    blueviolet: '#8a2be2',
    brown: '#a52a2a',
    burlywood: '#deb887',
    cadetblue: '#5f9ea0',
    chartreuse: '#7fff00',
    chocolate: '#d2691e',
    coral: '#ff7f50',
    chrome: '#D4AF37',
    cornflowerblue: '#6495ed',
    cornsilk: '#fff8dc',
    crimson: '#dc143c',
    cyan: '#00ffff',
    darkblue: '#00008b',
    darkcyan: '#008b8b',
    darkgoldenrod: '#b8860b',
    darkgray: '#a9a9a9',
    darkgreen: '#006400',
    darkkhaki: '#bdb76b',
    darkmagenta: '#8b008b',
    darkolivegreen: '#556b2f',
    darkorange: '#ff8c00',
    darkorchid: '#9932cc',
    darkred: '#8b0000',
    darksalmon: '#e9967a',
    darkseagreen: '#8fbc8f',
    darkslateblue: '#483d8b',
    darkslategray: '#2f4f4f',
    darkturquoise: '#00ced1',
    darkviolet: '#9400d3',
    deeppink: '#ff1493',
    deepskyblue: '#00bfff',
    dimgray: '#696969',
    dodgerblue: '#1e90ff',
    firebrick: '#b22222',
    floralwhite: '#fffaf0',
    forestgreen: '#228b22',
    fuchsia: '#ff00ff',
    gainsboro: '#dcdcdc',
    ghostwhite: '#f8f8ff',
    gold: '#ffd700',
    goldenrod: '#daa520',
    gray: '#808080',
    green: '#008000',
    greenyellow: '#adff2f',
    honeydew: '#f0fff0',
    hotpink: '#ff69b4',
    indianred: '#cd5c5c',
    indigo: '#4b0082',
    ivory: '#fffff0',
    khaki: '#f0e68c',
    lavender: '#e6e6fa',
    lavenderblush: '#fff0f5',
    lawngreen: '#7cfc00',
    lemonchiffon: '#fffacd',
    lightblue: '#add8e6',
    lightcoral: '#f08080',
    lightcyan: '#e0ffff',
    lightgoldenrodyellow: '#fafad2',
    lightgrey: '#d3d3d3',
    lightgreen: '#90ee90',
    lightpink: '#ffb6c1',
    lightsalmon: '#ffa07a',
    lightseagreen: '#20b2aa',
    lightskyblue: '#87cefa',
    lightslategray: '#778899',
    lightsteelblue: '#b0c4de',
    lightyellow: '#ffffe0',
    lime: '#00ff00',
    limegreen: '#32cd32',
    linen: '#faf0e6',
    magenta: '#ff00ff',
    maroon: '#800000',
    mediumaquamarine: '#66cdaa',
    mediumblue: '#0000cd',
    mediumorchid: '#ba55d3',
    mediumpurple: '#9370d8',
    mediumseagreen: '#3cb371',
    mediumslateblue: '#7b68ee',
    mediumspringgreen: '#00fa9a',
    mediumturquoise: '#48d1cc',
    mediumvioletred: '#c71585',
    midnightblue: '#191970',
    mintcream: '#f5fffa',
    mistyrose: '#ffe4e1',
    moccasin: '#ffe4b5',
    navajowhite: '#ffdead',
    navy: '#000080',
    ochra: '#fdf5e6',
    oldlace: '#fdf5e6',
    olive: '#808000',
    olivedrab: '#6b8e23',
    orange: '#ffa500',
    orangered: '#ff4500',
    orchid: '#da70d6',
    palegoldenrod: '#eee8aa',
    palegreen: '#98fb98',
    paleturquoise: '#afeeee',
    palevioletred: '#d87093',
    papayawhip: '#ffefd5',
    peachpuff: '#ffdab9',
    peru: '#cd853f',
    pink: '#ffc0cb',
    plum: '#dda0dd',
    powderblue: '#b0e0e6',
    purple: '#800080',
    rebeccapurple: '#663399',
    red: '#ff0000',
    rosybrown: '#bc8f8f',
    royalblue: '#4169e1',
    saddlebrown: '#8b4513',
    salmon: '#fa8072',
    sandybrown: '#f4a460',
    seagreen: '#2e8b57',
    seashell: '#fff5ee',
    sienna: '#a0522d',
    silver: '#c0c0c0',
    silverdigitaldoorviewer: '#c0c0c0',
    silverdigitaldoorviewerwithrecorder: '#c0c0c0',
    skyblue: '#87ceeb',
    slateblue: '#6a5acd',
    slategray: '#708090',
    snow: '#fffafa',
    springgreen: '#00ff7f',
    steelblue: '#4682b4',
    tan: '#d2b48c',
    teal: '#008080',
    thistle: '#d8bfd8',
    tomato: '#ff6347',
    turquoise: '#40e0d0',
    violet: '#ee82ee',
    wheat: '#f5deb3',
    white: '#e9efea',
    whitesmoke: '#f5f5f5',
    yellow: '#ffff00',
    lifetimebrass:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/lifetimeBrass_fb14dd8b-af95-4d8e-9214-643ac1c90a91.png?v=1627593807',
    yellowgreen: '#9acd32',
    blackorange:
        'https://cdn.shopify.com/s/files/1/2592/4270/files/swatch-black-orange.jpg?11677064816970603054',
    naturalwood:
        'https://cdn.shopify.com/s/files/1/2592/4270/files/swatch-natural-wood.jpg?5914773578951770782',
    oilrubbedbronzepermanent:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/2.png?117760',
    polishedbrass:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/1.png?117760',
    satinnickel:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
    satinnickellaminated:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
    laminatedsatinnickel:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
    satinchrome:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image4.png?133410',
    antiquebrass:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
    brass: 'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
    brasscoated:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
    antiquenickel:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
    anitquenickel: '#727472',
    polishedbrasscoated: '#D0D5DB',
    coatedpolishedbrass: '#cc9933',
    coatedsatinnickel: '#727472',
    oilrubbedbronzecoated: '#cd7f32',
    brasspolished: '#E3D343',
    satinnickelcoated: '#B5B6B5',
    permanentoilrubbedbronze: '#665d1e',
    nickelcoated:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
    nickel: 'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
    oilrubbedbronze:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image2.png?133410',
    polishedchrome:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image5.png?133410',
    blacksuede:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Capture.jpg?213391',
    matteblack:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Capture.jpg?213391',
    gunmetal:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Gun-matel.png?219497',
    antiquenickel:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Antique_Nickel.png?219497',
    suedeblack:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
    blackdigitaldoorviewerwithrecorder:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
    blackdigitaldoorviewer:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
    lookdoorviewerwithwifi: '#a0522d',
    powdercoatedexteriorblackral9004: '#000',
    carbonbrown:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Smart_Del_Box-Carbon_Brown-Finish_1500px.png?v=1601042376',
    manorgray:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Smart_Del_Box-Manor_Gray-Finish_1500px.png?v=1601043535',
    vivamagenta:
        'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Magenta-swatch_1.png?v=1689719593',
    ash: '#6C7576',
    };
    
    function checkDiscountLimitFull(thisId) {
        var currentCartItems = CartJS.cart.items || [];
        var qtyLimit = Number($('body').attr('data-qty-limit')) || 0;
    
        var disList = metaobjectDiscountData;
    
        var discountQty = 0;
        var productInCart = false;
        var thisItemHasDiscount = false;
    
        for (var i = 0; i < currentCartItems.length; i++) {
            var prod = currentCartItems[i];
            var prodId = prod.product_id * 1;
            var variantId = prod.variant_id;
    
            var newMatched = false;
            for (i=0;i<metaobjectDiscountData.length;i++){
            var checkString = metaobjectDiscountData[i].replace('gid://shopify/Product/', '') * 1;
            console.log(checkString);
            console.log(prodId);
                if (checkString === prodId){
                    newMatched = true;
                }
            }
    
            // Count total discounted quantity
            if (newMatched) {
            discountQty += prod.quantity;
            }
    
            // Check the product being added
            if (prod.variant_id == thisId) {
            productInCart = true;
            if (newMatched) {
                thisItemHasDiscount = true;
            }
            }
        }
    
        console.log('discounted product count: ' + discountQty);
    
        // If adding this product (which does NOT have a discount)
        // would put us over the discount limit, block it.
        if (productInCart && thisItemHasDiscount && qtyLimit > 0) {
            if (discountQty + 1 > qtyLimit) {
            console.log("discount limit reached");
            return true;  
            }
        }
    
        console.log("discount limit not reached");
        return false;
    }
    (function ($, root, undefined) {
    
        function getNearestWeekdayTwoDaysAhead() {
          const date = new Date();
          date.setDate(date.getDate() + 2);
    
          // Adjust if the resulting day is Saturday or Sunday
          const day = date.getDay();
          if (day === 6) { // Saturday
            date.setDate(date.getDate() + 2);
          } else if (day === 0) { // Sunday
            date.setDate(date.getDate() + 1);
          }
    
          const yyyy = date.getFullYear();
          const mm = String(date.getMonth() + 1).padStart(2, '0');
          const dd = String(date.getDate()).padStart(2, '0');
    
          return `${yyyy}/${mm}/${dd}`;
        }
    
        $(document).ready(function () {
            AOS.init();
    
            console.log('test');
    
            function compareProdTypes(prodType, groupType) {
                console.log(
                    'comparing product types ' +
                        prodType +
                        ' against ' +
                        groupType +
                        '.'
                );
                var smartLockTypes = [
                    'Smart Lock',
                    'Keypad Lock',
                    'Patio Door Locks',
                    'Front Door Bundle',
                ];
                var mechanicalLockTypes = [
                    'Mechanical Deadbolt',
                    'Mechanical Lever',
                    'Mechanical Knob',
                    'Mechanical Handleset',
                ];
    
                if (
                    smartLockTypes.includes(prodType) &&
                    smartLockTypes.includes(groupType)
                ) {
                    console.log('smart lock');
                    return true;
                } else if (
                    mechanicalLockTypes.includes(prodType) &&
                    mechanicalLockTypes.includes(groupType)
                ) {
                    console.log('mechanical lock');
                    return true;
                } else {
                    console.log('they do not match');
                    return false;
                }
            }
    
            if (
                $('#shopify-section-crossBanner').length ||
                $('#shopify-section-newCoBrandBanner').length
            ) {
                console.log('test');
                $('.navbar-main').attr('style', 'display:none!important;');
                $('.section-content').attr(
                    'style',
                    'padding-top:0!important;overflow:hidden;'
                );
                $('.site-footer').attr(
                    'style',
                    'background-color:rgb(26,26,26);padding-top:50px;color:white!important;'
                );
                $('.topbar .row .d-flex .d-block').attr(
                    'style',
                    'opacity:0;height:24px;'
                );
            }
    
            $('.smVideoButton').on('click', function (e) {
                e.preventDefault();
                var thisVideo = $(this).attr('video-code');
                $('.smVideoModal').fadeIn();
                $('.smVideoModal__wrapper').html(thisVideo);
            });
    
            if ($('.buy-pro-section .smVideoButton').length > 0) {
                $('.buy-pro-section').on('click', function (e) {
                    e.preventDefault();
                    var thisVideo = $(this)
                        .find('.smVideoButton')
                        .attr('video-code');
                    $('.smVideoModal').fadeIn();
                    $('.smVideoModal__wrapper').html(thisVideo);
                });
            }
    
            $('.smVideoModal__bkg, .smVideoModa__close').on('click', function () {
                $('.smVideoModal').fadeOut();
                $('.smVideoModal__wrapper').html('');
            });
    
            $('.crossSeven__mobSlider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
            });
    
            $('.slo3Mob__slider').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
            });
    
            $('[note-data]').on('click', function () {
                var textData = $(this).attr('note-data');
                var target = $('.sm-techNote');
                target.html(textData);
            });
    
            $('.sm-techSelected').each(function () {
                var textData = $(this).parent().find('label').attr('note-data');
                var target = $('.sm-techNote');
                target.html(textData);
            });
    
            $('.sm-techButton').on('click', function (e) {
                e.preventDefault();
            });
    
            $('#shopify-section-newHeaderSlider .newHero__slider').slick({
                dots: true,
                adaptiveHeight: true,
            });
    
            var addonPriceSet = false;
            var addonInterval = setInterval(function () {
                if ($('.template-product').length > 0) {
                    $('.product-addons .price').text(
                        'Get the same key cut for all keyed locks on your order ($3.99/lock).'
                    );
                    addonPriceSet = true;
                }
            }, 100);
    
            var variantId = $('#extend-offer').attr('data-product');
            var variantPrice = $('#extend-offer').attr('data-price');
            var variantType = $('#extend-offer').attr('data-type');
            // renders the Extend offer buttons for the product
            if (variantId) {
                Extend.buttons.render('#extend-offer', {
                    referenceId: variantId,
                    price: thisPrice,
                    category: thisType,
                });
            }
    
            $('.abPhones__slider').slick({
                dots: true,
            });
    
            $('.abProduct__imageSlider').slick({
                dots: true,
            });
    
            $('.abProduct__specTitle').on('click', function () {
                var thisThing = $(this);
                var thisPar = thisThing.closest('.abProduct__specWrapper');
                thisPar.find('.abProduct__specContent').slideToggle();
                thisPar
                    .find('.abProduct__specTitleArrow')
                    .toggleClass('abProduct__specTitleArrow--active');
            });
    
            function selectActiveVariant(thisThing) {
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                var color = thisParent
                    .find('.abProduct__color--selected')
                    .attr('datacolor');
                thisParent
                    .find('.abProduct__hiddenSelect')
                    .find('option')
                    .each(function () {
                        if ($(this).attr('data-option').includes(color)) {
                            var newVal = $(this).attr('value');
                            thisParent
                                .find('.abProduct__hiddenSelect')
                                .val(newVal)
                                .change();
                            thisParent
                                .find('.abProduct__hiddenSelect')
                                .find('option')
                                .attr('selected', false);
                            $(this).attr('selected', true);
                        }
                    });
            }
    
            function updateVariant(thisThing) {
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                var selected = thisParent.find(
                    '.abProduct__hiddenSelect [selected]'
                );
                thisParent
                    .find('.abProduct__spec--model')
                    .text(selected.attr('sku'));
                thisParent
                    .find('.abProduct__spec--finish, .colorName')
                    .text(
                        thisParent
                            .find('.abProduct__color--selected')
                            .attr('datacolor')
                    );
                thisParent
                    .find('.abProduct__spec--weight')
                    .text(selected.attr('weight'));
                thisParent.find('.abProduct__image').each(function () {
                    if ($(this).attr('src') == selected.attr('data-image')) {
                        var index = $(this)
                            .parent()
                            .parent()
                            .attr('data-slick-index');
                        thisParent
                            .find('.abProduct__imageSlider')
                            .slick('slickGoTo', index);
                        return false;
                    }
                });
                if (selected.attr('available') == 'true') {
                    thisParent.find('.abProduct__buy').text('Buy Now');
                    thisParent.find('.abProduct__buy').prop('disabled', false);
                } else {
                    thisParent.find('.abProduct__buy').text('Sold Out');
                    thisParent.find('.abProduct__buy').prop('disabled', true);
                }
            }
            $('.abProduct__hiddenSelect [selected]').each(function () {
                var thisThing = $(this);
                updateVariant(thisThing);
            });
    
            $('.abProduct__color').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                if (!$(this).hasClass('abProduct__color--selected')) {
                    thisParent
                        .find('.abProduct__color')
                        .removeClass('abProduct__color--selected');
                    $(this).addClass('abProduct__color--selected');
                    selectActiveVariant(thisThing);
                    updateVariant(thisThing);
                }
            });
    
            function showHideMiniCartKeyedAlike() {
                var count = 0;
                var alreadyGroups = false;
                for (i = 0; i < CartJS.cart.items.length; i++) {
                    if (
                        CartJS.cart.items[i].properties['_keyed_alike_available'] ==
                        'true'
                    ) {
                        var qty = CartJS.cart.items[i].quantity;
                        count += 1 * qty;
                    }
                    if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
                        alreadyGroups = true;
                    }
                }
                console.log(count);
                if (count > 1 && alreadyGroups == false) {
                    $('.miniCartKA').show();
                } else {
                    $('.miniCartKA').hide();
                }
            }
            $('a[data-target="#cartDrawer"]').on('click', function () {
                showHideMiniCartKeyedAlike();
            });
    
            function updateCart(openCart) {
                app._getCartData();
                app._vibrateDevice();
                app.$snotify.clear();
                showHideMiniCartKeyedAlike();
                setTimeout(function () {
                    if (
                        ((app.isLoading = false),
                        (app.loadingEvent = null),
                        app.storeUtilities.cartUpsells.settings.showOnPopUp)
                    ) {
                        var origin = app.cart.items.find(function (data) {
                            return data.variant_id === keys;
                        });
                        app._openModalCartUpsell(origin);
                    } else {
                        if (openCart == true) {
                            app._openCartDrawer();
                        } else {
                            app._touchCartDrawer();
                        }
                    }
                }, 300);
            }
    
            $('.abProduct__buy').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                console.log('pressed');
                if (
                    checkDiscountLimitFull(
                        thisParent.find('.abProduct__hiddenSelect').val()
                    )
                ) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
                CartJS.addItem(
                    thisParent.find('.abProduct__hiddenSelect').val(),
                    thisParent.find('.abProduct__qty').val(),
                    {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                    {
                        success: function (data, textStatus, jqXHR) {
                            setTimeout(function () {
                                updateCart(true);
                            }, 200);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    }
                );
            });
    
            $('.abProduct__qtyMinus').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                var currentVal = thisParent.find('.abProduct__qty').val();
                if (currentVal > 1) {
                    thisParent.find('.abProduct__qty').val(currentVal - 1);
                }
            });
    
            $('.abProduct__qtyPlus').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest(
                    '.abProduct__inner, .nestPDP__inner'
                );
                var currentVal = thisParent.find('.abProduct__qty').val();
                thisParent.find('.abProduct__qty').val(currentVal / 1 + 1);
            });
    
            $('.abProduct__toolButton').hover(
                function () {
                    var thisThing = $(this);
                    var thisParent = thisThing.closest(
                        '.abProduct__inner, .nestPDP__inner'
                    );
                    thisParent.find('.abProduct__toolTip').fadeIn();
                },
                function () {
                    var thisThing = $(this);
                    var thisParent = thisThing.closest(
                        '.abProduct__inner, .nestPDP__inner'
                    );
                    thisParent.find('.abProduct__toolTip').fadeOut();
                }
            );
    
            $('[datastyle]').each(function () {
                $(this).attr('style', $(this).attr('datastyle'));
            });
    
            $('.ABHalfHero__inner').slick({
                dots: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
            });
    
            $('.nestSwapper__slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
            });
    
            $('.nestGallery__slider').slick({
                infinite: true,
                centerMode: true,
                centerPadding: '60px',
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                responsive: [
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
    
            $('.cabGallery__slider').slick({
                infinite: true,
                centerMode: false,
                centerPadding: '60px',
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            centerPadding: '20px',
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            centerPadding: '20px',
                        },
                    },
                ],
            });
    
            $('.nestOther__slider').slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '60px',
                            dots: true,
                        },
                    },
                ],
            });
    
            $('.nestSwapper__button')
                .first()
                .addClass('nestSwapper__button--active');
            $('.nestSwapper__button').on('click', function () {
                var index = $(this).attr('data-index');
                $('.nestSwapper__button').removeClass(
                    'nestSwapper__button--active'
                );
                $(this).addClass('nestSwapper__button--active');
                $('.nestSwapper__slider').slick('slickGoTo', index);
            });
    
            if ($('.nestPDP').length) {
                $('html').attr('style', 'scroll-behavior: smooth;');
    
                var match = false;
                $('.abProduct__color').each(function () {
                    var thisThing = $(this);
                    if ($('.abProduct__buy').text() == 'Sold Out') {
                        match = thisThing;
                        match.click();
                    }
                });
    
                var nestInterval = setInterval(function () {
                    if ($('.abProduct__imageSlider.slick-initialized').length) {
                        clearInterval(nestInterval);
                        $('.abProduct__color').first().click();
                        setTimeout(function () {
                            match.click();
                        }, 2000);
                    }
                }, 100);
            }
    
            $('.nestFaq__dropWrapper').hide();
    
            $('.nestFaq__shelfTop').on('click', function () {
                $(this).parent().find('.nestFaq__dropWrapper').slideToggle();
                $(this)
                    .parent()
                    .find('.nestFaq__shelfArrow')
                    .toggleClass('nestFaq__shelfArrow--active');
            });
    
            $('.nestPDP .abProduct__color').on('click', function () {
                var dataColor = $(this).attr('datacolor');
                $('.nestPDP__colorName').text(dataColor);
                if (dataColor == 'Black Suede') {
                    $('.nestPDP__new').slideDown();
                } else {
                    $('.nestPDP__new').slideUp();
                }
            });
    
            $('.nestProdCard__buyButton').on('click', function () {
                console.log('pressed');
                var thisThing = $(this);
                var keyedAlike = thisThing.attr('data-keyed-alike');
    
                console.log(keyedAlike);
                if (checkDiscountLimitFull(thisThing.attr('data-id'))) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
    
                if (keyedAlike == 'true') {
                    CartJS.addItem(
                        thisThing.attr('data-id'),
                        1,
                        { _keyed_alike_available: 'true', "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
                        {
                            success: function (data, textStatus, jqXHR) {
                                setTimeout(function () {
                                    updateCart(true);
                                }, 200);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                } else {
                    CartJS.addItem(
                        thisThing.attr('data-id'),
                        1,
                        {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                        {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(true);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                }
            });
    
            var polishedBrass =
                'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/1.png?117760")';
            var satinNickel =
                'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760")';
            var oilRubbedBronze =
                'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image2.png?133410")';
    
            $('.nestProdCard__color').each(function () {
                var thisThing = $(this);
                if (thisThing.attr('data-name') == 'Satin Nickel') {
                    thisThing.attr(
                        'style',
                        'background-image:' + satinNickel + ';'
                    );
                }
                if (thisThing.attr('data-name') == 'Polished Brass') {
                    thisThing.attr(
                        'style',
                        'background-image:' + polishedBrass + ';'
                    );
                }
                if (thisThing.attr('data-name') == 'Oil Rubbed Bronze') {
                    thisThing.attr(
                        'style',
                        'background-image:' + oilRubbedBronze + ';'
                    );
                }
                thisThing.on('click', function () {
                    thisThing
                        .closest('.shopify-section')
                        .find('.nestProdCard__image')
                        .attr('src', thisThing.attr('data-image'));
                    thisThing
                        .closest('.shopify-section')
                        .find('.nestProdCard__currentColor')
                        .text(thisThing.attr('data-name'));
                    thisThing
                        .closest('.shopify-section')
                        .find('.nestProdCard__buyButton')
                        .attr('data-id', thisThing.attr('data-id'));
                    thisThing
                        .closest('.shopify-section')
                        .find('.nestProdCard__buyButton')
                        .attr(
                            'data-keyed-alike',
                            thisThing.attr('data-keyed-alike')
                        );
                    if (thisThing.attr('data-available') == 'false') {
                        thisThing
                            .closest('.shopify-section')
                            .find('.nestProdCard__buyButton')
                            .prop('disabled', true);
                        thisThing
                            .closest('.shopify-section')
                            .find('.nestProdCard__buyButton')
                            .text('Sold Out');
                    } else {
                        thisThing
                            .closest('.shopify-section')
                            .find('.nestProdCard__buyButton')
                            .prop('disabled', false);
                        thisThing
                            .closest('.shopify-section')
                            .find('.nestProdCard__buyButton')
                            .text('Buy Now');
                    }
                });
            });
    
            $('.boxWorks__slider').slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 990,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 750,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 510,
                        settings: {
                            slidesToShow: 1,
                            arrows: true,
                            dots: true,
                        },
                    },
                ],
            });
    
            if ($('.boxPDP').length) {
                function preload(arrayOfImages) {
                    $(arrayOfImages).each(function () {
                        $('<img/>')[0].src = this;
                    });
                }
                preload([
                    $('.boxPDP__colorButton--brown').attr('wifi-img'),
                    $('.boxPDP__colorButton--brown').attr('keypad-img'),
                    $('.boxPDP__colorButton--gray').attr('wifi-img'),
                    $('.boxPDP__colorButton--gray').attr('keypad-img'),
                ]);
    
                var boxColor = 'brown';
                var boxOption = 'wifi';
    
                var currentImg = $('.boxPDP__colorButton--brown').attr('wifi-img');
                var currentPrice = $('.boxPDP__colorButton--brown').attr(
                    'wifi-price'
                );
                var currentId = $('.boxPDP__colorButton--brown').attr('wifi-id');
                var currentAvailable = $('.boxPDP__colorButton--brown').attr(
                    'wifi-available'
                );
    
                function calculateItem() {
                    if (boxColor == 'brown') {
                        if (boxOption == 'wifi') {
                            currentImg = $('.boxPDP__colorButton--brown').attr(
                                'wifi-img'
                            );
                            currentPrice = $('.boxPDP__colorButton--brown').attr(
                                'wifi-price'
                            );
                            currentId = $('.boxPDP__colorButton--brown').attr(
                                'wifi-id'
                            );
                            currentAvailable = $(
                                '.boxPDP__colorButton--brown'
                            ).attr('wifi-available');
                        } else {
                            currentImg = $('.boxPDP__colorButton--brown').attr(
                                'keypad-img'
                            );
                            currentPrice = $('.boxPDP__colorButton--brown').attr(
                                'keypad-price'
                            );
                            currentId = $('.boxPDP__colorButton--brown').attr(
                                'keypad-id'
                            );
                            currentAvailable = $(
                                '.boxPDP__colorButton--brown'
                            ).attr('keypad-available');
                        }
                    } else {
                        if (boxOption == 'wifi') {
                            currentImg = $('.boxPDP__colorButton--gray').attr(
                                'wifi-img'
                            );
                            currentPrice = $('.boxPDP__colorButton--gray').attr(
                                'wifi-price'
                            );
                            currentId = $('.boxPDP__colorButton--gray').attr(
                                'wifi-id'
                            );
                            currentAvailable = $('.boxPDP__colorButton--gray').attr(
                                'wifi-available'
                            );
                        } else {
                            currentImg = $('.boxPDP__colorButton--gray').attr(
                                'keypad-img'
                            );
                            currentPrice = $('.boxPDP__colorButton--gray').attr(
                                'keypad-price'
                            );
                            currentId = $('.boxPDP__colorButton--gray').attr(
                                'keypad-id'
                            );
                            currentAvailable = $('.boxPDP__colorButton--gray').attr(
                                'keypad-available'
                            );
                        }
                    }
    
                    $('.boxPDP__price').text(currentPrice);
                    $('.boxPDP__image').attr('src', currentImg);
    
                    if (currentAvailable == 'true') {
                        $('.boxPDP__buy').prop('disabled', false);
                        $('.boxPDP__buy').text('Buy Now');
                    } else {
                        $('.boxPDP__buy').prop('disabled', true);
                        $('.boxPDP__buy').text('Sold Out');
                    }
                }
                calculateItem();
    
                $('.boxPDP__colorButton').on('click', function () {
                    var thisThing = $(this);
                    if (thisThing.hasClass('boxPDP__colorButton--brown')) {
                        boxColor = 'brown';
                    } else {
                        boxColor = 'gray';
                    }
                    $('.boxPDP__colorButton').removeClass(
                        'boxPDP__colorButton--active'
                    );
                    thisThing.addClass('boxPDP__colorButton--active');
                    calculateItem();
                });
    
                $('.boxPDP__colorButton--gray').click();
    
                $('.boxPDP__option').on('click', function () {
                    var thisThing = $(this);
                    if (thisThing.hasClass('boxPDP__option--wifi')) {
                        boxOption = 'wifi';
                    } else {
                        boxOption = 'keypad';
                    }
                    $('.boxPDP__option').removeClass('boxPDP__option--active');
                    thisThing.addClass('boxPDP__option--active');
                    calculateItem();
                });
    
                $('.boxPDP__buy').on('click', function () {
                    var thisThing = $(this);
                    if (checkDiscountLimitFull(currentId)) {
                        alert(
                            'You can only order up to ' +
                                $('body').attr('data-qty-limit') * 1 +
                                ' discounted items.'
                        );
                        return;
                    }
                    CartJS.addItem(
                        currentId,
                        1,
                        {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                        {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(true);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                });
    
                $('.boxVideo__playButton').on('click', function () {
                    var thisThing = $(this);
                    var videoCode = thisThing.attr('data-video');
                    $('.boxVideoModal').fadeIn();
                    $('.boxVideoModal__bucket').html(videoCode);
                });
    
                $('.boxVideoModal__overlay, .boxVideoModal__close').on(
                    'click',
                    function () {
                        $('.boxVideoModal').fadeOut();
                        $('.boxVideoModal__bucket').html('');
                    }
                );
            }
    
            // Smart Cabinet Page
            $('.cabPDP .pdp__options button').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest('.cabPDP');
    
                var varId = $(this).data('id');
    
                thisParent.find('.pdp__options button').removeClass('active');
                $(this).addClass('active');
    
                thisParent.find('.pdp__price .price').removeClass('active');
                thisParent
                    .find('.pdp__price .price[data-id="' + varId + '"]')
                    .addClass('active');
    
                thisParent.find('.pdp__select select').removeClass('active');
                thisParent
                    .find('.pdp__select select[data-id="' + varId + '"]')
                    .addClass('active');
    
                thisParent
                    .find('.pdp__features--cabinet .pdp__featuresContainer')
                    .html(
                        '<strong>Features</strong>' + $(this).attr('data-features')
                    );
                thisParent
                    .find('.pdp__technical--cabinet .pdp__nestFaq__drop')
                    .html($(this).attr('data-specs'));
    
                $(this)
                    .closest('.cabPDP')
                    .find('.pdp__features')
                    .html(
                        '<strong>Features</strong>' + $(this).attr('data-features')
                    );
            });
    
            $('.cabPDP .pdp__buy button').on('click', function () {
                var thisThing = $(this);
                var thisParent = thisThing.closest('.cabPDP');
                if (
                    checkDiscountLimitFull(
                        thisParent.find('.pdp__select select.active').val()
                    )
                ) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
                CartJS.addItem(
                    thisParent.find('.pdp__select select.active').val(),
                    1,
                    {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                    {
                        success: function (data, textStatus, jqXHR) {
                            updateCart(true);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    }
                );
            });
    
            $('.accessDesktop__slider').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
            });
    
            $('.accessDesktop__button').on('click', function () {
                var slideIndex = $(this).attr('data-slide') * 1;
                $('.accessDesktop__slider').slick('slickGoTo', slideIndex);
                $('.accessDesktop__button').removeClass(
                    'accessDesktop__button--active'
                );
                $(this).addClass('accessDesktop__button--active');
            });
    
            $('.accessFAQ__titleButton').on('click', function () {
                if ($(this).hasClass('accessFAQ__titleButton--active')) {
                    $(this).removeClass('accessFAQ__titleButton--active');
                    $(this).parent().find('.accessFAQ__accordionWrapper').slideUp();
                } else {
                    $('.accessFAQ__titleButton').removeClass(
                        'accessFAQ__titleButton--active'
                    );
                    $('.accessFAQ__titleButton')
                        .parent()
                        .find('.accessFAQ__accordionWrapper')
                        .slideUp();
                    $(this).addClass('accessFAQ__titleButton--active');
                    $(this)
                        .parent()
                        .find('.accessFAQ__accordionWrapper')
                        .slideDown();
                }
            });
    
            $('.accessMobile__slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                asNavFor: '.accessMobile__textSliderInner',
            });
    
            $('.accessMobile__textSliderInner').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                asNavFor: '.accessMobile__slider',
            });
    
            $('.accessMobile__previous').on('click', function () {
                $('.accessMobile__slider').slick('slickPrev');
                $('.accessMobile__textSliderInner').slick('slickPrev');
                var newIndex = $('.accessMobile__slider')
                    .find('.slick-current')
                    .attr('data-slick-index');
                $('.accessMobile__dot--active').removeClass(
                    'accessMobile__dot--active'
                );
                $('.accessMobile__dots')
                    .find('[data-slide="' + newIndex + '"]')
                    .addClass('accessMobile__dot--active');
            });
    
            $('.accessMobile__next').on('click', function () {
                $('.accessMobile__slider').slick('slickNext');
                $('.accessMobile__textSliderInner').slick('slickNext');
                var newIndex = $('.accessMobile__slider')
                    .find('.slick-current')
                    .attr('data-slick-index');
                $('.accessMobile__dot--active').removeClass(
                    'accessMobile__dot--active'
                );
                $('.accessMobile__dots')
                    .find('[data-slide="' + newIndex + '"]')
                    .addClass('accessMobile__dot--active');
            });
    
            $('.accessMobile__slider').on(
                'beforeChange',
                function (event, slick, currentSlide, nextSlide) {
                    $('.accessMobile__dot--active').removeClass(
                        'accessMobile__dot--active'
                    );
                    $('.accessMobile__dots')
                        .find('[data-slide="' + nextSlide + '"]')
                        .addClass('accessMobile__dot--active');
                }
            );
    
            $('.accessMobile__dot').on('click', function () {
                var newIndex = $(this).attr('data-slide');
                $('.accessMobile__slider').slick('slickGoTo', newIndex);
                $('.accessMobile__dot--active').removeClass(
                    'accessMobile__dot--active'
                );
                $('.accessMobile__dots')
                    .find('[data-slide="' + newIndex + '"]')
                    .addClass('accessMobile__dot--active');
            });
    
            $('.accessCollection__slider').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
    
            $('.accessCollection__prev').on('click', function () {
                console.log('test');
                $('.accessCollection__slider').slick('slickPrev');
                var newIndex =
                    $('.accessCollection__slider')
                        .find('.slick-current')
                        .attr('data-slick-index') * 1;
                $('.accessCollection__counterChanger').text(newIndex + 1);
            });
    
            $('.accessCollection__next').on('click', function () {
                $('.accessCollection__slider').slick('slickNext');
                var newIndex =
                    $('.accessCollection__slider')
                        .find('.slick-current')
                        .attr('data-slick-index') * 1;
                $('.accessCollection__counterChanger').text(newIndex + 1);
            });
    
            $('.accessCollection__slider').on(
                'beforeChange',
                function (event, slick, currentSlide, nextSlide) {
                    $('.accessCollection__counterChanger').text(nextSlide + 1);
                }
            );
    
            $('.accessCollectionCard__colorButton').each(function () {
                var colorName = $(this)
                    .attr('color-name')
                    .toLowerCase()
                    .replace(/\s/g, '');
                var colorCode = colorLib[colorName];
                if (colorCode) {
                    if (colorCode.includes('http')) {
                        $(this)
                            .find('.accessCollectionCard__colorBack')
                            .attr('style', 'background:url(' + colorCode + ');');
                    } else {
                        $(this)
                            .find('.accessCollectionCard__colorBack')
                            .attr('style', 'background:' + colorCode + ';');
                    }
                }
            });
    
            $('.sloFeatured__slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                asNavFor: '.sloFeatured__thumbSlider',
            });
    
            $('.sloFeatured__thumbSlider').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                focusOnSelect: true,
                asNavFor: '.sloFeatured__slider',
            });
    
            $('.sloFeatured__prevButton').on('click', function () {
                $('.sloFeatured__slider').slick('slickPrev');
            });
    
            $('.sloFeatured__nextButton').on('click', function () {
                $('.sloFeatured__slider').slick('slickNext');
            });
    
            $('.accessCollectionCard__colorButton').on('click', function () {
                var image = $(this).attr('color-image');
                var name = $(this).attr('color-name');
                var target = $(this)
                    .parent()
                    .parent()
                    .find('.accessCollectionCard__image');
                var available = $(this).attr('data-available');
                target.attr('src', image);
                $(this)
                    .parent()
                    .find('.accessCollectionCard__colorButton')
                    .removeClass('accessCollectionCard__colorButton--active');
                $(this).addClass('accessCollectionCard__colorButton--active');
                $(this)
                    .closest('.accessCollectionCard')
                    .find('.accessCollectionCard__colorName')
                    .text(name);
                var hasAddButton =
                    $(this).parent().parent().find('.nestProdCard__buyButton')
                        .length > 0;
                console.log(hasAddButton);
                if (hasAddButton) {
                    $(this)
                        .closest('.accessCollectionCard')
                        .find('.nestProdCard__buyButton')
                        .attr('data-id', $(this).attr('data-variant'));
                    $(this)
                        .closest('.accessCollectionCard')
                        .find('.nestProdCard__buyButton')
                        .attr('data-keyed-alike', $(this).attr('data-keyed-alike'));
                    $(this)
                        .closest('.accessCollectionCard')
                        .find('.nestProdCard__notifyButton')
                        .attr('variant-id', $(this).attr('data-variant'));
                }
            });
    
            $('.sloFeatured__colorButton').each(function () {
                var colorName = $(this)
                    .attr('color-name')
                    .toLowerCase()
                    .replace(/\s/g, '');
                var colorCode = colorLib[colorName];
                if (colorCode) {
                    if (colorCode.includes('http')) {
                        $(this)
                            .find('.sloFeatured__colorBack')
                            .attr('style', 'background:url(' + colorCode + ');');
                    } else {
                        $(this)
                            .find('.sloFeatured__colorBack')
                            .attr('style', 'background:' + colorCode + ';');
                    }
                }
            });
    
            $('.sloFeatured__colorButton').on('click', function () {
                var container = $(this).closest('.sloFeatured');
                var image = $(this).attr('color-image');
                var name = $(this).attr('color-name');
                var prod = $(this).attr('data-variant');
                var target = container
                    .find('.sloFeatured__slider')
                    .find('[data-slick-index="0"]')
                    .find('.sloFeatured__img')
                    .attr('src', image);
                var target2 = container
                    .find('.sloFeatured__slider')
                    .find('[data-slick-index="4"]')
                    .find('.sloFeatured__img')
                    .attr('src', image);
                var target3 = container
                    .find('.sloFeatured__thumbSlider ')
                    .find('[data-slick-index="0"]')
                    .find('.sloFeatured__thumbImg')
                    .attr('src', image)
                    .click();
                var target4 = container
                    .find('.sloFeatured__thumbSlider ')
                    .find('[data-slick-index="4"]')
                    .find('.sloFeatured__thumbImg')
                    .attr('src', image);
                target.attr('src', image);
                container
                    .find('.sloFeatured__colorButton')
                    .removeClass('sloFeatured__colorButton--active');
                $(this).addClass('sloFeatured__colorButton--active');
                container.find('.sloFeatured__colorName').text(name);
                container.find('.nestProdCard__buyButton').attr('data-id', prod);
            });
    
            $('.sloZwave__slider').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
    
            $('.sloZWave__toggle').on('click', function () {
                $('.sloZWave__toggle').removeClass('sloZWave__toggle--active');
                $(this).addClass('sloZWave__toggle--active');
                if ($(this).attr('data-tech') == 'bluetooth') {
                    $('.sloZwave__inner--bluetooth').removeClass(
                        'sloZwave__inner--hidden'
                    );
                    $('.sloZwave__inner--wifi').addClass('sloZwave__inner--hidden');
                } else {
                    $('.sloZwave__inner--wifi').removeClass(
                        'sloZwave__inner--hidden'
                    );
                    $('.sloZwave__inner--bluetooth').addClass(
                        'sloZwave__inner--hidden'
                    );
                }
            });
    
            $('.sloZwave__prevButton').on('click', function () {
                $(this).parent().find('.sloZwave__slider').slick('slickPrev');
            });
    
            $('.sloZwave__nextButton').on('click', function () {
                $(this).parent().find('.sloZwave__slider').slick('slickNext');
            });
    
            $('.sloZwave__prev').on('click', function () {
                $(this)
                    .parent()
                    .parent()
                    .find('.sloZwave__slider')
                    .slick('slickPrev');
                var newIndex =
                    $(this)
                        .parent()
                        .parent()
                        .find('.sloZwave__slider ')
                        .find('.slick-current')
                        .attr('data-slick-index') * 1;
                $(this)
                    .parent()
                    .find('.sloZwave__counterChanger')
                    .text(newIndex + 1);
            });
    
            $('.sloZwave__next').on('click', function () {
                $(this)
                    .parent()
                    .parent()
                    .find('.sloZwave__slider')
                    .slick('slickNext');
                var newIndex =
                    $(this)
                        .parent()
                        .parent()
                        .find('.sloZwave__slider ')
                        .find('.slick-current')
                        .attr('data-slick-index') * 1;
                $(this)
                    .parent()
                    .find('.sloZwave__counterChanger')
                    .text(newIndex + 1);
            });
    
            $('.accessCollection__slider').on(
                'beforeChange',
                function (event, slick, currentSlide, nextSlide) {
                    $(this)
                        .parent()
                        .parent()
                        .find('.sloZwave__counterChanger')
                        .text(nextSlide + 1);
                }
            );
    
            $('.sloTableM__dropSelected').on('click', function () {
                if ($(this).parent().hasClass('sloTableM__dropWrapper--open')) {
                    $(this).parent().removeClass('sloTableM__dropWrapper--open');
                    $(this).parent().find('.sloTableM__dropDownInner').slideUp();
                } else {
                    $(this).parent().addClass('sloTableM__dropWrapper--open');
                    $(this).parent().find('.sloTableM__dropDownInner').slideDown();
                }
            });
    
            $('.sloTableM__dropWrapper--left')
                .find('.sloTableM__dropButton')
                .on('click', function () {
                    var buttonVal = $(this).attr('data-button');
                    console.log(buttonVal);
                    var swapVal = $('.sloTableM__dropWrapper--left')
                        .find('.sloTableM__dropSelected span')
                        .text();
                    console.log(swapVal);
                    $('.sloTableM__dropWrapper--left')
                        .find('.sloTableM__dropSelected span')
                        .text(buttonVal);
                    $(this).attr('data-button', swapVal);
                    $(this).text(swapVal);
                    $('.sloTableM__dropWrapper--left')
                        .find('.sloTableM__dropSelected')
                        .click();
    
                    if (buttonVal == 'Assure Lock 2') {
                        $('.sloTableM__left').each(function () {
                            $(this).text($(this).attr('data-wifi'));
                        });
                        $('.sloTableM__leftLink').attr(
                            'href',
                            $(this).attr('data-wifi')
                        );
                    } else if (buttonVal == 'Assure Lock 2 with Wi-Fi') {
                        $('.sloTableM__left').each(function () {
                            $(this).text($(this).attr('data-zwave'));
                        });
                        $('.sloTableM__leftLink').attr(
                            'href',
                            $(this).attr('data-zwave')
                        );
                    } else if (buttonVal == 'Nest x Yale Lock') {
                        $('.sloTableM__left').each(function () {
                            $(this).text($(this).attr('data-zigbee'));
                        });
                        $('.sloTableM__leftLink').attr(
                            'href',
                            $(this).attr('data-zigbee')
                        );
                    } else if (buttonVal == 'Assure with Z-Wave Plus') {
                        $('.sloTableM__left').each(function () {
                            $(this).text($(this).attr('data-fifth'));
                        });
                        $('.sloTableM__leftLink').attr(
                            'href',
                            $(this).attr('data-fifth')
                        );
                    }
                });
    
            $('.sloTableM__dropWrapper--right')
                .find('.sloTableM__dropButton')
                .on('click', function () {
                    var buttonVal = $(this).attr('data-button');
                    console.log(buttonVal);
                    var swapVal = $('.sloTableM__dropWrapper--right')
                        .find('.sloTableM__dropSelected span')
                        .text();
                    console.log(swapVal);
                    $('.sloTableM__dropWrapper--right')
                        .find('.sloTableM__dropSelected span')
                        .text(buttonVal);
                    $(this).attr('data-button', swapVal);
                    $(this).text(swapVal);
                    $('.sloTableM__dropWrapper--right')
                        .find('.sloTableM__dropSelected')
                        .click();
    
                    if (buttonVal == 'Assure Lock 2') {
                        $('.sloTableM__right').each(function () {
                            $(this).text($(this).attr('data-wifi'));
                        });
                        $('.sloTableM__rightLink').attr(
                            'href',
                            $(this).attr('data-wifi')
                        );
                    } else if (buttonVal == 'Assure Lock 2 with Wi-Fi') {
                        $('.sloTableM__right').each(function () {
                            $(this).text($(this).attr('data-zwave'));
                        });
                        $('.sloTableM__rightLink').attr(
                            'href',
                            $(this).attr('data-zwave')
                        );
                    } else if (buttonVal == 'Nest x Yale Lock') {
                        $('.sloTableM__right').each(function () {
                            $(this).text($(this).attr('data-zigbee'));
                        });
                        $('.sloTableM__rightLink').attr(
                            'href',
                            $(this).attr('data-zigbee')
                        );
                    } else if (buttonVal == 'Assure with Z-Wave Plus') {
                        $('.sloTableM__right').each(function () {
                            $(this).text($(this).attr('data-fifth'));
                        });
                        $('.sloTableM__rightLink').attr(
                            'href',
                            $(this).attr('data-fifth')
                        );
                    }
                });
    
            if ($('.zigbee-hidden').length > 0) {
                $('.sloTableD__cell--zigbee').hide();
            }
            if ($('.nest-hidden').length > 0) {
                $('.sloTableD__cell--nest').hide();
            }
            if ($('.zwave-hidden').length > 0) {
                $('.sloTableD__cell--zwave').hide();
            }
    
            if ($('#shopify-section-template-product').length > 0) {
                function showCheck(variantID) {
                    //select object by passed id
                    var selected = varLib.find((x) => x.id === variantID);
                    //show-hide notify me box
                    if (selected.available == 'false') {
                        jQuery('.prodHideRow').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery('.notifyMe').show();
                    } else {
                        jQuery('.prodHideRow').attr('style', 'display:flex;');
                        jQuery('.notifyMe').hide();
                    }
    
                    console.log('SELECTED PROD DATA HERE');
                    console.log(selected);
    
                    //show-hide keyed alike box
                    if (selected.keyed_alike == 'true') {
                        $('#keyedAlike').val('true');
    
                        var count = 0;
                        var type = '';
                        var smartInCart = false;
                        for (i = 0; i < CartJS.cart.items.length; i++) {
                            if (
                                CartJS.cart.items[i].properties[
                                    '_keyed_alike_available'
                                ] == 'true'
                            ) {
                                var qty = CartJS.cart.items[i].quantity;
                                count += 1;
                                if (CartJS.cart.items[i].product_type == 'Smart Lock'){
                                    smartInCart = true;
                                }
                            }
    
                            if (type == '') {
                                if (
                                    CartJS.cart.items[i].properties[
                                        '_keyed_alike_group'
                                    ] > 0
                                ) {
                                    type = CartJS.cart.items[i].product_type;
                                }
                            }
                        }
    
                        if (
                            type == '' ||
                            compareProdTypes(selected['_type'], type)
                        ) {
                            if ($('.quantity').val() > 1) {
                                jQuery('.pdpKA').show();
                                jQuery('.pdpKA').attr(
                                    'data-type',
                                    selected['_type']
                                );
                            } else if (count > 0) {
                                jQuery('.pdpKA').show();
                                jQuery('.pdpKA').attr(
                                    'data-type',
                                    selected['_type']
                                );
                            } else {
                                jQuery('.pdpKA').hide();
                            }
                        } else {
                            jQuery('.pdpKA').hide();
                        }
    
                        if (smartInCart == true){
                            if (jQuery('.pdpKA').attr('data-type') != 'Smart Lock'){
                                jQuery('.pdpKA').hide();
                            }
                        }
    
                    } else {
                        jQuery('.pdpKA').hide();
                        $('#keyedAlike').val('false');
                    }
                }
    
                if (varLib[0].available == 'false') {
                    jQuery('.prodHideRow').attr('style', 'display:none!important;');
                    jQuery('.notifyMe').show();
                } else {
                    jQuery('.prodHideRow').attr('style', 'display:flex;');
                    jQuery('.notifyMe').hide();
                }
    
                var initialInterval = setInterval(function () {
                    console.log('interval Running');
                    if (typeof CartJS.cart.items !== 'undefined') {
                        var urlString = window.location.search;
                        var variantID = urlString.split('=')[1];
                        $('.notifyMe__submit').attr('data-variant', variantID);
                        showCheck(variantID);
                        clearInterval(initialInterval);
                    }
                }, 10);
    
                console.log(varLib);
    
                if ($('.template-product').length > 0) {
                    setInterval(function () {
                        var newSku = $('.hiddenSelectorForPDP')
                            .find(':selected')
                            .attr('data-sku');
                        var newFinish = $('input[name="color"]:checked').val();
                        $('.swapModel').text(newSku);
                        $('.swapFinish').text(newFinish);
                    }, 100);
    
                    var variantId = '';
                    setInterval(function () {
                        var testVar = $('.hiddenProdOption')
                            .first()
                            .attr('name')
                            .replace('product_options_', '')
                            .replace('[]', '');
                        if (testVar !== variantId) {
                            variantId = testVar;
                            console.log(variantId);
                            $('[src-' + variantId + ']').each(function () {
                                var htmlString = $(this).prop('outerHTML');
                                var element = $('<div></div>')
                                    .append(htmlString)
                                    .find('img');
                                element = element[0];
                                var newSrc =
                                    element.attributes['src-' + variantId].value;
                                console.log(newSrc);
                                $(this).attr('src', newSrc);
                            });
                        }
                    }, 100);
                }
    
                $('.selector-wrapper')
                    .find('input')
                    .on('change', function () {
                        var urlString = window.location.search;
                        var variantID = urlString.split('=')[1];
                        $('.notifyMe__submit').attr('data-variant', variantID);
                        showCheck(variantID);
                    });
                $('[data-qty-increase], [data-qty-decrease]').on(
                    'click',
                    function () {
                        var urlString = window.location.search;
                        var variantID = urlString.split('=')[1];
                        showCheck(variantID);
                    }
                );
    
                function watchForPopup(reference) {
                    var lookForPopup = setInterval(function () {
                        if ($('#extend-offers-modal-iframe').length > 0) {
                            var waitForClose = setInterval(function () {
                                if ($('#extend-offers-modal-iframe').length <= 0) {
                                    reference
                                        .closest('.shopify-section')
                                        .find('.pdpKAPop')
                                        .show();
                                    clearInterval(waitForClose);
                                }
                            }, 1);
                            clearInterval(lookForPopup);
                        } else {
                            clearInterval(lookForPopup);
                            var groupCount = 0;
                            var frozenCart = JSON.parse(JSON.stringify(CartJS));
                            for (i = 0; i < frozenCart.cart.items.length; i++) {
                                if (
                                    frozenCart.cart.items[i].properties['_name'] ==
                                    'keyed_alike_group'
                                ) {
                                    var qty = frozenCart.cart.items[i].quantity;
                                    groupCount += 1;
                                }
                                if (
                                    frozenCart.cart.items[i].properties['_groups'] *
                                        1 >
                                    1
                                ) {
                                    $('.pdpKAPop__addToExisting').hide();
                                }
                            }
                            if (groupCount > 0) {
                                $('.pdpKAPop__inner--existing').show();
                                $('.pdpKAPop__inner--new').hide();
                                reference
                                    .closest('.shopify-section')
                                    .find('.pdpKAPop')
                                    .show();
                            } else {
                                if (
                                    $('#cartDrawer').find(
                                        '.cart-item[data-variant-id="32146864832644"]'
                                    ).length > 0
                                ) {
                                } else {
                                    var _itemsToGroup = [];
                                    var _newKAItemCount = 0;
                                    var firstType = '';
                                    for (
                                        i = 0;
                                        i < frozenCart.cart.items.length;
                                        i++
                                    ) {
                                        if (i == 0) {
                                            firstType =
                                                frozenCart.cart.items[i][
                                                    'product_type'
                                                ];
                                        }
                                        if (
                                            frozenCart.cart.items[i].properties[
                                                '_keyed_alike_available'
                                            ] == 'true'
                                        ) {
                                            if (
                                                compareProdTypes(
                                                    frozenCart.cart.items[i][
                                                        'product_type'
                                                    ],
                                                    firstType
                                                )
                                            ) {
                                                _itemsToGroup.push({
                                                    id: frozenCart.cart.items[i].id,
                                                    quantity:
                                                        frozenCart.cart.items[i]
                                                            .quantity,
                                                    properties: {
                                                        _name: 'keyed_alike_group',
                                                        _value: 1,
                                                        _keyed_alike_group: 1,
                                                        _keyed_alike_available:
                                                            'true',
                                                        _type: firstType,
                                                        _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                                    },
                                                });
                                                _newKAItemCount +=
                                                    frozenCart.cart.items[i]
                                                        .quantity * 1;
                                            }
                                        }
                                    }
    
                                    for (j = 0; j < _itemsToGroup.length; j++) {
                                        CartJS.removeItemById(_itemsToGroup[j].id);
                                    }
    
                                    _itemsToGroup.push({
                                        id: 32146864832644,
                                        quantity: _newKAItemCount,
                                        properties: {
                                            _groups: 1,
                                            _type: firstType,
                                            _page_added: window.location.href,
                                        },
                                    });
                                    CartJS.addItems(_itemsToGroup, {
                                        success: function (
                                            data,
                                            textStatus,
                                            jqXHR
                                        ) {
                                            updateCart(true);
                                            $('.pdpKAPop').fadeOut();
                                        },
                                        error: function (
                                            jqXHR,
                                            textStatus,
                                            errorThrown
                                        ) {
                                            console.log(
                                                'Error: ' + errorThrown + '!'
                                            );
                                        },
                                    });
                                }
    
                                /*
                  $('.pdpKAPop__inner--existing').hide();
                  $('.pdpKAPop__inner--new').show();
                  */
                            }
                        }
                    }, 10);
                    var cancelEverything = setTimeout(function () {
                        if ($('#extend-offers-modal-iframe').length <= 0) {
                            clearInterval(lookForPopup);
                            console.log('did not find popup');
                        }
                    }, 1000);
                }
    
                $('form button[type="submit"]').on('click', function () {
                    var cartCount = CartJS.cart.item_count * 1;
                    var cartInterval = setInterval(function () {
                        if (CartJS.cart.item_count * 1 != cartCount) {
                            var urlString = window.location.search;
                            var variantID = urlString.split('=')[1];
                            showCheck(variantID);
                            clearInterval(cartInterval);
                            if ($('.pdpKA__checkbox').prop('checked')) {
                                watchForPopup($(this));
                            }
                        }
                    }, 10);
                });
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
    
                $('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
                    'click',
                    function () {
                        $('.pdpKAPop').fadeOut();
                    }
                );
    
                $('.pdpKAPop__continueButton').on('click', function () {
                    var itemsToGroup = [];
                    var newKAItemCount = 0;
                    var type = '';
                    type = $(this)
                        .closest('.shopify-section')
                        .find('.pdpKA__inner')
                        .parent()
                        .attr('data-type');
    
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties[
                                '_keyed_alike_available'
                            ] == 'true'
                        ) {
                            if (
                                compareProdTypes(
                                    CartJS.cart.items[i].product_type,
                                    type
                                )
                            ) {
                                itemsToGroup.push({
                                    id: CartJS.cart.items[i].id,
                                    quantity: CartJS.cart.items[i].quantity,
                                    properties: {
                                        _name: 'keyed_alike_group',
                                        _value: 1,
                                        _keyed_alike_group: 1,
                                        _keyed_alike_available: 'true',
                                        _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                    },
                                });
                                newKAItemCount += CartJS.cart.items[i].quantity * 1;
                            }
                        }
                    }
    
                    for (j = 0; j < itemsToGroup.length; j++) {
                        CartJS.removeItemById(itemsToGroup[j].id);
                    }
    
                    itemsToGroup.push({
                        id: 32146864832644,
                        quantity: newKAItemCount,
                        properties: {
                            _groups: 1,
                            _page_added: window.location.href,
                        },
                    });
    
                    CartJS.addItems(itemsToGroup, {
                        success: function (data, textStatus, jqXHR) {
                            updateCart(true);
                            $('.pdpKAPop').fadeOut();
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    });
                });
    
                $('.pdpKAPop__addToExisting').on('click', function () {
                    CartJS.removeItemById(32146864832644);
    
                    var itemsToGroup = [];
                    var newKAItemCount = 0;
                    var firstType = '';
    
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties['_keyed_alike_group'] >
                            0
                        ) {
                            firstType = CartJS.cart.items[i].product_type;
                        }
                    }
    
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            compareProdTypes(
                                CartJS.cart.items[i].product_type,
                                firstType
                            )
                        ) {
                            if (
                                CartJS.cart.items[i].properties[
                                    '_keyed_alike_available'
                                ] == 'true'
                            ) {
                                itemsToGroup.push({
                                    id: CartJS.cart.items[i].id,
                                    quantity: CartJS.cart.items[i].quantity,
                                    properties: {
                                        _name: 'keyed_alike_group',
                                        _value: 1,
                                        _keyed_alike_group: 1,
                                        _keyed_alike_available: 'true',
                                        _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                    },
                                });
                                newKAItemCount += CartJS.cart.items[i].quantity * 1;
                            }
                        }
                    }
    
                    for (j = 0; j < itemsToGroup.length; j++) {
                        CartJS.removeItemById(itemsToGroup[j].id);
                    }
    
                    itemsToGroup.push({
                        id: 32146864832644,
                        quantity: newKAItemCount,
                        properties: {
                            _groups: 1,
                            _page_added: window.location.href,
                        },
                    });
    
                    CartJS.addItems(itemsToGroup, {
                        success: function (data, textStatus, jqXHR) {
                            updateCart(true);
                            $('.pdpKAPop').fadeOut();
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    });
                });
            }
    
            if ($('#shopify-section-nestPDP').length > 0) {
                function showCheck(variantID) {
                    console.log(varLib);
                    console.log(variantID);
                    if (
                        varLib.find((x) => x.id === variantID).available == 'false'
                    ) {
                        jQuery('.abProduct__buy').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery('.notifyMe').show();
                    } else {
                        jQuery('.abProduct__buy').attr('style', 'display:flex;');
                        jQuery('.notifyMe').hide();
                    }
                }
    
                if (varLib[0].available == 'false') {
                    jQuery('.abProduct__buy').attr(
                        'style',
                        'display:none!important;'
                    );
                    jQuery('.notifyMe').show();
                } else {
                    jQuery('.abProduct__buy').attr('style', 'display:flex;');
                    jQuery('.notifyMe').hide();
                }
    
                console.log(varLib);
    
                $('.abProduct__hiddenSelect').on('change', function () {
                    var urlString = window.location.search;
                    var variantID = $(this).val();
                    $('.notifyMe__submit').attr('data-variant', variantID);
                    showCheck(variantID);
                });
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
    
            if ($('#shopify-section-cabinetPDP').length > 0) {
                function showCheck(variantID) {
                    if (
                        varLib.find((x) => x.id === variantID).available == 'false'
                    ) {
                        jQuery('.pdp__buy').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery('.pdp__disclaimer').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery('.notifyMe').show();
                    } else {
                        jQuery('.pdp__buy').attr('style', 'display:block;');
                        jQuery('.pdp__disclaimer').attr('style', 'display:block;');
                        jQuery('.notifyMe').hide();
                    }
                }
    
                if (varLib[0].available == 'false') {
                    jQuery('.pdp__buy').attr('style', 'display:none!important;');
                    jQuery('.pdp__disclaimer').attr(
                        'style',
                        'display:none!important;'
                    );
                    jQuery('.notifyMe').show();
                } else {
                    jQuery('.pdp__buy').attr('style', 'display:block;');
                    jQuery('.pdp__disclaimer').attr('style', 'display:block;');
                    jQuery('.notifyMe').hide();
                }
    
                console.log(varLib);
    
                $('.pdp__options')
                    .find('button')
                    .on('click', function () {
                        var variantID = $('.pdp__options')
                            .find('.active')
                            .attr('data-variant');
                        var productID = $('.pdp__options')
                            .find('.active')
                            .attr('data-id');
                        $('.notifyMe__submit').attr('data-variant', variantID);
                        $('.notifyMe__submit').attr('data-product', productID);
                        showCheck(variantID);
                    });
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
    
            if ($('#shopify-section-smartStoragePDPMulti').length > 0) {
                console.log('varLib: ' + varLibMulti);
                function showCheck(variantID) {
                    if (
                        varLibMulti.find((x) => x.id === variantID).available ==
                        'false'
                    ) {
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .pdp__buy'
                        ).attr('style', 'display:none!important;');
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
                        ).attr('style', 'display:none!important;');
                        $('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .notifyMe'
                        ).show();
                    } else {
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .pdp__buy'
                        ).attr('style', 'display:block;');
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
                        ).attr('style', 'display:block;');
                        $('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
                            'style',
                            'display:block!important;'
                        );
                        jQuery(
                            '#shopify-section-smartStoragePDPMulti .notifyMe'
                        ).hide();
                    }
                }
    
                if (varLibMulti[0].available == 'false') {
                    jQuery('#shopify-section-smartStoragePDPMulti .pdp__buy').attr(
                        'style',
                        'display:none!important;'
                    );
                    jQuery(
                        '#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
                    ).attr('style', 'display:none!important;');
                    $('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
                        'style',
                        'display:none!important;'
                    );
                    jQuery(
                        '#shopify-section-smartStoragePDPMulti .notifyMe'
                    ).show();
                } else {
                    jQuery('#shopify-section-smartStoragePDPMulti .pdp__buy').attr(
                        'style',
                        'display:block;'
                    );
                    jQuery(
                        '#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
                    ).attr('style', 'display:block;');
                    $('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
                        'style',
                        'display:block!important;'
                    );
                    jQuery(
                        '#shopify-section-smartStoragePDPMulti .notifyMe'
                    ).hide();
                }
    
                console.log('$( this ): ' + $(this));
                $(
                    '#shopify-section-smartStoragePDPMulti .pdp__options .group button'
                ).on('click', function () {
                    var variantID = $(this)
                        .closest('.cabPDP')
                        .find('.pdp__options .group .active')
                        .attr('data-variant');
                    var productID = $(this)
                        .closest('.cabPDP')
                        .find('.pdp__options .group .active')
                        .attr('data-id');
                    console.log('variantID: ' + variantID);
                    $(this)
                        .closest('.cabPDP')
                        .find('.notifyMe__submit')
                        .attr('data-variant', variantID);
                    $(this)
                        .closest('.cabPDP')
                        .find('.notifyMe__submit')
                        .attr('data-product', productID);
                    showCheck(variantID);
                });
                // $('.pdp__options').find('button').on('click', function(){
    
                // });
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
    
            if ($('#shopify-section-boxProd').length > 0) {
                function showCheck(variantID) {
                    if (
                        varLib.find((x) => x.id === variantID).available == 'false'
                    ) {
                        jQuery('.boxPDP__buy').attr(
                            'style',
                            'display:none!important;'
                        );
                        jQuery('.notifyMe').show();
                    } else {
                        jQuery('.boxPDP__buy').attr('style', 'display:block;');
                        jQuery('.notifyMe').hide();
                    }
                }
    
                if (varLib[0].available == 'false') {
                    jQuery('.boxPDP__buy').attr('style', 'display:none!important;');
                    jQuery('.notifyMe').show();
                } else {
                    jQuery('.boxPDP__buy').attr('style', 'display:block;');
                    jQuery('.notifyMe').hide();
                }
    
                console.log(varLib);
    
                $('.boxPDP__option').on('click', function () {
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    $('.notifyMe__submit').attr('data-variant', variantID);
                    $('.notifyMe__submit').attr('data-product', productID);
                    showCheck(variantID);
                    $('.pdp__features--box .pdp__featuresContainer').html(
                        $(this).attr('data-features')
                    );
                    $('.pdp__technical--box .nestFaq__drop').html(
                        $(this).attr('data-specs')
                    );
                });
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
    
                $('.boxPDP__colorButton').on('click', function () {
                    var wifiProd = $(this).attr('wifi-product');
                    var wifiVariant = $(this).attr('wifi-id');
                    var wifiAvailable = $(this).attr('wifi-available');
                    var keypadProd = $(this).attr('keypad-product');
                    var keypadVariant = $(this).attr('keypad-id');
                    var keypadAvailable = $(this).attr('keypad-available');
    
                    var wifi = $('.boxPDP__option--wifi');
                    var keypad = $('.boxPDP__option--keypad');
    
                    wifi.attr('data-product', wifiProd);
                    wifi.attr('data-variant', wifiVariant);
                    if (wifiAvailable == 'false') {
                        wifi.addClass('boxPDP__option--unavailable');
                    } else {
                        wifi.removeClass('boxPDP__option--unavailable');
                    }
    
                    keypad.attr('data-product', keypadProd);
                    keypad.attr('data-variant', keypadVariant);
                    if (keypadAvailable == 'false') {
                        keypad.addClass('boxPDP__option--unavailable');
                    } else {
                        keypad.removeClass('boxPDP__option--unavailable');
                    }
    
                    showCheck($('.boxPDP__option--active').attr('data-variant'));
                });
            }
    
            var colorOnly = true;
            $('.product-details-wrapper form')
                .find('.selector-wrapper')
                .each(function () {
                    console.log($(this).find('.color-swatch').length);
                    if ($(this).find('.color-swatch').length == 0) {
                        if ($(this).find('input').length > 1) {
                            colorOnly = false;
                        }
                    }
                });
    
            if (colorOnly && typeof varLib !== 'undefined') {
                var index = 0;
                $('.color-swatch').each(function () {
                    if (varLib[index].available == 'false') {
                        $(this).addClass('color-swatch--unavailable');
                    }
                    index++;
                });
            }
    
            $('.accessCollectionCard__colorButton').on('click', function () {
                if ($(this).attr('data-available') == 'true') {
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__buyButton')
                        .show();
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__notifyButton')
                        .hide();
                } else {
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__buyButton')
                        .hide();
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__notifyButton')
                        .show();
                }
            });
    
            $('.nestProdCard__color').on('click', function () {
                if ($(this).attr('data-available') == 'true') {
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__buyButton')
                        .show();
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__notifyButton')
                        .hide();
                } else {
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__buyButton')
                        .hide();
                    $(this)
                        .parent()
                        .parent()
                        .find('.nestProdCard__notifyButton')
                        .show();
                }
            });
    
            function openNotify(target) {
                target.attr('style', 'max-height:100%;');
            }
    
            function closeNotify(target) {
                target.attr('style', 'max-height:0%;');
            }
    
            $('.nestProdCard__notifyButton').on('click', function () {
                var target = $(this)
                    .parent()
                    .parent()
                    .parent()
                    .find('.prodCardNotify__frame');
                openNotify(target);
                var activeColor = target
                    .parent()
                    .find('.accessCollectionCard__colorButton--active')
                    .attr('color-name');
                var activeVariant = target
                    .parent()
                    .find('.accessCollectionCard__colorButton--active')
                    .attr('data-variant');
                target
                    .find('[data-option="Finish"], [data-option="Color"]')
                    .find('.prodCardNotify__selector')
                    .attr('data-value', activeColor);
                target
                    .find('[data-option="Finish"], [data-option="Color"]')
                    .find('.prodCardNotify__title')
                    .text(activeColor);
                target
                    .find('.prodCardNotify__hiddenSelector')
                    .val(activeVariant)
                    .change();
                target
                    .find('.prodCardNotify__hiddenSelector')
                    .find('[value="' + activeVariant + '"]')
                    .prop('selected', true);
                target
                    .find('.notifyMe__submit ')
                    .attr('data-variant', activeVariant);
            });
    
            $('.prodCardNotify__close').on('click', function () {
                var target = $(this).parent().parent();
                closeNotify(target);
            });
    
            $('.prodCardNotify__selected').on('click', function () {
                $(this).parent().find('.prodCardNotify__slider').slideToggle();
                $(this).parent().toggleClass('prodCardNotify__selector--active');
            });
    
            function changeNotifyVariant(target) {
                var textArray = [];
                target
                    .parent()
                    .find('.prodCardNotify__selector')
                    .each(function () {
                        textArray.push($(this).attr('data-value'));
                    });
                var textString = textArray.join(' / ');
                console.log(textString);
                var button = target.parent().find('.notifyMe__submit');
                var selected = target.find('[data-title="' + textString + '"]');
                var value = selected.attr('value');
                target.val(value).change();
                selected.prop('selected', true);
                button.attr('data-variant', value);
            }
    
            $('.prodCardNotify__choice').on('click', function () {
                $(this).parent().parent().find('.prodCardNotify__slider').slideUp();
                $(this)
                    .parent()
                    .parent()
                    .removeClass('prodCardNotify__selector--active');
                var name = $(this).attr('data-value');
                $(this).parent().parent().attr('data-value', name);
                $(this).parent().parent().find('.prodCardNotify__title').text(name);
                var target = $(this)
                    .parent()
                    .parent()
                    .parent()
                    .parent()
                    .find('.prodCardNotify__hiddenSelector');
                changeNotifyVariant(target);
            });
    
            $('.prodCardNotify__inner .notifyMe__submit').on('click', function (e) {
                e.preventDefault();
                var thisThing = $(this);
                var email = $(this).parent().find('.notifyMe__input').val();
                var variantID = $(this).attr('data-variant');
                var productID = $(this).attr('data-product');
                if (email.includes('@')) {
                    notifyMeCard(email, variantID, productID, thisThing);
                } else {
                    $('.notifyMe__error').show();
                }
            });
    
            $('#shopify-section-sloFeatured')
                .find('.notifyMe__submit')
                .on('click', function (e) {
                    e.preventDefault();
    
                    var email = $(this).parent().find('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $(this)
                            .parent()
                            .parent()
                            .parent()
                            .find('.notifyMe__error')
                            .show();
                    }
                });
    
            $('.sloFeatured__colorButton').on('click', function () {
                var thisThing = $(this);
                var variant = thisThing.attr('data-variant');
                var available = thisThing.attr('data-available');
                $('#shopify-section-sloFeatured')
                    .find('.notifyMe__submit')
                    .attr('data-variant', variant);
                if (available == 'true') {
                    $('#shopify-section-sloFeatured .notifyMe').hide();
                    $(
                        '#shopify-section-sloFeatured .nestProdCard__buttonRow'
                    ).show();
                } else {
                    $('#shopify-section-sloFeatured .notifyMe').show();
                    $(
                        '#shopify-section-sloFeatured .nestProdCard__buttonRow'
                    ).hide();
                }
            });
    
            if (
                $('#shopify-section-al2Product1').length > 0 ||
                $('#shopify-section-hdProduct1').length > 0 ||
                $('#shopify-section-lowesProduct1').length > 0 ||
                $('#shopify-section-costcoProduct1').length > 0 ||
                $('#shopify-section-smartMod-newProd').length > 0 ||
                $('.assureLock2Touch').length > 0 ||
                $('.approachPDP--code').length > 0 ||
                $('.al2Prod--matter2025').length > 0
            ) {
                $('.al2Prod__slider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                });
    
                function addToCart(variant, qty, keyed) {
                    if (checkDiscountLimitFull(variant)) {
                        alert(
                            'You can only order up to ' +
                                $('body').attr('data-qty-limit') * 1 +
                                ' discounted items.'
                        );
                        return;
                    }
                    if (typeof keyed !== 'undefined' && keyed) {
                        CartJS.addItem(
                            variant,
                            qty,
                            { _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
                            {
                                success: function (data, textStatus, jqXHR) {
                                    setTimeout(function () {
                                        updateCart(true);
                                    }, 200);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            }
                        );
                    } else {
                        CartJS.addItem(
                            variant,
                            qty,
                            {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                            {
                                success: function (data, textStatus, jqXHR) {
                                    updateCart(true);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            }
                        );
                    }
                }
    
                if (typeof createLib === 'function') {
                    var libs1 = createLib();
                    console.log(libs1);
                }
                if (typeof createLib2 === 'function') {
                    var libs2 = createLib2();
                    console.log(libs2);
                }
                if (typeof createLib3 === 'function') {
                    var libs3 = createLib3();
                    console.log(libs3);
                }
    
                function colorSetup(target) {
                    $(target)
                        .find('.al2Prod__colorButton')
                        .each(function () {
                            var thisThing = $(this);
                            var fullParent = thisThing.closest('.al2Prod');
                            if (thisThing.attr('data-color') == 'false') {
                                thisThing.hide();
                            } else {
                                thisThing.show();
    
                                if (fullParent.hasClass('al2Prod--1')) {
                                    var ctarget = libs1.colors.find(
                                        (x) =>
                                            x.title === thisThing.attr('data-color')
                                    );
                                } else if (fullParent.hasClass('al2Prod--2')) {
                                    var ctarget = libs2.colors.find(
                                        (x) =>
                                            x.title === thisThing.attr('data-color')
                                    );
                                } else {
                                    var ctarget = libs3.colors.find(
                                        (x) =>
                                            x.title === thisThing.attr('data-color')
                                    );
                                }
    
                                if (ctarget) {
                                    thisThing
                                        .find('.al2Prod__colorButtonInner')
                                        .attr(
                                            'style',
                                            'background-image:url(' +
                                                ctarget.src +
                                                ')'
                                        );
                                }
                            }
                        });
                }
    
                colorSetup('.al2Prod--1');
                colorSetup('.al2Prod--2');
                colorSetup('.al2Prod--3');
    
                function getActiveProductInfo(target) {
                    var prodOption = target
                        .find('.al2Prod__prodButton--active')
                        .attr('data-prod-option');
                    var keyOption = target
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-key-option');
                    var colorOption = target
                        .find('.al2Prod__colorButton--active')
                        .attr('data-color');
                    if (target.hasClass('al2Prod--1')) {
                        var lib = libs1;
                    } else if (target.hasClass('al2Prod--2')) {
                        var lib = libs2;
                    } else {
                        var lib = libs3;
                    }
                    for (i = 0; i < lib.products.length; i++) {
                        var descString = lib.products[i]['prod-desc'].toLowerCase();
                        if (
                            descString == 'viva magenta' &&
                            colorOption == 'Viva Magenta'
                        ) {
                            console.log('viva magenta');
                            var variant = false;
                            variant = lib.products[i].variants[0];
                            if (variant) {
                                var variantId = variant.id;
                                var variantImg = variant.image;
                                var variantPrice = variant.price;
                                var variantAvailable = variant.available;
                                var variantUrl = variant.url;
                                var variantProdId = variant['prod-id'];
                                var variantKeyed = variant.keyedalike;
                            }
                        } else {
                            var optionArray = descString.split(' ');
                            if (
                                prodOption == optionArray[0] &&
                                keyOption == optionArray[1]
                            ) {
                                if (
                                    target.find('.al2Prod__techButton--active')
                                        .length > 0
                                ) {
                                    var techOption = target
                                        .find('.al2Prod__techButton--active')
                                        .attr('data-tech-option');
                                    if (techOption == optionArray[2]) {
                                        var variant = false;
                                        if (
                                            lib.products[i][
                                                'option-one'
                                            ].toLowerCase() == 'finish' ||
                                            lib.products[i][
                                                'option-one'
                                            ].toLowerCase() == 'color'
                                        ) {
                                            var variant = lib.products[
                                                i
                                            ].variants.find(
                                                (x) =>
                                                    x['option-one'] === colorOption
                                            );
                                        } else if (
                                            lib.products[i][
                                                'option-two'
                                            ].toLowerCase() == 'finish' ||
                                            lib.products[i][
                                                'option-two'
                                            ].toLowerCase() == 'color'
                                        ) {
                                            var variant = lib.products[
                                                i
                                            ].variants.find(
                                                (x) =>
                                                    x['option-two'] === colorOption
                                            );
                                        } else {
                                            var variant = lib.products[
                                                i
                                            ].variants.find(
                                                (x) =>
                                                    x['option-three'] ===
                                                    colorOption
                                            );
                                        }
                                        if (variant) {
                                            var variantId = variant.id;
                                            var variantImg = variant.image;
                                            var variantPrice = variant.price;
                                            var variantAvailable =
                                                variant.available;
                                            var variantUrl = variant.url;
                                            var variantProdId = variant['prod-id'];
                                            var variantKeyed = variant.keyedalike;
                                            var variantTitle = false;
                                            var prodHandle = variant['prod-handle'];
                                        }
                                        if ('title' in lib.products[i]) {
                                            variantTitle = lib.products[i].title;
                                        }
                                    }
                                } else {
                                    var variant = false;
                                    if (
                                        lib.products[i][
                                            'option-one'
                                        ].toLowerCase() == 'finish' ||
                                        lib.products[i][
                                            'option-one'
                                        ].toLowerCase() == 'color'
                                    ) {
                                        var variant = lib.products[i].variants.find(
                                            (x) => x['option-one'] === colorOption
                                        );
                                    } else if (
                                        lib.products[i][
                                            'option-two'
                                        ].toLowerCase() == 'finish' ||
                                        lib.products[i][
                                            'option-two'
                                        ].toLowerCase() == 'color'
                                    ) {
                                        var variant = lib.products[i].variants.find(
                                            (x) => x['option-two'] === colorOption
                                        );
                                    } else {
                                        var variant = lib.products[i].variants.find(
                                            (x) => x['option-three'] === colorOption
                                        );
                                    }
                                    if (variant) {
                                        var variantId = variant.id;
                                        var variantImg = variant.image;
                                        var variantPrice = variant.price;
                                        var variantAvailable = variant.available;
                                        var variantUrl = variant.url;
                                        var variantProdId = variant['prod-id'];
                                        var variantKeyed = variant.keyedalike;
                                        var variantTitle = false;
                                        var prodHandle = variant['prod-handle'];
                                    }
                                    if ('title' in lib.products[i]) {
                                        variantTitle = lib.products[i].title;
                                    }
                                }
                            }
                            /*
                else{
                  var variant = false;
                  if (lib.products[i]['option-one'].toLowerCase() == 'finish' || lib.products[i]['option-one'].toLowerCase() == 'color'){
                    var variant = lib.products[i].variants.find(x => x['option-one'] === colorOption );
                  }
                  else if (lib.products[i]['option-two'].toLowerCase() == 'finish' || lib.products[i]['option-two'].toLowerCase() == 'color'){
                    var variant = lib.products[i].variants.find(x => x['option-two'] === colorOption );
                  }
                  else{
                    var variant = lib.products[i].variants.find(x => x['option-three'] === colorOption );
                  }
                  if (variant){
                    var variantId = variant.id;
                    var variantImg = variant.image;
                    var variantPrice = variant.price;
                    var variantAvailable = variant.available;
                    var variantUrl = variant.url;
                    var variantProdId = variant['prod-id'];
                    var variantKeyed = variant.keyedalike;
                  }
                }
                */
                        }
                    }
                    if (variant) {
                        var selectedProductInfo = {
                            productHandle: prodHandle,
                            productOption: prodOption,
                            keyOption: keyOption,
                            color: colorOption,
                            id: variantId,
                            image: variantImg,
                            price: variantPrice,
                            available: variantAvailable,
                            url: variantUrl,
                            prodId: variantProdId,
                            keyedalike: variantKeyed,
                        };
                        if (
                            target.find('.al2Prod__techButton--active').length > 0
                        ) {
                            selectedProductInfo['techOption'] = target
                                .find('.al2Prod__techButton--active')
                                .attr('data-tech-option');
                        }
                        if (variantTitle) {
                            selectedProductInfo['title'] = variantTitle;
                        }
                    } else {
                        var selectedProductInfo = false;
                    }
    
                    if (selectedProductInfo) {
                        fetch(
                            window.Shopify.routes.root +
                                'products/' +
                                prodHandle +
                                '.js'
                        )
                            .then((response) => response.json())
                            .then(
                                (product) =>
                                    function () {
                                        window.dataLayer.push({ ecommerce: null });
                                        window.dataLayer.push({
                                            event: 'view_item',
                                            fired_from: 'shopify',
                                            ecommerce: {
                                                currency: 'USD',
                                                value: product.price,
                                                items: [
                                                    {
                                                        item_id: product.id,
                                                        item_name: product.title,
                                                        item_brand: product.vendor,
                                                        item_category: product.type,
                                                        item_variant:
                                                            product.variants[0]
                                                                .title,
                                                        item_variant_id:
                                                            product.variants[0].sku,
                                                        price: product.price,
                                                        quantity: 1,
                                                    },
                                                ],
                                            },
                                        });
                                    }
                            );
                    }
    
                    return selectedProductInfo;
                }
    
                function preloadImage(url) {
                    var img = new Image();
                    img.src = url;
                }
    
                if (typeof createLib === 'function') {
                    for (i = 0; i < libs1.images.length; i++) {
                        preloadImage(libs1.images[i].src);
                        preloadImage(libs1.images[i].srcBlack);
                        preloadImage(libs1.images[i].srcBronze);
                        preloadImage(libs1.images[i].srcAsh);
                        preloadImage(libs1.images[i].srcBrass);
                preloadImage(libs1.images[i].srcSnow);
                    }
                }
    
                if (typeof createLib2 === 'function') {
                    for (i = 0; i < libs2.images.length; i++) {
                        preloadImage(libs2.images[i].src);
                        preloadImage(libs2.images[i].srcBlack);
                        preloadImage(libs2.images[i].srcBronze);
                        preloadImage(libs2.images[i].srcAsh);
                        preloadImage(libs2.images[i].srcBrass);
                preloadImage(libs2.images[i].srcSnow);
                    }
                }
    
                if (typeof createLib3 === 'function' && libs3 != false) {
                    for (i = 0; i < libs3.images.length; i++) {
                        preloadImage(libs3.images[i].src);
                        preloadImage(libs3.images[i].srcBlack);
                        preloadImage(libs3.images[i].srcBronze);
                        preloadImage(libs3.images[i].srcAsh);
                        preloadImage(libs3.images[i].srcBrass);
                preloadImage(libs3.images[i].srcSnow);
                    }
                }
    
                $(document).on('click change', '.pdpKA__checkbox', function () {
                    console.log("clicked the checkbox");
    
                    var count = 0;
    
                    if (CartJS.cart.items.length > 0){
    
                        if (window.CartJS && CartJS.cart && CartJS.cart.items) {
                            for (let i = 0; i < CartJS.cart.items.length; i++) {
                            if (CartJS.cart.items[i].properties && CartJS.cart.items[i].properties['_keyed_alike_available'] === 'true') {
                                count += 1; // or += CartJS.cart.items[i].quantity;
                            }
                            }
                        }
    
                        console.log(count);
    
                        if (count === 0) {
                            $('.pdpKA__checkbox').prop('checked', false);
                            $('.pdpKA--assureLanding').hide();
                        }
                    }
                    
                });
    
                function setActiveProduct(target, activeProduct) {
                    if (activeProduct == 'false' || activeProduct == false) {
                        console.log('error - no active product found');
                        return false;
                    }
                    if (target.hasClass('al2Prod--1')) {
                        var lib = libs1;
                    } else if (target.hasClass('al2Prod--2')) {
                        var lib = libs2;
                    } else {
                        var lib = libs3;
                    }
    
                    console.log(lib.images);
    
                    var matchString =
                        activeProduct.productOption + '/' + activeProduct.keyOption;
                    
                        console.log(matchString);
    
                    for (i = 0; i < lib.images.length; i++) {
                        if (lib.images[i].product == matchString) {
                            console.log(lib.images[i]);
                            if (lib.images[i].order == '1') {
                                //target.find('[data-order="1"]').find('img').attr('src', lib.images[i].src);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-silver', lib.images[i].src);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-bronze', lib.images[i].srcBronze);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-magenta', lib.images[i].srcMagenta);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-brass', lib.images[i].srcBrass);
                            } else if (lib.images[i].order == '2') {
                                //target.find('[data-order="2"]').find('img').attr('src', lib.images[i].src);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-silver', lib.images[i].src);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-bronze', lib.images[i].srcBronze);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-magenta', lib.images[i].srcMagenta);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-brass', lib.images[i].srcBrass);
                            } else if (lib.images[i].order == '3') {
                                //target.find('[data-order="3"]').find('img').attr('src', lib.images[i].src);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-silver', lib.images[i].src);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-bronze', lib.images[i].srcBronze);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-magenta', lib.images[i].srcMagenta);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-brass', lib.images[i].srcBrass);
                            } else {
                                //target.find('[data-order="4"]').find('img').attr('src', lib.images[i].src);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-silver', lib.images[i].src);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-bronze', lib.images[i].srcBronze);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-magenta', lib.images[i].srcMagenta);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-brass', lib.images[i].srcBrass);
                            }
                        }
                    }
    
                    target.find('.al2Prod__finishName').text(activeProduct.color);
    
                    if (activeProduct.color == 'Bronze') {
                        target
                            .find('.al2Prod__finishName')
                            .text('Oil Rubbed Bronze');
                    }
    
                    if (
                        $('.approachPDP').length > 0 &&
                        $('.approachPDP--code').length <= 0
                    ) {
                        if (activeProduct.color == 'Satin Nickel') {
                            target.find('.al2Prod__finishName').text('Silver');
                        }
                    }
    
                    var formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    });
                    var formatPrice = (activeProduct.price / 100).toFixed(2);
                    var price = formatter.format(formatPrice);
                    target.find('.al2Prod__price').text(price);
                    target
                        .find('.al2Prod__buyButton')
                        .attr('data-id', activeProduct.id);
                    target
                        .find('.al2Prod__buyButton')
                        .attr('data-keyed', activeProduct.keyedalike);
    
                    if ('title' in activeProduct) {
                        var textTitle = activeProduct.title;
                        target.find('.al2Prod__title').text(textTitle);
                    }
    
                    if (
                        target
                            .find('[data-key-option="keyed"]')
                            .hasClass('al2Prod__keyOptionButton--active')
                    ) {
                        target.find('.al2Prod__accessCard--key').show();
                    } else {
                        target.find('.al2Prod__accessCard--key').hide();
                    }
                    target.find('.smartPDP__learn').attr('href', activeProduct.url);
    
                    target
                        .closest('.al2Prod')
                        .find('.notifyMe__submit')
                        .attr('data-variant', activeProduct.id);
                    target
                        .closest('.al2Prod')
                        .find('.notifyMe__submit')
                        .attr('data-product', activeProduct.prodId);
                    console.log(activeProduct);
    
                    if (activeProduct.available == 'false') {
                        target
                            .find('.al2Prod__buyButton')
                            .addClass('al2Prod__buyButton--soldOut')
                            .text('Sold Out');
                        target.find('.smartPDP__buyWrapper').hide();
                        target
                            .find('.al2Prod__buyButtonRow')
                            .addClass('al2Prod__buyButtonRow--soldOut');
                        target.closest('.al2Prod').find('.notifyMe').slideDown();
                        target
                            .find('.al2Prod__learnButton')
                            .attr('style', 'margin-left:0;margin-bottom:15px;');
                    } else {
                        target
                            .find('.al2Prod__buyButton')
                            .removeClass('al2Prod__buyButton--soldOut')
                            .text('Buy Now');
                        target.find('.smartPDP__buyWrapper').show();
                        target
                            .find('.al2Prod__buyButtonRow')
                            .removeClass('al2Prod__buyButtonRow--soldOut');
                        target.closest('.al2Prod').find('.notifyMe').slideUp();
                        target.find('.al2Prod__learnButton').attr('style', '');
                    }
                }
    
                $('.al2Prod').each(function () {
                    var thisThing = $(this);
                    var selectedProduct = getActiveProductInfo(thisThing);
                    setActiveProduct(thisThing, selectedProduct);
                    //showCheck(thisThing);
                });
    
                $('.al2Prod__colorButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__colorButton')
                        .removeClass('al2Prod__colorButton--active');
                    thisThing.addClass('al2Prod__colorButton--active');
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    var targets = thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__slideImg');
                    targets.each(function(){
                        if (thisThing.attr('data-color').toLowerCase().indexOf('black') >= 0){
                            $(this).attr('src', $(this).attr('src-black'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('bronze') >= 0){
                            $(this).attr('src', $(this).attr('src-bronze'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('silver') >= 0 || thisThing.attr('data-color').toLowerCase().indexOf('nickel') >= 0){
                            $(this).attr('src', $(this).attr('src-silver'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('magenta') >= 0){
                            $(this).attr('src', $(this).attr('src-magenta'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('snow') >= 0){
                            $(this).attr('src', $(this).attr('src-snow'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('ash') >= 0){
                            $(this).attr('src', $(this).attr('src-ash'));
                        }
                        else if (thisThing.attr('data-color').toLowerCase().indexOf('brass') >= 0){
                            $(this).attr('src', $(this).attr('src-brass'));
                        }
                    });
                });
    
                $('.al2Prod__prodButton').on('click', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    //change active class
                    thisThing
                        .parent()
                        .find('.al2Prod__prodButton')
                        .removeClass('al2Prod__prodButton--active');
                    thisThing.addClass('al2Prod__prodButton--active');
    
                    //show magenta color on some, hide on others
                    parentContainer.find('.al2Prod__colorButton[data-color="Viva Magenta"]').hide();
    
                    //set the active product for the buy code
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
    
                    if (thisThing.attr('data-prod-option') === 'bluetooth') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-bluetooth');
                        parentContainer.find('.al2Prod__list').html(newHtml);
    
                        parentContainer.find('.al2Prod__accessCard--wifi').hide();
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .hide();
                        $('.assure-works').slideUp();
    
                        if ($('.approachPDP').length > 0) {
                            if ($('.approachPDP--keypad').length > 0) {
                                if (
                                    $('[data-key-option="key-free"]').hasClass(
                                        'al2Prod__keyOptionButton--active'
                                    )
                                ) {
                                    var newHtmlTwo = parentContainer
                                        .find('.al2Prod__techContent')
                                        .attr('data-bluetooth');
                                    parentContainer
                                        .find('.al2Prod__techContent')
                                        .html(newHtmlTwo);
                                } else {
                                    var newHtmlTwo = parentContainer
                                        .find('.al2Prod__techContent')
                                        .attr('data-touchpad');
                                    parentContainer
                                        .find('.al2Prod__techContent')
                                        .html(newHtmlTwo);
                                }
                            } else {
                                var newHtmlTwo = parentContainer
                                    .find('.al2Prod__techContent')
                                    .attr('data-bluetooth');
                                parentContainer
                                    .find('.al2Prod__techContent')
                                    .html(newHtmlTwo);
                            }
                        }
                    } else if (thisThing.attr('data-prod-option') === 'wifi') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-wifi');
                        parentContainer.find('.al2Prod__list').html(newHtml);
                        if ($('.approachPDP').length > 0) {
                            var newHtmlTwo = parentContainer
                                .find('.al2Prod__techContent')
                                .attr('data-wifi');
                            parentContainer
                                .find('.al2Prod__techContent')
                                .html(newHtmlTwo);
                        }
                        parentContainer.find('.al2Prod__accessCard--wifi').show();
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .show();
                        $('.assure-works').slideDown();
                    }
                });
    
                $('.al2Prod__colorButton[data-color="Viva Magenta"]').hide();
    
                $('#shopify-section-hdProduct1')
                    .find('.al2Prod__colorButton--active')
                    .click();
    
                $('.al2Prod__keyOptionButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__keyOptionButton')
                        .removeClass('al2Prod__keyOptionButton--active');
                    thisThing.addClass('al2Prod__keyOptionButton--active');
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    if (
                        parentContainer.find(
                            '.al2Prod__colorButton[data-color="Viva Magenta"]'
                        ).length > 0
                    ) {
                        if (
                            parentContainer
                                .find('.al2Prod__techButton--active')
                                .attr('data-tech-option') == 'wifi' &&
                            parentContainer
                                .find('.al2Prod__keyOptionButton--active')
                                .attr('data-key-option') == 'key-free' &&
                            parentContainer
                                .find('.al2Prod__prodButton--active')
                                .attr('data-prod-option') == 'touchscreen'
                        ) {
                            parentContainer
                                .find(
                                    '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                )
                                .show();
                        } else {
                            parentContainer
                                .find(
                                    '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                )
                                .hide();
                            if (
                                parentContainer
                                    .find(
                                        '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                    )
                                    .hasClass('al2Prod__colorButton--active')
                            ) {
                                parentContainer
                                    .find('.al2Prod__colorButton')
                                    .removeClass('al2Prod__colorButton--active');
                                parentContainer
                                    .find('.al2Prod__colorButton')
                                    .first()
                                    .addClass('al2Prod__colorButton--active');
                            }
                        }
                    }
    
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
                });
    
                $('.al2Prod__keyOptionButton').on('mousedown', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
    
                    if ($('.approachPDP').length > 0) {
                        console.log('mouseup');
                        if ($(this).attr('data-key-option') == 'key-free') {
                            var newHtml = parentContainer
                                .find('.al2Prod__list')
                                .attr('data-bluetooth');
                            parentContainer.find('.al2Prod__list').html(newHtml);
                            var newHtmlTwo = parentContainer
                                .find('.al2Prod__techContent')
                                .attr('data-bluetooth');
                            parentContainer
                                .find('.al2Prod__techContent')
                                .html(newHtmlTwo);
                        } else {
                            var newHtml = parentContainer
                                .find('.al2Prod__list')
                                .attr('data-touchpad');
                            parentContainer.find('.al2Prod__list').html(newHtml);
                            var newHtmlTwo = parentContainer
                                .find('.al2Prod__techContent')
                                .attr('data-touchpad');
                            parentContainer
                                .find('.al2Prod__techContent')
                                .html(newHtmlTwo);
                        }
                    }
                });
    
                $('.al2Prod__techButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__techButton')
                        .removeClass('al2Prod__techButton--active');
                    thisThing.addClass('al2Prod__techButton--active');
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    if (
                        parentContainer.find(
                            '.al2Prod__colorButton[data-color="Viva Magenta"]'
                        ).length > 0
                    ) {
                        if (
                            parentContainer
                                .find('.al2Prod__techButton--active')
                                .attr('data-tech-option') == 'wifi' &&
                            parentContainer
                                .find('.al2Prod__keyOptionButton--active')
                                .attr('data-key-option') == 'key-free' &&
                            parentContainer
                                .find('.al2Prod__prodButton--active')
                                .attr('data-prod-option') == 'touchscreen'
                        ) {
                            parentContainer
                                .find(
                                    '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                )
                                .show();
                        } else {
                            parentContainer
                                .find(
                                    '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                )
                                .hide();
                            if (
                                parentContainer
                                    .find(
                                        '.al2Prod__colorButton[data-color="Viva Magenta"]'
                                    )
                                    .hasClass('al2Prod__colorButton--active')
                            ) {
                                parentContainer
                                    .find('.al2Prod__colorButton')
                                    .removeClass('al2Prod__colorButton--active');
                                parentContainer
                                    .find('.al2Prod__colorButton')
                                    .first()
                                    .addClass('al2Prod__colorButton--active');
                            }
                        }
                    }
    
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    if (thisThing.attr('data-tech-option') === 'bluetooth') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-bluetooth');
                        parentContainer.find('.al2Prod__list').html(newHtml);
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .hide();
                    } else if (thisThing.attr('data-tech-option') === 'wifi') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-wifi');
                        parentContainer.find('.al2Prod__list').html(newHtml);
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .show();
                    }
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
                });
    
                $('.smartPDP__qtyBox input').on('change', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    showCheck(parentContainer);
                });
    
                var CartJSInterval = setInterval(function () {
                    if (typeof CartJS.cart.items !== 'undefined') {
                        $('.al2Prod').each(function () {
                            var thisThing = $(this);
                            showCheck(thisThing);
                        });
                        clearInterval(CartJSInterval);
                    }
                }, 10);
    
                function showCheck(targetSection) {
                    var keyed = targetSection
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-key-option');
                    var selectedType = targetSection
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-type');
                    if ($('.approachPDP--code').length > 0) {
                        keyed = 'keyed';
                        selectedType = 'Smart Lock';
                    }
    
                    //show-hide keyed alike box
                    if (keyed == 'keyed') {
                        var count = 0;
                        var type = 0;
                        for (i = 0; i < CartJS.cart.items.length; i++) {
                            if (
                                CartJS.cart.items[i].properties[
                                    '_keyed_alike_available'
                                ] == 'true'
                            ) {
                                var qty = CartJS.cart.items[i].quantity;
                                count += 1;
                            }
                            if (type == '') {
                                if (
                                    CartJS.cart.items[i].properties[
                                        '_keyed_alike_group'
                                    ] > 0
                                ) {
                                    type = CartJS.cart.items[i].product_type;
                                }
                            }
                        }
    
                        if (type == '' || compareProdTypes(selectedType, type)) {
                            if (targetSection.find('.smartPDP__qty').val() > 1) {
                                targetSection.find('.pdpKA--assureLanding').show();
                                targetSection
                                    .find('.pdpKA--assureLanding')
                                    .attr('data-type', selectedType);
                            } else if (count > 0) {
                                targetSection.find('.pdpKA--assureLanding').show();
                                targetSection
                                    .find('.pdpKA--assureLanding')
                                    .attr('data-type', selectedType);
                            } else {
                                targetSection.find('.pdpKA--assureLanding').hide();
                                targetSection
                                    .find('.pdpKA__checkbox')
                                    .prop('checked', false);
                            }
                        } else {
                            targetSection.find('.pdpKA--assureLanding').hide();
                            targetSection
                                .find('.pdpKA__checkbox')
                                .prop('checked', false);
                        }
                    } else {
                        targetSection.find('.pdpKA--assureLanding').hide();
                        targetSection
                            .find('.pdpKA__checkbox')
                            .prop('checked', false);
                    }
                }
    
                $('.pdpKAPop__continueButton').on('click', function () {
                    var itemsToGroup = [];
                    var newKAItemCount = 0;
                    var type = '';
                    type = $(this)
                        .closest('.shopify-section')
                        .find('.pdpKA__inner')
                        .parent()
                        .attr('data-type');
    
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties[
                                '_keyed_alike_available'
                            ] == 'true'
                        ) {
                            if (
                                compareProdTypes(
                                    CartJS.cart.items[i].product_type,
                                    type
                                )
                            ) {
                                itemsToGroup.push({
                                    id: CartJS.cart.items[i].id,
                                    quantity: CartJS.cart.items[i].quantity,
                                    properties: {
                                        _name: 'keyed_alike_group',
                                        _value: 1,
                                        _keyed_alike_group: 1,
                                        _keyed_alike_available: 'true',
                                        _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                    },
                                });
                                newKAItemCount += CartJS.cart.items[i].quantity * 1;
                            }
                        }
                    }
    
                    for (j = 0; j < itemsToGroup.length; j++) {
                        CartJS.removeItemById(itemsToGroup[j].id);
                    }
    
                    itemsToGroup.push({
                        id: 32146864832644,
                        quantity: newKAItemCount,
                        properties: {
                            _groups: 1,
                            _page_added: window.location.href,
                        },
                    });
    
                    CartJS.addItems(itemsToGroup, {
                        success: function (data, textStatus, jqXHR) {
                            updateCart(true);
                            $('.pdpKAPop').fadeOut();
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    });
                });
    
                $('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
                    'click',
                    function () {
                        $('.pdpKAPop').fadeOut();
                    }
                );
    
                function newKeyedSkipPopup(reference) {
                    var groupCount = 0;
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties['_name'] ==
                            'keyed_alike_group'
                        ) {
                            var qty = CartJS.cart.items[i].quantity;
                            groupCount += 1;
                        }
                        if (CartJS.cart.items[i].properties['_groups'] * 1 > 1) {
                            $('.pdpKAPop__addToExisting').hide();
                        }
                    }
                    console.log(groupCount);
                    if (groupCount > 0) {
                        $('.pdpKAPop__inner--existing').show();
                        $('.pdpKAPop__inner--new').hide();
                        reference
                            .closest('.shopify-section')
                            .find('.pdpKAPop')
                            .show();
                    } else {
                        if (
                            $('#cartDrawer').find(
                                '.cart-item[data-variant-id="32146864832644"]'
                            ).length > 0
                        ) {
                            console.log('there is already a key in the cart');
                        } else {
                            var _itemsToGroup = [];
                            var _newKAItemCount = 0;
                            var firstType = '';
                            for (i = 0; i < CartJS.cart.items.length; i++) {
                                if (i == 0) {
                                    firstType =
                                        CartJS.cart.items[i]['product_type'];
                                }
                                if (
                                    CartJS.cart.items[i].properties[
                                        '_keyed_alike_available'
                                    ] == 'true'
                                ) {
                                    if (
                                        compareProdTypes(
                                            CartJS.cart.items[i]['product_type'],
                                            firstType
                                        )
                                    ) {
                                        _itemsToGroup.push({
                                            id: CartJS.cart.items[i].id,
                                            quantity: CartJS.cart.items[i].quantity,
                                            properties: {
                                                _name: 'keyed_alike_group',
                                                _value: 1,
                                                _keyed_alike_group: 1,
                                                _keyed_alike_available: 'true',
                                                _type: firstType,
                                                _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                            },
                                        });
                                        _newKAItemCount +=
                                            CartJS.cart.items[i].quantity * 1;
                                    }
                                }
                            }
    
                            for (j = 0; j < _itemsToGroup.length; j++) {
                                CartJS.removeItemById(_itemsToGroup[j].id);
                            }
    
                            _itemsToGroup.push({
                                id: 32146864832644,
                                quantity: _newKAItemCount,
                                properties: {
                                    _groups: 1,
                                    _type: firstType,
                                    _page_added: window.location.href,
                                },
                            });
    
                            console.log('about');
                            CartJS.addItems(_itemsToGroup, {
                                success: function (data, textStatus, jqXHR) {
                                    updateCart(true);
                                    $('.pdpKAPop').fadeOut();
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            });
                        }
    
                        /*
              $('.pdpKAPop__inner--existing').hide();
              $('.pdpKAPop__inner--new').show();
              */
                    }
                }
    
                $('.al2Prod__buyButton').on('click', function () {
                    var oldCart = CartJS.cart.item_count * 1;
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    if ($(this).hasClass('al2Prod__buyButton--soldOut')) {
                    } else {
                        var varId = $(this).attr('data-id') * 1;
                        var qty = $(this)
                            .closest('.al2Prod__buyButtonRow')
                            .find('.smartPDP__qty')
                            .val();
                        if ($(this).attr('data-keyed') == 'true') {
                            addToCart(varId, qty, true);
                            if (
                                parentContainer
                                    .find('.pdpKA__checkbox')
                                    .prop('checked')
                            ) {
                                var keyCartWatch = setInterval(function () {
                                    if (CartJS.cart.item_count != oldCart) {
                                        newKeyedSkipPopup(thisThing);
                                        clearInterval(keyCartWatch);
                                    }
                                }, 50);
                            }
                        } else {
                            addToCart(varId, qty);
                        }
                    }
                });
    
                $('.al2Prod__accessButton').on('click', function () {
                    if ($(this).hasClass('al2Prod__accessButton--active')) {
                        $(this).removeClass('al2Prod__accessButton--active');
                        $(this).parent().find('.al2Prod__accessShelf').slideUp();
                    } else {
                        $(this).addClass('al2Prod__accessButton--active');
                        $(this).parent().find('.al2Prod__accessShelf').slideDown();
                    }
                });
    
                $('.al2Prod__techTitleButton').on('click', function () {
                    if ($(this).hasClass('al2Prod__techTitleButton--active')) {
                        $(this).removeClass('al2Prod__techTitleButton--active');
                        $(this).parent().find('.al2Prod__techShelf').slideUp();
                    } else {
                        $(this).addClass('al2Prod__techTitleButton--active');
                        $(this).parent().find('.al2Prod__techShelf').slideDown();
                    }
                });
    
                $('.al2App__button').each(function () {
                    preloadImage($(this).attr('data-image'));
                });
    
                $('.al2App__button').on('click', function () {
                    $(this)
                        .parent()
                        .find('.al2App__button')
                        .removeClass('al2App__button--active');
                    $(this).addClass('al2App__button--active');
    
                    var imgSrc = $(this).attr('data-image');
                    $('.al2App__image').attr('src', imgSrc);
                });
    
                $('.al2MobApp__topSlider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    asNavFor: '.al2MobApp__bottomSlider',
                });
    
                $('.al2MobApp__bottomSlider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    dots: false,
                    asNavFor: '.al2MobApp__topSlider',
                });
    
                $('.al2MobTable__dropTitle').on('click', function () {
                    var target = $(this).parent();
                    if (target.hasClass('al2MobTable__dropWrapper--active')) {
                        target.removeClass('al2MobTable__dropWrapper--active');
                        target.find('.al2MobTable__dropShelf').slideUp();
                    } else {
                        target.addClass('al2MobTable__dropWrapper--active');
                        target.find('.al2MobTable__dropShelf').slideDown();
                    }
                });
                $('.al2MobTable__dropOption').on('click', function () {
                    var newText = $(this).text();
                    var dataType = $(this).attr('data-type');
                    var target = $(this).closest('.al2MobTable__dropWrapper');
                    target.removeClass('al2MobTable__dropWrapper--active');
                    target.find('.al2MobTable__dropShelf').slideUp();
                    target.find('.al2MobTable__dropTitle span').text(newText);
                    if (target.hasClass('al2MobTable__dropWrapper--left')) {
                        $('.al2MobTable__cell--left').each(function () {
                            if (dataType == 'standard') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-standard'));
                            } else if (dataType == 'wifi') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-wifi'));
                            } else {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-zwave'));
                            }
                        });
                    } else {
                        $('.al2MobTable__cell--right').each(function () {
                            if (dataType == 'standard') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-standard'));
                            } else if (dataType == 'wifi') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-wifi'));
                            } else {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-zwave'));
                            }
                        });
                    }
                });
    
                $('.al2Prod--2')
                    .find('.al2Prod__keyOptionButton[data-key-option="key-free"]')
                    .click();
            }
    
            if ($('.al2Prod--matter2025').length > 0) {
                $('.al2Prod__slider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                });
    
                function addToCart(variant, qty, keyed) {
                    if (checkDiscountLimitFull(variant)) {
                        alert(
                            'You can only order up to ' +
                                $('body').attr('data-qty-limit') * 1 +
                                ' discounted items.'
                        );
                        return;
                    }
                    if (typeof keyed !== 'undefined' && keyed) {
                        CartJS.addItem(
                            variant,
                            qty,
                            { _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
                            {
                                success: function (data, textStatus, jqXHR) {
                                    setTimeout(function () {
                                        updateCart(true);
                                    }, 200);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            }
                        );
                    } else {
                        CartJS.addItem(
                            variant,
                            qty,
                            {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                            {
                                success: function (data, textStatus, jqXHR) {
                                    updateCart(true);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            }
                        );
                    }
                }
    
                if (typeof createLib === 'function') {
                    var libs1 = createLib();
                    console.log(libs1);
                }
    
                function colorSetup(target) {
                    $(target)
                        .find('.al2Prod__colorButton')
                        .each(function () {
                            var thisThing = $(this);
                            var fullParent = thisThing.closest('.al2Prod');
                            if (thisThing.attr('data-color') == 'false') {
                                thisThing.hide();
                            } else {
                                thisThing.show();
                                var ctarget = libs1.colors.find(
                                    (x) => x.title === thisThing.attr('data-color')
                                );
    
                                if (ctarget) {
                                    thisThing
                                        .find('.al2Prod__colorButtonInner')
                                        .attr(
                                            'style',
                                            'background-image:url(' +
                                                ctarget.src +
                                                ')'
                                        );
                                }
                            }
                        });
                }
    
                colorSetup('.al2Prod--1');
    
                function getActiveProductInfo(target) {
                    var prodOption = target
                        .find('.al2Prod__prodButton--active')
                        .attr('data-prod-option');
                    var keyOption = target
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-key-option');
                    var colorOption = target
                        .find('.al2Prod__colorButton--active')
                        .attr('data-color');
                    if (target.hasClass('al2Prod--1')) {
                        var lib = libs1;
                    } else if (target.hasClass('al2Prod--2')) {
                        var lib = libs2;
                    } else {
                        var lib = libs3;
                    }
                    for (i = 0; i < lib.products.length; i++) {
                        var descString = lib.products[i]['prod-desc'].toLowerCase();
    
                        var optionArray = descString.split(' ');
                        if (
                            prodOption == optionArray[0] &&
                            keyOption == optionArray[1]
                        ) {
                            var variant = false;
                            if (
                                lib.products[i]['option-one'].toLowerCase() ==
                                    'finish' ||
                                lib.products[i]['option-one'].toLowerCase() ==
                                    'color'
                            ) {
                                var variant = lib.products[i].variants.find(
                                    (x) => x['option-one'] === colorOption
                                );
                            } else if (
                                lib.products[i]['option-two'].toLowerCase() ==
                                    'finish' ||
                                lib.products[i]['option-two'].toLowerCase() ==
                                    'color'
                            ) {
                                var variant = lib.products[i].variants.find(
                                    (x) => x['option-two'] === colorOption
                                );
                            } else {
                                var variant = lib.products[i].variants.find(
                                    (x) => x['option-three'] === colorOption
                                );
                            }
                            if (variant) {
                                var variantId = variant.id;
                                var variantImg = variant.image;
                                var variantPrice = variant.price;
                                var variantAvailable = variant.available;
                                var variantUrl = variant.url;
                                var variantProdId = variant['prod-id'];
                                var variantKeyed = variant.keyedalike;
                                var variantTitle = false;
                                var prodHandle = variant['prod-handle'];
                            }
                            if ('title' in lib.products[i]) {
                                variantTitle = lib.products[i].title;
                            }
                        }
                    }
                    if (variant) {
                        var selectedProductInfo = {
                            productHandle: prodHandle,
                            productOption: prodOption,
                            keyOption: keyOption,
                            color: colorOption,
                            id: variantId,
                            image: variantImg,
                            price: variantPrice,
                            available: variantAvailable,
                            url: variantUrl,
                            prodId: variantProdId,
                            keyedalike: variantKeyed,
                        };
                        if (
                            target.find('.al2Prod__techButton--active').length > 0
                        ) {
                            selectedProductInfo['techOption'] = target
                                .find('.al2Prod__techButton--active')
                                .attr('data-tech-option');
                        }
                        if (variantTitle) {
                            selectedProductInfo['title'] = variantTitle;
                        }
                    } else {
                        var selectedProductInfo = false;
                    }
    
                    if (selectedProductInfo) {
                        fetch(
                            window.Shopify.routes.root +
                                'products/' +
                                prodHandle +
                                '.js'
                        )
                            .then((response) => response.json())
                            .then(
                                (product) =>
                                    function () {
                                        window.dataLayer.push({ ecommerce: null });
                                        window.dataLayer.push({
                                            event: 'view_item',
                                            fired_from: 'shopify',
                                            ecommerce: {
                                                currency: 'USD',
                                                value: product.price,
                                                items: [
                                                    {
                                                        item_id: product.id,
                                                        item_name: product.title,
                                                        item_brand: product.vendor,
                                                        item_category: product.type,
                                                        item_variant:
                                                            product.variants[0]
                                                                .title,
                                                        item_variant_id:
                                                            product.variants[0].sku,
                                                        price: product.price,
                                                        quantity: 1,
                                                    },
                                                ],
                                            },
                                        });
                                    }
                            );
                    }
    
                    return selectedProductInfo;
                }
    
                function preloadImage(url) {
                    var img = new Image();
                    img.src = url;
                }
    
                if (typeof createLib === 'function') {
                    for (i = 0; i < libs1.images.length; i++) {
                        preloadImage(libs1.images[i].srcSnow);
                        preloadImage(libs1.images[i].srcBlack);
                        preloadImage(libs1.images[i].srcAsh);
                    }
                }
    
                function setActiveProduct(target, activeProduct) {
                    if (activeProduct == 'false' || activeProduct == false) {
                        console.log('error - no active product found');
                        return false;
                    }
                    var lib = libs1;
    
                    console.log(lib.images);
    
                    var matchString =
                        activeProduct.productOption + '/' + activeProduct.keyOption;
    
                    for (i = 0; i < lib.images.length; i++) {
                        if (lib.images[i].product == matchString) {
                            if (lib.images[i].order == '1') {
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-snow', lib.images[i].srcSnow);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="1"]')
                                    .find('img')
                                    .attr('src-ash', lib.images[i].srcAsh);
                            } else if (lib.images[i].order == '2') {
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-snow', lib.images[i].srcSnow);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="2"]')
                                    .find('img')
                                    .attr('src-ash', lib.images[i].srcAsh);
                            } else if (lib.images[i].order == '3') {
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-snow', lib.images[i].srcSnow);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="3"]')
                                    .find('img')
                                    .attr('src-ash', lib.images[i].srcAsh);
                            } else {
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-snow', lib.images[i].srcSnow);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-black', lib.images[i].srcBlack);
                                target
                                    .find('[data-order="4"]')
                                    .find('img')
                                    .attr('src-ash', lib.images[i].srcAsh);
                            }
                        }
                    }
    
                    target.find('.al2Prod__finishName').text(activeProduct.color);
    
                    var formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    });
                    var formatPrice = (activeProduct.price / 100).toFixed(2);
                    var price = formatter.format(formatPrice);
                    target.find('.al2Prod__price').text(price);
                    target
                        .find('.al2Prod__buyButton')
                        .attr('data-id', activeProduct.id);
                    target
                        .find('.al2Prod__buyButton')
                        .attr('data-keyed', activeProduct.keyedalike);
    
                    if ('title' in activeProduct) {
                        var textTitle = activeProduct.title;
                        target.find('.al2Prod__title').text(textTitle);
                    }
    
                    if (
                        target
                            .find('[data-key-option="keyed"]')
                            .hasClass('al2Prod__keyOptionButton--active')
                    ) {
                        target.find('.al2Prod__accessCard--key').show();
                    } else {
                        target.find('.al2Prod__accessCard--key').hide();
                    }
                    target.find('.smartPDP__learn').attr('href', activeProduct.url);
    
                    target
                        .closest('.al2Prod')
                        .find('.notifyMe__submit')
                        .attr('data-variant', activeProduct.id);
                    target
                        .closest('.al2Prod')
                        .find('.notifyMe__submit')
                        .attr('data-product', activeProduct.prodId);
                    console.log(activeProduct);
    
                    if (activeProduct.available == 'false') {
                        target
                            .find('.al2Prod__buyButton')
                            .addClass('al2Prod__buyButton--soldOut')
                            .text('Sold Out');
                        target.find('.smartPDP__buyWrapper').hide();
                        target
                            .find('.al2Prod__buyButtonRow')
                            .addClass('al2Prod__buyButtonRow--soldOut');
                        target.closest('.al2Prod').find('.notifyMe').slideDown();
                        target
                            .find('.al2Prod__learnButton')
                            .attr('style', 'margin-left:0;margin-bottom:15px;');
                    } else {
                        target
                            .find('.al2Prod__buyButton')
                            .removeClass('al2Prod__buyButton--soldOut')
                            .text('Buy Now');
                        target.find('.smartPDP__buyWrapper').show();
                        target
                            .find('.al2Prod__buyButtonRow')
                            .removeClass('al2Prod__buyButtonRow--soldOut');
                        target.closest('.al2Prod').find('.notifyMe').slideUp();
                        target.find('.al2Prod__learnButton').attr('style', '');
                    }
                }
    
                $('.al2Prod').each(function () {
                    var thisThing = $(this);
                    var selectedProduct = getActiveProductInfo(thisThing);
                    setActiveProduct(thisThing, selectedProduct);
                    //showCheck(thisThing);
                });
    
                $('.al2Prod__colorButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__colorButton')
                        .removeClass('al2Prod__colorButton--active');
                    thisThing.addClass('al2Prod__colorButton--active');
    
                    if (thisThing.hasClass('al2Prod__colorButton--comingSoon')) {
                        $('.al2Prod__comingSoon').addClass(
                            'al2Prod__comingSoon--show'
                        );
                    } else {
                        $('.al2Prod__comingSoon').removeClass(
                            'al2Prod__comingSoon--show'
                        );
                    }
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    var targets = thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__slideImg');
                    targets.each(function () {
                        if (
                            thisThing
                                .attr('data-color')
                                .toLowerCase()
                                .indexOf('snow') >= 0
                        ) {
                            $(this).attr('src', $(this).attr('src-snow'));
                        } else if (
                            thisThing
                                .attr('data-color')
                                .toLowerCase()
                                .indexOf('black') >= 0
                        ) {
                            $(this).attr('src', $(this).attr('src-black'));
                        } else if (
                            thisThing
                                .attr('data-color')
                                .toLowerCase()
                                .indexOf('ash') >= 0
                        ) {
                            $(this).attr('src', $(this).attr('src-ash'));
                        } else if (
                            thisThing
                                .attr('data-color')
                                .toLowerCase()
                                .indexOf('brass') >= 0
                        ) {
                            $(this).attr('src', $(this).attr('src-brass'));
                        }
                    });
                });
    
                $('.al2Prod__prodButton').on('click', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    //change active class
                    thisThing
                        .parent()
                        .find('.al2Prod__prodButton')
                        .removeClass('al2Prod__prodButton--active');
                    thisThing.addClass('al2Prod__prodButton--active');
    
                    //set the active product for the buy code
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
                });
    
                $('.al2Prod__colorButton--active').click();
    
                $('.al2Prod__keyOptionButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__keyOptionButton')
                        .removeClass('al2Prod__keyOptionButton--active');
                    thisThing.addClass('al2Prod__keyOptionButton--active');
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
                });
    
                $('.al2Prod__keyOptionButton').on('mousedown', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
    
                    if ($('.approachPDP').length > 0) {
                        console.log('mouseup');
                        if ($(this).attr('data-key-option') == 'key-free') {
                            var newHtml = parentContainer
                                .find('.al2Prod__list')
                                .attr('data-bluetooth');
                            parentContainer.find('.al2Prod__list').html(newHtml);
                            var newHtmlTwo = parentContainer
                                .find('.al2Prod__techContent')
                                .attr('data-bluetooth');
                            parentContainer
                                .find('.al2Prod__techContent')
                                .html(newHtmlTwo);
                        } else {
                            var newHtml = parentContainer
                                .find('.al2Prod__list')
                                .attr('data-touchpad');
                            parentContainer.find('.al2Prod__list').html(newHtml);
                            var newHtmlTwo = parentContainer
                                .find('.al2Prod__techContent')
                                .attr('data-touchpad');
                            parentContainer
                                .find('.al2Prod__techContent')
                                .html(newHtmlTwo);
                        }
                    }
                });
    
                $('.al2Prod__techButton').on('click', function () {
                    var thisThing = $(this);
                    thisThing
                        .parent()
                        .find('.al2Prod__techButton')
                        .removeClass('al2Prod__techButton--active');
                    thisThing.addClass('al2Prod__techButton--active');
    
                    var parentContainer = thisThing.closest('.al2Prod');
                    var selectedProduct = getActiveProductInfo(parentContainer);
    
                    setActiveProduct(parentContainer, selectedProduct);
                    showCheck(parentContainer);
    
                    if (thisThing.attr('data-tech-option') === 'bluetooth') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-bluetooth');
                        parentContainer.find('.al2Prod__list').html(newHtml);
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .hide();
                    } else if (thisThing.attr('data-tech-option') === 'wifi') {
                        var newHtml = parentContainer
                            .find('.al2Prod__list')
                            .attr('data-wifi');
                        parentContainer.find('.al2Prod__list').html(newHtml);
                        parentContainer
                            .find('.al2Prod__worksIconWrapper--wifi')
                            .show();
                    }
    
                    thisThing
                        .closest('.al2Prod__inner')
                        .find('.al2Prod__colorButton--active')
                        .click();
                });
    
                $('.smartPDP__qtyBox input').on('change', function () {
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    showCheck(parentContainer);
                });
    
                var CartJSInterval = setInterval(function () {
                    if (typeof CartJS.cart.items !== 'undefined') {
                        $('.al2Prod').each(function () {
                            var thisThing = $(this);
                            showCheck(thisThing);
                        });
                        clearInterval(CartJSInterval);
                    }
                }, 10);
    
                function showCheck(targetSection) {
                    var keyed = targetSection
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-key-option');
                    var selectedType = targetSection
                        .find('.al2Prod__keyOptionButton--active')
                        .attr('data-type');
    
                    //show-hide keyed alike box
                    if (keyed == 'keyed') {
                        var count = 0;
                        var type = 0;
                        for (i = 0; i < CartJS.cart.items.length; i++) {
                            if (
                                CartJS.cart.items[i].properties[
                                    '_keyed_alike_available'
                                ] == 'true'
                            ) {
                                var qty = CartJS.cart.items[i].quantity;
                                count += 1;
                            }
                            if (type == '') {
                                if (
                                    CartJS.cart.items[i].properties[
                                        '_keyed_alike_group'
                                    ] > 0
                                ) {
                                    type = CartJS.cart.items[i].product_type;
                                }
                            }
                        }
    
                        if (type == '' || compareProdTypes(selectedType, type)) {
                            if (targetSection.find('.smartPDP__qty').val() > 1) {
                                targetSection.find('.pdpKA--assureLanding').show();
                                targetSection
                                    .find('.pdpKA--assureLanding')
                                    .attr('data-type', selectedType);
                            } else if (count > 0) {
                                targetSection.find('.pdpKA--assureLanding').show();
                                targetSection
                                    .find('.pdpKA--assureLanding')
                                    .attr('data-type', selectedType);
                            } else {
                                targetSection.find('.pdpKA--assureLanding').hide();
                                targetSection
                                    .find('.pdpKA__checkbox')
                                    .prop('checked', false);
                            }
                        } else {
                            targetSection.find('.pdpKA--assureLanding').hide();
                            targetSection
                                .find('.pdpKA__checkbox')
                                .prop('checked', false);
                        }
                    } else {
                        targetSection.find('.pdpKA--assureLanding').hide();
                        targetSection
                            .find('.pdpKA__checkbox')
                            .prop('checked', false);
                    }
                }
    
                $('.pdpKAPop__continueButton').on('click', function () {
                    var itemsToGroup = [];
                    var newKAItemCount = 0;
                    var type = '';
                    type = $(this)
                        .closest('.shopify-section')
                        .find('.pdpKA__inner')
                        .parent()
                        .attr('data-type');
    
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties[
                                '_keyed_alike_available'
                            ] == 'true'
                        ) {
                            if (
                                compareProdTypes(
                                    CartJS.cart.items[i].product_type,
                                    type
                                )
                            ) {
                                itemsToGroup.push({
                                    id: CartJS.cart.items[i].id,
                                    quantity: CartJS.cart.items[i].quantity,
                                    properties: {
                                        _name: 'keyed_alike_group',
                                        _value: 1,
                                        _keyed_alike_group: 1,
                                        _keyed_alike_available: 'true',
                                        _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                    },
                                });
                                newKAItemCount += CartJS.cart.items[i].quantity * 1;
                            }
                        }
                    }
    
                    for (j = 0; j < itemsToGroup.length; j++) {
                        CartJS.removeItemById(itemsToGroup[j].id);
                    }
    
                    itemsToGroup.push({
                        id: 32146864832644,
                        quantity: newKAItemCount,
                        properties: {
                            _groups: 1,
                            _page_added: window.location.href,
                        },
                    });
    
                    CartJS.addItems(itemsToGroup, {
                        success: function (data, textStatus, jqXHR) {
                            updateCart(true);
                            $('.pdpKAPop').fadeOut();
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    });
                });
    
                $('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
                    'click',
                    function () {
                        $('.pdpKAPop').fadeOut();
                    }
                );
    
                function newKeyedSkipPopup(reference) {
                    var groupCount = 0;
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties['_name'] ==
                            'keyed_alike_group'
                        ) {
                            var qty = CartJS.cart.items[i].quantity;
                            groupCount += 1;
                        }
                        if (CartJS.cart.items[i].properties['_groups'] * 1 > 1) {
                            $('.pdpKAPop__addToExisting').hide();
                        }
                    }
                    console.log(groupCount);
                    if (groupCount > 0) {
                        $('.pdpKAPop__inner--existing').show();
                        $('.pdpKAPop__inner--new').hide();
                        reference
                            .closest('.shopify-section')
                            .find('.pdpKAPop')
                            .show();
                    } else {
                        if (
                            $('#cartDrawer').find(
                                '.cart-item[data-variant-id="32146864832644"]'
                            ).length > 0
                        ) {
                            console.log('there is already a key in the cart');
                        } else {
                            var _itemsToGroup = [];
                            var _newKAItemCount = 0;
                            var firstType = '';
                            for (i = 0; i < CartJS.cart.items.length; i++) {
                                if (i == 0) {
                                    firstType =
                                        CartJS.cart.items[i]['product_type'];
                                }
                                if (
                                    CartJS.cart.items[i].properties[
                                        '_keyed_alike_available'
                                    ] == 'true'
                                ) {
                                    if (
                                        compareProdTypes(
                                            CartJS.cart.items[i]['product_type'],
                                            firstType
                                        )
                                    ) {
                                        _itemsToGroup.push({
                                            id: CartJS.cart.items[i].id,
                                            quantity: CartJS.cart.items[i].quantity,
                                            properties: {
                                                _name: 'keyed_alike_group',
                                                _value: 1,
                                                _keyed_alike_group: 1,
                                                _keyed_alike_available: 'true',
                                                _type: firstType,
                                                _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                            },
                                        });
                                        _newKAItemCount +=
                                            CartJS.cart.items[i].quantity * 1;
                                    }
                                }
                            }
    
                            for (j = 0; j < _itemsToGroup.length; j++) {
                                CartJS.removeItemById(_itemsToGroup[j].id);
                            }
    
                            _itemsToGroup.push({
                                id: 32146864832644,
                                quantity: _newKAItemCount,
                                properties: {
                                    _groups: 1,
                                    _type: firstType,
                                    _page_added: window.location.href,
                                },
                            });
    
                            console.log('about');
                            CartJS.addItems(_itemsToGroup, {
                                success: function (data, textStatus, jqXHR) {
                                    updateCart(true);
                                    $('.pdpKAPop').fadeOut();
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            });
                        }
    
                        /*
              $('.pdpKAPop__inner--existing').hide();
              $('.pdpKAPop__inner--new').show();
              */
                    }
                }
    
                $('.al2Prod__buyButton').on('click', function () {
                    var oldCart = CartJS.cart.item_count * 1;
                    console.log('buy now button pressed');
                    var thisThing = $(this);
                    var parentContainer = thisThing.closest('.al2Prod');
                    if ($(this).hasClass('al2Prod__buyButton--soldOut')) {
                    } else {
                        var varId = $(this).attr('data-id') * 1;
                        var qty = $(this)
                            .closest('.al2Prod__buyButtonRow')
                            .find('.smartPDP__qty')
                            .val();
                        if ($(this).attr('data-keyed') == 'true') {
                            addToCart(varId, qty, true);
                            if (
                                parentContainer
                                    .find('.pdpKA__checkbox')
                                    .prop('checked')
                            ) {
                                var keyCartWatch = setInterval(function () {
                                    if (CartJS.cart.item_count != oldCart) {
                                        newKeyedSkipPopup($(this));
                                        clearInterval(keyCartWatch);
                                    }
                                }, 50);
                            }
                        } else {
                            addToCart(varId, qty);
                        }
                    }
                });
    
                $('.al2Prod__accessButton').on('click', function () {
                    if ($(this).hasClass('al2Prod__accessButton--active')) {
                        $(this).removeClass('al2Prod__accessButton--active');
                        $(this).parent().find('.al2Prod__accessShelf').slideUp();
                    } else {
                        $(this).addClass('al2Prod__accessButton--active');
                        $(this).parent().find('.al2Prod__accessShelf').slideDown();
                    }
                });
    
                $('.al2Prod__techTitleButton').on('click', function () {
                    if ($(this).hasClass('al2Prod__techTitleButton--active')) {
                        $(this).removeClass('al2Prod__techTitleButton--active');
                        $(this).parent().find('.al2Prod__techShelf').slideUp();
                    } else {
                        $(this).addClass('al2Prod__techTitleButton--active');
                        $(this).parent().find('.al2Prod__techShelf').slideDown();
                    }
                });
    
                $('.al2App__button').each(function () {
                    preloadImage($(this).attr('data-image'));
                });
    
                $('.al2App__button').on('click', function () {
                    $(this)
                        .parent()
                        .find('.al2App__button')
                        .removeClass('al2App__button--active');
                    $(this).addClass('al2App__button--active');
    
                    var imgSrc = $(this).attr('data-image');
                    $('.al2App__image').attr('src', imgSrc);
                });
    
                $('.al2MobApp__topSlider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    asNavFor: '.al2MobApp__bottomSlider',
                });
    
                $('.al2MobApp__bottomSlider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    adaptiveHeight: true,
                    dots: false,
                    asNavFor: '.al2MobApp__topSlider',
                });
    
                $('.al2MobTable__dropTitle').on('click', function () {
                    var target = $(this).parent();
                    if (target.hasClass('al2MobTable__dropWrapper--active')) {
                        target.removeClass('al2MobTable__dropWrapper--active');
                        target.find('.al2MobTable__dropShelf').slideUp();
                    } else {
                        target.addClass('al2MobTable__dropWrapper--active');
                        target.find('.al2MobTable__dropShelf').slideDown();
                    }
                });
                $('.al2MobTable__dropOption').on('click', function () {
                    var newText = $(this).text();
                    var dataType = $(this).attr('data-type');
                    var target = $(this).closest('.al2MobTable__dropWrapper');
                    target.removeClass('al2MobTable__dropWrapper--active');
                    target.find('.al2MobTable__dropShelf').slideUp();
                    target.find('.al2MobTable__dropTitle span').text(newText);
                    if (target.hasClass('al2MobTable__dropWrapper--left')) {
                        $('.al2MobTable__cell--left').each(function () {
                            if (dataType == 'standard') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-standard'));
                            } else if (dataType == 'wifi') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-wifi'));
                            } else {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-zwave'));
                            }
                        });
                    } else {
                        $('.al2MobTable__cell--right').each(function () {
                            if (dataType == 'standard') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-standard'));
                            } else if (dataType == 'wifi') {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-wifi'));
                            } else {
                                $(this)
                                    .find('span')
                                    .text($(this).attr('data-zwave'));
                            }
                        });
                    }
                });
    
                $('.al2Prod--2')
                    .find('.al2Prod__keyOptionButton[data-key-option="key-free"]')
                    .click();
            }
    
            //end
    
            if ($('#smart-studio').length > 0) {
    
        var homeLib = createHomeArray();
        var doorLib = createDoorArray();
        var lockLib = createLockArray();
        var handleLib = createHandleArray();
    
        console.log(homeLib);
        console.log(doorLib);
        console.log(lockLib);
        console.log(handleLib);
    
        function preloadImage(url) {
            var img = new Image();
            img.src = url;
        }
        for (i = 0; i < homeLib.length; i++) {
            preloadImage(homeLib[i].mobile);
            preloadImage(homeLib[i].preview);
            preloadImage(homeLib[i].src);
            preloadImage(homeLib[i].zoomed);
            preloadImage(homeLib[i].zoomedMobile);
        }
        for (i = 0; i < doorLib.length; i++) {
            preloadImage(doorLib[i].preview);
            preloadImage(doorLib[i].srcs.black);
            preloadImage(doorLib[i].srcs.blue);
            preloadImage(doorLib[i].srcs.gray);
            preloadImage(doorLib[i].srcs.green);
            preloadImage(doorLib[i].srcs.pink);
            preloadImage(doorLib[i].srcs.red);
            preloadImage(doorLib[i].srcs.sage);
            preloadImage(doorLib[i].srcs.salmon);
            preloadImage(doorLib[i].srcs.teal);
            preloadImage(doorLib[i].srcs.white);
            preloadImage(doorLib[i].srcs.yellow);
            preloadImage(doorLib[i].srcs.midgray);
            preloadImage(doorLib[i].srcs.beige);
            preloadImage(doorLib[i].srcs.eggplant);
            preloadImage(doorLib[i].srcs.mobile_black);
            preloadImage(doorLib[i].srcs.mobile_blue);
            preloadImage(doorLib[i].srcs.mobile_gray);
            preloadImage(doorLib[i].srcs.mobile_green);
            preloadImage(doorLib[i].srcs.mobile_pink);
            preloadImage(doorLib[i].srcs.mobile_red);
            preloadImage(doorLib[i].srcs.mobile_sage);
            preloadImage(doorLib[i].srcs.mobile_salmon);
            preloadImage(doorLib[i].srcs.mobile_teal);
            preloadImage(doorLib[i].srcs.mobile_white);
            preloadImage(doorLib[i].srcs.mobile_yellow);
            preloadImage(doorLib[i].srcs.mobile_midgray);
            preloadImage(doorLib[i].srcs.mobile_beige);
            preloadImage(doorLib[i].srcs.mobile_eggplant);
            preloadImage(doorLib[i].srcs.zoom_black);
            preloadImage(doorLib[i].srcs.zoom_blue);
            preloadImage(doorLib[i].srcs.zoom_gray);
            preloadImage(doorLib[i].srcs.zoom_green);
            preloadImage(doorLib[i].srcs.zoom_pink);
            preloadImage(doorLib[i].srcs.zoom_red);
            preloadImage(doorLib[i].srcs.zoom_sage);
            preloadImage(doorLib[i].srcs.zoom_salmon);
            preloadImage(doorLib[i].srcs.zoom_teal);
            preloadImage(doorLib[i].srcs.zoom_white);
            preloadImage(doorLib[i].srcs.zoom_yellow);
            preloadImage(doorLib[i].srcs.zoom_midgray);
            preloadImage(doorLib[i].srcs.zoom_beige);
            preloadImage(doorLib[i].srcs.zoom_eggplant);
            preloadImage(doorLib[i].srcs.zoom_mobile_black);
            preloadImage(doorLib[i].srcs.zoom_mobile_blue);
            preloadImage(doorLib[i].srcs.zoom_mobile_gray);
            preloadImage(doorLib[i].srcs.zoom_mobile_green);
            preloadImage(doorLib[i].srcs.zoom_mobile_pink);
            preloadImage(doorLib[i].srcs.zoom_mobile_red);
            preloadImage(doorLib[i].srcs.zoom_mobile_sage);
            preloadImage(doorLib[i].srcs.zoom_mobile_salmon);
            preloadImage(doorLib[i].srcs.zoom_mobile_teal);
            preloadImage(doorLib[i].srcs.zoom_mobile_white);
            preloadImage(doorLib[i].srcs.zoom_mobile_yellow);
            preloadImage(doorLib[i].srcs.zoom_mobile_midgray);
            preloadImage(doorLib[i].srcs.zoom_mobile_beige);
            preloadImage(doorLib[i].srcs.zoom_mobile_eggplant);
        }
        for (i = 0; i < lockLib.length; i++) {
            if (typeof(lockLib[i].previews.silver) !== "undefined") {
                preloadImage(lockLib[i].previews.black);
                preloadImage(lockLib[i].previews.bronze);
                preloadImage(lockLib[i].previews.silver);
                preloadImage(lockLib[i].srcs.black);
                preloadImage(lockLib[i].srcs.bronze);
                preloadImage(lockLib[i].srcs.silver);
                preloadImage(lockLib[i].srcs.mobile_black);
                preloadImage(lockLib[i].srcs.mobile_bronze);
                preloadImage(lockLib[i].srcs.mobile_silver);
                preloadImage(lockLib[i].srcs.zoom_black);
                preloadImage(lockLib[i].srcs.zoom_bronze);
                preloadImage(lockLib[i].srcs.zoom_silver);
                preloadImage(lockLib[i].srcs.zoom_mobile_black);
                preloadImage(lockLib[i].srcs.zoom_mobile_bronze);
                preloadImage(lockLib[i].srcs.zoom_mobile_silver);
            }
            if (typeof(lockLib[i].previews.snow) !== "undefined") {
                preloadImage(lockLib[i].previews.snow);
                preloadImage(lockLib[i].previews.black);
                preloadImage(lockLib[i].previews.ash);
                preloadImage(lockLib[i].srcs.snow);
                preloadImage(lockLib[i].srcs.black);
                preloadImage(lockLib[i].srcs.ash);
                preloadImage(lockLib[i].srcs.mobile_snow);
                preloadImage(lockLib[i].srcs.mobile_black);
                preloadImage(lockLib[i].srcs.mobile_ash);
                preloadImage(lockLib[i].srcs.zoom_snow);
                preloadImage(lockLib[i].srcs.zoom_black);
                preloadImage(lockLib[i].srcs.zoom_ash);
                preloadImage(lockLib[i].srcs.zoom_mobile_snow);
                preloadImage(lockLib[i].srcs.zoom_mobile_black);
                preloadImage(lockLib[i].srcs.zoom_mobile_ash);
            }
            if (typeof(lockLib[i].previews.pantone) !== "undefined") {
                preloadImage(lockLib[i].previews.pantone);
                preloadImage(lockLib[i].srcs.pantone);
                preloadImage(lockLib[i].srcs.mobile_pantone);
                preloadImage(lockLib[i].srcs.zoom_pantone);
                preloadImage(lockLib[i].srcs.zoom_mobile_pantone);
            }
        }
        for (i = 0; i < handleLib.length; i++) {
            preloadImage(handleLib[i].mobile);
            preloadImage(handleLib[i].preview);
            preloadImage(handleLib[i].src);
            preloadImage(handleLib[i].zoom_src);
            preloadImage(handleLib[i].zoom_mobile);
        }
    
        showBoxData = {
            home: homeLib[0].src,
            zoomHome: homeLib[0].zoomed,
            door: doorLib[0].srcs.white,
            zoomDoor: doorLib[0].srcs.zoom_white,
            lock: '',
            zoomLock: '',
            handle: '',
            zoomHandle: ''
        }
    
        mobileBoxData = {
            home: homeLib[0].mobile,
            zoomHome: homeLib[0].zoomedMobile,
            door: doorLib[0].srcs.mobile_white,
            zoomDoor: doorLib[0].srcs.zoom_mobile_white,
            lock: '',
            zoomLock: '',
            handle: '',
            zoomHandle: ''
        }
    
        selectedData = {
            color: 'white',
            doorIndex: 0,
            style: 'standard',
            lock: 'touchscreen',
            key: 'keyfree',
            tech: 'bluetooth'
        }
    
        urlData = {
            home: 0,
            door: 0,
            color: 'white',
            style: 'standard',
            lock: 'touchscreen',
            key: 'keyfree',
            tech: 'bluetooth',
            finish: 0,
            handle: 0
        }
    
        function setDesktopShowBox(data) {
            $('.smartStudioD__wideHouse').attr('src', data.home);
            $('.smartStudioD__wideDoor').attr('src', data.door);
            $('.smartStudioD__wideLock').attr('src', data.lock);
            $('.smartStudioD__wideHandle').attr('src', data.handle);
    
            $('.smartStudioD__zoomHouse').attr('src', data.zoomHome);
            $('.smartStudioD__zoomDoor').attr('src', data.zoomDoor);
            $('.smartStudioD__zoomLock').attr('src', data.zoomLock);
            $('.smartStudioD__zoomHandle').attr('src', data.zoomHandle);
    
            if (data.lock == '') {
                $('.smartStudioD__wideLock').hide();
                $('.smartStudioD__zoomLock').hide();
            } else {
                $('.smartStudioD__wideLock').show();
                $('.smartStudioD__zoomLock').show();
            }
    
            if (data.handle == '') {
                $('.smartStudioD__wideHandle').hide();
                $('.smartStudioD__zoomHandle').hide();
            } else {
                $('.smartStudioD__wideHandle').show();
                $('.smartStudioD__zoomHandle').show();
            }
        }
        setDesktopShowBox(showBoxData);
    
        function setMobileShowBox(data) {
    
            $('.smartStudioM__wideHouse').attr('src', data.home);
            $('.smartStudioM__wideDoor').attr('src', data.door);
            $('.smartStudioM__wideLock').attr('src', data.lock);
            $('.smartStudioM__wideHandle').attr('src', data.handle);
    
            $('.smartStudioM__zoomHouse').attr('src', data.zoomHome);
            $('.smartStudioM__zoomDoor').attr('src', data.zoomDoor);
            $('.smartStudioM__zoomLock').attr('src', data.zoomLock);
            $('.smartStudioM__zoomHandle').attr('src', data.zoomHandle);
    
            if (data.lock == '') {
                $('.smartStudioM__wideLock').hide();
                $('.smartStudioM__zoomLock').hide();
            } else {
                $('.smartStudioM__wideLock').show();
                $('.smartStudioM__zoomLock').show();
            }
    
            if (data.handle == '') {
                $('.smartStudioM__wideHandle').hide();
                $('.smartStudioM__zoomHandle').hide();
            } else {
                $('.smartStudioM__wideHandle').show();
                $('.smartStudioM__zoomHandle').show();
            }
    
        }
        setMobileShowBox(mobileBoxData);
    
        function setDesktopHomeButtons() {
            var target = $('[data-menu="home"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner');
            var template = target.html();
            target.html('');
            for (i = 0; i < homeLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioD__sideBarButton--home').last();
                currentButton.attr('data-home', i);
                currentButton.find('img').attr('src', homeLib[i].preview).attr('alt', 'home button ' + i + ' thumbnail');
                currentButton.attr('data-src', homeLib[i].src);
                currentButton.attr('data-zoom-src', homeLib[i].zoomed);
            }
            $('.smartStudioD__sideBarButton--home').on('click', function() {
                showBoxData.home = $(this).attr('data-src');
                showBoxData.zoomHome = $(this).attr('data-zoom-src');
                setDesktopShowBox(showBoxData);
                $(this).parent().find('.smartStudioD__sideBarButton--active').removeClass('smartStudioD__sideBarButton--active');
                $(this).addClass('smartStudioD__sideBarButton--active');
    
                $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                urlData.home = $(this).attr('data-home');
            });
        }
        setDesktopHomeButtons();
    
        function setMobileHomeButtons() {
            var target = $('[data-menu="home"].smartStudioM__settingsBar .smartStudioM__settingsBarSled');
            var template = target.html();
            target.html('');
            for (i = 0; i < homeLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioM__settingsBarButton--home').last();
                currentButton.attr('data-home', i);
                currentButton.find('img').attr('src', homeLib[i].preview).attr('alt', 'home button ' + i + ' thumbnail');
                currentButton.attr('data-src', homeLib[i].mobile);
                currentButton.attr('data-zoom-src', homeLib[i].zoomedMobile);
            }
            $('.smartStudioM__settingsBarButton--home').on('click', function() {
                mobileBoxData.home = $(this).attr('data-src');
                mobileBoxData.zoomHome = $(this).attr('data-zoom-src');
                setMobileShowBox(mobileBoxData);
                $(this).parent().find('.smartStudioM__settingsBarButton--active').removeClass('smartStudioM__settingsBarButton--active');
                $(this).addClass('smartStudioM__settingsBarButton--active');
    
                $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                urlData.home = $(this).attr('data-home');
            });
        }
        setMobileHomeButtons();
    
        function setDoor() {
            var i = selectedData.doorIndex;
            if (selectedData.color == "white") {
                showBoxData.door = doorLib[i].srcs.white;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_white;
            } else if (selectedData.color == "pink") {
                showBoxData.door = doorLib[i].srcs.pink;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_pink;
            } else if (selectedData.color == "salmon") {
                showBoxData.door = doorLib[i].srcs.salmon;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_salmon;
            } else if (selectedData.color == "blue") {
                showBoxData.door = doorLib[i].srcs.blue;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_gray;
            } else if (selectedData.color == "gray") {
                showBoxData.door = doorLib[i].srcs.gray;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_gray;
            } else if (selectedData.color == "red") {
                showBoxData.door = doorLib[i].srcs.red;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_red;
            } else if (selectedData.color == "yellow") {
                showBoxData.door = doorLib[i].srcs.yellow;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_yellow;
            } else if (selectedData.color == "teal") {
                showBoxData.door = doorLib[i].srcs.teal;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_teal;
            } else if (selectedData.color == "black") {
                showBoxData.door = doorLib[i].srcs.black;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_black;
            } else if (selectedData.color == "sage") {
                showBoxData.door = doorLib[i].srcs.sage;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_sage;
            } else if (selectedData.color == "green") {
                showBoxData.door = doorLib[i].srcs.green;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_green;
            } else if (selectedData.color == "midgray") {
                showBoxData.door = doorLib[i].srcs.midgray;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_midgray;
            } else if (selectedData.color == "beige") {
                showBoxData.door = doorLib[i].srcs.beige;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_beige;
            } else if (selectedData.color == "eggplant") {
                showBoxData.door = doorLib[i].srcs.eggplant;
                showBoxData.zoomDoor = doorLib[i].srcs.zoom_eggplant;
            }
        }
    
        function setMobileDoor() {
            var i = selectedData.doorIndex;
            if (selectedData.color == "white") {
                mobileBoxData.door = doorLib[i].srcs.mobile_white;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_white;
            } else if (selectedData.color == "pink") {
                mobileBoxData.door = doorLib[i].srcs.mobile_pink;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_pink;
            } else if (selectedData.color == "salmon") {
                mobileBoxData.door = doorLib[i].srcs.mobile_salmon;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_salmon;
            } else if (selectedData.color == "blue") {
                mobileBoxData.door = doorLib[i].srcs.mobile_blue;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_gray;
            } else if (selectedData.color == "gray") {
                mobileBoxData.door = doorLib[i].srcs.mobile_gray;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_gray;
            } else if (selectedData.color == "red") {
                mobileBoxData.door = doorLib[i].srcs.mobile_red;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_red;
            } else if (selectedData.color == "yellow") {
                mobileBoxData.door = doorLib[i].srcs.mobile_yellow;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_yellow;
            } else if (selectedData.color == "teal") {
                mobileBoxData.door = doorLib[i].srcs.mobile_teal;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_teal;
            } else if (selectedData.color == "black") {
                mobileBoxData.door = doorLib[i].srcs.mobile_black;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_black;
            } else if (selectedData.color == "sage") {
                mobileBoxData.door = doorLib[i].srcs.mobile_sage;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_sage;
            } else if (selectedData.color == "green") {
                mobileBoxData.door = doorLib[i].srcs.mobile_green;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_green;
            } else if (selectedData.color == "midgray") {
                mobileBoxData.door = doorLib[i].srcs.mobile_midgray;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_midgray;
            } else if (selectedData.color == "beige") {
                mobileBoxData.door = doorLib[i].srcs.mobile_beige;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_beige;
            } else if (selectedData.color == "eggplant") {
                mobileBoxData.door = doorLib[i].srcs.mobile_eggplant;
                mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_eggplant;
            }
        }
    
        function setDesktopDoorButtons() {
            var target = $('[data-menu="door"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner');
            var template = target.html();
            target.html('');
            for (i = 0; i < doorLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioD__sideBarButton--door').last();
                currentButton.attr('data-door', i);
                currentButton.find('img').attr('src', doorLib[i].preview).attr('alt', 'door button ' + i + ' thumbnail');
            }
            $('.smartStudioD__sideBarButton--door').on('click', function() {
                selectedData.doorIndex = $(this).attr('data-door') * 1;
                setDoor();
                setDesktopShowBox(showBoxData);
                $(this).parent().find('.smartStudioD__sideBarButton--active').removeClass('smartStudioD__sideBarButton--active');
                $(this).addClass('smartStudioD__sideBarButton--active');
    
                $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                urlData.door = $(this).attr('data-door');
            });
        }
        setDesktopDoorButtons();
    
        function setMobileDoorButtons() {
            var target = $('[data-menu="door"].smartStudioM__settingsBar .smartStudioM__settingsBarSled');
            var template = target.html();
            target.html('');
            for (i = 0; i < doorLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioM__settingsBarButton--door').last();
                currentButton.attr('data-door', i);
                currentButton.find('img').attr('src', doorLib[i].preview).attr('alt', 'door button ' + i + ' thumbnail');
            }
            $('.smartStudioM__settingsBarButton--door').on('click', function() {
                selectedData.doorIndex = $(this).attr('data-door') * 1;
                setMobileDoor();
                setMobileShowBox(mobileBoxData);
                $(this).parent().find('.smartStudioM__settingsBarButton--active').removeClass('smartStudioM__settingsBarButton--active');
                $(this).addClass('smartStudioM__settingsBarButton--active');
    
                $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                urlData.door = $(this).attr('data-door');
            });
        }
        setMobileDoorButtons();
    
        $('.smartStudioD__sideBarColorButton').on('click', function() {
            selectedData.color = $(this).attr('data-color');
            setDoor();
            setDesktopShowBox(showBoxData);
            $(this).parent().find('.smartStudioD__sideBarColorButton--active').removeClass('smartStudioD__sideBarColorButton--active');
            $(this).addClass('smartStudioD__sideBarColorButton--active');
    
            $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
            urlData.color = $(this).attr('data-color');
        });
    
        $('.smartStudioM__colorButton').on('click', function() {
            selectedData.color = $(this).attr('data-color');
            setMobileDoor();
            setMobileShowBox(mobileBoxData);
            $(this).parent().find('.smartStudioM__colorButton--active').removeClass('smartStudioM__colorButton--active');
            $(this).addClass('smartStudioM__colorButton--active');
    
            $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
            urlData.color = $(this).attr('data-color');
        });
    
        function setDesktopFinishButtons() {
            var pantone = false;
            var matter = false;
            var target = $('[data-menu="finish"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner');
            var selected = '';
            if (selectedData.style == 'standard') {
                if (selectedData.key == 'keyfree') {
                    if (selectedData.lock == 'touchscreen') {
                        selected = lockLib[4];
                        pantone = true;
                    } else {
                        selected = lockLib[6];
                    }
                } else {
                    if (selectedData.lock == 'touchscreen') {
                        selected = lockLib[3];
                    } else {
                        if (selectedData.tech == 'matter') {
                            selected = lockLib[7];
                            matter = true;
                        } else {
                            selected = lockLib[5];
                        }
                    }
                }
            } else if (selectedData.style == 'touch') {
                if (selectedData.key == 'keyfree') {
                    selected = lockLib[1];
                } else {
                    selected = lockLib[0];
                }
            } else if (selectedData.style == 'plus') {
                selected = lockLib[2];
            }
    
            if (matter == false) {
                target.find('[data-finish="0"]').attr('data-src', selected.srcs.black).attr('data-zoom-src', selected.srcs.zoom_black).find('img').attr('src', selected.previews.black);
                target.find('[data-finish="1"]').attr('data-src', selected.srcs.silver).attr('data-zoom-src', selected.srcs.zoom_silver).find('img').attr('src', selected.previews.silver);
                target.find('[data-finish="2"]').attr('data-src', selected.srcs.bronze).attr('data-zoom-src', selected.srcs.zoom_bronze).find('img').attr('src', selected.previews.bronze);
                target.find('[data-finish="0"]').show();
                target.find('[data-finish="1"]').show();
                target.find('[data-finish="2"]').show();
                target.find('[data-finish="4"]').hide();
                target.find('[data-finish="5"]').hide();
                target.find('[data-finish="6"]').hide();
    
                if (pantone == true) {
                    target.find('[data-finish="3"]').attr('data-src', selected.srcs.pantone).attr('data-zoom-src', selected.srcs.zoom_pantone).find('img').attr('src', selected.previews.pantone);
                    target.find('[data-finish="3"]').show();
                } else {
                    target.find('[data-finish="3"]').hide();
                }
            } else {
                target.find('[data-finish="0"]').hide();
                target.find('[data-finish="1"]').hide();
                target.find('[data-finish="2"]').hide();
                target.find('[data-finish="3"]').hide();
    
                target.find('[data-finish="4"]').attr('data-src', selected.srcs.snow).attr('data-zoom-src', selected.srcs.zoom_snow).find('img').attr('src', selected.previews.snow);
                target.find('[data-finish="4"]').show();
                target.find('[data-finish="5"]').attr('data-src', selected.srcs.black).attr('data-zoom-src', selected.srcs.zoom_black).find('img').attr('src', selected.previews.black);
                target.find('[data-finish="5"]').show();
                target.find('[data-finish="6"]').attr('data-src', selected.srcs.ash).attr('data-zoom-src', selected.srcs.zoom_ash).find('img').attr('src', selected.previews.ash);
                target.find('[data-finish="6"]').show();
            }
    
    
    
            $('.smartStudioD__sideBarButton--finish').on('click', function() {
                showBoxData.lock = $(this).attr('data-src');
                showBoxData.zoomLock = $(this).attr('data-zoom-src');
                setDesktopShowBox(showBoxData);
                $(this).parent().find('.smartStudioD__sideBarButton--active').removeClass('smartStudioD__sideBarButton--active');
                $(this).addClass('smartStudioD__sideBarButton--active');
    
                $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                urlData.finish = $(this).attr('data-finish');
            });
        }
        setDesktopFinishButtons();
    
        function setMobileFinishButtons() {
            var pantone = false;
            var matter = false;
            var target = $('[data-menu="finish"].smartStudioM__settingsBar .smartStudioM__settingsBarSled');
            var selected = '';
            if (selectedData.style == 'standard') {
                if (selectedData.key == 'keyfree') {
                    if (selectedData.lock == 'touchscreen') {
                        selected = lockLib[4];
                        pantone = true;
                    } else {
                        selected = lockLib[6];
                    }
                } else {
                    if (selectedData.lock == 'touchscreen') {
                        selected = lockLib[3];
                    } else {
                        if (selectedData.tech == 'matter') {
                            selected = lockLib[7];
                            matter = true;
                        } else {
                            selected = lockLib[5];
                        }
                    }
                }
            } else if (selectedData.style == 'touch') {
                if (selectedData.key == 'keyfree') {
                    selected = lockLib[1];
                } else {
                    selected = lockLib[0];
                }
            } else if (selectedData.style == 'plus') {
                selected = lockLib[2];
            }
    
            if (matter == false) {
                target.find('[data-finish="0"]').attr('data-src', selected.srcs.mobile_black).attr('data-zoom-src', selected.srcs.zoom_mobile_black).find('img').attr('src', selected.previews.black);
                target.find('[data-finish="1"]').attr('data-src', selected.srcs.mobile_silver).attr('data-zoom-src', selected.srcs.zoom_mobile_silver).find('img').attr('src', selected.previews.silver);
                target.find('[data-finish="2"]').attr('data-src', selected.srcs.mobile_bronze).attr('data-zoom-src', selected.srcs.zoom_mobile_bronze).find('img').attr('src', selected.previews.bronze);
                target.find('[data-finish="0"]').show();
                target.find('[data-finish="1"]').show();
                target.find('[data-finish="2"]').show();
                target.find('[data-finish="4"]').hide();
                target.find('[data-finish="5"]').hide();
                target.find('[data-finish="6"]').hide();
    
                if (pantone == true) {
                    target.find('[data-finish="3"]').attr('data-src', selected.srcs.mobile_pantone).attr('data-zoom-src', selected.srcs.zoom_mobile_pantone).find('img').attr('src', selected.previews.pantone);
                    target.find('[data-finish="3"]').show();
                } else {
                    target.find('[data-finish="3"]').hide();
                }
            } else {
                target.find('[data-finish="0"]').hide();
                target.find('[data-finish="1"]').hide();
                target.find('[data-finish="2"]').hide();
                target.find('[data-finish="3"]').hide();
    
                target.find('[data-finish="4"]').attr('data-src', selected.srcs.mobile_snow).attr('data-zoom-src', selected.srcs.zoom_mobile_snow).find('img').attr('src', selected.previews.snow);
                target.find('[data-finish="4"]').show();
                target.find('[data-finish="5"]').attr('data-src', selected.srcs.mobile_black).attr('data-zoom-src', selected.srcs.zoom_mobile_black).find('img').attr('src', selected.previews.black);
                target.find('[data-finish="5"]').show();
                target.find('[data-finish="6"]').attr('data-src', selected.srcs.mobile_ash).attr('data-zoom-src', selected.srcs.zoom_mobile_ash).find('img').attr('src', selected.previews.ash);
                target.find('[data-finish="6"]').show();
            }
    
            $('.smartStudioM__settingsBarButton--finish').on('click', function() {
                mobileBoxData.lock = $(this).attr('data-src');
                mobileBoxData.zoomLock = $(this).attr('data-zoom-src');
                setMobileShowBox(mobileBoxData);
                $(this).parent().find('.smartStudioM__settingsBarButton--active').removeClass('smartStudioM__settingsBarButton--active');
                $(this).addClass('smartStudioM__settingsBarButton--active');
    
                $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                urlData.finish = $(this).attr('data-finish');
            });
        }
        setMobileFinishButtons();
    
        $('.smartStudioD__sideBarSlideButton').on('click', function() {
            var thisThing = $(this);
            var slide = $(this).closest('.smartStudioD__sideBarSlide');
    
            if (slide.attr('data-step') == 'step-1') {
                selectedData.style = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioD__sideBarSlideButton--active').removeClass('smartStudioD__sideBarSlideButton--active');
                thisThing.addClass('smartStudioD__sideBarSlideButton--active');
                setDesktopFinishButtons();
    
                $('.smartStudioD__sideBarNextArrow').removeClass('smartStudioD__sideBarNextArrow--disabled');
                urlData.style = $(this).attr('data-answer');
    
                if (urlData.style == "standard") {
                    $('.smartStudioD__sideBarSlideButton--matter').show();
                } else {
                    $('.smartStudioD__sideBarSlideButton--matter').hide();
                }
            } else if (slide.attr('data-step') == 'step-2') {
                selectedData.tech = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioD__sideBarSlideButton--active').removeClass('smartStudioD__sideBarSlideButton--active');
                thisThing.addClass('smartStudioD__sideBarSlideButton--active');
                setDesktopFinishButtons();
    
                $('.smartStudioD__sideBarNextArrow').removeClass('smartStudioD__sideBarNextArrow--disabled');
                urlData.tech = $(this).attr('data-answer');
    
                var selectedStyle = $('.smartStudioD__sideBarSlide[data-step="step-1"]').find('.smartStudioD__sideBarSlideButton--active').attr('data-answer');
                if (selectedStyle == "plus") {
                    selectedData.key = "keyfree";
                    selectedData.lock = "touchscreen";
                    $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                } else if (selectedStyle == "standard" && urlData.tech == "matter") {
                    selectedData.key = "keyed";
                    selectedData.lock = "keypad";
                    urlData.key = "keyed";
                    urlData.lock = "keypad";
                    $('.smartStudioD__sideBarNextArrow').addClass('smartStudioD__sideBarNextArrow--end');
                    $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                    setDesktopFinishButtons();
                } else {
                    $('.smartStudioD__topBarNavButton--next').removeClass('smartStudioD__topBarNavButton--active');
                    $('.smartStudioD__sideBarNextArrow').removeClass('smartStudioD__sideBarNextArrow--end');
                }
            } else if (slide.attr('data-step') == 'step-3') {
                if (urlData.tech != "matter") {
                    selectedData.key = thisThing.attr('data-answer');
                    thisThing.parent().find('.smartStudioD__sideBarSlideButton--active').removeClass('smartStudioD__sideBarSlideButton--active');
                    thisThing.addClass('smartStudioD__sideBarSlideButton--active');
                    setDesktopFinishButtons();
                    $('.smartStudioD__sideBarNextArrow').removeClass('smartStudioD__sideBarNextArrow--disabled');
                    urlData.key = $(this).attr('data-answer');
    
                    var selectedStyle = $('.smartStudioD__sideBarSlide[data-step="step-1"]').find('.smartStudioD__sideBarSlideButton--active').attr('data-answer');
                    if (selectedStyle == "touch") {
                        selectedData.lock = "touchscreen";
                        $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                    } else {
                        $('.smartStudioD__topBarNavButton--next').removeClass('smartStudioD__topBarNavButton--active');
                    }
                }
            } else if (slide.attr('data-step') == 'step-4') {
                selectedData.lock = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioD__sideBarSlideButton--active').removeClass('smartStudioD__sideBarSlideButton--active');
                thisThing.addClass('smartStudioD__sideBarSlideButton--active');
                setDesktopFinishButtons();
    
                $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--active');
                urlData.lock = $(this).attr('data-answer');
            }
        });
    
        $('.smartStudioM__typeSlideButton').on('click', function() {
            var thisThing = $(this);
            var slide = $(this).closest('.smartStudioM__typeSlide');
            if (slide.attr('data-step') == 'step-1') {
                selectedData.style = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioM__typeSlideButton--active').removeClass('smartStudioM__typeSlideButton--active');
                thisThing.addClass('smartStudioM__typeSlideButton--active');
                setMobileFinishButtons();
                $('.smartStudioM__typeSlideNextArrow').removeClass('smartStudioM__typeSlideNextArrow--disabled');
                urlData.style = $(this).attr('data-answer');
    
                if (urlData.style == "standard") {
                    $('.smartStudioM__sideBarSlideButton--matter').show();
                } else {
                    $('.smartStudioM__sideBarSlideButton--matter').hide();
                }
    
                $('.smartStudioM__typeSlideNextArrow').click();
            } else if (slide.attr('data-step') == 'step-2') {
                selectedData.tech = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioM__typeSlideButton--active').removeClass('smartStudioM__typeSlideButton--active');
                thisThing.addClass('smartStudioM__typeSlideButton--active');
                setMobileFinishButtons();
                $('.smartStudioM__typeSlideNextArrow').removeClass('smartStudioM__typeSlideNextArrow--disabled');
                urlData.tech = $(this).attr('data-answer');
    
                var selectedStyle = $('.smartStudioM__typeSlide[data-step="step-1"]').find('.smartStudioM__typeSlideButton--active').attr('data-answer');
                if (selectedStyle == "plus") {
                    selectedData.key = "keyfree";
                    selectedData.lock = "touchscreen";
                    $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                    $('.smartStudioM__controlBarButton--next').click();
                } else if (selectedStyle == "standard" && urlData.tech == "matter") {
                    selectedData.key = "keyed";
                    selectedData.lock = "keypad";
                    urlData.key = "keyed";
                    urlData.lock = "keypad";
                    $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                    $('.smartStudioM__controlBarButton--next').click();
                } else {
                    $('.smartStudioM__typeSlideNextArrow').click();
                }
            } else if (slide.attr('data-step') == 'step-3') {
                selectedData.key = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioM__typeSlideButton--active').removeClass('smartStudioM__typeSlideButton--active');
                thisThing.addClass('smartStudioM__typeSlideButton--active');
                setMobileFinishButtons();
                $('.smartStudioM__typeSlideNextArrow').removeClass('smartStudioM__typeSlideNextArrow--disabled');
                urlData.key = $(this).attr('data-answer');
                var selectedStyle = $('.smartStudioM__typeSlide[data-step="step-1"]').find('.smartStudioM__typeSlideButton--active').attr('data-answer');
                if (selectedStyle == "touch") {
                    selectedData.lock = "touchscreen";
                    $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                    $('.smartStudioM__controlBarButton--next').click();
                    setMobileFinishButtons()
                } else {
                    $('.smartStudioM__typeSlideNextArrow').click();
                }
            } else {
                selectedData.lock = thisThing.attr('data-answer');
                thisThing.parent().find('.smartStudioM__typeSlideButton--active').removeClass('smartStudioM__typeSlideButton--active');
                thisThing.addClass('smartStudioM__typeSlideButton--active');
                setMobileFinishButtons();
    
                $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--active');
                urlData.lock = $(this).attr('data-answer');
                $('.smartStudioM__controlBarButton--next').click();
            }
        });
    
        function setDesktopHandleButtons() {
            var target = $('[data-menu="handle"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner');
            var template = target.html();
            target.html('');
            for (i = 0; i < handleLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioD__sideBarButton--handle').last();
                currentButton.attr('data-handle', i);
                currentButton.find('img').attr('src', handleLib[i].preview).attr('alt', 'handle button ' + i + ' thumbnail');
                currentButton.attr('data-src', handleLib[i].src);
                currentButton.attr('data-zoom-src', handleLib[i].zoom_src);
            }
            $('.smartStudioD__sideBarButton--handle').on('click', function() {
                showBoxData.handle = $(this).attr('data-src');
                showBoxData.zoomHandle = $(this).attr('data-zoom-src');
                setDesktopShowBox(showBoxData);
                $(this).parent().find('.smartStudioD__sideBarButton--active').removeClass('smartStudioD__sideBarButton--active');
                $(this).addClass('smartStudioD__sideBarButton--active');
    
                $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--results');
                urlData.handle = $(this).attr('data-handle');
            });
        }
        setDesktopHandleButtons();
    
        function setMobileHandleButtons() {
            var target = $('[data-menu="handle"].smartStudioM__settingsBar .smartStudioM__settingsBarSled');
            var template = target.html();
            target.html('');
            for (i = 0; i < handleLib.length; i++) {
                target.append(template);
                var currentButton = $('.smartStudioM__settingsBarButton--handle').last();
                currentButton.attr('data-handle', i);
                currentButton.find('img').attr('src', handleLib[i].preview).attr('alt', 'handle button ' + i + ' thumbnail');
                currentButton.attr('data-src', handleLib[i].mobile);
                currentButton.attr('data-zoom-src', handleLib[i].zoom_mobile);
            }
            $('.smartStudioM__settingsBarButton--handle').on('click', function() {
                mobileBoxData.handle = $(this).attr('data-src');
                mobileBoxData.zoomHandle = $(this).attr('data-zoom-src');
                setMobileShowBox(mobileBoxData);
                $(this).parent().find('.smartStudioM__settingsBarButton--active').removeClass('smartStudioM__settingsBarButton--active');
                $(this).addClass('smartStudioM__settingsBarButton--active');
    
                $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--results');
                urlData.handle = $(this).attr('data-handle');
            });
        }
        setMobileHandleButtons();
    
        function studioZoomIn() {
            $('.smartStudioD__showBox').addClass('smartStudioD__showBox--zoom');
        }
    
        function studioZoomOut() {
            $('.smartStudioD__showBox').removeClass('smartStudioD__showBox--zoom');
        }
    
        function studioZoomInMobile() {
            $('.smartStudioM__showBox').addClass('smartStudioM__showBox--zoom');
        }
    
        function studioZoomOutMobile() {
            $('.smartStudioM__showBox').removeClass('smartStudioM__showBox--zoom');
        }
    
    
        function setStep(step) {
            var stepArray = ['intro', 'home', 'door', 'color', 'type', 'finish', 'handle'];
            var menu = stepArray[step];
    
            // START GTM event for Flywheel Demand
            try {
                var _gtmSelect = stepArray[currentStep]
                var dataLayer = window.dataLayer || []
    
                if (step > currentStep) {
                    switch (_gtmSelect) {
                        case 'intro':
                            dataLayer.push({
                                event: 'quiz_start'
                            })
                            break
                        case 'type':
                            dataLayer.push({
                                event: 'quiz_next',
                                quiz_step: 'type',
                                quiz_selection: `${urlData.style} | ${urlData.lock} | ${urlData.key} | ${urlData.tech}`
                            })
                            break
                        default:
                            dataLayer.push({
                                event: 'quiz_next',
                                quiz_step: _gtmSelect,
                                quiz_selection: urlData[_gtmSelect]
                            })
                    }
                }
            } catch (error) {
                console.error('GTM tracking for quiz error: ', error)
            }
            // END GTM event for Flywheel Demand
    
            var stepTarget = $('.smartStudioD__topBarButton[data-index="' + step + '"]');
            var menuTarget = $('.smartStudioD__sideBar[data-menu="' + menu + '"]');
    
            var targetSlider = $('.smartStudioD__topBarButtonRow');
    
            var origin = targetSlider.offset().left
            var targetPos = ((stepTarget.offset().left + stepTarget.outerWidth()) - origin) + targetSlider.scrollLeft();
            var scrollAmount = (targetPos - targetSlider.outerWidth() + 6);
    
            if (scrollAmount > 0) {
                targetSlider.animate({
                    scrollLeft: scrollAmount
                }, 500);
            }
            stepTarget.addClass('smartStudioD__topBarButton--active');
    
            if ($('.smartStudioD__sideBarWrapper--open').length) {
                $('.smartStudioD__sideBarWrapper').removeClass('smartStudioD__sideBarWrapper--open');
                $('.smartStudioD__sideBarToolTip').fadeOut(200);
                setTimeout(function() {
                    $('.smartStudioD__sideBar').hide();
                    menuTarget.show();
                    $('.smartStudioD__sideBarWrapper').addClass('smartStudioD__sideBarWrapper--open');
                    if (tutorial == true) {
                        setTimeout(function() {
                            menuTarget.find('.smartStudioD__sideBarToolTip').fadeIn(200);
                        }, 100);
                    }
                }, 200);
            } else {
                $('.smartStudioD__sideBar').hide();
                menuTarget.show();
                $('.smartStudioD__sideBarWrapper').addClass('smartStudioD__sideBarWrapper--open');
                if (tutorial == true) {
                    setTimeout(function() {
                        menuTarget.find('.smartStudioD__sideBarToolTip').fadeIn(200);
                    }, 100);
                }
            }
    
            if (!$('.smartStudioD__showBox--open').length) {
                $('.smartStudioD__showBox').addClass('smartStudioD__showBox--open');
            }
    
            currentStep = step;
    
            if (step > 1) {
                $('[data-direction="back"].smartStudioD__topBarNavButton').removeClass('smartStudioD__topBarNavButton--disabled');
            } else {
                $('[data-direction="back"].smartStudioD__topBarNavButton').addClass('smartStudioD__topBarNavButton--disabled');
            }
    
            if (menuTarget.find('.smartStudioD__sideBarButton--active').length || menuTarget.find('.smartStudioD__sideBarColorButton--active').length || menuTarget.find('[data-step="step-3"].smartStudioD__sideBarSlide').find('.smartStudioD__sideBarSlideButton--active').length) {
                $('[data-direction="next"].smartStudioD__topBarNavButton').addClass('smartStudioD__topBarNavButton--active');
            } else {
                $('[data-direction="next"].smartStudioD__topBarNavButton').removeClass('smartStudioD__topBarNavButton--active');
            }
    
            if (step > 4) {
                studioZoomIn();
            } else {
                studioZoomOut();
            }
        }
    
        function setStepMobile(step) {
            var stepArray = ['intro', 'home', 'door', 'color', 'type', 'finish', 'handle'];
            var menu = stepArray[step];
    
            // START GTM event for Flywheel Demand
            try {
                var _gtmSelect = stepArray[currentStep]
                var dataLayer = window.dataLayer || []
    
                if (step > currentStep) {
                    switch (_gtmSelect) {
                        case 'intro':
                            dataLayer.push({
                                event: 'quiz_start'
                            })
                            break
                        case 'type':
                            dataLayer.push({
                                event: 'quiz_next',
                                quiz_step: 'type',
                                quiz_selection: `${urlData.style} | ${urlData.lock} | ${urlData.key} | ${urlData.tech}`
                            })
                            break
                        default:
                            dataLayer.push({
                                event: 'quiz_next',
                                quiz_step: _gtmSelect,
                                quiz_selection: urlData[_gtmSelect]
                            })
                    }
                }
            } catch (error) {
                console.error('GTM tracking for quiz error: ', error)
            }
            // END GTM event for Flywheel Demand
    
            var stepTarget = $('.smartStudioM__controlBarTopButton[data-index="' + step + '"]');
            var menuTarget = $('.smartStudioM__settingsBar[data-menu="' + menu + '"]');
    
            var targetSlider = $('.smartStudioM__controlBarTopFrame');
    
            var origin = targetSlider.offset().left
            var targetPos = ((stepTarget.offset().left + stepTarget.outerWidth()) - origin) + targetSlider.scrollLeft();
            var scrollAmount = (targetPos - targetSlider.outerWidth() + 6);
    
            if (scrollAmount > 0) {
                targetSlider.animate({
                    scrollLeft: scrollAmount
                }, 500);
            }
            stepTarget.addClass('smartStudioM__controlBarTopButton--active');
    
            if ($('.smartStudioM__settingsWrapper--open').length) {
                $('.smartStudioM__settingsWrapper').removeClass('smartStudioM__settingsWrapper--open');
                $('.smartStudioM__toolTip').fadeOut(200);
                setTimeout(function() {
                    $('.smartStudioM__settingsBar').hide();
                    menuTarget.show();
                    $('.smartStudioM__settingsWrapper').addClass('smartStudioM__settingsWrapper--open');
                }, 200);
            } else {
                $('.smartStudioM__settingsBar').hide();
                menuTarget.show();
                $('.smartStudioM__settingsWrapper').addClass('smartStudioM__settingsWrapper--open');
            }
    
            if (!$('.smartStudioM__showBox--open').length) {
                $('.smartStudioM__showBox').addClass('smartStudioM__showBox--open');
            }
    
            currentStep = step;
    
            if (step > 1) {
                $('[data-direction="back"].smartStudioM__controlBarButton').removeClass('smartStudioM__controlBarButton--disabled');
            } else {
                $('[data-direction="back"].smartStudioM__controlBarButton').addClass('smartStudioM__controlBarButton--disabled');
            }
    
            if (menuTarget.find('.smartStudioM__settingsBarButton--active').length || menuTarget.find('.smartStudioM__colorButton--active').length || menuTarget.find('[data-step="step-3"].smartStudioM__typeSlide').find('.smartStudioM__typeSlideButton--active').length) {
                $('[data-direction="next"].smartStudioM__controlBarButton').addClass('smartStudioM__controlBarButton--active');
            } else {
                $('[data-direction="next"].smartStudioM__controlBarButton').removeClass('smartStudioM__controlBarButton--active');
            }
    
            if (step > 4) {
                studioZoomInMobile();
            } else {
                studioZoomOutMobile();
            }
        }
    
        $('.smartStudioD__sideBarClose').on('click', function() {
            $('.smartStudioD__sideBarWrapper').removeClass('smartStudioD__sideBarWrapper--open');
            $('.smartStudioD__showBox').removeClass('smartStudioD__showBox--open');
            $('.smartStudioD__sideBarToolTip').fadeOut(200);
        });
    
        var tutorial = false;
        var started = false;
        var currentStep = 0;
        $('.smartStudioD__startPopButton').on('click', function() {
            tutorial = true;
            started = true;
            setStep(1);
            $('.smartStudioD__startPop').fadeOut(200);
        });
    
        $('.smartStudioM__startPopButton').on('click', function() {
            started = true;
            setStepMobile(1);
            $('.smartStudioM__startPop').fadeOut(200);
        });
    
        $('.smartStudioD__close').on('click', function() {
            tutorial = false;
            started = true;
            setStep(1);
            $('.smartStudioD__startPop').fadeOut(200);
        });
    
        $('.smartStudioD__sideBarToolTipClose').on('click', function() {
            var target = $(this).parent();
            target.fadeOut(200);
            setTimeout(function() {
                target.attr('style', 'display:none!important;');
            }, 200);
        });
    
        $('.smartStudioM__toolTipClose').on('click', function() {
            var target = $(this).parent();
            target.fadeOut(200);
            setTimeout(function() {
                target.attr('style', 'display:none!important;');
            }, 200);
        });
    
        $('[data-direction="next"].smartStudioD__topBarNavButton').on('click', function() {
            if ($(this).hasClass('smartStudioD__topBarNavButton--results')) {
                var dataString = JSON.stringify(urlData);
                var trimmed = dataString.slice(1, -1);
    
                // START GTM event for Flywheel Demand
                try {
                    var dataLayer = window.dataLayer || []
                    dataLayer.push({
                        event: 'quiz_next',
                        quiz_step: 'handle',
                        quiz_selection: urlData.handle
                    })
                } catch (error) {
                    console.error('GTM tracking for quiz error: ', error)
                }
                // END GTM event for Flywheel Demand
    
                window.location.href = '/pages/smart-studio-results?answers=' + trimmed;
            } else if ($(this).hasClass('smartStudioD__topBarNavButton--active')) {
                var targetStep = currentStep + 1;
                setStep(targetStep);
                if (targetStep == "6" && $('.smartStudioD__sideBarButton--handle').hasClass('smartStudioD__sideBarButton--active')) {
                    $('.smartStudioD__topBarNavButton--next').addClass('smartStudioD__topBarNavButton--results');
                }
            }
        });
    
        $('[data-direction="next"].smartStudioM__controlBarButton').on('click', function() {
            if ($(this).hasClass('smartStudioM__controlBarButton--results')) {
                var dataString = JSON.stringify(urlData);
                var trimmed = dataString.slice(1, -1);
    
                // START GTM event for Flywheel Demand
                try {
                    var dataLayer = window.dataLayer || []
                    dataLayer.push({
                        event: 'quiz_next',
                        quiz_step: 'handle',
                        quiz_selection: urlData.handle
                    })
                } catch (error) {
                    console.error('GTM tracking for quiz error: ', error)
                }
                // END GTM event for Flywheel Demand
    
                window.location.href = '/pages/smart-studio-results?answers=' + trimmed;
            } else if ($(this).hasClass('smartStudioM__controlBarButton--active')) {
                var targetStep = currentStep + 1;
                setStepMobile(targetStep);
                if (targetStep == "6" && $('.smartStudioM__settingsBarButton--handle').hasClass('smartStudioM__settingsBarButton--active')) {
                    $('.smartStudioM__controlBarButton--next').addClass('smartStudioM__controlBarButton--results');
                }
            }
        });
    
        $('[data-direction="back"].smartStudioD__topBarNavButton').on('click', function() {
            if (!$(this).hasClass('smartStudioD__topBarNavButton--disabled')) {
                var targetStep = currentStep - 1;
                setStep(targetStep);
                $('.smartStudioD__topBarNavButton--next').removeClass('smartStudioD__topBarNavButton--results');
            }
        });
    
        $('[data-direction="back"].smartStudioM__controlBarButton').on('click', function() {
            if (!$(this).hasClass('smartStudioM__controlBarButton--disabled')) {
                var targetStep = currentStep - 1;
                setStepMobile(targetStep);
                $('.smartStudioM__controlBarButton--next').removeClass('smartStudioM__controlBarButton--results');
            }
        });
    
        $('.smartStudioD__topBarButton').on('click', function() {
            if ($(this).hasClass('smartStudioD__topBarButton--active')) {
                var index = $(this).attr('data-index') * 1;
                if (currentStep != index || $('.smartStudioD__showBox--open').length == 0) {
                    setStep(index);
                }
            }
        });
    
        $('.smartStudioM__controlBarTopButton').on('click', function() {
            if ($(this).hasClass('smartStudioM__controlBarTopButton--active')) {
                var index = $(this).attr('data-index') * 1;
                if (currentStep != index || $('.smartStudioM__showBox--open').length == 0) {
                    setStepMobile(index);
                }
            }
        });
    
        $('.smartStudioD__sideBarInfoIcon').on('click', function() {
            var target = $(this).closest('.smartStudioD__sideBarInner').find('.smartStudioD__sideBarToolTip').fadeIn(200);
        });
    
        $('.smartStudioM__settingsBarInfo').on('click', function() {
            var target = $(this).closest('.smartStudioM__settingsBar').find('.smartStudioM__toolTip').fadeIn(200);
        });
    
        var slide = 0;
    
        function goToSlide(slide) {
            $('.smartStudioD__sideBarSliderSled').attr('style', 'transform:translateX(calc((-100% / 4) * ' + slide + '));');
        }
    
        function goToSlideMobile(slide) {
            $('.smartStudioM__typeSlideSliderSled').attr('style', 'transform:translateX(calc((-100% / 4) * ' + slide + '));');
        }
    
        $('.smartStudioD__sideBarNext').on('click', function() {
            if (!$(this).find('img').hasClass('smartStudioD__sideBarNextArrow--disabled') && !$(this).find('img').hasClass('smartStudioD__sideBarNextArrow--end')) {
                var selectedStyle = $('.smartStudioD__sideBarSlide[data-step="step-1"]').find('.smartStudioD__sideBarSlideButton--active').attr('data-answer');
    
                slide += 1;
    
                if (slide == 1) {
                    if (selectedStyle == 'plus') {
                        $(this).find('img').addClass('smartStudioD__sideBarNextArrow--end');
                    } else {
                        $(this).find('img').removeClass('smartStudioD__sideBarNextArrow--end');
                    }
                }
                if (slide == 2) {
                    if (selectedStyle == 'touch') {
                        $(this).find('img').addClass('smartStudioD__sideBarNextArrow--end');
                    } else {
                        $(this).find('img').removeClass('smartStudioD__sideBarNextArrow--end');
                    }
                }
    
    
                goToSlide(slide);
                $('.smartStudioD__sideBarPrevious').find('img').removeClass('smartStudioD__sideBarPreviousArrow--disabled');
                if ($('[data-step="step-' + (slide + 1) + '"].smartStudioD__sideBarSlide').find('.smartStudioD__sideBarSlideButton--active')) {
                    $(this).find('img').removeClass('smartStudioD__sideBarNextArrow--disabled');
                } else {
                    $(this).find('img').addClass('smartStudioD__sideBarNextArrow--disabled');
                }
                if (slide == 1) {
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-2'));
                }
                if (slide == 2) {
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-3'));
                }
                if (slide == 3) {
                    $(this).find('img').addClass('smartStudioD__sideBarNextArrow--end');
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-4'));
                }
                $('.smartStudioD__sideBarDot').removeClass('smartStudioD__sideBarDot--active');
                $('.smartStudioD__sideBarDot[data-step="step-' + (slide + 1) + '"]').show();
                $('.smartStudioD__sideBarDot[data-step="step-' + (slide + 1) + '"]').addClass('smartStudioD__sideBarDot--active');
            }
        });
    
        $('.smartStudioM__typeSlideNext').on('click', function() {
            if (!$(this).find('img').hasClass('smartStudioM__typeSlideNextArrow--disabled') && !$(this).find('img').hasClass('smartStudioM__typeSlideNextArrow--end')) {
    
                var selectedStyle = $('.smartStudioM__typeSlide[data-step="step-1"]').find('.smartStudioM__typeSlideButton--active').attr('data-answer');
    
                slide += 1;
    
                if (slide == 1) {
                    if (selectedStyle == 'plus') {
                        $(this).find('img').addClass('smartStudioM__typeSlideNextArrow--end');
                    } else {
                        $(this).find('img').removeClass('smartStudioM__typeSlideNextArrow--end');
                    }
                }
                if (slide == 2) {
                    if (selectedStyle == 'touch') {
                        $(this).find('img').addClass('smartStudioM__typeSlideNextArrow--end');
                    } else {
                        $(this).find('img').removeClass('smartStudioM__typeSlideNextArrow--end');
                    }
                }
    
                goToSlideMobile(slide);
                $('.smartStudioM__typeSlidePrevious').find('img').removeClass('smartStudioM__typeSlidePreviousArrow--disabled');
                if ($('[data-step="step-' + (slide + 1) + '"].smartStudioM__typeSlide').find('.smartStudioM__typeSlideButton--active')) {
                    $(this).find('img').removeClass('smartStudioM__typeSlideNextArrow--disabled');
                } else {
                    $(this).find('img').addClass('smartStudioM__typeSlideNextArrow--disabled');
                }
                if (slide == 3) {
                    $(this).find('img').addClass('smartStudioM__typeSlideNextArrow--end');
                }
                $('.smartStudioM__typeSlideBarDot').removeClass('smartStudioM__typeSlideBarDot--active');
                $('.smartStudioM__typeSlideBarDot[data-step="step-' + (slide + 1) + '"]').addClass('smartStudioM__typeSlideBarDot--active');
            }
        });
    
        $('.smartStudioD__sideBarDot').hide();
        $('.smartStudioD__sideBarDot[data-step="step-1"]').show();
    
        $('.smartStudioD__sideBarPrevious').on('click', function() {
            if (!$(this).find('img').hasClass('smartStudioD__sideBarPreviousArrow--disabled')) {
                slide -= 1;
                goToSlide(slide);
                $('.smartStudioD__sideBarNext').find('img').removeClass('smartStudioD__sideBarNextArrow--end');
                if (slide == 2) {
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-3'));
                }
                if (slide == 1) {
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-2'));
                }
                if (slide == 0) {
                    $(this).find('img').addClass('smartStudioD__sideBarPreviousArrow--disabled')
                    $('.smartStudioD__sideBarTitle--multi').text($('.smartStudioD__sideBarTitle--multi').attr('step-1'));
                }
                $('.smartStudioD__sideBarDot').removeClass('smartStudioD__sideBarDot--active');
                $('.smartStudioD__sideBarDot[data-step="step-' + (slide + 1) + '"]').addClass('smartStudioD__sideBarDot--active');
            }
        });
    
        $('.smartStudioM__typeSlidePrevious').on('click', function() {
            if (!$(this).find('img').hasClass('smartStudioM__typeSlidePreviousArrow--disabled')) {
                slide -= 1;
                goToSlideMobile(slide);
                $('.smartStudioM__typeSlideNext').find('img').removeClass('smartStudioM__typeSlideNextArrow--end');
                if (slide == 0) {
                    $(this).find('img').addClass('smartStudioM__typeSlidePreviousArrow--disabled')
                }
                $('.smartStudioM__typeSlideBarDot').removeClass('smartStudioM__typeSlideBarDot--active');
                $('.smartStudioM__typeSlideBarDot[data-step="step-' + (slide + 1) + '"]').addClass('smartStudioM__typeSlideBarDot--active');
            }
        });
    
    }
    
    if ($('#smart-studio-results').length > 0) {
        var homeLib = createHomeArray();
        var doorLib = createDoorArray();
        var lockLib = createLockArray();
        var handleLib = createHandleArray();
        var productLib = createProductArray();
        var handleProductLib = createHandleProductArray();
    
        function preloadImage(url) {
            var img = new Image();
            img.src = url;
        }
        for (i = 0; i < homeLib.length; i++) {
            preloadImage(homeLib[i].mobile);
            preloadImage(homeLib[i].preview);
            preloadImage(homeLib[i].src);
            preloadImage(homeLib[i].zoomed);
            preloadImage(homeLib[i].zoomedMobile);
        }
        for (i = 0; i < doorLib.length; i++) {
            preloadImage(doorLib[i].preview);
            preloadImage(doorLib[i].srcs.black);
            preloadImage(doorLib[i].srcs.blue);
            preloadImage(doorLib[i].srcs.gray);
            preloadImage(doorLib[i].srcs.green);
            preloadImage(doorLib[i].srcs.pink);
            preloadImage(doorLib[i].srcs.red);
            preloadImage(doorLib[i].srcs.sage);
            preloadImage(doorLib[i].srcs.salmon);
            preloadImage(doorLib[i].srcs.teal);
            preloadImage(doorLib[i].srcs.white);
            preloadImage(doorLib[i].srcs.midgray);
            preloadImage(doorLib[i].srcs.beige);
            preloadImage(doorLib[i].srcs.eggplant);
            preloadImage(doorLib[i].srcs.mobile_black);
            preloadImage(doorLib[i].srcs.mobile_blue);
            preloadImage(doorLib[i].srcs.mobile_gray);
            preloadImage(doorLib[i].srcs.mobile_green);
            preloadImage(doorLib[i].srcs.mobile_pink);
            preloadImage(doorLib[i].srcs.mobile_red);
            preloadImage(doorLib[i].srcs.mobile_sage);
            preloadImage(doorLib[i].srcs.mobile_salmon);
            preloadImage(doorLib[i].srcs.mobile_teal);
            preloadImage(doorLib[i].srcs.mobile_white);
            preloadImage(doorLib[i].srcs.mobile_yellow);
            preloadImage(doorLib[i].srcs.mobile_midgray);
            preloadImage(doorLib[i].srcs.mobile_beige);
            preloadImage(doorLib[i].srcs.mobile_eggplant);
            preloadImage(doorLib[i].srcs.zoom_black);
            preloadImage(doorLib[i].srcs.zoom_blue);
            preloadImage(doorLib[i].srcs.zoom_gray);
            preloadImage(doorLib[i].srcs.zoom_green);
            preloadImage(doorLib[i].srcs.zoom_pink);
            preloadImage(doorLib[i].srcs.zoom_red);
            preloadImage(doorLib[i].srcs.zoom_sage);
            preloadImage(doorLib[i].srcs.zoom_salmon);
            preloadImage(doorLib[i].srcs.zoom_teal);
            preloadImage(doorLib[i].srcs.zoom_white);
            preloadImage(doorLib[i].srcs.zoom_yellow);
            preloadImage(doorLib[i].srcs.zoom_midgray);
            preloadImage(doorLib[i].srcs.zoom_beige);
            preloadImage(doorLib[i].srcs.zoom_eggplant);
            preloadImage(doorLib[i].srcs.zoom_mobile_black);
            preloadImage(doorLib[i].srcs.zoom_mobile_blue);
            preloadImage(doorLib[i].srcs.zoom_mobile_gray);
            preloadImage(doorLib[i].srcs.zoom_mobile_green);
            preloadImage(doorLib[i].srcs.zoom_mobile_pink);
            preloadImage(doorLib[i].srcs.zoom_mobile_red);
            preloadImage(doorLib[i].srcs.zoom_mobile_sage);
            preloadImage(doorLib[i].srcs.zoom_mobile_salmon);
            preloadImage(doorLib[i].srcs.zoom_mobile_teal);
            preloadImage(doorLib[i].srcs.zoom_mobile_white);
            preloadImage(doorLib[i].srcs.zoom_mobile_yellow);
            preloadImage(doorLib[i].srcs.zoom_mobile_midgray);
            preloadImage(doorLib[i].srcs.zoom_mobile_beige);
            preloadImage(doorLib[i].srcs.zoom_mobile_eggplant);
        }
        for (i = 0; i < lockLib.length; i++) {
            if (typeof(lockLib[i].previews.silver) !== "undefined") {
                preloadImage(lockLib[i].previews.black);
                preloadImage(lockLib[i].previews.bronze);
                preloadImage(lockLib[i].previews.silver);
                preloadImage(lockLib[i].srcs.black);
                preloadImage(lockLib[i].srcs.bronze);
                preloadImage(lockLib[i].srcs.silver);
                preloadImage(lockLib[i].srcs.mobile_black);
                preloadImage(lockLib[i].srcs.mobile_bronze);
                preloadImage(lockLib[i].srcs.mobile_silver);
                preloadImage(lockLib[i].srcs.zoom_black);
                preloadImage(lockLib[i].srcs.zoom_bronze);
                preloadImage(lockLib[i].srcs.zoom_silver);
                preloadImage(lockLib[i].srcs.zoom_mobile_black);
                preloadImage(lockLib[i].srcs.zoom_mobile_bronze);
                preloadImage(lockLib[i].srcs.zoom_mobile_silver);
            }
            if (typeof(lockLib[i].previews.snow) !== "undefined") {
                preloadImage(lockLib[i].previews.snow);
                preloadImage(lockLib[i].previews.black);
                preloadImage(lockLib[i].previews.ash);
                preloadImage(lockLib[i].srcs.snow);
                preloadImage(lockLib[i].srcs.black);
                preloadImage(lockLib[i].srcs.ash);
                preloadImage(lockLib[i].srcs.mobile_snow);
                preloadImage(lockLib[i].srcs.mobile_black);
                preloadImage(lockLib[i].srcs.mobile_ash);
                preloadImage(lockLib[i].srcs.zoom_snow);
                preloadImage(lockLib[i].srcs.zoom_black);
                preloadImage(lockLib[i].srcs.zoom_ash);
                preloadImage(lockLib[i].srcs.zoom_mobile_snow);
                preloadImage(lockLib[i].srcs.zoom_mobile_black);
                preloadImage(lockLib[i].srcs.zoom_mobile_ash);
            }
            if (typeof(lockLib[i].previews.pantone) !== "undefined") {
                preloadImage(lockLib[i].previews.pantone);
                preloadImage(lockLib[i].srcs.pantone);
                preloadImage(lockLib[i].srcs.mobile_pantone);
                preloadImage(lockLib[i].srcs.zoom_pantone);
                preloadImage(lockLib[i].srcs.zoom_mobile_pantone);
            }
        }
        for (i = 0; i < handleLib.length; i++) {
            preloadImage(handleLib[i].mobile);
            preloadImage(handleLib[i].preview);
            preloadImage(handleLib[i].src);
            preloadImage(handleLib[i].zoom_src);
            preloadImage(handleLib[i].zoom_mobile);
        }
    
        var urlSearch = window.location.search;
        var decodedUrlSearch = decodeURIComponent((urlSearch + '').replace(/\+/g, '%20'));
        var urlDataString = '{' + decodedUrlSearch.split('=')[1] + '}';
        var urlData = JSON.parse(urlDataString);
    
        function setShowBox(data) {
            var color = data.color;
            var doorIndex = data.door * 1;
            var finishIndex = data.finish * 1;
            var handleIndex = data.handle * 1;
            var homeIndex = data.home * 1;
            var style = data.style;
            var key = data.key;
            var lock = data.lock;
            var tech = data.tech;
    
            var desktopDoor = '';
            var mobileDoor = '';
    
            if (color == "white") {
                desktopDoor = doorLib[doorIndex].srcs.white;
                mobileDoor = doorLib[doorIndex].srcs.mobile_white;
            } else if (color == "pink") {
                desktopDoor = doorLib[doorIndex].srcs.pink;
                mobileDoor = doorLib[doorIndex].srcs.mobile_pink;
            } else if (color == "salmon") {
                desktopDoor = doorLib[doorIndex].srcs.salmon;
                mobileDoor = doorLib[doorIndex].srcs.mobile_salmon;
            } else if (color == "blue") {
                desktopDoor = doorLib[doorIndex].srcs.blue;
                mobileDoor = doorLib[doorIndex].srcs.mobile_gray;
            } else if (color == "gray") {
                desktopDoor = doorLib[doorIndex].srcs.gray;
                mobileDoor = doorLib[doorIndex].srcs.mobile_gray;
            } else if (color == "red") {
                desktopDoor = doorLib[doorIndex].srcs.red;
                mobileDoor = doorLib[doorIndex].srcs.mobile_red;
            } else if (color == "yellow") {
                desktopDoor = doorLib[doorIndex].srcs.yellow;
                mobileDoor = doorLib[doorIndex].srcs.mobile_yellow;
            } else if (color == "teal") {
                desktopDoor = doorLib[doorIndex].srcs.teal;
                mobileDoor = doorLib[doorIndex].srcs.mobile_teal;
            } else if (color == "black") {
                desktopDoor = doorLib[doorIndex].srcs.black;
                mobileDoor = doorLib[doorIndex].srcs.mobile_black;
            } else if (color == "sage") {
                desktopDoor = doorLib[doorIndex].srcs.sage;
                mobileDoor = doorLib[doorIndex].srcs.mobile_sage;
            } else if (color == "green") {
                desktopDoor = doorLib[i].srcs.green;
                mobileDoor = doorLib[i].srcs.mobile_green;
            } else if (color == "midgray") {
                desktopDoor = doorLib[i].srcs.midgray;
                mobileDoor = doorLib[i].srcs.mobile_midgray;
            } else if (color == "beige") {
                desktopDoor = doorLib[i].srcs.beige;
                mobileDoor = doorLib[i].srcs.mobile_beige;
            } else if (color == "eggplant") {
                desktopDoor = doorLib[i].srcs.eggplant;
                mobileDoor = doorLib[i].srcs.mobile_eggplant;
            }
    
            var selected = 0;
            if (style == 'standard') {
                if (key == 'keyfree') {
                    if (lock == 'touchscreen') {
                        selected = lockLib[4];
                    } else {
                        selected = lockLib[6];
                    }
                } else {
                    if (lock == 'touchscreen') {
                        selected = lockLib[3];
                    } else {
                        if (tech == "matter") {
                            selected = lockLib[7];
                            console.log(selected);
                        } else {
                            selected = lockLib[5];
                        }
                    }
                }
            } else if (style == 'touch') {
                if (key == 'keyfree') {
                    selected = lockLib[1];
                } else {
                    selected = lockLib[0];
                }
            } else if (style == 'plus') {
                selected = lockLib[2];
            }
    
            var desktopLock = '';
            var mobileLock = '';
            if (finishIndex == 0) {
                desktopLock = selected.srcs.black;
                mobileLock = selected.srcs.mobile_black;
            } else if (finishIndex == 1) {
                desktopLock = selected.srcs.silver;
                mobileLock = selected.srcs.mobile_silver;
            } else if (finishIndex == 2) {
                desktopLock = selected.srcs.bronze;
                mobileLock = selected.srcs.mobile_bronze;
            } else if (finishIndex == 3) {
                desktopLock = selected.srcs.pantone;
                mobileLock = selected.srcs.mobile_pantone;
            } else if (finishIndex == 4) {
                desktopLock = selected.srcs.snow;
                mobileLock = selected.srcs.mobile_snow;
            } else if (finishIndex == 5) {
                desktopLock = selected.srcs.black;
                mobileLock = selected.srcs.mobile_black;
            } else if (finishIndex == 6) {
                desktopLock = selected.srcs.ash;
                mobileLock = selected.srcs.mobile_ash;
            } else {
                desktopLock = selected.srcs.bronze;
                mobileLock = selected.srcs.mobile_bronze;
            }
    
            $('.studioResults__heroBoxDesktopHome').attr('src', homeLib[homeIndex].src);
            $('.studioResults__heroBoxDesktopDoor').attr('src', desktopDoor);
            $('.studioResults__heroBoxDesktopLock').attr('src', desktopLock);
            $('.studioResults__heroBoxDesktopHandle').attr('src', handleLib[handleIndex].src);
    
            $('.studioResults__heroBoxMobileHome').attr('src', homeLib[homeIndex].mobile);
            $('.studioResults__heroBoxMobileDoor').attr('src', mobileDoor);
            $('.studioResults__heroBoxMobileLock').attr('src', mobileLock);
            $('.studioResults__heroBoxMobileHandle').attr('src', handleLib[handleIndex].mobile);
        }
        setShowBox(urlData);
    
        var chooseString = 'Yale Assure Lock 2 ';
    
        if (urlData.style == 'stardard') {
    
        } else if (urlData.style == 'touch') {
            chooseString += 'Touch ';
        } else if (urlData.style == 'plus') {
            chooseString += 'Plus ';
        }
    
        if (urlData.key == 'keyed') {
            chooseString += 'with Keys | ';
        } else {
            chooseString += 'without Keys | ';
        }
        if (urlData.tech == 'wifi') {
            chooseString += 'Wi-Fi Upgrade | ';
        } else if (urlData.tech == 'bluetooth') {
            chooseString += 'Bluetooth | ';
        } else if (urlData.tech == 'matter') {
            chooseString += 'Matter | ';
        }
        if (urlData.finish == 0) {
            chooseString += 'Matte Black | ';
        } else if (urlData.finish == 1) {
            chooseString += 'Silver | ';
        } else if (urlData.finish == 2) {
            chooseString += 'Bronze | ';
        } else if (urlData.finish == 3) {
            chooseString += 'Pantone 18-1750, Viva Magenta | ';
        } else if (urlData.finish == 4) {
            chooseString += 'Snow | ';
        } else if (urlData.finish == 5) {
            chooseString += 'Matte Black | ';
        } else if (urlData.finish == 6) {
            chooseString += 'Ash | ';
        } else {
            chooseString += 'Bronze | ';
        }
        var yourtext = handleProductLib[(urlData.handle * 1)].name;
        var capitalized = yourtext.substr(0, 1).toUpperCase() + yourtext.substr(1);
        chooseString += capitalized + ' Hardware'
    
        $('.studioResults__textBucket').text(chooseString);
    
        function checkBlack(string) {
            if (string == 'black' || string == 'Black' || string == 'matte black' || string == 'Matte Black' || string == 'black suede' || string == 'Black Suede') {
                return true;
            } else {
                return false;
            }
        }
    
        function checkSilver(string) {
            if (string == 'silver' || string == 'Silver' || string == 'satin nickel' || string == 'Satin Nickel' || string == 'polished chrome' || string == 'Polished Chrome' || string == 'satin chrome' || string == 'Satin Chrome') {
                return true;
            } else {
                return false;
            }
        }
    
        function checkBronze(string) {
            if (string == 'bronze' || string == 'Bronze' || string == 'oil rubbed bronze' || string == 'Oil Rubbed Bronze' || string == 'polished brass' || string == 'Polished Brass') {
                return true;
            } else {
                return false;
            }
        }
    
        function checkPantone(string) {
            if (string.indexOf('magenta') > 0 || string.indexOf('Magenta') > 0) {
                return true;
            } else {
                return false;
            }
        }
    
        function checkSnow(string) {
            if (string == "snow" || string == "Snow") {
                return true;
            } else {
                return false;
            }
        }
    
        function checkAsh(string) {
            if (string == "ash" || string == "Ash") {
                return true;
            } else {
                return false;
            }
        }
    
        function pickProducts(data) {
            var finishIndex = data.finish * 1;
            var style = data.style;
            var key = data.key;
            var lock = data.lock;
            var tech = data.tech;
            var handleIndex = data.handle * 1;
    
            $('.studioCard--lock').each(function() {
                var thisStyle = $(this).attr('data-style');
                var thisKey = $(this).attr('data-key');
                var thisLock = $(this).attr('data-lock');
                var thisTech = $(this).attr('data-tech');
                var thisFinish = $(this).attr('data-finish');
    
                if (thisKey == key || key == "either") {
                    if (thisLock == lock && thisTech == tech && thisStyle == style) {
                        if (finishIndex == 0 && checkBlack(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 1 && checkSilver(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 2 && checkBronze(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 3 && checkPantone(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 4 && checkSnow(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 5 && checkBlack(thisFinish)) {
                            $(this).show();
                        } else if (finishIndex == 6 && checkAsh(thisFinish)) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    } else {
                        $(this).hide();
                    }
                } else {
                    $(this).hide();
                }
            });
    
            $('.studioCard--handle').each(function() {
                var thisFinish = $(this).attr('data-finish');
                if ($(this).attr('data-handle') == 'ridgefield' && handleIndex == 0) {
                    if (finishIndex == 0 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 1 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 2 && checkBronze(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 3 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 4 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 5 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 6 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                } else if ($(this).attr('data-handle') == 'kincaid' && handleIndex == 1) {
                    if (finishIndex == 0 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 1 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 2 && checkBronze(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 3 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 4 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 5 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 6 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                } else if ($(this).attr('data-handle') == 'valdosta' && handleIndex == 2) {
                    if (finishIndex == 0 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 1 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 2 && checkBronze(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 3 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 4 && checkSilver(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 5 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else if (finishIndex == 6 && checkBlack(thisFinish)) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                } else {
                    $(this).hide();
                }
            });
    
        }
        pickProducts(urlData);
    
        function addToCart(variant, qty, keyed) {
            if (checkDiscountLimitFull(variant)) {
                alert('You can only order up to ' + $('body').attr('data-qty-limit') * 1 + ' discounted items.');
                return;
            }
            if (typeof keyed !== "undefined" && keyed) {
                CartJS.addItem(variant, qty, {
                    "_keyed_alike_available": keyed
                }, {
                    "success": function(data, textStatus, jqXHR) {
                        setTimeout(function() {
                            updateCart(true);
                        }, 200);
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log('Error: ' + errorThrown + '!');
                    }
                });
            } else {
                CartJS.addItem(variant, qty, {}, {
                    "success": function(data, textStatus, jqXHR) {
                        updateCart(true);
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log('Error: ' + errorThrown + '!');
                    }
                });
            }
        }
    
        $('.studioCard__extendWrapper').each(function() {
            var variantId = $(this).attr('data-id');
            var thisPrice = $(this).attr('data-price');
            var thisType = $(this).attr('data-type');
            var id = '#' + $(this).attr('id');
            Extend.buttons.render(
                id, {
                    referenceId: variantId,
                    price: thisPrice,
                    category: thisType
                }
            )
            $(this).parent().find('.studioCard__buyButton').on('click', function() {
                var qty = $(this).parent().parent().find('.studioCard__quantity').text() * 1;
                ExtendShopify.handleAddToCart(id, {
                    quantity: qty,
                    modal: false,
                    done: function() {
                        if (keyed == "true") {
                            addToCart(variantId, qty, "true");
                        } else {
                            addToCart(variantId, qty);
                        }
                    }
                });
            });
        });
    
        $('.studioCard__quantityMinus').on('click', function() {
            var target = $(this).parent().find('.studioCard__quantity');
            if ((target.text() * 1) > 1) {
                target.text((target.text() * 1) - 1);
            }
        });
    
        $('.studioCard__quantityPlus').on('click', function() {
            var target = $(this).parent().find('.studioCard__quantity');
            target.text((target.text() * 1) + 1);
        });
        }
    
            if ($('#shopify-section-matterNotify').length > 0) {
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
    
            if ($('#edit-keyed-alike').length > 0) {
                function getKeyableItems() {
                    var keyableItems = [];
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties[
                                '_keyed_alike_available'
                            ] == 'true'
                        ) {
                            var clone = JSON.parse(
                                JSON.stringify(CartJS.cart.items[i])
                            );
                            clone.index = i + 1;
                            keyableItems.push(clone);
                        }
                    }
                    return keyableItems;
                }
    
                function getSavedItems() {
                    var savedItems = [];
                    for (i = 0; i < CartJS.cart.items.length; i++) {
                        if (
                            CartJS.cart.items[i].properties['_name'] ==
                            'keyed_alike_group'
                        ) {
                            var clone = JSON.parse(
                                JSON.stringify(CartJS.cart.items[i])
                            );
                            savedItems.push(clone);
                        }
                    }
                    return savedItems;
                }
    
                var mobileGroupItemTemplate = $('.kaMGroup__prodList').html();
                $('.kaMGroup__prodList').html('');
    
                function fillCartListing(prodList) {
                    var template = $('.ka__cartList').html();
                    $('.ka__cartList').html('');
    
                    var mobTemplate = $('.kaM__cartItems').html();
                    $('.kaM__cartItems').html('');
    
                    for (i = 0; i < prodList.length; i++) {
                        var prod = prodList[i];
                        if (
                            $('.kaCartItem[data-id="' + prod.variant_id + '"]')
                                .length == 0
                        ) {
                            $('.ka__cartList').html(
                                $('.ka__cartList').html() + template
                            );
                            var target = $('.kaCartItem').last();
                            target.attr('data-id', prod.variant_id);
                            target.attr('data-type', prod.product_type);
                            target.attr('data-qty', prod.quantity);
                            target.attr('data-qtyavailable', prod.quantity);
                            target
                                .find('.kaCartItem__image')
                                .attr('src', prod.image)
                                .attr('alt', prod.title);
                            if (prod.variant_title != 'default') {
                                target
                                    .find('.kaCartItem__title')
                                    .html(
                                        prod.product_title +
                                            '</br>' +
                                            prod.variant_title
                                    );
                            } else {
                                target
                                    .find('.kaCartItem__title')
                                    .html(prod.product_title);
                            }
                            target
                                .find(
                                    '.kaCartItem__showQty, .kaCartItem__editQtyAvailable, .kaCartItem__editQtyTotal'
                                )
                                .text(prod.quantity);
    
                            //mobile
                            $('.kaM__cartItems').html(
                                $('.kaM__cartItems').html() + mobTemplate
                            );
                            var mobTarget = $('.kaMCartItem').last();
                            mobTarget.attr('data-id', prod.variant_id);
                            mobTarget.attr('data-type', prod.product_type);
                            mobTarget.attr('data-qty', prod.quantity);
                            mobTarget
                                .find('.kaMCartItem__img')
                                .attr('src', prod.image)
                                .attr('alt', prod.title);
                            if (prod.variant_title != 'default') {
                                mobTarget
                                    .find('.kaMCartItem__title')
                                    .html(
                                        prod.product_title +
                                            '</br>' +
                                            prod.variant_title
                                    );
                            } else {
                                mobTarget
                                    .find('.kaMCartItem__title')
                                    .html(prod.product_title);
                            }
    
                            mobTarget
                                .find('.kaMCartItem__qty')
                                .text(prod.quantity + '/' + prod.quantity);
                        } else {
                            var target = $(
                                '.kaCartItem[data-id="' + prod.variant_id + '"]'
                            );
                            var currentQty = target.attr('data-qty') * 1;
                            target.attr('data-qty', currentQty + prod.quantity);
                            target.attr(
                                'data-qtyavailable',
                                currentQty + prod.quantity
                            );
                            target.attr('data-type', prod.product_type);
                            target
                                .find('.kaCartItem__editQtyTotal')
                                .text(currentQty + prod.quantity);
                            target
                                .find('.kaCartItem__showQty')
                                .text(currentQty + prod.quantity);
                        }
    
                        //mobile group template generation
                        var mobileCurrentProds = $('.kaMGroup__prodList').html();
                        if (
                            $('.kaMProd[data-id="' + prod.variant_id + '"]')
                                .length == 0
                        ) {
                            $('.kaMGroup__prodList').html(
                                mobileCurrentProds + mobileGroupItemTemplate
                            );
                            var mobileNewProd = $('.kaMGroup__prodList')
                                .find('.kaMProd')
                                .last();
                            mobileNewProd.attr('data-qty', prod.quantity);
                            mobileNewProd.find('.kaMProd__qty').text(prod.quantity);
                            mobileNewProd.attr('data-max-qty', prod.quantity);
                            mobileNewProd.attr('data-id', prod.id);
                            mobileNewProd.attr('data-type', prod.product_type);
                            mobileNewProd.attr('data-group', '0');
                            mobileNewProd
                                .find('.kaMProd__image')
                                .attr('src', prod.image);
                            mobileNewProd
                                .find('.kaMProd__image')
                                .attr('alt', prod.title);
                            if (prod.variant_title != 'default') {
                                mobileNewProd
                                    .find('.kaMProd__title')
                                    .html(
                                        prod.product_title +
                                            '</br>' +
                                            prod.variant_title
                                    );
                            } else {
                                mobileNewProd
                                    .find('.kaMProd__title')
                                    .text(prod.product_title);
                            }
                            mobileNewProd
                                .find('.kaMProd__minusButton')
                                .addClass('kaMProd__minusButton--disabled');
                        } else {
                            var mobileTarget = $(
                                '.kaMProd[data-id="' + prod.variant_id + '"]'
                            );
                            var mobileCurrentQty =
                                mobileTarget.attr('data-qty') * 1;
                            mobileTarget.attr(
                                'data-qty',
                                mobileCurrentQty + prod.quantity
                            );
                            mobileTarget.attr(
                                'data-max-qty',
                                mobileCurrentQty + prod.quantity
                            );
                            mobileTarget.attr('data-type', prod.product_type);
                            mobileTarget
                                .find('.kaMProd__qty')
                                .text(mobileCurrentQty + prod.quantity);
                            mobileTarget
                                .find('.kaMProd__minusButton')
                                .addClass('kaMProd__minusButton--disabled');
                        }
                    }
    
                    mobileGroupTemplate = $('.kaM__groupsList').html();
                    $('.kaM__groupsList').html('');
    
                    bindPlusButton();
                    bindMinusButton();
                    bindMobilePlusButton();
                    bindMobileCreateGroup();
    
                    bindMobileRemoveEvents();
                    bindMobileSliders();
                }
    
                function fillSavedProducts(prodList) {
                    for (i = 0; i < prodList.length; i++) {
                        var prodData = prodList[i];
                        var thisGroup = prodData.properties['_value'];
                        var thisQty = prodData.quantity * 1;
                        var thisId = prodData.variant_id;
                        var thisTitle = prodData.product_title;
                        var thisType = prodData.product_type;
    
                        var product = $('.kaCartItem[data-id="' + thisId + '"]');
                        var productImage = product
                            .find('.kaCartItem__image')
                            .attr('src');
                        var productTitle = product
                            .find('.kaCartItem__image')
                            .attr('alt');
                        var productQty = product.attr('data-qty') * 1;
                        var productMaxQty = product.attr('data-qtyavailable');
    
                        if (
                            $('.kaGroup[data-group="' + thisGroup + '"]').length ==
                            0
                        ) {
                            var groupNumber = thisGroup * 1;
                            for (j = 0; j < groupNumber; j++) {
                                if (
                                    $('.kaGroup[data-group="' + (j * 1 + 1) + '"]')
                                        .length == 0
                                ) {
                                    var currentGroups = $('.kaGroups').html();
                                    $('.kaGroups').html(
                                        currentGroups + groupTemplate
                                    );
                                    var target = $('.kaGroup').last();
                                    target.find('.kaGroup__index').text(j * 1 + 1);
                                    target.attr('data-group', j * 1 + 1);
                                    target.attr('data-state', 'saved');
                                    groupStateCSS(target);
    
                                    //mobile
                                    var mobCurrentGroups =
                                        $('.kaM__groupsList').html();
                                    $('.kaM__groupsList').html(
                                        mobCurrentGroups + mobileGroupTemplate
                                    );
                                    var mobTarget = $('.kaM__groupWrapper').last();
                                    mobTarget
                                        .find(
                                            '.kaMGroup__titleNumber, .kaM__groupNumber'
                                        )
                                        .text(j * 1 + 1);
                                    mobTarget.attr('data-group', j * 1 + 1);
                                    mobTarget.attr('data-state', 'saved');
                                }
                            }
                        }
    
                        var group = $('.kaGroup[data-group="' + thisGroup + '"]');
    
                        var currentProds = group
                            .find('.kaGroup__productList')
                            .html();
                        group
                            .find('.kaGroup__productList')
                            .html(currentProds + groupItemTemplate);
    
                        var newProd = group.find('.kaGroupProd').last();
                        newProd.attr('data-qty', thisQty);
                        newProd.find('.kaGroupProd__qty').text(thisQty);
                        newProd.attr('data-id', thisId);
                        newProd.attr('data-type', thisType);
                        newProd.attr('data-group', thisGroup);
                        newProd
                            .find('.kaGroupProd__image')
                            .attr('src', productImage);
                        newProd.find('.kaGroupProd__image').attr('alt', thisTitle);
                        newProd.find('.kaGroupProd__title').text(thisTitle);
    
                        product.attr('data-qty', productQty - thisQty);
                        product
                            .find('.kaCartItem__editQtyAvailable')
                            .text(productQty - thisQty);
                        product
                            .find('.kaCartItem__showQty')
                            .text(productQty - thisQty);
                        if (
                            product.find('.kaCartItem__editQtyAvailable').text() ==
                            '0'
                        ) {
                            product
                                .find('.kaCartItem__plusButton')
                                .addClass('kaCartItem__plusButton--disabled');
                        }
                    }
    
                    $('.kaCartItem').each(function () {
                        var thisQty = $(this).attr('data-qty');
                        var thisId = $(this).attr('data-id');
    
                        var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
                        var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;
    
                        mobProd.attr('data-qty', thisQty);
                        var mobProdQty =
                            mobProdQtyMax - mobProd.attr('data-qty') * 1;
                        var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;
    
                        mobProd.find('.kaMProd__qty').text(mobProdQtyString);
                        if (mobProdQty == 0) {
                            mobProd
                                .find('.kaMProd__plusButton')
                                .addClass('kaMProd__plusButton--disabled');
                        } else if (mobProdQty == mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .addClass('kaMProd__minusButton--disabled');
                        } else if (mobProdQty < mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .removeClass('kaMProd__minusButton--disabled');
                        }
    
                        $('.kaMCartItem[data-id="' + thisId + '"]')
                            .find('.kaMCartItem__qty')
                            .text(thisQty + '/' + thisQty);
                    });
    
                    var subtotal = 0;
                    $('.kaGroupProd').each(function () {
                        subtotal += $(this).attr('data-qty') * 1 * 3.99;
                    });
                    subtotal = subtotal.toFixed(2);
                    $('.ka__groupSubtotalPrice').text('$' + subtotal);
                    $('.kaMFooter__subtotalPrice').text('$' + subtotal);
    
                    var totalQty = 0;
                    $('.kaCartItem__showQty').each(function () {
                        var addQty = $(this).text() * 1;
                        totalQty += addQty;
                    });
                    if (totalQty == 0) {
                        $('.kaGroups__createButton').addClass(
                            'kaGroups__createButton--hidden'
                        );
                        $('.kaM__groupsAddNewWrapper').addClass(
                            'kaM__groupsAddNew--hidden'
                        );
                    }
    
                    $('.kaM__groupsAddNewWrapper').addClass(
                        'kaM__groupsAddNewWrapper--remove'
                    );
                    $('.kaM__groupsAddNewWrapper')
                        .last()
                        .removeClass('kaM__groupsAddNewWrapper--remove');
                    $('.kaM__groupsAddNewWrapper--remove').remove();
    
                    if ($('.kaGroup').length > 0) {
                        pageState = 'saved';
                        stateCSS(pageState);
                    } else {
                        pageState = 'empty';
                        stateCSS(pageState);
                    }
    
                    bindMinusButton();
                    bindMobilePlusButton();
                    bindMobileCreateGroup();
    
                    bindSaveGroup();
                    bindEditGroup();
                    bindSlideGroup();
                    bindRemoveGroup();
    
                    bindMobileRemoveEvents();
                    bindMobileSliders();
                }
    
                function afterCartJSLoad() {
                    var keyableItems = getKeyableItems();
                    var savedItems = getSavedItems();
                    fillCartListing(keyableItems);
                    fillSavedProducts(savedItems);
    
                    if ($('.kaGroup').last().attr('data-group') == '1') {
                        $('.kaGroup').each(function () {
                            $(this).attr('data-active', 'false');
                            $(this).attr('data-state', 'saved');
                            var firstGroupedType = $(this)
                                .find('.kaGroupProd')
                                .attr('data-type');
                            $(this).attr('data-type', firstGroupedType);
                            groupStateCSS($(this));
                        });
                        var group = $('.kaGroup').last();
                        group.attr('data-saved', 'true');
                        group.attr('data-active', 'true');
                        group.attr('data-state', 'editing');
                        pageState = 'editing';
                        groupStateCSS(group);
                        stateCSS(pageState);
                    }
                }
    
                var CartJSInterval = setInterval(function () {
                    if (typeof CartJS.cart.items !== 'undefined') {
                        afterCartJSLoad();
                        clearInterval(CartJSInterval);
                    }
                }, 10);
    
                // options are: 'empty', 'groups', 'editing', 'saved'
                var pageState = 'empty';
    
                var groupItemTemplate = $('.kaGroup__productList').html();
                $('.kaGroup__productList').html('');
                var groupTemplate = $('.kaGroups').html();
                $('.kaGroups').html('');
    
                var mobileGroupTemplate = '';
    
                function addNewGroup() {
                    var groupCount = $('.kaGroup').length + 1;
                    var currentGroups = $('.kaGroups').html();
                    $('.kaGroups').html(currentGroups + groupTemplate);
                    var target = $('.kaGroup').last();
                    target.find('.kaGroup__index').text(groupCount);
                    target.attr('data-group', groupCount);
                    target.attr('data-state', 'empty');
                    target.attr('data-active', 'true');
                    target.attr('data-type', 'none');
    
                    var mobileCurrentGroups = $('.kaM__groupsList').html();
                    $('.kaM__groupsList').html(
                        mobileCurrentGroups + mobileGroupTemplate
                    );
                    var target = $('.kaM__groupWrapper').last();
                    target
                        .find('.kaMGroup__titleNumber, .kaM__groupNumber')
                        .text(groupCount);
                    target.attr('data-group', groupCount);
                    target.attr('data-state', 'empty');
                    target.attr('data-active', 'true');
                    target.attr('data-type', 'none');
    
                    $('.kaCartItem').each(function () {
                        var thisQty = $(this).attr('data-qty');
                        var thisId = $(this).attr('data-id');
    
                        var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
                        var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;
                        mobProd.attr('data-qty', thisQty);
                        var mobProdQty =
                            mobProdQtyMax - mobProd.attr('data-qty') * 1;
                        var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;
    
                        mobProd.find('.kaMProd__qty').text(mobProdQtyString);
                        if (mobProdQty == 0) {
                            mobProd
                                .find('.kaMProd__plusButton')
                                .addClass('kaMProd__plusButton--disabled');
                        } else if (mobProdQty == mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .addClass('kaMProd__minusButton--disabled');
                        } else if (mobProdQty < mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .removeClass('kaMProd__minusButton--disabled');
                        }
                    });
    
                    bindSaveGroup();
                    bindEditGroup();
                    bindSlideGroup();
                    bindRemoveGroup();
    
                    bindMobileRemoveEvents();
                    bindMobileSliders();
    
                    $('.kaM__groupsAddNewWrapper').addClass(
                        'kaM__groupsAddNewWrapper--remove'
                    );
                    $('.kaM__groupsAddNewWrapper')
                        .last()
                        .removeClass('kaM__groupsAddNewWrapper--remove');
                    $('.kaM__groupsAddNewWrapper--remove').remove();
                }
    
                function stateCSS(state) {
                    if (state == 'empty') {
                        $('.kaState__empty').show();
    
                        $('.kaState__full').hide();
                        $('.ka__groupFrameLower').hide();
    
                        $('.kaCartItem__showQty').hide();
                        $('.kaCartItem__editQty').show();
    
                        $('.kaCartItem__plusButton').show();
    
                        $('.kaGroups__createButton').hide();
                        $('.ka__groupButtonRow').slideUp();
    
                        //mobile
                        $('.kaM__groupsEmptyWrapper').show();
                        $('.kaM__groupsListWrapper').hide();
                        $('.kaMFooter').hide();
                        $('.kaM__groupsAddNewWrapper').hide();
                        $('.kaMFooter__completeButton').hide();
                        $('.kaMFooter__saveGroupButton').hide();
                    } else if (state == 'groups') {
                        $('.kaState__empty').hide();
    
                        $('.kaState__full').show();
                        $('.ka__groupFrameLower').show();
    
                        $('.kaCartItem__showQty').hide();
                        $('.kaCartItem__editQty').show();
    
                        $('.kaCartItem__plusButton').show();
                        $('.kaGroups__createButton').hide();
                        $('.ka__groupButtonRow').slideUp();
    
                        //mobile
                        $('.kaM__groupsEmptyWrapper').hide();
                        $('.kaM__groupsListWrapper').show();
                        $('.kaMFooter').show();
                        $('.kaM__groupsAddNewWrapper').hide();
                        $('.kaMFooter__completeButton').hide();
                        $('.kaMFooter__saveGroupButton').hide();
                    } else if (state == 'editing') {
                        $('.kaState__empty').hide();
    
                        $('.kaState__full').show();
                        $('.ka__groupFrameLower').show();
    
                        $('.kaCartItem__showQty').hide();
                        $('.kaCartItem__editQty').show();
    
                        $('.kaCartItem__plusButton').show();
                        $('.kaGroups__createButton').hide();
                        $('.ka__groupButtonRow').slideUp();
    
                        //mobile
                        $('.kaM__groupsEmptyWrapper').hide();
                        $('.kaM__groupsListWrapper').show();
                        $('.kaMFooter').show();
                        $('.kaM__groupsAddNewWrapper').hide();
                        $('.kaMFooter__completeButton').hide();
                        $('.kaMFooter__saveGroupButton').show();
                    } else if (state == 'saved') {
                        $('.kaState__empty').hide();
    
                        $('.kaState__full').show();
                        $('.ka__groupFrameLower').show();
    
                        $('.kaCartItem__showQty').hide();
                        $('.kaCartItem__editQty').show();
    
                        $('.kaCartItem__plusButton').hide();
                        $('.kaGroups__createButton').show();
                        $('.ka__groupButtonRow').slideDown();
    
                        //mobile
                        $('.kaM__groupsEmptyWrapper').hide();
                        $('.kaM__groupsListWrapper').show();
                        $('.kaMFooter').show();
                        $('.kaM__groupsAddNewWrapper').show();
                        $('.kaMFooter__completeButton').show();
                        $('.kaMFooter__saveGroupButton').hide();
                    } else if (state == 'completed') {
                        $('.kaState__empty').hide();
    
                        $('.kaState__full').show();
                        $('.ka__groupFrameLower').show();
    
                        $('.kaCartItem__showQty').hide();
                        $('.kaCartItem__editQty').show();
    
                        $('.kaCartItem__plusButton').hide();
                        $('.kaGroups__createButton').show();
                        $('.ka__groupButtonRow').slideUp();
    
                        //mobile
                        $('.kaM__groupsEmptyWrapper').hide();
                        $('.kaM__groupsListWrapper').show();
                        $('.kaMFooter').show();
                        $('.kaM__groupsAddNewWrapper').show();
                        $('.kaMFooter__completeButton').show();
                        $('.kaMFooter__saveGroupButton').hide();
                    }
                }
    
                function groupStateCSS(group) {
                    if (group.attr('data-state') == 'empty') {
                        group.find('.kaGroup__empty').show();
                        group.find('.kaGroup__productList').hide();
                        group.find('.kaGroup__unsavedButtonRow').hide();
                        group.find('.kaGroup__savedButtonRow').show();
                        group.find('.kaGroup__arroe').hide();
                        group.find('.kaGroupProd__removeButton').show();
                        group.find('.kaGroup__editButton').hide();
                    } else if (group.attr('data-state') == 'saved') {
                        group.find('.kaGroup__empty').hide();
                        group.find('.kaGroup__productList').show();
                        group.find('.kaGroup__unsavedButtonRow').hide();
                        group.find('.kaGroup__savedButtonRow').show();
                        group.find('.kaGroup__arroe').show();
                        group.find('.kaGroupProd__removeButton').hide();
                        group.find('.kaGroup__editButton').show();
                    } else if (group.attr('data-state') == 'editing') {
                        group.find('.kaGroup__empty').hide();
                        group.find('.kaGroup__productList').show();
                        group.find('.kaGroup__unsavedButtonRow').show();
                        group.find('.kaGroup__savedButtonRow').hide();
                        group.find('.kaGroup__arroe').hide();
                        group.find('.kaGroupProd__removeButton').show();
                        group.find('.kaGroup__editButton').show();
                    }
                }
    
                $('.kaEmpty__startButton').on('click', function () {
                    pageState = 'groups';
                    stateCSS(pageState);
                    addNewGroup();
                    groupStateCSS($('.kaGroup').last());
                });
    
                $('.kaM__groupsEmptyCreateNew').on('click', function () {
                    pageState = 'editing';
                    stateCSS(pageState);
                    addNewGroup();
                    groupStateCSS($('.kaGroup').last());
                });
    
                function addProductToGroup(product, group) {
                    var id = product.attr('data-id');
                    var productImage = product
                        .find('.kaCartItem__image')
                        .attr('src');
                    var productTitle = product
                        .find('.kaCartItem__image')
                        .attr('alt');
                    var qty = product.attr('data-qty') * 1;
    
                    var sameType = true;
    
                    if (group.attr('data-type') == 'none') {
                        group.attr('data-type', product.attr('data-type'));
                    } else {
                        if (
                            !compareProdTypes(
                                product.attr('data-type'),
                                group.attr('data-type')
                            )
                        ) {
                            sameType = false;
                            $('.kaTypePopup').fadeIn();
                        }
                    }
    
                    if (sameType == true) {
                        group.attr('data-state', 'editing');
                        groupStateCSS(group);
    
                        var mobileGroup = $(
                            '.kaM__groupWrapper[data-group="' +
                                group.attr('data-group') +
                                '"]'
                        );
    
                        if (qty > 0) {
                            var currentProds = group
                                .find('.kaGroup__productList')
                                .html();
                            var mobileCurrentProds = mobileGroup
                                .find('.kaMGroup__prodList')
                                .html();
                            if (
                                group.find('.kaGroupProd[data-id="' + id + '"]')
                                    .length == 0
                            ) {
                                group
                                    .find('.kaGroup__productList')
                                    .html(currentProds + groupItemTemplate);
                                var prod = group.find('.kaGroupProd').last();
                                prod.attr('data-qty', 1);
                                prod.find('.kaGroupProd__qty').text(1);
                                prod.attr('data-id', id);
                                prod.attr('data-group', group.attr('data-group'));
                                prod.find('.kaGroupProd__image').attr(
                                    'src',
                                    productImage
                                );
                                prod.find('.kaGroupProd__image').attr(
                                    'alt',
                                    productTitle
                                );
                                prod.find('.kaGroupProd__title').text(productTitle);
                                product.attr('data-qty', qty - 1);
                                product
                                    .find('.kaCartItem__editQtyAvailable')
                                    .text(qty - 1);
                                product.find('.kaCartItem__showQty').text(qty - 1);
                                if (qty - 1 == 0) {
                                    product
                                        .find('.kaCartItem__plusButton')
                                        .addClass(
                                            'kaCartItem__plusButton--disabled'
                                        );
                                }
                            } else {
                                var prod = group.find(
                                    '.kaGroupProd[data-id="' + id + '"]'
                                );
                                var newQty = prod.attr('data-qty') * 1 + 1;
                                prod.attr('data-qty', newQty);
                                prod.find('.kaGroupProd__qty').text(newQty);
                                product.attr('data-qty', qty - 1);
                                product
                                    .find('.kaCartItem__editQtyAvailable')
                                    .text(qty - 1);
                                product.find('.kaCartItem__showQty').text(qty - 1);
                                if (qty - 1 == 0) {
                                    product
                                        .find('.kaCartItem__plusButton')
                                        .addClass(
                                            'kaCartItem__plusButton--disabled'
                                        );
                                }
                            }
    
                            //mobile
                            $('.kaCartItem').each(function () {
                                var thisQty = $(this).attr('data-qty');
                                var thisId = $(this).attr('data-id');
    
                                var mobProd = $(
                                    '.kaMProd[data-id="' + thisId + '"]'
                                );
                                var mobProdQtyMax =
                                    mobProd.attr('data-max-qty') * 1;
    
                                mobProd.attr('data-qty', thisQty);
                                var mobProdQty =
                                    mobProdQtyMax - mobProd.attr('data-qty') * 1;
                                var mobProdQtyString =
                                    mobProdQty + '/' + mobProdQtyMax;
    
                                mobProd
                                    .find('.kaMProd__qty')
                                    .text(mobProdQtyString);
                                if (mobProdQty == 0) {
                                    mobProd
                                        .find('.kaMProd__plusButton')
                                        .addClass('kaMProd__plusButton--disabled');
                                } else if (mobProdQty == mobProdQtyMax) {
                                    mobProd
                                        .find('.kaMProd__minusButton')
                                        .addClass('kaMProd__minusButton--disabled');
                                } else if (mobProdQty < mobProdQtyMax) {
                                    mobProd
                                        .find('.kaMProd__minusButton')
                                        .removeClass(
                                            'kaMProd__minusButton--disabled'
                                        );
                                }
    
                                $('.kaMCartItem[data-id="' + thisId + '"]')
                                    .find('.kaMCartItem__qty')
                                    .text(mobProdQtyString);
                            });
    
                            var totalQty = 0;
                            $('.kaCartItem__showQty').each(function () {
                                var addQty = $(this).text() * 1;
                                totalQty += addQty;
                            });
                            if (totalQty <= 1) {
                                $('.kaGroups__createButton').addClass(
                                    'kaGroups__createButton--hidden'
                                );
                                $('.kaM__groupsAddNewWrapper').addClass(
                                    'kaM__groupsAddNewWrapper--hidden'
                                );
                            }
                        }
    
                        bindMinusButton();
                        bindMobilePlusButton();
                    }
                }
    
                $(
                    '.kaTypePopup__overlay, .kaTypePopup__close, .kaTypePopup__closeButton'
                ).on('click', function () {
                    $('.kaTypePopup').fadeOut();
                });
    
                function bindPlusButton() {
                    $('.kaCartItem__plusButton').on('click', function () {
                        var product = $(this).closest('.kaCartItem');
                        if (pageState == 'empty') {
                            addNewGroup();
                            var group = $('.kaGroup').last();
                            addProductToGroup(product, group);
    
                            var groupQty = 0;
                            group.find('.kaGroupProd__qty').each(function () {
                                groupQty += $(this).text() * 1;
                            });
                            if (groupQty > 1) {
                                group.find('.kaGroup__saveButton').show();
                            } else {
                                group.find('.kaGroup__saveButton').hide();
                            }
                        } else if (
                            pageState == 'groups' ||
                            pageState == 'editing'
                        ) {
                            var group = $('.kaGroup[data-active="true"]');
                            addProductToGroup(product, group);
    
                            var groupQty = 0;
                            group.find('.kaGroupProd__qty').each(function () {
                                groupQty += $(this).text() * 1;
                            });
                            if (groupQty > 1) {
                                group.find('.kaGroup__saveButton').show();
                            } else {
                                group.find('.kaGroup__saveButton').hide();
                            }
                        }
    
                        pageState = 'editing';
                        stateCSS(pageState);
    
                        var subtotal = 0;
                        $('.kaGroupProd').each(function () {
                            subtotal += $(this).attr('data-qty') * 1 * 3.99;
                        });
                        subtotal = subtotal.toFixed(2);
                        $('.ka__groupSubtotalPrice').text('$' + subtotal);
                        $('.kaMFooter__subtotalPrice').text('$' + subtotal);
                    });
                }
    
                function bindMobilePlusButton() {
                    $('.kaMProd__plusButton')
                        .unbind('click')
                        .on('click', function () {
                            console.log('test');
                            var thisThing = $(this).closest('.kaMProd');
                            var product = $(
                                '.kaCartItem[data-id="' +
                                    thisThing.attr('data-id') +
                                    '"]'
                            );
    
                            var groupData = thisThing
                                .closest('.kaM__groupWrapper')
                                .attr('data-group');
                            var group = $(
                                '.kaGroup[data-group="' + groupData + '"]'
                            );
                            addProductToGroup(product, group);
    
                            var groupQty = 0;
                            group.find('.kaGroupProd__qty').each(function () {
                                groupQty += $(this).text() * 1;
                            });
                            if (groupQty > 1) {
                                group.find('.kaGroup__saveButton').show();
                            } else {
                                group.find('.kaGroup__saveButton').hide();
                            }
    
                            pageState = 'editing';
                            stateCSS(pageState);
    
                            var subtotal = 0;
                            $('.kaGroupProd').each(function () {
                                subtotal += $(this).attr('data-qty') * 1 * 3.99;
                            });
                            subtotal = subtotal.toFixed(2);
                            $('.ka__groupSubtotalPrice').text('$' + subtotal);
                            $('.kaMFooter__subtotalPrice').text('$' + subtotal);
                        });
                }
    
                function bindMinusButton() {
                    $('.kaGroupProd__removeButton, .kaMProd__minusButton')
                        .unbind('click')
                        .on('click', function () {
                            if ($(this).hasClass('kaGroupProd__removeButton')) {
                                var prod = $(this).closest('.kaGroupProd');
                            } else {
                                var prodId = $(this)
                                    .closest('.kaMProd')
                                    .attr('data-id');
                                var prodGroup = $(this)
                                    .closest('.kaM__groupWrapper')
                                    .attr('data-group');
                                var prod = $(
                                    '.kaGroupProd[data-id="' +
                                        prodId +
                                        '"][data-group="' +
                                        prodGroup +
                                        '"]'
                                );
                            }
    
                            var id = prod.attr('data-id');
                            console.log(id);
                            var original = $('.kaCartItem[data-id="' + id + '"]');
                            var qty = original.attr('data-qty');
                            var group = prod.closest('.kaGroup');
                            var newQty = prod.attr('data-qty') * 1 - 1;
    
                            var mobileGroup = $(
                                '.kaM__groupWrapper[data-group="' +
                                    prod.attr('data-group') +
                                    '"]'
                            );
                            var mobileProd = mobileGroup.find(
                                '.kaMProd[data-prod="' + id + '"]'
                            );
    
                            if (newQty >= 0) {
                                if (newQty > 0) {
                                    prod.attr('data-qty', newQty);
                                    prod.find('.kaGroupProd__qty').text(newQty);
    
                                    original.attr('data-qty', qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__editQtyAvailable')
                                        .text(qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__showQty')
                                        .text(qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__plusButton')
                                        .removeClass(
                                            'kaCartItem__plusButton--disabled'
                                        );
                                } else {
                                    prod.remove();
    
                                    original.attr('data-qty', qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__editQtyAvailable')
                                        .text(qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__showQty')
                                        .text(qty * 1 + 1);
                                    original
                                        .find('.kaCartItem__plusButton')
                                        .removeClass(
                                            'kaCartItem__plusButton--disabled'
                                        );
                                }
    
                                $('.kaCartItem').each(function () {
                                    var thisQty = $(this).attr('data-qty');
                                    var thisId = $(this).attr('data-id');
    
                                    var mobProd = $(
                                        '.kaMProd[data-id="' + thisId + '"]'
                                    );
                                    var mobProdQtyMax =
                                        mobProd.attr('data-max-qty') * 1;
    
                                    mobProd.attr('data-qty', thisQty);
                                    var mobProdQty =
                                        mobProdQtyMax -
                                        mobProd.attr('data-qty') * 1;
                                    var mobProdQtyString =
                                        mobProdQty + '/' + mobProdQtyMax;
    
                                    mobProd
                                        .find('.kaMProd__qty')
                                        .text(mobProdQtyString);
                                    if (mobProdQty == 0) {
                                        mobProd
                                            .find('.kaMProd__plusButton')
                                            .addClass(
                                                'kaMProd__plusButton--disabled'
                                            );
                                    } else if (mobProdQty == mobProdQtyMax) {
                                        mobProd
                                            .find('.kaMProd__minusButton')
                                            .addClass(
                                                'kaMProd__minusButton--disabled'
                                            );
                                    } else if (mobProdQty < mobProdQtyMax) {
                                        mobProd
                                            .find('.kaMProd__minusButton')
                                            .removeClass(
                                                'kaMProd__minusButton--disabled'
                                            );
                                    }
    
                                    $('.kaMCartItem[data-id="' + thisId + '"]')
                                        .find('.kaMCartItem__qty')
                                        .text(mobProdQtyString);
    
                                    var groupQty = 0;
                                    group
                                        .find('.kaGroupProd__qty')
                                        .each(function () {
                                            groupQty += $(this).text() * 1;
                                        });
                                    if (groupQty > 1) {
                                        group.find('.kaGroup__saveButton').show();
                                    } else {
                                        group.find('.kaGroup__saveButton').hide();
                                    }
                                });
    
                                if (group.find('.kaGroupProd').length == 0) {
                                    group.attr('data-state', 'empty');
                                    groupStateCSS(group);
                                }
                                var totalQty = 0;
                                $('.kaCartItem__showQty').each(function () {
                                    var addQty = $(this).text() * 1;
                                    totalQty += addQty;
                                });
                                if (totalQty > 0) {
                                    $('.kaGroups__createButton').removeClass(
                                        'kaGroups__createButton--hidden'
                                    );
                                    $('.kaM__groupsAddNewWrapper').addClass(
                                        'kaM__groupsAddNewWrapper--hidden'
                                    );
                                }
                            }
                            var subtotal = 0;
                            $('.kaGroupProd').each(function () {
                                subtotal += $(this).attr('data-qty') * 1 * 3.99;
                            });
                            subtotal = subtotal.toFixed(2);
                            $('.ka__groupSubtotalPrice').text('$' + subtotal);
                            $('.kaMFooter__subtotalPrice').text('$' + subtotal);
                        });
                }
    
                function bindSaveGroup() {
                    $('.kaGroup__saveButton')
                        .unbind('click')
                        .on('click', function () {
                            var group = $(this).closest('.kaGroup');
                            group.attr('data-saved', 'true');
                            group.attr('data-active', 'false');
                            group.attr('data-state', 'saved');
                            pageState = 'saved';
                            groupStateCSS(group);
                            stateCSS(pageState);
                        });
                }
    
                function bindEditGroup() {
                    $('.kaGroup__editButton')
                        .unbind('click')
                        .on('click', function () {
                            $('.kaGroup').each(function () {
                                $(this).attr('data-active', 'false');
                                $(this).attr('data-state', 'saved');
                                groupStateCSS($(this));
                            });
                            var group = $(this).closest('.kaGroup');
                            group.attr('data-saved', 'true');
                            group.attr('data-active', 'true');
                            group.attr('data-state', 'editing');
                            pageState = 'editing';
                            groupStateCSS(group);
                            stateCSS(pageState);
    
                            var groupQty = 0;
                            group.find('.kaGroupProd__qty').each(function () {
                                groupQty += $(this).text() * 1;
                            });
                            if (groupQty > 1) {
                                group.find('.kaGroup__saveButton').show();
                            } else {
                                group.find('.kaGroup__saveButton').hide();
                            }
                        });
                }
    
                function slideUpGroup(group) {
                    group.find('.kaGroup__shelf').slideUp();
                    group.addClass('kaGroup--hidden');
                }
                function slideDownGroup(group) {
                    group.find('.kaGroup__shelf').slideDown();
                    group.removeClass('kaGroup--hidden');
                }
    
                function bindSlideGroup() {
                    $('.kaGroup__accordionTitle')
                        .unbind('click')
                        .on('click', function () {
                            var group = $(this).closest('.kaGroup');
                            if (group.attr('data-state') == 'saved') {
                                if (group.hasClass('kaGroup--hidden')) {
                                    slideDownGroup(group);
                                } else {
                                    slideUpGroup(group);
                                }
                            }
                        });
                }
    
                $('.kaGroups__createButton').on('click', function () {
                    pageState = 'groups';
                    stateCSS(pageState);
                    addNewGroup();
                    groupStateCSS($('.kaGroup').last());
                    $('.kaGroup[data-active="false"]').each(function () {
                        var group = $(this);
                        slideUpGroup(group);
                    });
                });
    
                function bindMobileCreateGroup() {
                    $('.kaM__groupsAddNew')
                        .unbind('click')
                        .on('click', function () {
                            pageState = 'groups';
                            stateCSS(pageState);
                            addNewGroup();
                            groupStateCSS($('.kaGroup').last());
                            $('.kaGroup[data-active="false"]').each(function () {
                                var group = $(this);
                                slideUpGroup(group);
                            });
                        });
                }
    
                function removeGroup(groupIndex) {
                    var group = $('.kaGroup[data-group="' + groupIndex + '"]');
                    group.find('.kaGroupProd').each(function () {
                        var prod = $(this);
                        var id = prod.attr('data-id');
                        var original = $('.kaCartItem[data-id="' + id + '"]');
                        var qtyToAdd = prod.attr('data-qty');
                        var qty = original.attr('data-qty');
    
                        original.attr('data-qty', qty * 1 + qtyToAdd * 1);
                        original
                            .find('.kaCartItem__editQtyAvailable')
                            .text(qty * 1 + qtyToAdd * 1);
                        original
                            .find('.kaCartItem__showQty')
                            .text(qty * 1 + qtyToAdd * 1);
                        original
                            .find('.kaCartItem__plusButton')
                            .removeClass('kaCartItem__plusButton--disabled');
                    });
    
                    group.remove();
                    $(
                        '.kaM__groupWrapper[data-group="' + groupIndex + '"]'
                    ).remove();
    
                    $('.kaCartItem').each(function () {
                        var thisQty = $(this).attr('data-qty');
                        var thisId = $(this).attr('data-id');
    
                        var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
                        var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;
    
                        mobProd.attr('data-qty', thisQty);
                        var mobProdQty =
                            mobProdQtyMax - mobProd.attr('data-qty') * 1;
                        var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;
    
                        mobProd.find('.kaMProd__qty').text(mobProdQtyString);
                        if (mobProdQty == 0) {
                            mobProd
                                .find('.kaMProd__plusButton')
                                .addClass('kaMProd__plusButton--disabled');
                        } else if (mobProdQty == mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .addClass('kaMProd__minusButton--disabled');
                        } else if (mobProdQty < mobProdQtyMax) {
                            mobProd
                                .find('.kaMProd__minusButton')
                                .removeClass('kaMProd__minusButton--disabled');
                        }
    
                        $('.kaMCartItem[data-id="' + thisId + '"]')
                            .find('.kaMCartItem__qty')
                            .text(prod.quantity + '/' + prod.quantity);
                    });
    
                    var groupCount = 1;
                    $('.kaGroup').each(function () {
                        $(this).attr('data-group', groupCount);
                        $(this).find('.kaGroup__index').text(groupCount);
                        groupCount += 1;
                    });
                    if (groupCount == 1) {
                        pageState = 'empty';
                        stateCSS(pageState);
                    }
                    groupCount = 1;
                    $('.kaM__groupWrapper').each(function () {
                        $(this).attr('data-group', groupCount);
                        $(this)
                            .find('.kaM__groupNumber, .kaMGroup__titleNumber')
                            .text(groupCount);
                        groupCount += 1;
                    });
    
                    $('.kaRemovePopup').fadeOut();
    
                    var totalQty = 0;
                    $('.kaCartItem__showQty').each(function () {
                        var addQty = $(this).text() * 1;
                        totalQty += addQty;
                    });
                    if (totalQty > 0) {
                        $('.kaGroups__createButton').removeClass(
                            'kaGroups__createButton--hidden'
                        );
                        $('.kaM__groupsAddNewWrapper').removeClass(
                            'kaM__groupsAddNewWrapper--hidden'
                        );
                    }
    
                    var subtotal = 0;
                    $('.kaGroupProd').each(function () {
                        subtotal += $(this).attr('data-qty') * 1 * 3.99;
                    });
                    subtotal = subtotal.toFixed(2);
                    $('.ka__groupSubtotalPrice').text('$' + subtotal);
                    $('.kaMFooter__subtotalPrice').text('$' + subtotal);
    
                    completeKA(false);
                }
    
                function bindRemoveGroup() {
                    $('.kaGroup__removeButton')
                        .unbind('click')
                        .on('click', function () {
                            $('.kaState__full').addClass('kaState__full--noScroll');
                            $('.kaRemovePopup').fadeIn();
                            var group = $(this).closest('.kaGroup');
                            $('.kaRemovePop__remove').attr(
                                'data-group',
                                group.attr('data-group')
                            );
                        });
                }
    
                function bindMobileRemoveEvents() {
                    $('.kaMGroup__removeButton')
                        .unbind('click')
                        .on('click', function () {
                            $(this)
                                .closest('.kaM__groupWrapper')
                                .find('.kaMGroup__removePopup')
                                .fadeIn();
                            var groupIndex = $(this)
                                .closest('.kaM__groupWrapper')
                                .attr('data-group');
                            var group = $(
                                '.kaGroup[data-group="' + groupIndex + '"]'
                            );
                            $(this)
                                .closest('.kaM__groupWrapper')
                                .find('.kaMGroup__removePopRemove')
                                .attr('data-group', group.attr('data-group'));
                        });
    
                    $('.kaMGroup__removePopRemove')
                        .unbind('click')
                        .on('click', function () {
                            var groupIndex = $(this).attr('data-group');
                            removeGroup(groupIndex);
                            $(this).closest('.kaMGroup__removePopup').fadeOut();
                            if ($('.kaM__groupWrapper').length() < 1) {
                                pageState = 'empty';
                                stateCSS(pageState);
                            } else {
                                pageState = 'saved';
                                stateCSS(pageState);
                            }
                        });
    
                    $('.kaMGroup__removePopCancel')
                        .unbind('click')
                        .on('click', function () {
                            $(this).closest('.kaMGroup__removePopup').fadeOut();
                        });
                }
    
                function bindMobileSliders() {
                    $('.kaM__group')
                        .unbind('click')
                        .on('click', function () {
                            var target = $(this).parent().find('.kaM__groupCard');
                            target.attr('style', 'transform:translateX(0%);');
                            pageState = 'editing';
                            stateCSS(pageState);
                            bindMinusButton();
                            bindMobilePlusButton();
                        });
                    $('.kaMGroup__close, .kaMGroup__titleArrowButton')
                        .unbind('click')
                        .on('click', function () {
                            var target = $(this).closest('.kaM__groupCard');
                            target.attr('style', 'transform:translateX(100%);');
                            pageState = 'saved';
                            stateCSS(pageState);
                        });
                }
    
                $('.kaMFooter__saveGroupButton').on('click', function () {
                    $('.kaM__groupCard').attr(
                        'style',
                        'transform:translateX(100%);'
                    );
                    pageState = 'saved';
                    stateCSS(pageState);
                    bindMobileCreateGroup();
                });
    
                $('.kaRemovePop__remove').on('click', function () {
                    var groupIndex = $(this).attr('data-group');
                    $('.kaState__full').removeClass('kaState__full--noScroll');
                    $('.kaRemovePopup').fadeOut();
                    removeGroup(groupIndex);
                    pageState = 'saved';
                    stateCSS(pageState);
                });
    
                $('.kaRemovePop__cancel').on('click', function () {
                    $('.kaRemovePopup').fadeOut();
                    $('.kaState__full').removeClass('kaState__full--noScroll');
                });
    
                $('.ka__groupKeepShoppingButton').on('click', function () {
                    $('.kaLeavePop').fadeIn();
                });
    
                $(
                    '.kaLeavePop__background, .kaLeavePop__close, .kaLeavePop__continue'
                ).on('click', function () {
                    $('.kaLeavePop').fadeOut();
                });
    
                function completeKA(openCart) {
                    if ($('.kaGroupProd').length > 0) {
                        var keyableItems = getKeyableItems();
                        for (i = 0; i < keyableItems.length; i++) {
                            CartJS.removeItemById(keyableItems[i].id);
                        }
                        var isKey = false;
                        for (i = 0; i < CartJS.cart.items.length; i++) {
                            if (CartJS.cart.items[i].id === 32146864832644) {
                                isKey = true;
                            }
                        }
                        if (isKey) {
                            CartJS.removeItemById(32146864832644);
                        }
    
                        var kaLib = [];
                        var keyCount = 0;
                        $('.kaCartItem').each(function () {
                            if ($(this).attr('data-qty') * 1 > 0) {
                                var kaProdObj = {
                                    id: $(this).attr('data-id') * 1,
                                    quantity: $(this).attr('data-qty') * 1,
                                    properties: {
                                        _keyed_alike_available: 'true',
                                    },
                                };
                                kaLib.push(kaProdObj);
                            }
                        });
                        $('.kaGroupProd').each(function () {
                            var kaProdObj = {
                                id: $(this).attr('data-id') * 1,
                                quantity: $(this).attr('data-qty') * 1,
                                properties: {
                                    _name: 'keyed_alike_group',
                                    _value: $(this).attr('data-group') * 1,
                                    _keyed_alike_group:
                                        $(this).attr('data-group') * 1,
                                    _keyed_alike_available: 'true',
                                    _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                },
                            };
                            kaLib.push(kaProdObj);
                            keyCount += $(this).attr('data-qty') * 1;
                        });
                        var keyProdObj = {
                            id: 32146864832644,
                            quantity: keyCount,
                            properties: {
                                _groups: $('.kaGroup').length,
                                _page_added: window.location.href
                            },
                        };
                        kaLib.push(keyProdObj);
    
                        console.log(keyProdObj);
                        CartJS.addItems(kaLib, {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(openCart);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        });
                    } else {
                        var newKeyableItems = getKeyableItems();
                        for (i = 0; i < newKeyableItems.length; i++) {
                            CartJS.removeItemById(newKeyableItems[i].id);
                        }
                        CartJS.removeItemById(32146864832644);
                        var newKaLib = [];
                        console.log(newKeyableItems);
                        for (i = 0; i < newKeyableItems.length; i++) {
                            var newKaProdObj = {
                                id: newKeyableItems[i].id,
                                quantity: newKeyableItems[i].quantity,
                                properties: {
                                    _keyed_alike_available: 'true',
                                    _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                },
                            };
                            newKaLib.push(newKaProdObj);
                        }
                        console.log(newKaLib);
                        CartJS.addItems(newKaLib, {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(openCart);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        });
                    }
                }
    
                $('.ka__groupCompleteButton, .kaMFooter__completeButton').on(
                    'click',
                    function () {
                        completeKA(true);
                        pageState = 'completed';
                        stateCSS(pageState);
                    }
                );
    
                $('#cartDrawer .btn-close').on('click', function () {
                    if (pageState == 'completed') {
                        pageState = 'saved';
                        stateCSS(pageState);
                    }
                });
            }
    
            if ($('#shopify-section-downloadHero').length > 0) {
                $('.topbar').remove();
            }
    
            if ($('#shopify-section-matterNotify').length > 0) {
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
        });
    
        $(document).ready(function () {
            $('#smart-safe .pdp__options button:first-of-type').on(
                'click',
                function () {
                    $('.worksWith__1').show();
                    $('.worksWith__2').hide();
                    var newImgSrc = $('.pdp__image .ftd__swap .product__one').attr(
                        'src'
                    );
                    $('.pdp__image .ftd__image img').attr('src', newImgSrc);
                    var newThumbSrc = $(
                        '.pdp__thumbs .ftd__swap .product__one'
                    ).attr('src');
                    $('.pdp__thumbs .ftd__image img').attr('src', newThumbSrc);
    
                    $('.pdp__featuresContainer').html(
                        $(this).attr('data-features')
                    );
                    $('.pdp__technical .nestFaq__drop').html(
                        $(this).attr('data-specs')
                    );
                }
            );
    
            $('#smart-safe .pdp__options button:last-of-type').on(
                'click',
                function () {
                    $('.worksWith__1').hide();
                    $('.worksWith__2').show();
                    var newImgSrc = $('.pdp__image .ftd__swap .product__two').attr(
                        'src'
                    );
                    $('.pdp__image .ftd__image img').attr('src', newImgSrc);
                    var newThumbSrc = $(
                        '.pdp__thumbs .ftd__swap .product__two'
                    ).attr('src');
                    $('.pdp__thumbs .ftd__image img').attr('src', newThumbSrc);
    
                    $('.pdp__featuresContainer').html(
                        $(this).attr('data-features')
                    );
                    $('.pdp__technical .nestFaq__drop').html(
                        $(this).attr('data-specs')
                    );
                }
            );
    
            /*$('.collection-menu .nav .nav-item div a[aria-label="Yale Assure Lock 2_img"]').attr('href', '/pages/smart-locks');*/
            $(
                '.collection-menu .nav .nav-item div a[aria-label="Yale Assure Lock 2_title"]'
            ).attr('href', '/pages/yale-assure-lock-2');
    
            $(
                '.index-shop-collection a[aria-label="Yale Assure Lock 2_image"'
            ).hide();
            $(
                '.index-shop-collection a[aria-label="Yale Assure Lock 2_desc"'
            ).hide();
    
            $('.index-shop-collection a[aria-label="Safes_image"').attr(
                'href',
                '/pages/smart-safe'
            );
            $('.index-shop-collection a[aria-label="Safes_desc"').text(
                'Smart Safes'
            );
    
            $('.smartWifiPDP .smartPDP__images').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.smartWifiPDP .smartPDP__thumbs',
                infinite: true,
            });
    
            $('.smartWifiPDP .smartPDP__thumbs').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.smartWifiPDP .smartPDP__images',
                dots: false,
                centerMode: false,
                vertical: true,
                focusOnSelect: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 3,
                            vertical: false,
                        },
                    },
                ],
            });
    
            $('.smartZwavePDP .smartPDP__images').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.smartZwavePDP .smartPDP__thumbs',
                infinite: true,
            });
    
            $('.smartZwavePDP .smartPDP__thumbs').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.smartZwavePDP .smartPDP__images',
                dots: false,
                centerMode: false,
                vertical: true,
                focusOnSelect: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 3,
                            vertical: false,
                        },
                    },
                ],
            });
    
            $('.smartMatterPDP .smartPDP__images').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.smartMatterPDP .smartPDP__thumbs',
                infinite: true,
            });
    
            $('.smartMatterPDP .smartPDP__thumbs').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: '.smartMatterPDP .smartPDP__images',
                dots: false,
                centerMode: false,
                vertical: true,
                focusOnSelect: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 950,
                        settings: {
                            slidesToShow: 3,
                            vertical: false,
                        },
                    },
                ],
            });
    
            $('.smartPDP__techButton').on('click', function () {
                var target = $(this).parent().find('.smartPDP__techSled');
                if (target.is(':visible')) {
                    target.slideUp();
                    $(this).removeClass('smartPDP__accordion--active');
                } else {
                    target.slideDown();
                    $(this).addClass('smartPDP__accordion--active');
                }
            });
    
            $('.smartPDP__compatButton').on('click', function () {
                var target = $(this).parent().find('.smartPDP__compatSled');
                if (target.is(':visible')) {
                    target.slideUp();
                    $(this).removeClass('smartPDP__accordion--active');
                } else {
                    target.slideDown();
                    $(this).addClass('smartPDP__accordion--active');
                }
            });
    
            function updateCart() {
                app._getCartData();
                app._vibrateDevice();
                app.$snotify.clear();
                setTimeout(function () {
                    if (
                        ((app.isLoading = false),
                        (app.loadingEvent = null),
                        app.storeUtilities.cartUpsells.settings.showOnPopUp)
                    ) {
                        var origin = app.cart.items.find(function (data) {
                            return data.variant_id === keys;
                        });
                        app._openModalCartUpsell(origin);
                    } else {
                        app._toggleCartDrawer();
                    }
                }, 300);
            }
    
            function addToCart(variant, qty) {
                if (checkDiscountLimitFull(variant)) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
                CartJS.addItem(
                    variant,
                    qty,
                    {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                    {
                        success: function (data, textStatus, jqXHR) {
                            updateCart();
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        },
                    }
                );
            }
    
            $('.smartPDP__buy').on('click', function () {
                var variant = $(this).attr('data-id');
                var qty = $(this)
                    .closest('.smartPDP__buyRow')
                    .find('.smartPDP__qty')
                    .val();
                addToCart(variant, qty);
            });
    
            $('.smartPDP__qtyMinus').on('click', function () {
                var target = $(this).parent().find('input');
                var qty = target.val() * 1;
                if (qty > 1) {
                    target.val(qty - 1).change();
                }
            });
    
            $('.smartPDP__qtyPlus').on('click', function () {
                var target = $(this).parent().find('input');
                var qty = target.val() * 1;
                target.val(qty + 1).change();
            });
    
            if ($('#shopify-section-smart-module-banner').length > 0) {
                function notifyMe(email, variantID, productID, target) {
                    var apiKey = 'VdEWmd';
                    var platform = 'shopify';
    
                    fetch(
                        'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
                        {
                            headers: {
                                accept: 'application/json, text/plain, */*',
                                'content-type':
                                    'application/x-www-form-urlencoded;charset=UTF-8',
                            },
                            body: new URLSearchParams({
                                a: apiKey,
                                email: email,
                                platform: 'shopify',
                                variant: variantID,
                                product: productID,
                            }),
                            method: 'POST',
                        }
                    )
                        .then((response) => {
                            console.log(response);
                            target.find('.notifyMe__success').show();
                            target.find('.notifyMe__error').hide();
                        })
                        .catch((err) => {
                            console.error(err);
                            target.find('.notifyMe__error').text(err).show();
                        });
                }
    
                $('.notifyMe__submit').on('click', function (e) {
                    e.preventDefault();
                    var target = $(this).closest('.notifyMe');
    
                    var email = $('.notifyMe__input').val();
                    var variantID = $(this).attr('data-variant');
                    var productID = $(this).attr('data-product');
                    if (email.includes('@')) {
                        notifyMe(email, variantID, productID, target);
                    } else {
                        $('.notifyMe__error').show();
                    }
                });
            }
    
            var windowWidth = $(window).width();
    
            if (windowWidth <= 560) {
                $('.assure-grid .grid-list').slick({
                    infinite: true,
                    fade: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                });
            }
    
            if (windowWidth <= 900) {
                $('.assure-cta .grid-list').slick({
                    infinite: false,
                    variableWidth: true,
                    fade: false,
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                });
    
                $(
                    '.template-page-assure-plus-landing .assure-access .images--mobile'
                ).slick({
                    infinite: true,
                    fade: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    asNavFor: '.assure-access .tabs-list',
                });
    
                $(
                    '.template-page-assure-plus-landing .assure-access .tabs-list'
                ).slick({
                    infinite: true,
                    fade: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    asNavFor: '.assure-access .images--mobile',
                });
    
                $(
                    '.template-page-assure-touch-landing .assure-access .images--mobile'
                ).slick({
                    infinite: true,
                    fade: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                });
            }
    
            $('.assure-switch button').on('click', function () {
                var dataID = $(this).attr('data-id');
                console.log(dataID);
    
                $('.assure-switch button').removeClass('active');
                $('.assure-switch .images img').removeClass('active');
    
                $(this).addClass('active');
                $('.assure-switch .images img[data-id="' + dataID + '"]').addClass(
                    'active'
                );
            });
    
            $('.assure-access button').on('click', function () {
                var dataID = $(this).attr('data-id');
                console.log(dataID);
    
                $('.assure-access .tab-item').removeClass('active');
                $('.assure-access .images img').removeClass('active');
    
                $(this).closest('.tab-item').addClass('active');
                $('.assure-access .images img[data-id="' + dataID + '"]').addClass(
                    'active'
                );
            });
    
            /*$('.template-page-assure-touch-landing  .al2Faq__titleWrapper, .template-page-assure-plus-landing  .al2Faq__titleWrapper').on('click', function(){
          if ($(this).hasClass('al2Faq__titleWrapper--active')){
            $(this).removeClass('al2Faq__titleWrapper--active');
            $(this).parent().find('.al2Faq__shelf').slideUp();
          }
          else{
            $(this).addClass('al2Faq__titleWrapper--active');
            $(this).parent().find('.al2Faq__shelf').slideDown();
          }
        });*/
    
            $('.pantonePage .pantone__slider .slider__slides').slick({
                infinite: true,
                fade: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                // responsive: [
                //   {
                //     breakpoint: 990,
                //     settings: {
                //       slidesToShow: 3,
                //       arrows:true,
                //       dots: true
                //     }
                //   },
                //   {
                //     breakpoint: 750,
                //     settings: {
                //       slidesToShow: 2,
                //       arrows:true,
                //       dots: true
                //     }
                //   },
                //   {
                //     breakpoint: 510,
                //     settings: {
                //       slidesToShow: 1,
                //       arrows:true,
                //       dots: true
                //     }
                //   }
                // ]
            });
    
            $('.pantonePage .al2Faq__titleWrapper').on('click', function () {
                if ($(this).hasClass('al2Faq__titleWrapper--active')) {
                    $(this).removeClass('al2Faq__titleWrapper--active');
                    $(this).parent().find('.al2Faq__shelf').slideUp();
                } else {
                    $(this).addClass('al2Faq__titleWrapper--active');
                    $(this).parent().find('.al2Faq__shelf').slideDown();
                }
            });
    
            $('.pantonePage .tabs__slider .slider-top').slick({
                infinite: true,
                fade: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                asNavFor: '.pantonePage .tabs__slider .slider-bottom',
            });
    
            $('.pantonePage .tabs__slider .slider-bottom').slick({
                infinite: true,
                fade: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                asNavFor: '.pantonePage .tabs__slider .slider-top',
            });
    
            // asNavFor: '.accessMobile__textSliderInner'
    
            $('.pantonePage .pantone__tabs button').on('click', function () {
                var dataID = $(this).closest('.tab').attr('data-id');
    
                $('.pantonePage .pantone__tabs .tab').removeClass('tab--active');
                $('.pantonePage .pantone__tabs .image').removeClass(
                    'image--active'
                );
    
                $(this).closest('.tab').addClass('tab--active');
                $(
                    '.pantonePage .pantone__tabs .image[data-id="' + dataID + '"]'
                ).addClass('image--active');
            });
    
            $('.panProd__slideshow').slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
            });
    
            if ($('#shopify-section-pantone-plp-product').length > 0) {
                var currentPrice = $('.panProd__colorSelector--active').attr(
                    'data-price'
                );
                var currentComparePrice = $('.panProd__colorSelector--active').attr(
                    'data-compare-price'
                );
    
                var currentRawPrice =
                    $('.panProd__colorSelector--active').attr('data-price-raw') * 1;
                var currentRawComparePrice =
                    $('.panProd__colorSelector--active').attr(
                        'data-compare-price-raw'
                    ) * 1;
    
                $('.panProd__price').text(currentPrice);
                if (currentRawPrice < currentRawComparePrice) {
                    $('.panProd__comparePrice').text(currentComparePrice);
                }
    
                var currentCoreColor = $('.panProd__colorRow')
                    .find('.panProd__colorSelector')
                    .first()
                    .attr('data-color-name');
                $('.panProd__colorTitle').text(currentCoreColor);
    
                var currentURL = $('.panProd__colorSelector--active').attr(
                    'data-url'
                );
                $('.panProd__leanMore').attr('href', currentURL);
    
                $('.panProd__colorSelector').on('click', function () {
                    $('.panProd__colorSelector').removeClass(
                        'panProd__colorSelector--active'
                    );
                    $(this).addClass('panProd__colorSelector--active');
    
                    var newVariantId = $(this).attr('data-id');
                    var newPrice = $(this).attr('data-price');
                    var newComparePrice = $(this).attr('data-compare-price');
                    var newPriceRaw = $(this).attr('data-price-raw') * 1;
                    var newComparePriceRaw =
                        $(this).attr('data-compare-price--raw') * 1;
                    var newURL = $(this).attr('data-url');
                    var newImgOne = $(this).attr('data-image-one');
                    var newImgTwo = $(this).attr('data-image-two');
                    var newImgThree = $(this).attr('data-image-three');
                    var newImgFour = $(this).attr('data-image-four');
    
                    $('.panProd__price').text(newPrice);
                    if (newPriceRaw < newComparePriceRaw) {
                        $('.panProd__comparePrice').text(newComparePrice);
                    }
    
                    $('.panProd__buy').attr('data-id', newVariantId);
                    $('.panProd__leanMore').attr('href', newURL);
    
                    $('.panProd__slideImage--one').attr('src', newImgOne);
                    $('.panProd__slideImage--two').attr('src', newImgTwo);
                    $('.panProd__slideImage--three').attr('src', newImgThree);
                    $('.panProd__slideImage--four').attr('src', newImgFour);
    
                    if (!$(this).hasClass('panProd__colorSelector--limited')) {
                        var newColorName = $(this).attr('data-color-name');
    
                        $('.panProd__colorTitle').text(newColorName);
                    }
                });
    
                $('.panProd__qtyMinus').on('click', function () {
                    var currentQty = $('.panProd__qty').attr('data-qty') * 1;
                    if (currentQty > 1) {
                        $('.panProd__qty').attr('data-qty', currentQty - 1);
                        $('.panProd__qty').text(currentQty - 1);
                    }
                });
    
                $('.panProd__qtyPlus').on('click', function () {
                    var currentQty = $('.panProd__qty').attr('data-qty') * 1;
                    $('.panProd__qty').attr('data-qty', currentQty + 1);
                    $('.panProd__qty').text(currentQty + 1);
                });
    
                function PantoneAddToCart(variant, qty) {
                    if (checkDiscountLimitFull(variant)) {
                        alert(
                            'You can only order up to ' +
                                $('body').attr('data-qty-limit') * 1 +
                                ' discounted items.'
                        );
                        return;
                    }
                    CartJS.addItem(
                        variant,
                        qty,
                        {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                        {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(true);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                }
    
                $('.panProd__buy').on('click', function () {
                    var currentVariant = $(this).attr('data-id');
                    var currentQty = $('.panProd__qty').attr('data-qty');
                    PantoneAddToCart(currentVariant, currentQty);
                });
            }
    
            $('.panInsta__slider').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 4,
                arrows: true,
                dots: true,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        },
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
    
            $('.panInsta__playButtonWrapper').on('click', function () {
                var iframeCode = $(this).attr('data-iframe');
                $('.panInsta__modalIframeWrapper').html(iframeCode);
                $('.panInsta__modal').fadeIn();
            });
    
            $('.panInsta__modalBkg, .panInsta__modalClose').on(
                'click',
                function () {
                    $('.panInsta__modalIframeWrapper').html('');
                    $('.panInsta__modal').fadeOut();
                }
            );
        });
    
        if ($('#redirect').length > 0) {
            window.location.replace(
                'https://support.shopyalehome.com/en_us/faq-keyed-alike-BJAtsdIJ2'
            );
        }
    
        $(document).ready(function () {
            if ($('.assure-compare').length > 0) {
                var setHeight = 0;
                $('.asCompare__row--one').each(function () {
                    if ($(this).outerHeight() > setHeight) {
                        setHeight = $(this).outerHeight();
                    }
                });
                $('.asCompare__row--one').attr(
                    'style',
                    'height:' + setHeight + 'px;'
                );
    
                setHeight = 0;
                $('.asCompare__row--two').each(function () {
                    if ($(this).outerHeight() > setHeight) {
                        setHeight = $(this).outerHeight();
                    }
                });
                $('.asCompare__row--two').attr(
                    'style',
                    'height:' + setHeight + 'px;'
                );
    
                setHeight = 0;
                $('.asCompare__row--three').each(function () {
                    if ($(this).outerHeight() > setHeight) {
                        setHeight = $(this).outerHeight();
                    }
                });
                $('.asCompare__row--three').attr(
                    'style',
                    'height:' + setHeight + 'px;'
                );
    
                setHeight = 0;
                $('.asCompare__row--four').each(function () {
                    if ($(this).outerHeight() > setHeight) {
                        setHeight = $(this).outerHeight();
                    }
                });
                $('.asCompare__row--four').attr(
                    'style',
                    'height:' + setHeight + 'px;'
                );
    
                setHeight = 0;
                $('.asCompare__row--five').each(function () {
                    if ($(this).outerHeight() > setHeight) {
                        setHeight = $(this).outerHeight();
                    }
                });
                $('.asCompare__row--five').attr(
                    'style',
                    'height:' + setHeight + 'px;'
                );
            }
    
            $('.asProdColumn__toggleButton').on('click', function () {
                var column = $(this).closest('.asProdColumn');
                column
                    .find('.asProdColumn__toggleButton')
                    .removeClass('asProdColumn__toggleButton--active');
                $(this).addClass('asProdColumn__toggleButton--active');
                if ($(this).attr('data-toggle') == 'bluetooth') {
                    column
                        .find('.asProdColumn__slider')
                        .removeClass('asProdColumn__slider--wifi')
                        .addClass('asProdColumn__slider--bluetooth');
                    column
                        .find('.asProdColumn__sled')
                        .removeClass('asProdColumn__sled--wifi')
                        .addClass('asProdColumn__sled--bluetooth');
                } else {
                    column
                        .find('.asProdColumn__slider')
                        .removeClass('asProdColumn__slider--bluetooth')
                        .addClass('asProdColumn__slider--wifi');
                    column
                        .find('.asProdColumn__sled')
                        .removeClass('asProdColumn__sled--bluetooth')
                        .addClass('asProdColumn__sled--wifi');
                }
            });
    
            function setCompareMobileProds() {
                var firstColumnNum = $('.asMobComp__select--one').attr(
                    'data-number'
                );
                var secondColumnNum = $('.asMobComp__select--two').attr(
                    'data-number'
                );
    
                var firstColumnTech = $('.asMobComp__toggleWrapper--one')
                    .find('.asMobComp__toggleButton--active')
                    .attr('data-tech');
                var secondColumnTech = $('.asMobComp__toggleWrapper--two')
                    .find('.asMobComp__toggleButton--active')
                    .attr('data-tech');
    
                $('.asMobComp__iconBlock--one')
                    .find('.asMobComp__iconWrapper')
                    .removeClass('asMobComp__iconWrapper--active');
                $('.asMobComp__iconBlock--one')
                    .find('[data-number="' + firstColumnNum + '"]')
                    .addClass('asMobComp__iconWrapper--active');
    
                $('.asMobComp__stat--one')
                    .find('.asMobComp__statWrapper')
                    .removeClass('asMobComp__statWrapper--active');
                $('.asMobComp__stat--one')
                    .find('[data-number="' + firstColumnNum + '"]')
                    .addClass('asMobComp__statWrapper--active');
    
                $('.asMobComp__priceWrapper--one')
                    .find('.asMobComp__priceBox')
                    .removeClass('asMobComp__priceBox--active');
                $('.asMobComp__priceWrapper--one')
                    .find('[data-number="' + firstColumnNum + '"]')
                    .addClass('asMobComp__priceBox--active');
    
                $('.asMobComp__buyWrapper--one')
                    .find('.asMobComp__buyBox')
                    .removeClass('asMobComp__buyBox--active');
                $('.asMobComp__buyWrapper--one')
                    .find('[data-number="' + firstColumnNum + '"]')
                    .addClass('asMobComp__buyBox--active');
    
                $('.asMobComp__learnWrapper--one')
                    .find('.asMobComp__learnBox')
                    .removeClass('asMobComp__learnBox--active');
                $('.asMobComp__learnWrapper--one')
                    .find('[data-number="' + firstColumnNum + '"]')
                    .addClass('asMobComp__learnBox--active');
    
                $('.asMobComp__iconBlock--two')
                    .find('.asMobComp__iconWrapper')
                    .removeClass('asMobComp__iconWrapper--active');
                $('.asMobComp__iconBlock--two')
                    .find('[data-number="' + secondColumnNum + '"]')
                    .addClass('asMobComp__iconWrapper--active');
    
                $('.asMobComp__stat--two')
                    .find('.asMobComp__statWrapper')
                    .removeClass('asMobComp__statWrapper--active');
                $('.asMobComp__stat--two')
                    .find('[data-number="' + secondColumnNum + '"]')
                    .addClass('asMobComp__statWrapper--active');
    
                $('.asMobComp__priceWrapper--two')
                    .find('.asMobComp__priceBox')
                    .removeClass('asMobComp__priceBox--active');
                $('.asMobComp__priceWrapper--two')
                    .find('[data-number="' + secondColumnNum + '"]')
                    .addClass('asMobComp__priceBox--active');
    
                $('.asMobComp__buyWrapper--two')
                    .find('.asMobComp__buyBox')
                    .removeClass('asMobComp__buyBox--active');
                $('.asMobComp__buyWrapper--two')
                    .find('[data-number="' + secondColumnNum + '"]')
                    .addClass('asMobComp__buyBox--active');
    
                $('.asMobComp__learnWrapper--two')
                    .find('.asMobComp__learnBox')
                    .removeClass('asMobComp__learnBox--active');
                $('.asMobComp__learnWrapper--two')
                    .find('[data-number="' + secondColumnNum + '"]')
                    .addClass('asMobComp__learnBox--active');
    
                if (firstColumnTech == 'bluetooth') {
                    $('.asMobComp__iconBlock--one')
                        .find('.asMobComp__icon--bluetooth')
                        .show();
                    $('.asMobComp__iconBlock--one')
                        .find('.asMobComp__icon--wifi')
                        .hide();
    
                    $('.asMobComp__stat--one')
                        .find('.asMobComp__statText--bluetooth')
                        .show();
                    $('.asMobComp__stat--one')
                        .find('.asMobComp__statText--wifi')
                        .hide();
    
                    $('.asMobComp__priceWrapper--one')
                        .find('.asMobComp__price--bluetooth')
                        .show();
                    $('.asMobComp__priceWrapper--one')
                        .find('.asMobComp__price--wifi')
                        .hide();
    
                    $('.asMobComp__buyWrapper--one')
                        .find('.asMobComp__buy--bluetooth')
                        .show();
                    $('.asMobComp__buyWrapper--one')
                        .find('.asMobComp__buy--wifi')
                        .hide();
    
                    $('.asMobComp__learnWrapper--one')
                        .find('.asMobComp__learn--bluetooth')
                        .show();
                    $('.asMobComp__learnWrapper--one')
                        .find('.asMobComp__learn--wifi')
                        .hide();
                } else {
                    $('.asMobComp__iconBlock--one')
                        .find('.asMobComp__icon--bluetooth')
                        .hide();
                    $('.asMobComp__iconBlock--one')
                        .find('.asMobComp__icon--wifi')
                        .show();
    
                    $('.asMobComp__stat--one')
                        .find('.asMobComp__statText--bluetooth')
                        .hide();
                    $('.asMobComp__stat--one')
                        .find('.asMobComp__statText--wifi')
                        .show();
    
                    $('.asMobComp__priceWrapper--one')
                        .find('.asMobComp__price--bluetooth')
                        .hide();
                    $('.asMobComp__priceWrapper--one')
                        .find('.asMobComp__price--wifi')
                        .show();
    
                    $('.asMobComp__buyWrapper--one')
                        .find('.asMobComp__buy--bluetooth')
                        .hide();
                    $('.asMobComp__buyWrapper--one')
                        .find('.asMobComp__buy--wifi')
                        .show();
    
                    $('.asMobComp__learnWrapper--one')
                        .find('.asMobComp__learn--bluetooth')
                        .hide();
                    $('.asMobComp__learnWrapper--one')
                        .find('.asMobComp__learn--wifi')
                        .show();
                }
    
                if (secondColumnTech == 'bluetooth') {
                    $('.asMobComp__iconBlock--two')
                        .find('.asMobComp__icon--bluetooth')
                        .show();
                    $('.asMobComp__iconBlock--two')
                        .find('.asMobComp__icon--wifi')
                        .hide();
    
                    $('.asMobComp__stat--two')
                        .find('.asMobComp__statText--bluetooth')
                        .show();
                    $('.asMobComp__stat--two')
                        .find('.asMobComp__statText--wifi')
                        .hide();
    
                    $('.asMobComp__priceWrapper--two')
                        .find('.asMobComp__price--bluetooth')
                        .show();
                    $('.asMobComp__priceWrapper--two')
                        .find('.asMobComp__price--wifi')
                        .hide();
    
                    $('.asMobComp__buyWrapper--two')
                        .find('.asMobComp__buy--bluetooth')
                        .show();
                    $('.asMobComp__buyWrapper--two')
                        .find('.asMobComp__buy--wifi')
                        .hide();
    
                    $('.asMobComp__learnWrapper--two')
                        .find('.asMobComp__learn--bluetooth')
                        .show();
                    $('.asMobComp__learnWrapper--two')
                        .find('.asMobComp__learn--wifi')
                        .hide();
                } else {
                    $('.asMobComp__iconBlock--two')
                        .find('.asMobComp__icon--bluetooth')
                        .hide();
                    $('.asMobComp__iconBlock--two')
                        .find('.asMobComp__icon--wifi')
                        .show();
    
                    $('.asMobComp__stat--two')
                        .find('.asMobComp__statText--bluetooth')
                        .hide();
                    $('.asMobComp__stat--two')
                        .find('.asMobComp__statText--wifi')
                        .show();
    
                    $('.asMobComp__priceWrapper--two')
                        .find('.asMobComp__price--bluetooth')
                        .hide();
                    $('.asMobComp__priceWrapper--two')
                        .find('.asMobComp__price--wifi')
                        .show();
    
                    $('.asMobComp__buyWrapper--two')
                        .find('.asMobComp__buy--bluetooth')
                        .hide();
                    $('.asMobComp__buyWrapper--two')
                        .find('.asMobComp__buy--wifi')
                        .show();
    
                    $('.asMobComp__learnWrapper--two')
                        .find('.asMobComp__learn--bluetooth')
                        .hide();
                    $('.asMobComp__learnWrapper--two')
                        .find('.asMobComp__learn--wifi')
                        .show();
                }
            }
            setCompareMobileProds();
    
            $('.asMobComp__selectDropButton').on('click', function () {
                var container = $(this).closest('.asMobComp__select');
                var thisThing = $(this);
                container.attr('data-number', thisThing.attr('data-number'));
                container.find('.asMobComp__selectedName').text(thisThing.text());
    
                setCompareMobileProds();
            });
    
            $('.asMobComp__toggleButton').on('click', function () {
                var container = $(this).closest('.asMobComp__toggleWrapper');
                var thisThing = $(this);
    
                container
                    .find('.asMobComp__toggleButton')
                    .removeClass('asMobComp__toggleButton--active');
                thisThing.addClass('asMobComp__toggleButton--active');
    
                if (thisThing.attr('data-tech') == 'bluetooth') {
                    container
                        .find('.asMobComp__toggleBkg')
                        .removeClass('asMobComp__toggleBkg--wifi');
                    container
                        .find('.asMobComp__toggleBkg')
                        .addClass('asMobComp__toggleBkg--bluetooth');
                } else {
                    container
                        .find('.asMobComp__toggleBkg')
                        .addClass('asMobComp__toggleBkg--wifi');
                    container
                        .find('.asMobComp__toggleBkg')
                        .removeClass('asMobComp__toggleBkg--bluetooth');
                }
    
                setCompareMobileProds();
            });
    
            $('.assure-switch [data-iframe]').on('click', function () {
                var target = $('.touchVidModal');
                var iframe = $(this).attr('data-iframe');
    
                target.find('.touchVidModal__iframeWrapper').html(iframe);
                target.fadeIn();
            });
    
            $('.touchVidModal__bkg, .touchVidModal__close').on(
                'click',
                function () {
                    var target = $('.touchVidModal');
    
                    target.find('.touchVidModal__iframeWrapper').html('');
                    target.fadeOut();
                }
            );
            if ($('.al2Prod__colorButtonInner').length > 0) {
                $('.al2Prod__colorButtonInner:first').click();
            }
    
            $('.workPill__slider .slider__slides').slick({
                slidesToShow: 3,
                variableWidth: false,
                infinite: false,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            // variableWidth: false,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: false,
                            fade: true,
                        },
                    },
                ],
            });
    
            $('.workPill__tabs .slider').slick({
                infinite: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
    
            $('.accessCollection__prev--tabs').on('click', function () {
                $('.workPill__tabs .slider').slick('slickPrev');
            });
    
            $('.accessCollection__next--tabs').on('click', function () {
                $('.workPill__tabs .slider').slick('slickNext');
            });
    
            $('.workPill__slider .slider__slides').on(
                'afterChange',
                function (event, slick, currentSlide) {
                    if (
                        slick.currentSlide >=
                        slick.slideCount - slick.options.slidesToShow
                    ) {
                        $('.workPill__slider .slider__slides').slick(
                            'slickGoTo',
                            0
                        );
                    }
                }
            );
    
            $('.workPill__tabs .tab-btn button').on('click', function () {
                var dataID = $(this).attr('data-id');
    
                $('.workPill__tabs .tab-btn').removeClass('active');
                $(this).closest('.tab-btn').addClass('active');
    
                $('.workPill__tabs .tabs__list .tab-block').removeClass('active');
                $(
                    '.workPill__tabs .tabs__list .tab-block[data-id="' +
                        dataID +
                        '"]'
                ).addClass('active');
                $(
                    '.workPill__tabs .tabs__list .tab-block[data-id="' +
                        dataID +
                        '"] .slider'
                ).slick('setPosition');
            });
    
            $('.works-with .trigger').on('click', function () {
                $(this).toggleClass('active');
                $(this).next('.copy').slideToggle(350);
            });
    
            // Works With Pillars Brand Filter - DESKTOP
            $('.workPill__explore .explore__filters--desktop .filter').on(
                'click',
                function () {
                    var filterVal = $(this).attr('data-id');
    
                    if ($(this).hasClass('active')) {
                        $(this).removeClass('active');
                        $('.explore__brands .brand').fadeOut(200, function () {
                            setTimeout(function () {
                                $('.explore__brands .brand')
                                    .removeClass('active')
                                    .fadeIn(100);
                                // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
                            }, 200);
                        });
                    } else {
                        $('.workPill__explore .filter').removeClass('active');
                        $(this).addClass('active');
    
                        $('.explore__brands .brand').fadeOut(200, function () {
                            if (filterVal == 'all') {
                                setTimeout(function () {
                                    $('.explore__brands .brand')
                                        .removeClass('active')
                                        .fadeIn(100);
                                    // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
                                }, 200);
                            } else {
                                setTimeout(function () {
                                    $('.explore__brands .brand').removeClass(
                                        'active'
                                    );
                                    $(
                                        '.explore__brands .brand[data-' +
                                            filterVal +
                                            '="true"]'
                                    )
                                        .addClass('active')
                                        .fadeIn(100);
                                }, 200);
                            }
                        });
                    }
                }
            );
    
            // Works With Pillars Brand Filter - MOBILE
            $('.workPill__explore .explore__filters--mobile .chooser .filter').on(
                'click',
                function () {
                    $(
                        '.workPill__explore .explore__filters--mobile  .chooser'
                    ).toggleClass('is-open');
                    $(
                        '.workPill__explore .explore__filters--mobile  .list'
                    ).slideToggle(400);
                }
            );
    
            $('.workPill__explore .explore__filters--mobile .list .filter').on(
                'click',
                function () {
                    var filterVal = $(this).attr('data-id');
                    $(
                        '.workPill__explore .explore__filters--mobile  .chooser li'
                    ).removeClass('active');
                    $(
                        '.workPill__explore .explore__filters--mobile  .chooser'
                    ).toggleClass('is-open');
    
                    $(
                        '.workPill__explore .explore__filters--mobile .chooser .filter[data-id="' +
                            filterVal +
                            '"]'
                    )
                        .closest('li')
                        .addClass('active');
    
                    $('.explore__filters--mobile  .list').slideUp(400, function () {
                        setTimeout(function () {
                            $(
                                '.workPill__explore .explore__filters--mobile  .list li'
                            ).removeClass('active');
                            $(
                                '.workPill__explore .explore__filters--mobile .list .filter[data-id="' +
                                    filterVal +
                                    '"]'
                            )
                                .closest('li')
                                .addClass('active');
                        }, 450);
                    });
    
                    $('.explore__brands .brand').fadeOut(200, function () {
                        if (filterVal == 'all') {
                            setTimeout(function () {
                                $('.explore__brands .brand')
                                    .removeClass('active')
                                    .fadeIn(100);
                                // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
                            }, 200);
                        } else {
                            setTimeout(function () {
                                $('.explore__brands .brand').removeClass('active');
                                $(
                                    '.explore__brands .brand[data-' +
                                        filterVal +
                                        '="true"]'
                                )
                                    .addClass('active')
                                    .fadeIn(100);
                            }, 200);
                        }
                    });
                }
            );
    
            // Works With Tabs Filter - MOBILE
            $('.workPill__tabs .explore__filters--mobile .chooser button').on(
                'click',
                function () {
                    $(
                        '.workPill__tabs .explore__filters--mobile  .chooser'
                    ).toggleClass('is-open');
                    $(
                        '.workPill__tabs .explore__filters--mobile  .list'
                    ).slideToggle(400);
                }
            );
    
            $('.workPill__tabs .explore__filters--mobile .list button').on(
                'click',
                function () {
                    var filterVal = $(this).attr('data-id');
                    $(
                        '.workPill__tabs .explore__filters--mobile  .chooser li'
                    ).removeClass('active');
                    $(
                        '.workPill__tabs .explore__filters--mobile  .chooser'
                    ).toggleClass('is-open');
    
                    $(
                        '.workPill__tabs .explore__filters--mobile .chooser button[data-id="' +
                            filterVal +
                            '"]'
                    )
                        .closest('li')
                        .addClass('active');
    
                    $('.explore__filters--mobile .list').slideUp(400, function () {
                        setTimeout(function () {
                            $(
                                '.workPill__tabs .explore__filters--mobile  .list li'
                            ).removeClass('active');
                            $(
                                '.workPill__tabs .explore__filters--mobile .list button[data-id="' +
                                    filterVal +
                                    '"]'
                            )
                                .closest('li')
                                .addClass('active');
                        }, 450);
                    });
                }
            );
    
            $('.sloFeatured__techSwap').on('click', function () {
                $('.sloFeatured__techSwap').removeClass(
                    'sloFeatured__techSwap--active'
                );
                $(this).addClass('sloFeatured__techSwap--active');
                if ($(this).attr('data-tech') == 'bluetooth') {
                    $('.sloFeatured__techContainer--bluetooth').show();
                    $('.sloFeatured__techContainer--wifi').hide();
                } else {
                    $('.sloFeatured__techContainer--bluetooth').hide();
                    $('.sloFeatured__techContainer--wifi').show();
                }
            });
    
            function legalScrollRight() {
                $('.newLegalHeader__tabsFrame').animate(
                    { scrollLeft: '+=164' },
                    200
                );
            }
            $('.newLegalHeader__tabsNext').on('click', function () {
                legalScrollRight();
            });
            function legalScrollLeft() {
                $('.newLegalHeader__tabsFrame').animate(
                    { scrollLeft: '-=164' },
                    200
                );
            }
            $('.newLegalHeader__tabsPrev').on('click', function () {
                legalScrollLeft();
            });
    
            console.log('test the legal page here');
    
            function legalCheckScroll() {
                if ($('.newLegalHeader__tabsFrame').length > 0) {
                    var $width = $('.newLegalHeader__tabsFrame').outerWidth();
                    var $scrollWidth = $('.newLegalHeader__tabsFrame')[0]
                        .scrollWidth;
                    var $scrollLeft = $('.newLegalHeader__tabsFrame').scrollLeft();
    
                    if ($scrollWidth - $width === $scrollLeft) {
                        $('.newLegalHeader__tabsNextBox').fadeOut();
                    } else {
                        $('.newLegalHeader__tabsNextBox').fadeIn();
                    }
                    if ($scrollLeft === 0) {
                        $('.newLegalHeader__tabsPrevBox').fadeOut();
                    } else {
                        $('.newLegalHeader__tabsPrevBox').fadeIn();
                    }
                }
            }
            legalCheckScroll();
    
            $('.newLegalHeader__tabsFrame').on('scroll', function () {
                legalCheckScroll();
            });
    
            $('.newLegalTopButton').on('click', function () {
                $('body, html').animate({ scrollTop: '0' }, 200);
            });
    
            $('.newLegalHeader__mobileTabSelected').on('click', function () {
                $('.newLegalHeader__mobileTabsDrawer').slideToggle();
            });
        });
    
        $(document).ready(function () {
            function updateCart(openCart) {
                app._getCartData();
                app._vibrateDevice();
                app.$snotify.clear();
                showHideMiniCartKeyedAlike();
                setTimeout(function () {
                    if (
                        ((app.isLoading = false),
                        (app.loadingEvent = null),
                        app.storeUtilities.cartUpsells.settings.showOnPopUp)
                    ) {
                        var origin = app.cart.items.find(function (data) {
                            return data.variant_id === keys;
                        });
                        app._openModalCartUpsell(origin);
                    } else {
                        if (openCart == true) {
                            app._openCartDrawer();
                        } else {
                            app._touchCartDrawer();
                        }
                    }
                }, 300);
            }
    
            function showHideMiniCartKeyedAlike() {
                var count = 0;
                var alreadyGroups = false;
                for (i = 0; i < CartJS.cart.items.length; i++) {
                    if (
                        CartJS.cart.items[i].properties['_keyed_alike_available'] ==
                        'true'
                    ) {
                        var qty = CartJS.cart.items[i].quantity;
                        count += 1 * qty;
                    }
                    if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
                        alreadyGroups = true;
                    }
                }
                console.log(count);
                if (count > 1 && alreadyGroups == false) {
                    $('.miniCartKA').show();
                } else {
                    $('.miniCartKA').hide();
                }
            }
    
            function getIndexVariantData(targetButton) {
                var targetContainer = targetButton.closest('.card');
                var activeColorTitle = targetContainer
                    .find('.color-swatch input:checked')
                    .attr('value');
    
                var targetSelector = targetContainer.find('.indexBuySelect');
                var selectedVariant = false;
                var found = false;
                targetSelector.find('option').each(function () {
                    if (
                        $(this).attr('data-options').indexOf(activeColorTitle) >=
                            0 &&
                        found == false
                    ) {
                        selectedVariant = {
                            id: $(this).attr('value') * 1,
                            available: $(this).attr('data-available'),
                            price: $(this).attr('data-price'),
                        };
                        var imgSrc = $(this).attr('data-image');
                        console.log(imgSrc);
                        targetContainer.find('.card-img-image').attr('src', imgSrc);
                        found = true;
                    }
                });
    
                return selectedVariant;
            }
    
            function displayIndexVaraintData(variantData, targetButton) {
                var targetContainer = targetButton.closest('.card-body');
                targetContainer.find('.CROProdPrice').text(variantData.price);
                targetContainer
                    .find('.indexBuyButton')
                    .attr('data-id', variantData.id);
                if (variantData.available == 'true') {
                    targetContainer.find('.indexBuyButton').text('Buy Now');
                    targetContainer
                        .find('.indexBuyButton')
                        .removeClass('indexBuyButton--soldOut');
                } else {
                    targetContainer.find('.indexBuyButton').text('Out of Stock');
                    targetContainer
                        .find('.indexBuyButton')
                        .addClass('indexBuyButton--soldOut');
                }
            }
    
            function initializeAllHomeCROButtons() {
                $('.indexBuyButton').each(function () {
                    var thisThing = $(this);
                    var variantData = getIndexVariantData(thisThing);
                    displayIndexVaraintData(variantData, thisThing);
                });
            }
    
            function bindHomeCROButtons() {
                $('.CROColorButton')
                    .unbind('click')
                    .on('click', function () {
                        var thisThing = $(this);
                        var variantData = getIndexVariantData(thisThing);
                        displayIndexVaraintData(variantData, thisThing);
                    });
    
                $('.indexBuyButton')
                    .unbind('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        var variantID = $(this).attr('data-id');
                        if (checkDiscountLimitFull(variantID)) {
                            alert(
                                'You can only order up to ' +
                                    $('body').attr('data-qty-limit') * 1 +
                                    ' discounted items.'
                            );
                            return;
                        }
                        CartJS.addItem(
                            variantID,
                            1,
                            {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                            {
                                success: function (data, textStatus, jqXHR) {
                                    updateCart(true);
                                },
                                error: function (jqXHR, textStatus, errorThrown) {
                                    console.log('Error: ' + errorThrown + '!');
                                },
                            }
                        );
                    });
            }
            bindHomeCROButtons();
            initializeAllHomeCROButtons();
    
            setInterval(function () {
                bindHomeCROButtons();
                //initializeAllHomeCROButtons();
            }, 500);
    
            if (indexBuyButtonTest == true) {
                $('.showForCROIndexTest').show();
                $('.hideForCROIndexTest').hide();
            } else {
                $('.showForCROIndexTest').hide();
                $('.hideForCROIndexTest').show();
            }
    
            function setHomeAwardWidths() {
                $('.indexPress__card').each(function () {
                    var thisThing = $(this);
                    var targetWidth = $(this).find('img').width();
                    thisThing.attr('style', 'width:' + targetWidth + 'px;');
                });
            }
            setHomeAwardWidths();
    
            var homeIndexCount = 0;
    
            if ($('.indexPress__card').length > 0) {
                setInterval(function () {
                    homeIndexCount += 1;
                    if (homeIndexCount > 3) {
                        homeIndexCount = 0;
                    }
                    $('.indexPress__dot').removeClass('indexPress__dot--active');
                    $('.indexPress__card').removeClass('indexPress__card--active');
    
                    $(
                        '.indexPress__dot[data-index="' + homeIndexCount + '"]'
                    ).addClass('indexPress__dot--active');
                    $(
                        '.indexPress__card[data-index="' + homeIndexCount + '"]'
                    ).addClass('indexPress__card--active');
    
                    setHomeAwardWidths();
                }, 2000);
            }
    
            $('.approachVideos__button').on('click', function () {
                var dataIndex = $(this).attr('data-index');
                var thisParent = $(this).closest('.approachVideos');
    
                if (!$(this).hasClass('approachVideos__button--active')) {
                    thisParent
                        .find('.approachVideos__button')
                        .removeClass('approachVideos__button--active');
                    $(this).addClass('approachVideos__button--active');
    
                    thisParent
                        .find('.approachVideos__video')
                        .removeClass('approachVideos__video--active');
                    thisParent
                        .find(
                            '.approachVideos__video[data-index="' + dataIndex + '"]'
                        )
                        .addClass('approachVideos__video--active');
                }
            });
    
            $('.approachManageButton__button').on('click', function () {
                var dataIndex = $(this).attr('data-index');
                var thisParent = $(this).closest('.approachManage');
    
                if (!$(this).parent().hasClass('approachManageButton--active')) {
                    thisParent
                        .find('.approachManageButton')
                        .removeClass('approachManageButton--active');
                    $(this).parent().addClass('approachManageButton--active');
    
                    thisParent
                        .find('.approachManage__image')
                        .removeClass('approachManage__image--active');
                    thisParent
                        .find(
                            '.approachManage__image[data-index="' + dataIndex + '"]'
                        )
                        .addClass('approachManage__image--active');
                }
            });
    
            $('.approachVideoPlayer__playButton').on('click', function () {
                var iframeHTML = $(this).attr('data-iframe');
                $(this)
                    .closest('.shopify-section')
                    .find('.approachVideoPopup')
                    .fadeIn();
                $(this)
                    .closest('.shopify-section')
                    .find('.approachVideoPopup__iframeWrapper')
                    .html(iframeHTML);
            });
    
            $('.approachVideoPopup__background, .approachVideoPopup__close').on(
                'click',
                function () {
                    var parentTarget = $(this).closest('.approachVideoPopup');
                    var iframeWrapper = parentTarget.find(
                        '.approachVideoPopup__iframeWrapper'
                    );
                    iframeWrapper.html('');
                    parentTarget.fadeOut();
                }
            );
    
            const approachAppSlider = new Swiper(
                '.approachApp__mobileSliderContainer',
                {
                    pagination: {
                        el: '.approachApp__sliderDots',
                    },
                    navigation: {
                        nextEl: '.approachApp__nextSlide',
                        prevEl: '.approachApp__previousSlide',
                    },
                }
            );
    
            const approachManageUpperSlider = new Swiper(
                '.approachManage__mobileUpperSliderContainer',
                {
                    pagination: {
                        el: '.approachManage__dots',
                    },
                    navigation: {
                        nextEl: '.approachManage__next',
                        prevEl: '.approachManage__previous',
                    },
                }
            );
    
            const approachManageLowerSlider = new Swiper(
                '.approachManage__mobileLowerSliderContainer',
                {
                    pagination: {
                        el: '.approachManage__dots',
                    },
                    navigation: {
                        nextEl: '.approachManage__next',
                        prevEl: '.approachManage__previous',
                    },
                }
            );
    
            $('.al2Sticky--approach').parent().addClass('newSticky');
    
            $('.newsList__showMore').on('click', function () {
                $('.newsCard--hidden').removeClass('newsCard--hidden');
                $('.newsList__showFlex').hide();
            });
    
            if ($('.pressBody__sideBar').length > 0) {
                var sideBarContent = $('.pressBody__sideBar').html();
                $('.pressMobileSidebarContainer').html(sideBarContent);
            }
    
            if ($('.topbar--countdown').length > 0) {
                var endDateString = $('.headerCountDown__countWrapper').attr(
                    'data-date'
                );
                const targetTime = new Date(endDateString);
    
                setInterval(function () {
                    const currentTime = new Date();
                    const difference = targetTime - currentTime;
    
                    const days = Math.floor(difference / (1000 * 60 * 60 * 24))
                        .toString()
                        .padStart(2, '0');
                    const hours = Math.floor(
                        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    )
                        .toString()
                        .padStart(2, '0');
                    const minutes = Math.floor(
                        (difference % (1000 * 60 * 60)) / (1000 * 60)
                    )
                        .toString()
                        .padStart(2, '0');
                    const seconds = Math.floor((difference % (1000 * 60)) / 1000)
                        .toString()
                        .padStart(2, '0');
    
                    $('.headerCountDown__number--days').text(days);
                    $('.headerCountDown__number--hours').text(hours);
                    $('.headerCountDown__number--minutes').text(minutes);
                    $('.headerCountDown__number--seconds').text(seconds);
                }, 100);
            }
    
            var swiperLib = [];
            var arrayIndex = 0;
            $('.swiper-wrapper').each(function () {
                var origin = $(this).closest('[data-section-index]');
                var builderIndex = origin.attr('data-section-index');
    
                if (origin.hasClass('expressionCardRow')) {
                    swiperLib.push(
                        new Swiper(
                            '[data-section-index="' +
                                builderIndex +
                                '"] .expressionCardRow__sliderWrapper',
                            {
                                loop: false,
                                slidesPerView: 1,
                                spaceBetween: 20,
                                navigation: {
                                    prevEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .expressionCardRow__previous',
                                    nextEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .expressionCardRow__next',
                                },
                                breakpoints: {
                                    600: {
                                        slidesPerView: 2,
                                    },
                                    800: {
                                        slidesPerView: 3,
                                    },
                                    1000: {
                                        slidesPerView: 4,
                                    },
                                },
                            }
                        )
                    );
    
                    arrayIndex += 1;
                } else if (origin.hasClass('liftThreeCards')) {
                    swiperLib.push(
                        new Swiper(
                            '[data-section-index="' +
                                builderIndex +
                                '"] .liftThreeCards__sliderWrapper',
                            {
                                loop: false,
                                slidesPerView: 1,
                                spaceBetween: 20,
                                navigation: {
                                    prevEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .liftThreeCards__previous',
                                    nextEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .liftThreeCards__next',
                                },
                                breakpoints: {
                                    600: {
                                        slidesPerView: 2,
                                    },
                                    800: {
                                        slidesPerView: 3,
                                    },
                                },
                            }
                        )
                    );
                } else if (origin.hasClass('liftFourCards')) {
                    swiperLib.push(
                        new Swiper(
                            '[data-section-index="' +
                                builderIndex +
                                '"] .liftFourCards__sliderWrapper',
                            {
                                loop: false,
                                slidesPerView: 1,
                                spaceBetween: 20,
                                navigation: {
                                    prevEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .liftFourCards__previous',
                                    nextEl:
                                        '[data-section-index="' +
                                        builderIndex +
                                        '"] .liftFourCards__next',
                                },
                                breakpoints: {
                                    600: {
                                        slidesPerView: 2,
                                    },
                                    800: {
                                        slidesPerView: 3,
                                    },
                                    1000: {
                                        slidesPerView: 3,
                                    },
                                },
                            }
                        )
                    );
                }
            });
    
            if ($('.approachPDP').length > 0) {
                if ($('.approachPDP--keypad').length > 0) {
                    $('[data-prod-option="wifi"]').on('click', function () {
                        $('.al2Prod__newTag').hide();
                    });
                    $('[data-prod-option="bluetooth"]').on('click', function () {
                        $('.al2Prod__newTag').show();
                    });
                } else {
                    $('[data-key-option="key-free"]').on('click', function () {
                        $('.al2Prod__newTag').hide();
                    });
                    $('[data-key-option="keyed"]').on('click', function () {
                        $('.al2Prod__newTag').show();
                    });
                }
                $('[data-prod-option="wifi"]').on('click', function () {
                    $('[data-key-option="key-free"]').click();
                    $('.al2Prod__keyOptionRow').hide();
                });
                $('[data-prod-option="bluetooth"]').on('click', function () {
                    $('.al2Prod__keyOptionRow').show();
                    $('[data-key-option="keyed"]').click();
                });
            }
    
            function replaceNavForB2B() {
                $('.topbar').remove();
                $('.b2bHide').hide();
                var desktopNav = $('.navbar-main').find('ul.main-nav');
                var newNavHTML =
                    '<li class="nav-item dropdown"><a name="Business Overview" href="/pages/business-and-multi-family" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglebusiness-and-multi-family">Business Overview</a></li>';
                newNavHTML +=
                    '<li class="nav-item dropdown"><a name="Multi-Family Housing" href="/pages/multi-family-housing" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglemulti-family-housing">Multi-Family Housing</a></li>';
                newNavHTML +=
                    '<li class="nav-item dropdown"><a name="Security Integrators" href="/pages/security-integrators" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglesecurity-integrators">Security Integrators</a></li>';
                newNavHTML +=
                    '<li class="nav-item dropdown"><a name="Wholesale Distribution" href="/pages/wholesale-distribution" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglewholesale-distribution">Wholesale Distribution</a></li>';
                newNavHTML +=
                    '<li class="nav-item dropdown"><a name="Support" target="_blank" href="https://support.shopyalehome.com/" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglesupport">Support</a></li>';
                desktopNav.html(newNavHTML);
            }
    
            function replaceMobNavForB2B() {
                $('header nav a[name="search"]').html('');
                $('header nav a[name="cart"]').html('');
                $('header nav a[name="account"]').html('');
                $('header nav a[name="menu"]').attr('style', 'height:20px;');
                $('.b2bHide').hide();
                var desktopNav = $('.mobile-nav-drawer .navbar-mobile')
                    .find('ul.navbar-nav')
                    .first();
                var newNavHTML =
                    '<li class="nav-item "><a href="/pages/business-and-multi-family" name="Business Overview" title="Business Overview" aria-label="Business Overview" class="nav-link">Business Overview</a></li>';
                newNavHTML +=
                    '<li class="nav-item "><a href="/pages/multi-family-housing" name="Multi-Family Housing" title="Multi-Family Housing" aria-label="Multi-Family Housing" class="nav-link">Multi-Family Housing</a></li>';
                newNavHTML +=
                    '<li class="nav-item "><a href="/pages/security-integrators" name="Security Integrators" title="Security Integrators" aria-label="Security Integrators" class="nav-link">Security Integrators</a></li>';
                newNavHTML +=
                    '<li class="nav-item "><a href="/pages/wholesale-distribution" name="Wholesale Distribution" title="Wholesale Distribution" aria-label="Wholesale Distribution" class="nav-link">Wholesale Distribution</a></li>';
                newNavHTML +=
                    '<li class="nav-item "><a href="https://support.shopyalehome.com/" target="_blank" name="Support" title="Support" aria-label="Support" class="nav-link">Support</a></li>';
                desktopNav.html(newNavHTML);
            }
    
            var isB2bPage = false;
            var b2bClassList = [
                '.template-page-lift-businessmultifamily',
                '.template-page-lift-multifamily',
                '.template-page-lift-security',
                '.template-page-lift-wholesale',
                '.template-page-new-multi-family'
            ];
            for (i = 0; i < b2bClassList.length; i++) {
                if ($(b2bClassList[i]).length > 0) {
                    isB2bPage = true;
                }
            }
            if (isB2bPage) {
                replaceNavForB2B();
                replaceMobNavForB2B();
            }
        });
    
        $(document).ready(function () {
            var sliderArray = [];
            var swiperCount = 0;
            $('[data-builder-index] .swiper-wrapper').each(function () {
                var thisIndex = $(this)
                    .closest('[data-builder-index]')
                    .attr('data-builder-index');
                var thisParent = $(this).parent();
                if (thisParent.hasClass('abnbShop__sliderWrapper')) {
                    var swiperData = {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        freeMode: {
                            enabled: true,
                            sticky: true,
                        },
                        mousewheel: {
                            enabled: true,
                            forceToAxis: true,
                        },
                        navigation: {
                            nextEl: '.abnbShop__nextArrow',
                            prevEl: '.abnbShop__prevArrow',
                        },
                        loop: false,
                        breakpoints: {
                            1000: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                        },
                    };
                    sliderArray[swiperCount] = new Swiper(
                        '[data-builder-index="' +
                            thisIndex +
                            '"] .abnbShop__sliderWrapper',
                        swiperData
                    );
                    swiperCount++;
                } else if (thisParent.hasClass('abnbLinks__sliderWrapper')) {
                    var swiperData = {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        loop: false,
                        navigation: {
                            nextEl: '.abnbLinks__nextArrow',
                            prevEl: '.abnbLinks__prevArrow',
                        },
                        freeMode: {
                            enabled: true,
                            sticky: true,
                        },
                        mousewheel: {
                            enabled: true,
                            forceToAxis: true,
                        },
                        breakpoints: {
                            1000: {
                                slidesPerView: 3,
                            },
                        },
                    };
                    sliderArray[swiperCount] = new Swiper(
                        '[data-builder-index="' +
                            thisIndex +
                            '"] .abnbLinks__sliderWrapper',
                        swiperData
                    );
                    swiperCount++;
                } else if (thisParent.hasClass('eco3Cards__sliderWrapper')) {
                    var swiperData = {
                        slidesPerView: 1,
                        spaceBetween: 12,
                        loop: false,
                        navigation: {
                            nextEl:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Card__arrow--next',
                            prevEl:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Card__arrow--prev',
                        },
                        freeMode: {
                            enabled: true,
                            sticky: true,
                        },
                        mousewheel: {
                            enabled: true,
                            forceToAxis: true,
                        },
                        pagination: {
                            el:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Cards__dotsHolder',
                        },
                        breakpoints: {
                            1000: {
                                slidesPerView: 3,
                            },
                        },
                    };
                    sliderArray[swiperCount] = new Swiper(
                        '[data-builder-index="' +
                            thisIndex +
                            '"] .eco3Cards__sliderWrapper',
                        swiperData
                    );
                    swiperCount++;
                } else if (thisParent.hasClass('eco3Col__sliderWrapper')) {
                    var swiperData = {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        loop: false,
                        navigation: {
                            nextEl:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Card__arrow--next',
                            prevEl:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Card__arrow--prev',
                        },
                        freeMode: {
                            enabled: true,
                            sticky: true,
                        },
                        mousewheel: {
                            enabled: true,
                            forceToAxis: true,
                        },
                        pagination: {
                            el:
                                '[data-builder-index="' +
                                thisIndex +
                                '"] .eco3Cards__dotsHolder',
                        },
                        breakpoints: {
                            1000: {
                                slidesPerView: 3,
                            },
                        },
                    };
                    sliderArray[swiperCount] = new Swiper(
                        '[data-builder-index="' +
                            thisIndex +
                            '"] .eco3Col__sliderWrapper',
                        swiperData
                    );
                    swiperCount++;
                }
            });
    
            $('.abnbProdSlide__color').on('click', function () {
                var slideParent = $(this).closest('.abnbProdSlide');
                slideParent
                    .find('.abnbProdSlide__color')
                    .removeClass('abnbProdSlide__color--active');
                $(this).addClass('abnbProdSlide__color--active');
                var imageTarget = slideParent.find('.abnbProdSlide__image');
                if ($(this).attr('data-name') == 'Black Suede') {
                    imageTarget.attr('src', imageTarget.attr('data-black'));
                } else if (
                    $(this).attr('data-name') == 'Satin Nickel' ||
                    $(this).attr('data-name') == 'Silver'
                ) {
                    imageTarget.attr('src', imageTarget.attr('data-silver'));
                } else if (
                    $(this).attr('data-name') == 'Oil Rubbed Bronze' ||
                    $(this).attr('data-name') == 'Bronze'
                ) {
                    imageTarget.attr('src', imageTarget.attr('data-bronze'));
                } else if (
                    $(this).attr('data-name') == 'Lifetime Brass' ||
                    $(this).attr('data-name') == 'Brass'
                ) {
                    imageTarget.attr('src', imageTarget.attr('data-brass'));
                }
                var colorName = $(this).attr('data-name');
                slideParent.find('.abnbProdSlide__colorLabel').text(colorName);
                var skuNumber = $(this).attr('data-sku');
                slideParent.find('.abnbProdSlide__sku').text(skuNumber);
    
                if ($(this).attr('data-available') == 'false') {
                    slideParent.find('.abnbProdSlide__buy').prop('disabled', true);
                    slideParent
                        .find('.abnbProdSlide__buy')
                        .addClass('abnbProdSlide__buy--disabled');
                    slideParent.find('.abnbProdSlide__buyInner').text('Sold Out');
                } else {
                    slideParent.find('.abnbProdSlide__buy').prop('disabled', false);
                    slideParent
                        .find('.abnbProdSlide__buy')
                        .removeClass('abnbProdSlide__buy--disabled');
                    slideParent.find('.abnbProdSlide__buyInner').text('Buy Now');
                }
            });
    
            $('.abnbProdSlide__qtyLess').on('click', function () {
                var slideParent = $(this).closest('.abnbProdSlide');
                var qtyNode = slideParent.find('.abnbProdSlide__input');
                var qty = qtyNode.val() * 1;
                if (qty > 1) {
                    qtyNode.val(qty - 1);
                }
            });
    
            $('.abnbProdSlide__qtyMore').on('click', function () {
                var slideParent = $(this).closest('.abnbProdSlide');
                var qtyNode = slideParent.find('.abnbProdSlide__input');
                var qty = qtyNode.val() * 1;
                qtyNode.val(qty + 1);
            });
    
            function updateCart(openCart) {
                app._getCartData();
                app._vibrateDevice();
                app.$snotify.clear();
                showHideMiniCartKeyedAlike();
                setTimeout(function () {
                    if (
                        ((app.isLoading = false),
                        (app.loadingEvent = null),
                        app.storeUtilities.cartUpsells.settings.showOnPopUp)
                    ) {
                        var origin = app.cart.items.find(function (data) {
                            return data.variant_id === keys;
                        });
                        app._openModalCartUpsell(origin);
                    } else {
                        if (openCart == true) {
                            app._openCartDrawer();
                        } else {
                            app._touchCartDrawer();
                        }
                    }
                }, 300);
            }
    
            function addToCart(variant, qty, keyed) {
                if (checkDiscountLimitFull(variant)) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
                if (typeof keyed !== 'undefined' && keyed) {
                    CartJS.addItem(
                        variant,
                        qty,
                        { _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
                        {
                            success: function (data, textStatus, jqXHR) {
                                setTimeout(function () {
                                    updateCart(true);
                                }, 200);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                } else {
                    CartJS.addItem(
                        variant,
                        qty,
                        {"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
                        {
                            success: function (data, textStatus, jqXHR) {
                                updateCart(true);
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            },
                        }
                    );
                }
            }
    
            function showHideMiniCartKeyedAlike() {
                var count = 0;
                var alreadyGroups = false;
                for (i = 0; i < CartJS.cart.items.length; i++) {
                    if (
                        CartJS.cart.items[i].properties['_keyed_alike_available'] ==
                        'true'
                    ) {
                        var qty = CartJS.cart.items[i].quantity;
                        count += 1 * qty;
                    }
                    if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
                        alreadyGroups = true;
                    }
                }
                console.log(count);
                if (count > 1 && alreadyGroups == false) {
                    $('.miniCartKA').show();
                } else {
                    $('.miniCartKA').hide();
                }
            }
    
            $('.abnbProdSlide__buy').on('click', function () {
                var slideParent = $(this).closest('.abnbProdSlide');
                var qtyNode = slideParent.find('.abnbProdSlide__input');
                var activeColor = slideParent.find('.abnbProdSlide__color--active');
    
                var qty = qtyNode.val() * 1;
                var variantId = activeColor.attr('data-id') * 1;
                var keyed = activeColor.attr('data-keyed') == 'true';
    
                addToCart(variantId, qty, keyed);
            });
    
            var firstAbnbSbs = $('.abnbSBS').first();
            $(
                '<div class="abnbSBSMob"><div class="abnbSBSMob__inner"><div class="abnbSBSMob__sliderControls"></div><div class="abnbSBSMob__sliderWrapper"><div class="abnbSBSMob__slider swiper-wrapper"></div></div><div class="abnbSBSMob__dotsWrapper"></div></div></div>'
            ).insertBefore(firstAbnbSbs);
            $('.abnbSBSMob__sliderControls').html(
                '<button class="abnbSBSMob__prevArrow"><img class="abnbSBSMob__prevArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Rectangle_155.png?v=1721942984" alt="previous arrow icon"></button><button class="abnbSBSMob__nextArrow"><img class="abnbSBSMob__nextArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Rectangle_155.png?v=1721942984" alt="next arrow icon"></button>'
            );
    
            const html = (strings, ...values) =>
                String.raw({ raw: strings }, ...values);
            var mobAbnbSlideTemplate = html`<div
                class="abnbSBSMobSlide swiper-slide"
            >
                <div class="abnbSBSMobSlide__inner">
                    <div class="abnbSBSMobSlide__upper">
                        <div class="abnbSBSMobSlide__title"></div>
                        <div class="abnbSBSMobSlide__text"></div>
                    </div>
                    <div class="abnbSBSMobSlide__lower">
                        <div class="abnbSBSMobSlide__imageWrapper">
                            <img class="abnbSBSMobSlide__image" src="" alt="" />
                        </div>
                    </div>
                </div>
            </div>`;
    
            $('.abnbSBSMob').append(mobAbnbSlideTemplate);
            var template = $('.abnbSBSMobSlide').clone(false);
            $('.abnbSBSMobSlide').remove();
    
            $('.abnbSBS').each(function () {
                var thisElement = template.clone(false);
                var slideTitle = $(this).find('.abnbSBS__title').text();
                thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
                var slideText = $(this).find('.abnbSBS__text').text();
                thisElement.find('.abnbSBSMobSlide__text').text(slideText);
                var slideSrc = $(this).find('.abnbSBS__image').attr('src');
                var slideAlt = $(this).find('.abnbSBS__image').attr('alt');
                thisElement.find('.abnbSBSMobSlide__image').attr('src', slideSrc);
                thisElement.find('.abnbSBSMobSlide__image').attr('alt', slideAlt);
    
                $('.abnbSBSMob__slider').append(thisElement);
            });
    
            var abnbSbsSlider = new Swiper('.abnbSBSMob__sliderWrapper', {
                slidesPerView: 1,
                loop: false,
                navigation: {
                    nextEl: '.abnbSBSMob__nextArrow',
                    prevEl: '.abnbSBSMob__prevArrow',
                },
                freeMode: {
                    enabled: true,
                    sticky: true,
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                },
                pagination: {
                    el: '.abnbSBSMob__dotsWrapper',
                    type: 'bullets',
                },
            });
    
            if ($('.approachPDP--code').length > 0) {
                var firstAbnbSbs = $('.approachSBS').first();
                $(
                    '<div class="abnbSBSMob abnbSBSMob--code"><div class="abnbSBSMob__inner"><div class="abnbSBSMob__sliderControls"></div><div class="abnbSBSMob__sliderWrapper"><div class="abnbSBSMob__slider swiper-wrapper"></div></div><div class="abnbSBSMob__dotsWrapper"></div></div></div>'
                ).insertBefore(firstAbnbSbs);
                $('.abnbSBSMob__sliderControls').html(
                    '<button class="abnbSBSMob__prevArrow"><img class="abnbSBSMob__prevArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Frame_3113_1.png?v=1725648245" alt="previous arrow icon"></button><button class="abnbSBSMob__nextArrow"><img class="abnbSBSMob__nextArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Frame_3112_3.png?v=1725648245" alt="next arrow icon"></button>'
                );
    
                const html = (strings, ...values) =>
                    String.raw({ raw: strings }, ...values);
                var mobAbnbSlideTemplate = html`<div
                    class="abnbSBSMobSlide swiper-slide"
                >
                    <div class="abnbSBSMobSlide__inner">
                        <div class="abnbSBSMobSlide__upper">
                            <div class="abnbSBSMobSlide__title"></div>
                            <div class="abnbSBSMobSlide__text"></div>
                        </div>
                        <div class="abnbSBSMobSlide__lower">
                            <div class="abnbSBSMobSlide__imageWrapper">
                                <img class="abnbSBSMobSlide__image" src="" alt="" />
                            </div>
                        </div>
                    </div>
                </div>`;
    
                $('.abnbSBSMob').append(mobAbnbSlideTemplate);
                var template = $('.abnbSBSMobSlide').clone(false);
                $('.abnbSBSMobSlide').remove();
    
                $('.approachSBS').each(function () {
                    var thisElement = template.clone(false);
                    var slideTitle = $(this).find('.approachSBS__title').text();
                    thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
                    var slideText = $(this).find('.approachSBS__text').text();
                    thisElement.find('.abnbSBSMobSlide__text').text(slideText);
                    var slideSrc = $(this).find('.approachSBS__image').attr('src');
                    var slideAlt = $(this).find('.approachSBS__image').attr('alt');
                    thisElement
                        .find('.abnbSBSMobSlide__image')
                        .attr('src', slideSrc);
                    thisElement
                        .find('.abnbSBSMobSlide__image')
                        .attr('alt', slideAlt);
    
                    $('.abnbSBSMob__slider').append(thisElement);
                });
    
                $('.newKeypadColor').each(function () {
                    var thisElement = template.clone(false);
                    var slideTitle = $(this).find('.newKeypadColor__title').text();
                    thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
                    var slideText = $(this).find('.newKeypadColor__text').text();
                    thisElement.find('.abnbSBSMobSlide__text').text(slideText);
                    var slideSrc = $(this)
                        .find('.newKeypadColor__image')
                        .attr('src');
                    var slideAlt = $(this)
                        .find('.newKeypadColor__image')
                        .attr('alt');
                    thisElement
                        .find('.abnbSBSMobSlide__image')
                        .attr('src', slideSrc);
                    thisElement
                        .find('.abnbSBSMobSlide__image')
                        .attr('alt', slideAlt);
    
                    $('.abnbSBSMob__slider').append(thisElement);
                });
    
                var codeSlider = new Swiper('.abnbSBSMob__sliderWrapper', {
                    slidesPerView: 1,
                    loop: false,
                    navigation: {
                        nextEl: '.abnbSBSMob__nextArrow',
                        prevEl: '.abnbSBSMob__prevArrow',
                    },
                    freeMode: {
                        enabled: true,
                        sticky: true,
                    },
                    mousewheel: {
                        enabled: true,
                        forceToAxis: true,
                    },
                    pagination: {
                        el: '.abnbSBSMob__dotsWrapper',
                        type: 'bullets',
                    },
                });
            }
    
            $('.pdpKA__text').html(
                'The ideal solution to access your new locks with fewer keys. Just $3.99 per lock. Keyed Alike processing time is 5 business days.'
            );
    
            $('.abnbProdSlide__color--active').click();
    
            var headerSwiper = new Swiper('.headerSlider__container', {
                loop: true,
                slidesPerView: 1,
                navigation: {
                    prevEl: '.headerSlider__prev',
                    nextEl: '.headerSlider__next',
                },
                autoplay: {
                    delay: 5000,
                },
            });
    
            if ($('.hdBars').length > 0) {
                $('#shopify-section-header').hide();
            }
    
            $('[ga-handle]').each(function () {
                var handle = $(this).attr('ga-handle');
                console.log(handle);
                gaView(handle);
            });
    
            function gaView(productHandle) {
                fetch(
                    window.Shopify.routes.root + 'products/' + productHandle + '.js'
                )
                    .then((response) => response.json())
                    .then(
                        (product) =>
                            function () {
                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push({
                                    event: 'view_item',
                                    fired_from: 'shopify',
                                    ecommerce: {
                                        currency: 'USD',
                                        value: product.price,
                                        items: [
                                            {
                                                item_id: product.id,
                                                item_name: product.title,
                                                item_brand: product.vendor,
                                                item_category: product.type,
                                                item_variant:
                                                    product.variants[0].title,
                                                item_variant_id:
                                                    product.variants[0].sku,
                                                price: product.price,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                });
                            }
                    );
            }
    
            function gaAddToCart(productHandle) {
                fetch(
                    window.Shopify.routes.root + 'products/' + productHandle + '.js'
                )
                    .then((response) => response.json())
                    .then(
                        (product) =>
                            function () {
                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push({
                                    event: 'add_to_cart',
                                    fired_from: 'shopify',
                                    ecommerce: {
                                        currency: 'USD',
                                        value: product.price,
                                        items: [
                                            {
                                                item_id: product.id,
                                                item_name: product.title,
                                                item_brand: product.vendor,
                                                item_category: product.type,
                                                item_variant:
                                                    product.variants[0].title,
                                                item_variant_id:
                                                    product.variants[0].sku,
                                                price: product.price,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                });
                            }
                    );
            }
    
            function gaRemoveFromCart(productHandle) {
                fetch(
                    window.Shopify.routes.root + 'products/' + productHandle + '.js'
                )
                    .then((response) => response.json())
                    .then(
                        (product) =>
                            function () {
                                window.dataLayer.push({ ecommerce: null });
                                window.dataLayer.push({
                                    event: 'remove_from_cart',
                                    fired_from: 'shopify',
                                    ecommerce: {
                                        currency: 'USD',
                                        value: product.price,
                                        items: [
                                            {
                                                item_id: product.id,
                                                item_name: product.title,
                                                item_brand: product.vendor,
                                                item_category: product.type,
                                                item_variant:
                                                    product.variants[0].title,
                                                item_variant_id:
                                                    product.variants[0].sku,
                                                price: product.price,
                                                quantity: 1,
                                            },
                                        ],
                                    },
                                });
                            }
                    );
            }
    
            if ($('body.template-product').length > 0) {
                var thisHandle = $('[data-discount-handle]').attr('data-discount-handle');
                
                for (i = 0; i < discountProds.length; i++) {
                    if (discountProds[i].handle == thisHandle) {
                        $('.discounted-prices').removeClass('hide');
                        $('.non-discounted-prices').addClass('hide');
                        $('.discounted-prices').find('.actual-price').text(discountProds[i]['canadian_discount_price']);
                        var originalPrice = $('.discounted-prices').find('.pdp__comparePrice').text().substring(1) * 1;
                        var discountedPrice = $('.discounted-prices').find('.actual-price').text().substring(1) * 1;
                        var discountString = (100 - (discountedPrice / originalPrice) * 100).toFixed(0) + '% OFF';
                        $('.discounted-prices').find('.pdp__discountBubble').text(discountString);
                    }
                }
            }
    
            var endDateString = $('.headerCountDown__countWrapper').attr(
                'data-date'
            );
            const targetTime = new Date(endDateString);
    
            setInterval(function () {
                const currentTime = new Date();
                const difference = targetTime - currentTime;
    
                const days = Math.floor(difference / (1000 * 60 * 60 * 24))
                    .toString()
                    .padStart(2, '0');
                const hours = Math.floor(
                    (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                )
                    .toString()
                    .padStart(2, '0');
                const minutes = Math.floor(
                    (difference % (1000 * 60 * 60)) / (1000 * 60)
                )
                    .toString()
                    .padStart(2, '0');
                const seconds = Math.floor((difference % (1000 * 60)) / 1000)
                    .toString()
                    .padStart(2, '0');
    
                $('.headerCountDown__number--days').text(days);
                $('.headerCountDown__number--hours').text(hours);
                $('.headerCountDown__number--minutes').text(minutes);
                $('.headerCountDown__number--seconds').text(seconds);
            }, 100);
        });
    
        $(document).ready(function () {
            $('.sentryVideo__playButton').on('click', function () {
                var iframeCode = $(this).attr('iframe-code');
                var targetModal = $(this)
                    .closest('.shopify-section')
                    .find('.sentryModal');
                targetModal.find('.sentryModal__iframeWrapper').html(iframeCode);
                targetModal.fadeIn();
            });
            $('.sentryModal__overlay, .sentryModal__close').on(
                'click',
                function () {
                    var targetModal = $(this)
                        .closest('.shopify-section')
                        .find('.sentryModal');
                    targetModal.find('.sentryModal__iframeWrapper').html('');
                    targetModal.fadeOut();
                }
            );
    
            function preloadImage(url) {
                var img = new Image();
                img.src = url;
            }
    
            $('.al2App--freeConnect .al2App__button').each(function () {
                preloadImage($(this).attr('data-image'));
            });
    
            $('.al2App--freeConnect .al2App__button').on('click', function () {
                $(this)
                    .parent()
                    .find('.al2App__button')
                    .removeClass('al2App__button--active');
                $(this).addClass('al2App__button--active');
    
                var imgSrc = $(this).attr('data-image');
                $('.al2App--freeConnect .al2App__image').attr('src', imgSrc);
            });
    
            if ($('.al2Faq').length > 0) {
                $('.al2Faq__titleWrapper').on('click', function () {
                    if ($(this).hasClass('al2Faq__titleWrapper--active')) {
                        $(this).removeClass('al2Faq__titleWrapper--active');
                        $(this).parent().find('.al2Faq__shelf').slideUp();
                    } else {
                        $(this).addClass('al2Faq__titleWrapper--active');
                        $(this).parent().find('.al2Faq__shelf').slideDown();
                    }
                });
            }
    
            $('.nav-item .linklist a').on('mouseenter', function () {
                let dataID = $(this).attr('data-id');
    
                console.log(dataID);
    
                $('.nav-item .linklist a').removeClass('active');
    
                $(this).addClass('active');
                $('.nav-item .card-wrap').addClass('hidden');
                $('.nav-item .card-wrap[data-id="' + dataID + '"]').removeClass(
                    'hidden'
                );
            });
    
            $('.mobileNav__parent--accordion').on('click', function(){
                var target = $(this).parent().find('.mobileNav__parentDrop');
                $(this).toggleClass('mobileNav__parent--accordionOpen');
                target.slideToggle();
            });
    
            $('.mobileNav__child--accordion').on('click', function(){
                var target = $(this).parent().find('.mobileNav__childDrop');
                $(this).toggleClass('mobileNav__child--accordionOpen');
                target.slideToggle();
            });
    
            var $alerts = $('#shopify-section-header-alerts');
            var threshold = 40;
    
            $(window).on('scroll', function () {
                if ($(this).scrollTop() > threshold) {
                    $('body').addClass('body-scrolled');
                    if ($alerts.is(':visible')) {
                        $alerts.slideUp(200);
                    }
                } else {
                    $('body').removeClass('body-scrolled');
                    if (!$alerts.is(':visible')) {
                        $alerts.slideDown(200);
                    }
                }
            });
    
            $('.mobileNav__parent--page').on('click', function(){
                var targetString = $(this).attr('data-mobile-nav-target');
                var targetPage = $('[data-mobile-nav-page="'+targetString+'"]');
                targetPage.show();
                targetPage.addClass("mobileNav__childPage--open");
            });
    
            $('.mobileNav__childPageBack').on('click', function(){
                var target = $('.mobileNav__childPage--open');
                target.removeClass("mobileNav__childPage--open");
                setTimeout(function(){
                    target.hide();
                }, 400);
            });
    
            $(document).on('keydown', '.mobileNav__searchInput', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
    
                const query = $(this).val().trim();
    
                if (query.length) {
                window.location.href = '/search?q=' + encodeURIComponent(query);
                }
            }
            });
    
            // Toggle dropdown
            $(document).on('click', '.locSwitcher__button', function () {
            $('.locSwitcher__dropDown').toggle();
            });
    
            // Handle country switch
            $(document).on('click', '.locSwitcher__swapButton', function () {
                var countryCode = $(this).data('country');
                var fr = $(this).hasClass('locSwitcher__swapButton--fr');
        
                if (!countryCode) return;
        
                var $form = $('#CountryLocalizationForm');
        
                // Set country
                $form.find('[name="country_code"]').val(countryCode);
        
                // Optional: update icon immediately (UX polish)
                if (countryCode === 'CA') {
                    $('.locSwitcher__icon--usa').hide();
                    if (fr){
                        $('.locSwitcher__icon--ca').hide();
                        $('.locSwitcher__icon--cafr').show();
                    }
                    else{
                        $('.locSwitcher__icon--cafr').hide();
                        $('.locSwitcher__icon--ca').show();
                    }
                } else {
                    $('.locSwitcher__icon--usa').show();
                    $('.locSwitcher__icon--ca').hide();
                    $('.locSwitcher__icon--cafr').hide();
                }

                $form.trigger('submit');

                setTimeout(function () {
                    const path = window.location.pathname.replace(/^\/(en-ca|fr-ca)(?=\/|$)/i, '');

                    const region = countryCode === 'CA'
                        ? (fr ? '/fr-ca' : '/en-ca')
                        : '';

                    window.location.href = window.location.origin + region + (path || '/') + window.location.search + window.location.hash;
                }, 500);
            });
    
            function urlCheck(thisUrl){
                var response = '';
                if (thisUrl){
                    if (thisUrl.startsWith('/')){
                        response = "internal";
                    }
                    else{
                        if (thisUrl.includes('shopyalehome')){
                            response = "internal";
                        }
                        else{
                            response = "external";
                        }
                    }
                }
                else{
                    response = "empty";
                }
                return response;
            }
    
            function localizeHref(href, localePrefix){
                if (!href) return href;
                if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return href;
    
                var originalHref = href;
                var origin = '';
    
                if (href.startsWith('https://www.shopyalehome.com')) {
                    origin = 'https://www.shopyalehome.com';
                    href = href.replace(origin, '');
                }
                else if (href.startsWith('https://shopyalehome.com')) {
                    origin = 'https://shopyalehome.com';
                    href = href.replace(origin, '');
                }
                else if (href.startsWith('www.shopyalehome.com')) {
                    origin = 'https://www.shopyalehome.com';
                    href = href.replace('www.shopyalehome.com', '');
                }
    
                if (!href.startsWith('/')) return originalHref;
    
                href = href.replace(/^\/(en-ca|fr-ca|fr|en-fr)(\/|$)/, '/');
    
                if (href === '/' || href === '') {
                    return origin + localePrefix + '/';
                }
    
                var localizablePaths = [
                    '/pages/',
                    '/collections/',
                    '/products/',
                    '/blogs/',
                    '/articles/'
                ];
    
                var shouldLocalize = localizablePaths.some(function(path){
                    return href.indexOf(path) === 0;
                });
    
                if (!shouldLocalize) return originalHref;
    
                return origin + localePrefix + href;
            }
    
            function localizeLinks(){
    
                var currentPath = window.location.pathname;
                if ($('.locSwitcher').attr('data-current-loc') == "CA"){
                    $('.locSwitcher__icon--usa').hide();
                    if (currentPath.includes('/fr-ca')) {
                        $('.locSwitcher__icon--ca').hide();
                        $('.locSwitcher__icon--cafr').show();
                    }
                    else{
                        $('.locSwitcher__icon--cafr').hide();
                        $('.locSwitcher__icon--ca').show();
                    }
                    $('.index-featured-collection').hide();
                    $('.pdpKA__inner').parent().remove();
                    $('.miniCartKA').remove();
                    $('.main-nav .nav-item [href="/en-ca/collections/bundle"]').closest('.nav-item').remove();
                    $('.main-nav .sub-menu [href="/en-ca/pages/smart-storage"]').remove();
                    $('.main-nav .nav-item [href="/fr-ca/collections/bundle"]').closest('.nav-item').remove();
                    $('.main-nav .sub-menu [href="/fr-ca/pages/smart-storage"]').remove();
                    $('.main-nav .sub-menu [data-id="door-hardware"]').remove();
                    $('.main-nav .sub-menu [data-id="accessories"] [href="/collections/door-lock-hardware"]').remove();
                    $('.main-nav .sub-menu [data-id="accessories"] [href="/collections/accessories"]').remove();
                    $('.main-nav .sub-menu [data-id="quincaillerie-de-porte"]').remove();
                    $('.main-nav .sub-menu [data-id="accessoires"] [href="/collections/door-lock-hardware"]').remove();
                    $('.main-nav .sub-menu [data-id="accessoires"] [href="/collections/accessories"]').remove();
                    $('a[href="/collections"]').hide();
                    $('[data-id="shop-by-space"]').attr('data-id', 'magasiner-par-espace');
                    $('[data-id="serrures-intelligentes-supplementaires"]').attr('data-id', 'plus-de-serrures-intelligentes');

                    $('.mobileNav__parent[href="/en-ca/collections/bundle"]').parent().remove();
                    $('.mobileNav__child[href="/en-ca/pages/smart-storage"]').parent().remove();
                    $('.mobileNav__child[href="/en-ca/collections/door-lock-hardware"]').parent().remove();
                    
                    $('.hide-on-canada').hide();
                    $('body').addClass('canadaSite');
                }
    
                var localePrefix = '';
    
                if (currentPath.includes('/fr-ca')) {
                    localePrefix = '/fr-ca';
                }
                else if (currentPath.includes('/en-ca')) {
                    localePrefix = '/en-ca';
                }
                else if (currentPath.includes('/fr')) {
                    localePrefix = '/fr';
                }
    
                if (!localePrefix) return;
    
                $('a').each(function(){
                    var href = $(this).attr('href');
                    var localizedHref = localizeHref(href, localePrefix);
    
                    if (localizedHref !== href) {
                        $(this).attr('href', localizedHref);
                    }
                });
            }
    
            localizeLinks();
    
            if ($('#shopify-section-template-collection').length > 0){
                var collectionInterval = setInterval(function(){
                    if ($('.card-product').length > 1){
                        localizeLinks();
                        clearInverval(collectionInterval);
                    }
                }, 100);
            }
    
        });
    
    
        //pdp overhaul
        $(document).ready(function () {
            var selectors = {
                variantSelect: '.pdpMain__variantSelector--primary',
                optionButton: '.pdpMain__optionButton',
                finishButton: '.pdpMain__optionButton--finish',
                addToCart: '[data-add-to-cart]',
                qty: '.pdpMain__qty',
                mainQty: '.pdpMain__qty:not(.pdpMain__qty--sticky)',
                keyedCheckbox: '.pdpMain__pdpKACheckbox'
            };
    
            var classes = {
                active: 'pdpMain__optionButton--active',
                oos: 'pdpMain__optionButton--oos',
                atcOos: 'pdpMain__atc--oos',
                stickyOos: 'pdpMain__stickyBuy--oos'
            };
    

            var pdpActiveRoot = $();

            function getPdpRoot($fromEl) {
                if ($fromEl && $fromEl.length) {
                    var $found = $fromEl.closest('.pdpMain');
                    if ($found.length) return $found;
                }
                if (pdpActiveRoot.length) return pdpActiveRoot;
                return $('.pdpMain').first();
            }

            function isPlpShopRoot($root) {
                $root = $root || getPdpRoot();
                return $root.hasClass('pdpMain--plp');
            }

            function $pdp(selector) {
                return getPdpRoot().find(selector);
            }

            function resolvePdpRootFromEl($el) {
                var $root = ($el && $el.length) ? $el.closest('.pdpMain') : $();
                if ($root.length) return $root;
                $root = $('.pdpMain:not(.pdpMain--plp)').first();
                if ($root.length) return $root;
                return $('.pdpMain').first();
            }

            function getFixedModel($root) {
                $root = $root || getPdpRoot();
                var fixedModel = $root.attr('data-fixed-model');
                return fixedModel || null;
            }

            function getFixedCustomOption(optionIndex) {
                if (optionIndex === 'model') {
                    return getFixedModel();
                }

                return getPdpRoot().attr('data-fixed-' + optionIndex) || null;
            }

            function getFixedShopifyOptionValue(optionIndex) {
                return getPdpRoot().attr('data-fixed-option-' + optionIndex) || null;
            }

            function getSelectedModel() {
                var fixedModel = getFixedModel();
                if (fixedModel) return fixedModel;

                return $pdp('.pdpMain__optionButton--active[data-option-index="model"]')
                    .attr('data-option-value') || null;
            }

            var customOptionMap = {
                model: 'data-model',
                technology: 'data-technology',
                'key-option': 'data-key-option',
                function: 'data-function'
            };
    
            function initPdpTooltipIcons($root) {
                if (typeof tooltipJSON === 'undefined' || !Array.isArray(tooltipJSON)) return;

                for (var i = 0; i < tooltipJSON.length; i++) {
                    var tooltip = tooltipJSON[i];
                    var optionType = tooltip.option_type;
                    var optionIcon = tooltip.option_icon;

                    if (!optionType) continue;

                    var $buttonInner = $root.find('.pdpMain__optionButton[data-option-value="' + optionType + '"]')
                        .find('.pdpMain__optionButtonInner');

                    if (!$buttonInner.length) continue;

                    if (optionIcon && optionIcon !== 'undefined') {
                        $buttonInner.each(function () {
                            var existing = $(this).html();

                            if ($(this).find('.pdpMain__optionButtonIcon').length) return;

                            $(this).html(
                                '<img class="pdpMain__optionButtonIcon" src="' + optionIcon + '" alt="' + optionType + '">' +
                                existing
                            );
                        });
                    }
                }
            }
    
            function preloadImage(url) {
                if (!url) return;
    
                var img = new Image();
                img.src = url;
            }
    
            function getUnformattedPrice(price) {
                if (!price) return 0;
    
                return Math.round(
                    parseFloat(
                        price.toString().replace('$', '').replace(',', '')
                    ) * 100
                );
            }
    
            function getFormattedPrice(price) {
                var cents = price;
    
                if (typeof cents === 'string' && cents.indexOf('$') > -1) {
                    cents = getUnformattedPrice(cents);
                }
    
                cents = parseFloat(cents);
    
                if (isNaN(cents)) cents = 0;
    
                return '$' + (cents / 100).toFixed(2);
            }
    
            function initGallery($root) {
                $root = $root || getPdpRoot();
                if ($root.data('galleryInitialized')) return;

                var $thumbTarget = $root.find('.pdpMain__thumbnailGalleryWrapper');
                var $galleryTarget = $root.find('.pdpMain__imageGalleryWrapper');

                if (!$thumbTarget.length || !$galleryTarget.length) return;

                var thumnSwiper = new Swiper($thumbTarget[0], {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    loop: false,
                    breakpoints: {
                        1000: {
                            slidesPerView: 6
                        }
                    }
                });

                var gallerySwiper = new Swiper($galleryTarget[0], {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                    navigation: {
                        nextEl: $root.find('.pdpMain__imageGalleryNext')[0],
                        prevEl: $root.find('.pdpMain__imageGalleryPrevious')[0]
                    },
                    thumbs: {
                        swiper: thumnSwiper
                    }
                });

                $root.data('gallerySwiper', gallerySwiper);
                $root.data('thumbSwiper', thumnSwiper);
                $root.data('galleryInitialized', true);
            }
    
            function getColorImageByName(color) {
                if (typeof colorLib === 'undefined') return null;
    
                return colorLib[color];
            }
    
            function initFinishButtons($root) {
                $root = $root || getPdpRoot();
                $root.find(selectors.finishButton).each(function () {
                    var $button = $(this);
                    var colorName = $button.attr('data-finish-name');
                    var colorCode;
                    var imageSrc;
    
                    if (!colorName) return;
    
                    colorCode = colorName.toLowerCase().replace(/\s/g, '');
                    imageSrc = getColorImageByName(colorCode);
    
                    if (!imageSrc) return;
    
                    if (imageSrc.indexOf('#') > -1) {
                        $button
                            .find('.pdpMain__optionFinishButtonColorRing')
                            .css('background', imageSrc);
                    } else {
                        $button
                            .find('.pdpMain__optionFinishButtonColorRing')
                            .css('background', 'url(' + imageSrc + ')');
                    }
                });
            }
    
            function getSelectedCustomOptions() {
                var selected = {};

                $.each(customOptionMap, function (optionIndex) {
                    var fixedValue = getFixedCustomOption(optionIndex);
                    if (fixedValue) {
                        selected[optionIndex] = fixedValue;
                    }
                });

                $pdp('.pdpMain__optionButton--active[data-option-index]').each(function () {
                    var optionIndex = $(this).attr('data-option-index');

                    if (!customOptionMap[optionIndex] || selected[optionIndex]) return;

                    selected[optionIndex] = $(this).attr('data-option-value');
                });

                return selected;
            }

            function getSelectedOptionValues() {
                var options = [];
                var i;
                var fixedOption;

                $pdp('.pdpMain__optionButton--active[data-option-index]').each(function () {
                    var optionIndex = $(this).attr('data-option-index');

                    if (customOptionMap[optionIndex]) return;

                    optionIndex = parseInt(optionIndex, 10);

                    if (!isNaN(optionIndex)) {
                        options[optionIndex] = $(this).attr('data-option-value');
                    }
                });

                for (i = 0; i < 3; i++) {
                    fixedOption = getFixedShopifyOptionValue(i);
                    if (fixedOption) {
                        options[i] = fixedOption;
                    }
                }

                return options;
            }
    
            function variantMatchesSelections($variant, ignoredCustomOption) {
                var customOptions = getSelectedCustomOptions();
                var shopifyOptions = getSelectedOptionValues();
                var matches = true;
    
                $.each(customOptions, function (optionIndex, selectedValue) {
                    if (ignoredCustomOption && optionIndex === ignoredCustomOption) return;
    
                    if (
                        selectedValue &&
                        $variant.attr(customOptionMap[optionIndex]) !== selectedValue
                    ) {
                        matches = false;
                        return false;
                    }
                });
    
                if (!matches) return false;
    
                for (var i = 0; i < shopifyOptions.length; i++) {
                    if (!shopifyOptions[i]) continue;
    
                    var selectedValue = shopifyOptions[i];
    
                    if (
                        $variant.attr('data-option-' + (i + 1)) !== selectedValue &&
                        $variant.attr('data-option-1') !== selectedValue &&
                        $variant.attr('data-option-2') !== selectedValue &&
                        $variant.attr('data-option-3') !== selectedValue
                    ) {
                        return false;
                    }
                }
    
                return true;
            }
    
            function pdpDebugVariant($variant) {
                if (!$variant || !$variant.length) return null;
    
                return {
                    id: $variant.val(),
                    available: $variant.attr('data-available'),
                    title: $variant.attr('data-title'),
                    model: $variant.attr('data-model'),
                    technology: $variant.attr('data-technology'),
                    keyOption: $variant.attr('data-key-option'),
                    functionality: $variant.attr('data-function'),
                    option1: $variant.attr('data-option-1'),
                    option2: $variant.attr('data-option-2'),
                    option3: $variant.attr('data-option-3')
                };
            }
    
            function variantMatchesCustomSelections($variant) {
                var customOptions = getSelectedCustomOptions();
                var matches = true;
    
                $.each(customOptions, function (optionIndex, selectedValue) {
                    if (
                        selectedValue &&
                        $variant.attr(customOptionMap[optionIndex]) !== selectedValue
                    ) {
                        matches = false;
                        return false;
                    }
                });
    
                return matches;
            }
    
            function getActiveVariantSelector() {
                var $match = $();
                var $root = getPdpRoot();

                if (!$root.hasClass('pdpMain--multi')) {
                    return $root.find('.pdpMain__variantSelector--primary');
                }

                $root.find('.pdpMain__variantSelector').each(function () {
                    var $selector = $(this);
    
                    $selector.find('option').each(function () {
                        if (variantMatchesCustomSelections($(this))) {
                            $match = $selector;
                            return false;
                        }
                    });
    
                    if ($match.length) return false;
                });
    
                if ($match.length) {
                    $root.find('.pdpMain__variantSelector').removeClass('pdpMain__variantSelector--active');
                    $match.addClass('pdpMain__variantSelector--active');
                    return $match;
                }
    
                return $pdp('.pdpMain__variantSelector--active').first();
            }
    
            function findVariantByOptions() {
                var $selector = getActiveVariantSelector();
                var $match = $();
    
                console.log('[PDP] findVariantByOptions');
                console.log('Active selector:', {
                    title: $selector.attr('data-title'),
                    product: $selector.attr('data-product')
                });
                console.log('Selected custom:', getSelectedCustomOptions());
                console.log('Selected Shopify:', getSelectedOptionValues());
    
                $selector.find('option').each(function () {
                    var $variant = $(this);
                    var matches = variantMatchesSelections($variant);
    
                    console.log('Variant checked:', {
                        matches: matches,
                        variant: pdpDebugVariant($variant)
                    });
    
                    if (matches) {
                        $match = $variant;
                        console.log('[PDP] Matched variant:', pdpDebugVariant($match));
                        return false;
                    }
                });
    
                if (!$match.length) {
                    console.warn('[PDP] No variant matched selected options.');
                }
    
                return $match;
            }
    
            function getActiveVariant() {
                return getActiveVariantSelector().find('option:selected');
            }
    
            function syncActiveVariant() {
                var $selector = getActiveVariantSelector();
                var $selectedVariant;
    
                console.log('[PDP] syncActiveVariant start');
    
                if (!$selector.length) {
                    console.warn('[PDP] No selector found.');
                    return $();
                }

                // Ensure finish list matches the active product before resolving
                // the variant (hides Brass on Plus, etc.).
                updateFinishButtonsForActiveProduct();
    
                // Exact option match only (OOS variants included).
                // Never substitute a different/in-stock variant — that desyncs
                // the finish UI from ATC and can add the wrong product.
                $selectedVariant = findVariantByOptions();
    
                if (!$selectedVariant.length) {
                    console.warn('[PDP] No matching variant for selected options.');
                    console.log('Selected custom:', getSelectedCustomOptions());
                    console.log('Selected Shopify:', getSelectedOptionValues());
    
                    updatePdpState($());
                    return $();
                }
    
                $selectedVariant.prop('selected', true);
                $selector.val($selectedVariant.val()).trigger('change');
    
                console.log('[PDP] syncActiveVariant selected:', pdpDebugVariant($selectedVariant));
    
                updatePdpState($selectedVariant);
    
                return $selectedVariant;
            }
    
            function updateCustomOptionAvailability() {
                if (!getPdpRoot().hasClass('pdpMain--multi')) return;

                var selectedModel = getSelectedModel();

                $.each(customOptionMap, function (optionIndex, attrName) {
                    var validValues = [];

                    if (optionIndex === 'model') {
                        if (!getFixedModel()) {
                            $pdp('.pdpMain__optionButton[data-option-index="model"]').show();
                        }
                        return;
                    }

                    if (getFixedCustomOption(optionIndex)) return;
    
                    $pdp('.pdpMain__variantSelector option').each(function () {
                        var $variant = $(this);
    
                        if (selectedModel && $variant.attr('data-model') !== selectedModel) {
                            return;
                        }
    
                        var value = $variant.attr(attrName);
    
                        if (value && validValues.indexOf(value) === -1) {
                            validValues.push(value);
                        }
                    });
    
                    $pdp('.pdpMain__optionButton[data-option-index="' + optionIndex + '"]').each(function () {
                        var $button = $(this);
                        var value = $button.attr('data-option-value');
                        var existsForModel = validValues.indexOf(value) > -1;
    
                        $button.toggle(existsForModel);
    
                        if (!existsForModel) {
                            $button.removeClass(classes.active);
                        }
                    });
    
                    if (!$pdp('.pdpMain__optionButton--active[data-option-index="' + optionIndex + '"]').length) {
                        $pdp('.pdpMain__optionButton[data-option-index="' + optionIndex + '"]:visible')
                            .first()
                            .addClass(classes.active);
                    }
                });
            }
    
            function clearInvalidCustomSelections() {
                var customOptionsToCheck = [
                    'technology',
                    'key-option',
                    'function'
                ];
    
                $.each(customOptionsToCheck, function (i, optionIndex) {
                    var $activeButton = $pdp('.pdpMain__optionButton--active[data-option-index="' + optionIndex + '"]');
    
                    if (!$activeButton.length) return;
    
                    var selectedValue = $activeButton.attr('data-option-value');
                    var isStillValid = false;
    
                    $pdp('.pdpMain__variantSelector option').each(function () {
                        var $variant = $(this);
    
                        if (
                            $variant.attr(customOptionMap[optionIndex]) === selectedValue &&
                            variantMatchesSelections($variant, optionIndex)
                        ) {
                            isStillValid = true;
                            return false;
                        }
                    });
    
                    if (!isStillValid) {
                        $activeButton.removeClass(classes.active);
                    }
                });
            }
    
            function getTooltipFieldValue(field) {
                if (!field) return '';
    
                if (typeof field === 'object' && field.value) {
                    return field.value;
                }
    
                return field;
            }
    
            function getTooltipTextByOptionValue(optionValue) {
                if (
                    typeof tooltipJSON === 'undefined' ||
                    !Array.isArray(tooltipJSON) ||
                    !optionValue
                ) {
                    return '';
                }
    
                for (var i = 0; i < tooltipJSON.length; i++) {
                    var tooltip = tooltipJSON[i];
    
                    if (!tooltip) continue;
    
                    var optionType = getTooltipFieldValue(tooltip.option_type);
                    var tooltipText = getTooltipFieldValue(tooltip.tooltip_text);
    
                    if (optionType === optionValue) {
                        return tooltipText || '';
                    }
                }
    
                return '';
            }
    
            function tooltipHasRealContent(tooltipText) {
                if (!tooltipText || typeof tooltipText !== 'string') return false;
    
                return tooltipText.replace(/<[^>]*>/g, '').trim() !== '';
            }
    
            function updateOptionRowTooltip($button) {
                if (!$button || !$button.length) return;
    
                var optionValue = $button.attr('data-option-value');
                var tooltipText = getTooltipTextByOptionValue(optionValue);
    
                var $row = $button.closest('.pdpMain__optionRow');
                var $tooltipContainer = $row.find('.pdpMain__optionLabelToolTipContainer');
                var $tooltipInner = $row.find('.pdpMain__optionLabelToolTipPopupInner');
    
                if (!$tooltipContainer.length) return;
    
                if (!$tooltipInner.length) {
                    $tooltipInner = $('<div class="pdpMain__optionLabelToolTipPopupInner"></div>');
                }
    
                if (tooltipHasRealContent(tooltipText)) {
                    $tooltipInner.html(tooltipText);
    
                    if (!$row.find('.pdpMain__optionLabelToolTipPopup').length) {
                        $tooltipContainer.append(
                            '<div class="pdpMain__optionLabelToolTipPopup" style="display:none;"></div>'
                        );
                    }
    
                    $row.find('.pdpMain__optionLabelToolTipPopup').html($tooltipInner);
                    $tooltipContainer.show();
                } else {
                    $row.find('.pdpMain__optionLabelToolTipPopupInner').empty();
                    $tooltipContainer.hide();
                }
            }
    
            function updateAllOptionRowTooltips() {
                $pdp('.pdpMain__optionButton--active[data-option-index]').each(function () {
                    updateOptionRowTooltip($(this));
                });
            }
    
            function handleOptionClick($button) {
                pdpActiveRoot = $button.closest('.pdpMain');
                var optionIndex = $button.attr('data-option-index');
    
                console.log('[PDP] option clicked:', {
                    optionIndex: optionIndex,
                    value: $button.attr('data-option-value')
                });
    
                $pdp('.pdpMain__optionButton[data-option-index="' + optionIndex + '"]')
                    .removeClass(classes.active);
    
                $button.addClass(classes.active);
    
                updateSelectedOptionLabel($button);
    
                if ($button && $button.length) {
                    updateOptionRowTooltip($button);
                }
    
                if (getPdpRoot().hasClass('pdpMain--multi')) {
                    updateCustomOptionAvailability();
                }

                // Hide finishes that aren't on this product before syncing price/ATC
                updateFinishButtonsForActiveProduct();
    
                syncActiveVariant();
                updateComparisonCurrentState();
                updateOptionButtonOosStates();

                if (optionIndex === 'technology') {
                    updateCompareTech();
                }
            }
    
            function isDiscountActive($variant) {
                var hasDiscount = $variant.attr('data-discount') === 'true';
                var startDate = $variant.attr('data-discount-start-date');
                var endDate = $variant.attr('data-discount-end-date');
                var now = new Date();
    
                if (!hasDiscount) return false;
    
                if (startDate && now < new Date(startDate)) {
                    return false;
                }
    
                if (endDate && now > new Date(endDate)) {
                    return false;
                }
    
                return true;
            }
    
            function getAccordionStorageKey($root) {
                $root = $root || getPdpRoot();

                if (isPlpShopRoot($root)) {
                    return $root.closest('.plpShop');
                }

                return $(document.body);
            }

            function getAccordionState($root) {
                var $storage = getAccordionStorageKey($root);
                var state = $storage.data('accordionState');

                if (!state) {
                    state = {
                        lastProductId: null,
                        request: null
                    };
                    $storage.data('accordionState', state);
                }

                return state;
            }

            function getAccordionScope($root) {
                $root = $root || getPdpRoot();

                if (isPlpShopRoot($root)) {
                    return $root.closest('.plpShop').find('.pdpAcc');
                }

                return $('.pdpAcc');
            }

            function setAccordionLoading(isLoading, $root) {
                var $scope = getAccordionScope($root);

                $scope.toggleClass('pdpAcc--loading', isLoading);
                $scope.find('.pdpAccordion__featuresContent, .pdpAccordion__techspecsContent, .pdpAccordion__downloadsContent')
                    .toggleClass('pdpAccordion__content--loading', isLoading);
            }

            function maybeUpdateAccordion($variant) {
                var $root = getPdpRoot();
                var $scope = getAccordionScope($root);

                if (!$scope.length) return;

                if (isPlpShopRoot($root)) {
                    updatePlpShopAccordion();
                    return;
                }

                var state = getAccordionState($root);
                var $selector = getActiveVariantSelector();
                var productId = $selector.attr('data-product');

                if (productId !== state.lastProductId) {
                    state.lastProductId = productId;
                    updateAccordionFromProductPage($root);
                } else {
                    updateAccordionVariantSwaps($variant, $root);
                }
            }

            function updatePlpShopAccordion() {
                var $root = getPdpRoot();
                var $shop = $root.closest('.plpShop');
                var $scope = getAccordionScope($root);
                var productId = getActiveVariantSelector().attr('data-product');

                if (!productId || !$scope.length || !$shop.length) return;

                var features = $shop
                    .find('.plpShop__accordionTemplates [data-product-id="' + productId + '"][data-accordion-part="features"]')
                    .html();
                var techSpecs = $shop
                    .find('.plpShop__accordionTemplates [data-product-id="' + productId + '"][data-accordion-part="tech-specs"]')
                    .html();

                if (typeof features !== 'undefined') {
                    $scope.find('.pdpAccordion--features .pdpAccordion__featuresContent').html(features || '');
                }

                if (typeof techSpecs !== 'undefined') {
                    $scope.find('.pdpAccordion--techspecs .pdpAccordion__techspecsContent').html(techSpecs || '');
                }
            }

            function initPlpShopAccordionState($root) {
                var $scope = getAccordionScope($root);
                var isDesktop = window.matchMedia('(min-width: 1001px)').matches;

                $scope.find('.pdpAccordion').removeClass('pdpAccordion--active');
                $scope.find('.pdpAccordion__shelf').hide();

                if (isDesktop) {
                    var $features = $scope.find('.pdpAccordion--features');
                    $features.addClass('pdpAccordion--active');
                    $features.find('.pdpAccordion__shelf').show();
                }
            }

            function updateAccordionFromProductPage($root) {
                $root = $root || getPdpRoot();
                var state = getAccordionState($root);
                var $scope = getAccordionScope($root);
                var $selector = getActiveVariantSelector();
                var productUrl = $selector.attr('data-url');

                if (!productUrl || !$scope.length) return;

                if (state.request) {
                    state.request.abort();
                }

                setAccordionLoading(true, $root);

                state.request = $.get(productUrl, function (html) {
                    var $html = $('<div>').html(html);

                    var newFeatures = $html.find('.pdpAccordion--features .pdpAccordion__featuresContent').html();
                    var newTechSpecs = $html.find('.pdpAccordion--techspecs .pdpAccordion__techspecsContent').html();
                    var newDownloads = $html.find('.pdpAccordion--downloads .pdpAccordion__downloadsContent').html();

                    if (newFeatures) {
                        $scope.find('.pdpAccordion--features .pdpAccordion__featuresContent').html(newFeatures);
                    }

                    if (newTechSpecs) {
                        $scope.find('.pdpAccordion--techspecs .pdpAccordion__techspecsContent').html(newTechSpecs);
                    }

                    if (newDownloads) {
                        $scope.find('.pdpAccordion--downloads .pdpAccordion__downloadsContent').html(newDownloads);
                    }

                    updateAccordionVariantSwaps(getActiveVariant(), $root);
                })
                .always(function () {
                    setAccordionLoading(false, $root);
                    state.request = null;
                });
            }

            function updateAccordionVariantSwaps($variant, $root) {
                if (!$variant || !$variant.length) return;

                var $scope = getAccordionScope($root);
                var sku = $variant.attr('data-sku');
                var finishIndex = parseInt($pdp(selectors.finishButton).first().attr('data-option-index'), 10);
                var finish = '';

                if (!isNaN(finishIndex)) {
                    finish = $variant.attr('data-option-' + (finishIndex + 1));
                }

                if (sku) {
                    $scope.find('[data-swap-model]').text(sku);
                }

                if (finish) {
                    $scope.find('[data-swap-finish]').text(finish);
                }
            }

            function updateLearnMoreLink($variant) {
                var $link = $pdp('[data-plp-learn-more]');

                if (!$link.length) return;

                var pdpUrl = $variant && $variant.length ? $variant.attr('data-pdp-url') : '';

                if (pdpUrl) {
                    $link.attr('href', pdpUrl);
                }
            }
    
            function variantMatchesSelectionsWithOverride($variant, overrideIndex, overrideValue) {
                var customOptions = getSelectedCustomOptions();
                var shopifyOptions = getSelectedOptionValues();
                var matches = true;
    
                $.each(customOptions, function (optionIndex, selectedValue) {
                    var valueToCheck = optionIndex === overrideIndex ? overrideValue : selectedValue;
    
                    if (
                        valueToCheck &&
                        $variant.attr(customOptionMap[optionIndex]) !== valueToCheck
                    ) {
                        matches = false;
                        return false;
                    }
                });
    
                if (!matches) return false;
    
                for (var i = 0; i < shopifyOptions.length; i++) {
                    var selectedValue = i.toString() === overrideIndex ? overrideValue : shopifyOptions[i];
    
                    if (!selectedValue) continue;
    
                    if (
                        $variant.attr('data-option-' + (i + 1)) !== selectedValue &&
                        $variant.attr('data-option-1') !== selectedValue &&
                        $variant.attr('data-option-2') !== selectedValue &&
                        $variant.attr('data-option-3') !== selectedValue
                    ) {
                        return false;
                    }
                }
    
                return true;
            }
    
            function updateOptionButtonOosStates() {
                $pdp('.pdpMain__optionButton[data-option-index]').each(function () {
                    var $button = $(this);
                    var optionIndex = $button.attr('data-option-index');
                    var optionValue = $button.attr('data-option-value');
                    var hasAvailableVariant = false;

                    // Finishes are handled by updateFinishButtonsForActiveProduct
                    // (hide when missing, OOS cross-out only when the color exists).
                    if ($button.hasClass('pdpMain__optionButton--finish')) return;
    
                    if (!optionValue) return;
    
                    $pdp('.pdpMain__variantSelector option').each(function () {
                        var $variant = $(this);
    
                        if (!variantMatchesSelectionsWithOverride($variant, optionIndex, optionValue)) {
                            return;
                        }
    
                        if ($variant.attr('data-available') === 'true') {
                            hasAvailableVariant = true;
                            return false;
                        }
                    });
    
                    $button.toggleClass(classes.oos, !hasAvailableVariant);
                });
            }

            // Hide finishes that are not options on the active product combo.
            // Cross out only finishes that exist but are out of stock.
            // Returns true if the active finish had to be changed.
            function updateFinishButtonsForActiveProduct() {
                var $finishButtons = $pdp(selectors.finishButton);
                var finishIndex;
                var finishChanged = false;

                if (!$finishButtons.length) return false;

                finishIndex = $finishButtons.first().attr('data-option-index');

                $finishButtons.each(function () {
                    var $button = $(this);
                    var optionValue = $button.attr('data-option-value');
                    var hasMatchingVariant = false;
                    var hasAvailableVariant = false;

                    if (!optionValue) return;

                    $pdp('.pdpMain__variantSelector option').each(function () {
                        var $variant = $(this);

                        if (!variantMatchesSelectionsWithOverride($variant, finishIndex, optionValue)) {
                            return;
                        }

                        hasMatchingVariant = true;

                        if ($variant.attr('data-available') === 'true') {
                            hasAvailableVariant = true;
                            return false;
                        }
                    });

                    if (!hasMatchingVariant) {
                        if ($button.hasClass(classes.active)) {
                            finishChanged = true;
                        }
                        $button
                            .removeClass(classes.active)
                            .removeClass(classes.oos)
                            .hide();
                        return;
                    }

                    $button.show();
                    $button.toggleClass(classes.oos, !hasAvailableVariant);
                });

                if (!$pdp('.pdpMain__optionButton--finish.pdpMain__optionButton--active:visible').length) {
                    var $nextFinish = $pdp('.pdpMain__optionButton--finish:visible').first();

                    if ($nextFinish.length) {
                        $pdp('.pdpMain__optionButton--finish').removeClass(classes.active);
                        $nextFinish.addClass(classes.active);
                        updateSelectedOptionLabel($nextFinish);
                        finishChanged = true;
                    }
                }

                return finishChanged;
            }
    
            function updateProductTitle() {
                var $selector = getActiveVariantSelector();
    
                if (!$selector.length) return;
    
                var title = $selector.attr('data-title');
    
                if (!title) return;
    
                $pdp('.pdpMain__title').text(title);
                // Sticky bar lives outside .pdpMain, so query it globally
                $('.pdpMain__stickyTitle').text(title);
                $pdp('.pdpMain__breadCrumb--current').text(title);
    
                updateComparisonCurrentState();
            }
    
            function updateWorksWith($variant) {
                var ww;
                if (!$variant || !$variant.length) return;
                ww = $variant.attr('data-works-with-matches');
                if (ww) {
                    var workswithArray = ww.split(',');
    
                    $pdp('.pdpMain__worksWithIconWrapper').hide();
                    if (workswithArray.length){
                        for (i=0;i<workswithArray.length;i++){
                            var workString = workswithArray[i];
                            $pdp('.pdpMain__worksWithIconWrapper[data-label="'+workString+'"]').show();
                        }
                    }
                    
                }
            }
    
            function updatePdpUrl($variant) {
                var basePath;
                var params;
                var newUrl;
                var variantId;
    
                if (!$variant || !$variant.length) return;
                if (!window.history || !window.history.replaceState) return;
    
                variantId = $variant.val();
                if (!variantId) return;
    
                // Multi PDPs switch the product handle. Simple PDPs stay on this path.
                basePath = $variant.attr('data-pdp-url');
    
                if (basePath) {
                    basePath = basePath.split('?')[0].split('#')[0];
                } else {
                    basePath = window.location.pathname;
                }
    
                params = new URLSearchParams(window.location.search);
                params.set('variant', variantId);
    
                newUrl = basePath + '?' + params.toString() + window.location.hash;
    
                if (newUrl === window.location.pathname + window.location.search + window.location.hash) {
                    return;
                }
    
                window.history.replaceState({}, '', newUrl);
            }
    
            function normalizePath(url) {
                if (!url) return '';
    
                var path = url.toString().split('?')[0].split('#')[0];
    
                if (path.indexOf('http') === 0) {
                    var anchor = document.createElement('a');
                    anchor.href = path;
                    path = anchor.pathname;
                }
    
                if (path.length > 1 && path.charAt(path.length - 1) === '/') {
                    path = path.slice(0, -1);
                }
    
                return path;
            }
    
            function getProductHandle(url) {
                var path = normalizePath(url);
                var segments = path.split('/').filter(Boolean);
                var productsIndex = segments.indexOf('products');
    
                if (productsIndex !== -1 && segments[productsIndex + 1]) {
                    return segments[productsIndex + 1];
                }
    
                return segments[segments.length - 1] || '';
            }
    
            function urlsPointToSameProduct(a, b) {
                var handleA = getProductHandle(a);
                var handleB = getProductHandle(b);
    
                return handleA !== '' && handleA === handleB;
            }
    
            function findOptionByVariantId(variantId, $root) {
                if (!variantId) return $();
    
                var $match = $();
                var $scope = ($root && $root.length) ? $root : getPdpRoot();
    
                $scope.find('.pdpMain__variantSelector option').each(function () {
                    if ($(this).val() === String(variantId)) {
                        $match = $(this);
                        return false;
                    }
                });
    
                return $match;
            }
    
            function findSelectorByProductUrl(path, $root) {
                var $match = $();
                var $scope = ($root && $root.length) ? $root : getPdpRoot();
    
                $scope.find('.pdpMain__variantSelector').each(function () {
                    var $selector = $(this);
                    var selectorUrl =
                        $selector.attr('data-url') ||
                        $selector.find('option').first().attr('data-pdp-url');
    
                    if (urlsPointToSameProduct(selectorUrl, path)) {
                        $match = $selector;
                        return false;
                    }
                });
    
                return $match;
            }
    
            function getDefaultOptionForSelector($selector) {
                if (!$selector || !$selector.length) return $();
    
                var $option = $selector.find('option[data-available="true"]').first();
    
                if (!$option.length) {
                    $option = $selector.find('option').first();
                }
    
                return $option;
            }
    
            function activateOptionButton(optionIndex, value) {
                if (!value) return;
    
                var $button = $();
    
                $pdp('.pdpMain__optionButton[data-option-index="' + optionIndex + '"]').each(function () {
                    if ($(this).attr('data-option-value') === value) {
                        $button = $(this);
                        return false;
                    }
                });
    
                if (!$button.length) return;
    
                $pdp('.pdpMain__optionButton[data-option-index="' + optionIndex + '"]')
                    .removeClass(classes.active);
    
                $button.addClass(classes.active);
    
                if ($button.hasClass('pdpMain__optionButton--finish')) {
                    updateSelectedOptionLabel($button);
                }
            }
    
            function setOptionsFromVariant($option) {
                var i;
    
                if (!$option || !$option.length) return;
    
                $.each(customOptionMap, function (optionIndex, attrName) {
                    activateOptionButton(optionIndex, $option.attr(attrName));
                });
    
                // Finish and any other Shopify option buttons (simple PDPs).
                for (i = 0; i < 3; i++) {
                    activateOptionButton(String(i), $option.attr('data-option-' + (i + 1)));
                }
            }
    
            function initFromUrl(capturedVariantId, capturedPath) {
                if ($('.plpShop').length) return;
                if (!$('.pdpMain--multi').length) return;

                pdpActiveRoot = $('.pdpMain--multi').first();
                var $root = pdpActiveRoot;
    
                // Prefer values captured before any syncActiveVariant can rewrite history
                var variantId = capturedVariantId;
                var currentPath = capturedPath;
    
                if (!variantId && !currentPath) {
                    var params = new URLSearchParams(window.location.search);
                    variantId = params.get('variant');
                    currentPath = window.location.pathname;
                } else if (!variantId) {
                    var fallbackParams = new URLSearchParams(window.location.search);
                    variantId = fallbackParams.get('variant');
                }
    
                var $option = $();
                var $selector = $();
    
                // 1. ?variant= is the most specific signal (Shopify standard deep link)
                if (variantId) {
                    $option = findOptionByVariantId(variantId, $root);
    
                    if ($option.length) {
                        $selector = $option.closest('.pdpMain__variantSelector');
                    }
                }
    
                // 2. Fall back to matching the product handle in the URL path
                if (!$selector.length && currentPath) {
                    $selector = findSelectorByProductUrl(currentPath, $root);
                }
    
                if (!$selector.length) return;
    
                // 3. If no variant param matched, pick the first available variant for that product
                if (!$option.length) {
                    $option = getDefaultOptionForSelector($selector);
                }
    
                if (!$option.length) return;
    
                // 4. Drive the UI from that variant's data attributes
                setOptionsFromVariant($option);
                updateCustomOptionAvailability();
                // Re-apply in case availability toggle cleared a needed selection
                setOptionsFromVariant($option);
                updateFinishButtonsForActiveProduct();
    
                $root.find('.pdpMain__variantSelector').removeClass('pdpMain__variantSelector--active');
                $selector.addClass('pdpMain__variantSelector--active');
                $option.prop('selected', true);
                $selector.val($option.val());
            }
    
            function updateReviews() {
                var productId = getActiveVariantSelector().attr('data-product');
    
                if (!productId) return;
    
                clearTimeout(updateReviews._timer);
    
                var $root = getPdpRoot();
                updateReviews._timer = setTimeout(function () {
                    $root.find('[data-bv-show][data-bv-product-id]').each(function () {
                        setBvProduct($(this), productId, 0);
                    });
                }, 100);
            }
    
            function setBvProduct($el, productId, attempts) {
                if ($el.attr('data-bv-product-id') === productId) return;
    
                // Only mutate a container BV has already rendered once; otherwise the
                // change lands mid-init and BV's observer leaves it stuck/empty.
                if ($el.attr('data-bv-ready') !== 'true') {
                    if (attempts > 60) {
                        console.warn('[PDP reviews] never became ready:', $el.attr('data-bv-show'));
                        return;
                    }
                    setTimeout(function () {
                        setBvProduct($el, productId, attempts + 1);
                    }, 100);
                    return;
                }
    
                console.log('[PDP reviews] set', $el.attr('data-bv-show'), '->', productId);
                $el.attr('data-bv-product-id', productId);
            }
    
            function updateCompareTech(){
                var selectedTech = $pdp('[data-option-index="technology"].pdpMain__optionButton--active').attr('data-option-value');
                if (!selectedTech) return;

                var techTarget = null;
                if (selectedTech == 'Bluetooth') {
                    techTarget = 'bluetooth';
                } else if (selectedTech == 'Wi-Fi') {
                    techTarget = 'wifi';
                }

                if (!techTarget) return;

                setAllCompareTech(techTarget);
            }

            // Compare chart: only READ liquid data-*-price attrs and update displayed text.
            // Never write those attributes.
            function setDesktopCompareTech(position, techTarget) {
                var headPosition =
                    position === 'center' ? 'Center' :
                    position === 'right' ? 'Right' : 'Left';

                $('.pdpCompare__productHead--' + headPosition).find('.pdpCompare__toggle')
                    .removeClass('pdpCompare__toggle--wifi pdpCompare__toggle--bluetooth')
                    .addClass('pdpCompare__toggle--' + techTarget);

                $('.pdpCompare__desktopCell--' + position).each(function () {
                    var newText = $(this).find('.pdpCompare__desktopCellText').attr('data-' + techTarget);
                    $(this).find('.pdpCompare__desktopCellText').text(newText);
                });

                var $footPrice = $('.pdpCompare__productFoot--' + position + ' .pdpCompare__productPrice');
                var newPrice = $footPrice.attr('data-' + techTarget + '-price');
                if (newPrice) {
                    $footPrice.text(newPrice);
                }
            }

            function setMobileCompareTech($column, techTarget) {
                if (!$column || !$column.length) return;

                $column.find('.pdpCompare__toggle')
                    .removeClass('pdpCompare__toggle--wifi pdpCompare__toggle--bluetooth')
                    .addClass('pdpCompare__toggle--' + techTarget);

                $column.find('.pdpCompare__mobileCellInner').each(function () {
                    $(this).text($(this).attr('data-' + techTarget) || '');
                });

                var $dataOption = $('.pdpCompare__mobileData option').eq(
                    $column.find('.pdpCompare__mobileSelector').val()
                );
                var newPrice =
                    $dataOption.attr('data-' + techTarget + '-price') ||
                    $dataOption.attr('data-price') ||
                    '';
                if (newPrice) {
                    $column.find('.pdpCompare__mobilePrice').text(newPrice);
                }
            }

            function setAllCompareTech(techTarget) {
                ['left', 'center', 'right'].forEach(function (position) {
                    setDesktopCompareTech(position, techTarget);
                });

                $('.pdpCompare__mobileColumn').each(function () {
                    setMobileCompareTech($(this), techTarget);
                });

                setTimeout(function () {
                    if (typeof equalizeMobileCompareCellHeights === 'function') {
                        equalizeMobileCompareCellHeights();
                    }
                }, 0);
            }
    
    
            function updatePdpState($variant) {
                var $root = getPdpRoot();

                updateProductTitle();
                updatePrice($variant);
                maybeUpdateAccordion($variant);
                updateGallery($variant);
                updateNotifyMe($variant);
                updateSku($variant);
                updateBuyButtons($variant);
                updateFinishAvailability();
                updateKeyedAlikeMenu($variant);
                updateOptionButtonOosStates();
                updateWorksWith($variant);
                updateLearnMoreLink($variant);
                if (!isPlpShopRoot($root)) {

                    console.log('THIS IS NOT A PLP')
                    updatePdpUrl($variant);
                    updateReviews();
                }
            }
    
            function updatePrice($variant) {
                var hasActiveDiscount;
                var realPrice;
                var salePrice;
                var discountAmount;
                var discountType;
                var discountExtraText;
                var discountMessage = '';
                var discountHidePrice = "false";
    
                if (!$variant || !$variant.length) return;
    
                hasActiveDiscount = isDiscountActive($variant);
                realPrice = getUnformattedPrice($variant.attr('data-price'));
                discountAmount = $variant.attr('data-discount-amount');
                discountType = $variant.attr('data-discount-type');
                discountExtraText = $variant.attr('data-discount-extra-text') || '';
                discountHidePrice = $variant.attr('data-discount-hide-price');
    
                $pdp('.pdpMain__realPrice').text(getFormattedPrice(realPrice));
    
                if (!hasActiveDiscount) {
                    $pdp('.pdpMain__galleryDiscountPill').fadeOut();
                    $pdp('.pdpMain__oldPrice').hide();
                    $pdp('.pdpMain__salePrice').hide();
                    $pdp('.pdpMain__priceDiscountPill').hide();
                    $pdp('.pdpMain__realPrice').show();
                    return;
                }
    
                if (discountType === 'Percent Off') {
                    discountMessage = discountAmount + '% OFF';
                    salePrice = realPrice - realPrice * (parseInt(discountAmount, 10) / 100);
                } else if (discountType === 'Dollars Off') {
                    discountMessage = getFormattedPrice(discountAmount) + ' OFF';
                    salePrice = realPrice - getUnformattedPrice(discountAmount);
                } else {
                    discountMessage = 'NOW ' + getFormattedPrice(discountAmount);
                    salePrice = getUnformattedPrice(discountAmount);
                }
    
                if (discountExtraText) {
                    discountMessage += ' ' + discountExtraText;
                }
    
                $pdp('.pdpMain__galleryDiscountPillInner').text(discountMessage);
                $pdp('.pdpMain__galleryDiscountPill').fadeIn();
    
                if (discountHidePrice == "true"){
                    $pdp('.pdpMain__priceDiscountPillInner').text(discountMessage);
                    $pdp('.pdpMain__oldPrice').hide();
                    $pdp('.pdpMain__realPrice').text(getFormattedPrice(realPrice)).show();
                    $pdp('.pdpMain__salePrice').hide();
                    $pdp('.pdpMain__priceDiscountPill').show();
                }
                else{
                    $pdp('.pdpMain__priceDiscountPillInner').text(discountMessage);
                    $pdp('.pdpMain__oldPrice').text(getFormattedPrice(realPrice)).show();
                    $pdp('.pdpMain__realPrice').hide();
                    $pdp('.pdpMain__salePrice').text(getFormattedPrice(salePrice)).show();
                    $pdp('.pdpMain__priceDiscountPill').show();
                }
                
            }
    
            function updateGallery($variant) {
                var imageAttrs = [
                    'data-image-one',
                    'data-image-two',
                    'data-image-three',
                    'data-image-four',
                    'data-image-five',
                    'data-image-six'
                ];
    
                if (!$variant || !$variant.length) return;
    
                $.each(imageAttrs, function (index, attr) {
                    var imageSrc = $variant.attr(attr);
    
                    var $fullImage = $pdp('.pdpMain__fullImage[data-variant-image="' + index + '"]');
                    var $thumbImage = $pdp('.pdpMain__thumbnailImage[data-variant-image="' + index + '"]');
    
                    var $fullSlide = $fullImage.closest('.pdpMain__imageGallerySlide');
                    var $thumbSlide = $thumbImage.closest('.pdpMain__thumbnailGallerySlide');
    
                    if (imageSrc) {
                        preloadImage(imageSrc);
    
                        $fullImage.attr('src', imageSrc);
                        $thumbImage.attr('src', imageSrc);
    
                        $fullSlide.show();
                        $thumbSlide.show();
                    } else {
                        $fullImage.attr('src', '');
                        $thumbImage.attr('src', '');
    
                        $fullSlide.hide();
                        $thumbSlide.hide();
                    }
                });
    
                var $root = getPdpRoot();
                var gallerySwiper = $root.data('gallerySwiper');
                var thumnSwiper = $root.data('thumbSwiper');

                if (gallerySwiper && gallerySwiper.slideTo) {
                    gallerySwiper.slideTo(0);
                }

                if (thumnSwiper && thumnSwiper.update) {
                    thumnSwiper.update();
                }

                if (gallerySwiper && gallerySwiper.update) {
                    gallerySwiper.update();
                }
            }

            function updateNotifyMe($variant) {
                var isAvailable = $variant && $variant.length && $variant.attr('data-available') === 'true';
    
                $pdp('.pdpMain__notifyMeWrapper').toggle(!isAvailable);
            }
    
            function updateSku($variant) {
                var sku;
    
                if (!$variant || !$variant.length) return;
    
                sku = $variant.attr('data-sku');
    
                if (sku) {
                    $pdp('.pdpMain__prodNumber').text(sku);
                }
            }
    
            function updateBuyButtons($variant) {
                var isAvailable = $variant && $variant.length && $variant.attr('data-available') === 'true';
    
                console.log('[PDP] updateBuyButtons', {
                    isAvailable: isAvailable,
                    variant: pdpDebugVariant($variant)
                });
    
                $pdp('.pdpMain__atc')
                    .toggleClass(classes.atcOos, !isAvailable)
                    .prop('disabled', !isAvailable);
    
                // Sticky bar lives outside .pdpMain, so query it globally
                $('.pdpMain__stickyBuy')
                    .toggleClass(classes.stickyOos, !isAvailable)
                    .prop('disabled', !isAvailable);
    
                $pdp('.pdpMain__atcInner').text(
                    isAvailable ? 'Add to Cart' : 'Out of Stock'
                );
                $('.pdpMain__stickyBuyInner').text(
                    isAvailable ? 'Add to Cart' : 'Out of Stock'
                );
            }
    
            function updateFinishAvailability() {
                var $root = getPdpRoot();
                var $finishButtons = $root.find(selectors.finishButton);
                var finishIndex;
    
                if (!$finishButtons.length) return;

                // Multi PDPs: finishes come from the primary product's option list,
                // but not every multi product carries every color. Hide missing
                // colors; only cross out colors that exist and are OOS.
                if ($root.hasClass('pdpMain--multi')) {
                    updateFinishButtonsForActiveProduct();
                    return;
                }

                var $selector = $root.find(selectors.variantSelect);
                if (!$selector.length) return;
    
                finishIndex = parseInt($finishButtons.first().attr('data-option-index'), 10);
    
                $finishButtons.each(function () {
                    var $finishButton = $(this);
                    var testOptions = getSelectedOptionValues();
                    var hasMatchingVariant = false;
                    var hasAvailableVariant = false;
    
                    testOptions[finishIndex] = $finishButton.attr('data-option-value');
    
                    $selector.find('option').each(function () {
                        var $variant = $(this);
                        var variantMatches = true;
    
                        for (var i = 0; i < testOptions.length; i++) {
                            if (
                                testOptions[i] &&
                                $variant.attr('data-option-' + (i + 1)) !== testOptions[i]
                            ) {
                                variantMatches = false;
                                break;
                            }
                        }
    
                        if (!variantMatches) return;

                        hasMatchingVariant = true;

                        if ($variant.attr('data-available') === 'true') {
                            hasAvailableVariant = true;
                            return false;
                        }
                    });

                    if (!hasMatchingVariant) {
                        $finishButton
                            .removeClass(classes.active)
                            .removeClass(classes.oos)
                            .hide();
                        return;
                    }

                    $finishButton.show();
                    $finishButton.toggleClass(classes.oos, !hasAvailableVariant);
                });

                if (!$root.find('.pdpMain__optionButton--finish.pdpMain__optionButton--active:visible').length) {
                    var $nextFinish = $root.find('.pdpMain__optionButton--finish:visible').first();
                    if ($nextFinish.length) {
                        $root.find('.pdpMain__optionButton--finish').removeClass(classes.active);
                        $nextFinish.addClass(classes.active);
                        updateSelectedOptionLabel($nextFinish);
                    }
                }
            }
    
            function updateSelectedOptionLabel($button) {
                $button
                    .closest('.pdpMain__optionFlex')
                    .find('.pdpMain__optionSelectedFinishName')
                    .text($button.attr('data-option-value'));
            }
    
            function copyCurrentUrl() {
                navigator.clipboard.writeText(window.location.href)
                    .then(function () {
                        console.log('URL copied!');
                    })
                    .catch(function (err) {
                        console.error('Failed to copy URL:', err);
                    });
            }
    
            function notifyMe(email, variantID) {
                var publicApiKey = 'VdEWmd';
                var compositeVariantId = '$shopify:::$default:::' + variantID;
    
                var payload = {
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: email
                                    }
                                }
                            },
                            channels: ['EMAIL']
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: compositeVariantId
                                }
                            }
                        }
                    }
                };
    
                return fetch(
                    'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + publicApiKey,
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/vnd.api+json',
                            Accept: 'application/vnd.api+json',
                            revision: '2024-06-15'
                        },
                        body: JSON.stringify(payload)
                    }
                )
                    .then(function (res) {
                        if (res.status === 202) {
                            $('.notifyMe__success').show();
                            $('.notifyMe__error').hide();
                            $pdp('.pdpMain__notifyFormSubmit').hide();
                            return;
                        }
    
                        return res.json().then(function (err) {
                            return Promise.reject(err);
                        });
                    })
                    .catch(function (err) {
                        console.error(err);
    
                        $('.notifyMe__error')
                            .text('There was a problem signing you up – please try again.')
                            .show();
                    });
            }
    
            function showHideMiniCartKeyedAlike() {
                var count = 0;
                var alreadyGroups = false;
    
                for (var i = 0; i < CartJS.cart.items.length; i++) {
                    if (CartJS.cart.items[i].properties['_keyed_alike_available'] === 'true') {
                        count += CartJS.cart.items[i].quantity * 1;
                    }
    
                    if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
                        alreadyGroups = true;
                    }
                }
    
                if (count > 1 && alreadyGroups === false) {
                    $('.miniCartKA').show();
                } else {
                    $('.miniCartKA').hide();
                }
            }
    
            function updateCart(openCart) {
                app._getCartData();
                app._vibrateDevice();
                app.$snotify.clear();
                showHideMiniCartKeyedAlike();
    
                setTimeout(function () {
                    if (app.storeUtilities.cartUpsells.settings.showOnPopUp) {
                        var origin = app.cart.items.find(function (data) {
                            return data.variant_id === keys;
                        });
    
                        app._openModalCartUpsell(origin);
                        return;
                    }
    
                    if (openCart === true) {
                        app._openCartDrawer();
                    } else {
                        app._touchCartDrawer();
                    }
                }, 300);
            }
    
            function addToCart(variant, qty, keyed) {
                var $variant = findVariantByOptions();
                var productType;
                var groupNumber = 1;
                var variantKeyedAlike;
                var properties;

                if (!$variant.length) {
                    $variant = getActiveVariant();
                }

                productType = $variant.attr('data-product-type');
                variantKeyedAlike = $variant.attr('data-keyed-alike') === 'true';
    
                if (checkDiscountLimitFull(variant)) {
                    alert(
                        'You can only order up to ' +
                            $('body').attr('data-qty-limit') * 1 +
                            ' discounted items.'
                    );
                    return;
                }
    
                // Only create a keyed-alike group when the user opted in AND
                // this variant's metafield allows keyed alike.
                if (keyed && variantKeyedAlike) {
                    CartJS.addItems(
                        [
                            {
                                id: variant,
                                quantity: qty,
                                properties: {
                                    _name: 'keyed_alike_group',
                                    _value: groupNumber,
                                    _keyed_alike_group: groupNumber,
                                    _keyed_alike_available: 'true',
                                    _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                                }
                            },
                            {
                                id: 32146864832644,
                                quantity: qty,
                                properties: {
                                    _groups: groupNumber,
                                    _type: productType,
                                    _page_added: window.location.href,
                                }
                            }
                        ],
                        {
                            success: function () {
                                updateCart(true);
                                $('.pdpKAPop').fadeOut();
                            },
                            error: function (jqXHR, textStatus, errorThrown) {
                                console.log('Error: ' + errorThrown + '!');
                            }
                        }
                    );
    
                    return;
                }

                properties = {
                    _requested_ship_date: getNearestWeekdayTwoDaysAhead()
                };

                // Mark eligibility only when the variant metafield says so.
                // Do not stamp this on every PDP add-to-cart.
                if (variantKeyedAlike) {
                    properties._keyed_alike_available = 'true';
                }
    
                CartJS.addItem(
                    variant,
                    qty,
                    properties,
                    {
                        success: function () {
                            updateCart(true);
                        },
                        error: function (jqXHR, textStatus, errorThrown) {
                            console.log('Error: ' + errorThrown + '!');
                        }
                    }
                );
            }
    
            function addActivePdpVariantToCart() {
                // Resolve from current option buttons — never trust a stale
                // <select> selection that could be a default/in-stock fallback.
                var $activeVariant = findVariantByOptions();
                var qty = parseInt(getPdpRoot().find(selectors.mainQty).val(), 10);
                var keyed =
                    getPdpRoot().find(selectors.keyedCheckbox).is(':checked') &&
                    $activeVariant.attr('data-keyed-alike') === 'true';
    
                if (!$activeVariant.length || $activeVariant.attr('data-available') !== 'true') {
                    return;
                }
    
                if (isNaN(qty) || qty < 1) {
                    qty = 1;
                }
    
                addToCart($activeVariant.val(), qty, keyed);
            }
    
            function bindEvents() {
                $(document).on('click', selectors.optionButton, function () {
                    pdpActiveRoot = $(this).closest('.pdpMain');
                    handleOptionClick($(this));
                });
    
                $(document).on('click', '[data-copy-url]', function (e) {
                    e.preventDefault();
                    copyCurrentUrl();
                });
    
                $(document).on('click', selectors.addToCart, function (e) {
                    var $button = $(this);
                    // Sticky ATC lives outside .pdpMain — fall back to the main PDP root
                    pdpActiveRoot = resolvePdpRootFromEl($button);

                    e.preventDefault();
    
                    if (
                        $button.prop('disabled') ||
                        $button.hasClass(classes.atcOos) ||
                        $button.hasClass(classes.stickyOos)
                    ) {
                        return;
                    }
    
                    addActivePdpVariantToCart();
                });
    
                $(document).on('click', '.pdpMain__notifyFormSubmit', function (e) {
                    pdpActiveRoot = $(this).closest('.pdpMain');
                    var email = $pdp('.pdpMain__notifyFormInput').val();
                    var $activeVariant = findVariantByOptions();
                    var productID = getActiveVariantSelector().attr('data-product');
    
                    e.preventDefault();
    
                    if (!email || !$activeVariant.length) return;
    
                    notifyMe(email, $activeVariant.val(), productID);
                });
            }

            function runWhenCartReady(callback) {
                var attempts = 0;
                var maxAttempts = 40;
    
                function check() {
                    attempts++;
    
                    if (
                        typeof CartJS !== 'undefined' &&
                        CartJS.cart &&
                        CartJS.cart.items
                    ) {
                        callback();
                        return;
                    }
    
                    if (attempts < maxAttempts) {
                        setTimeout(check, 100);
                    }
                }
    
                check();
            }
    
            function initPdp() {
                if (!$('.pdpMain__variantSelector').length) return;

                bindEvents();

                // Capture URL before any syncActiveVariant can rewrite history via updatePdpUrl
                var isMultiPdp = $('.pdpMain--multi').length && !$('.plpShop').length;
                var urlVariantId = new URLSearchParams(window.location.search).get('variant');
                var urlPath = window.location.pathname;

                $('.pdpMain').each(function () {
                    var $urlVariant;

                    pdpActiveRoot = $(this);
                    initGallery(pdpActiveRoot);
                    initFinishButtons(pdpActiveRoot);
                    initPdpTooltipIcons(pdpActiveRoot);

                    if (pdpActiveRoot.hasClass('pdpMain--multi')) {
                        updateCustomOptionAvailability();
                    }

                    // Simple PDPs: preselect from ?variant= before the first sync
                    // writes the default variant into the URL. Multi PDPs do this
                    // in initFromUrl so a product-handle swap is not overwritten.
                    if (
                        urlVariantId &&
                        !pdpActiveRoot.hasClass('pdpMain--multi') &&
                        !isPlpShopRoot(pdpActiveRoot)
                    ) {
                        $urlVariant = findOptionByVariantId(urlVariantId, pdpActiveRoot);

                        if ($urlVariant.length) {
                            setOptionsFromVariant($urlVariant);
                        }
                    }

                    // Defer first sync on multi PDP until after URL options are applied,
                    // otherwise updatePdpUrl overwrites the landing product handle.
                    if (!(isMultiPdp && pdpActiveRoot.hasClass('pdpMain--multi') && !isPlpShopRoot(pdpActiveRoot))) {
                        syncActiveVariant();
                        updateAllOptionRowTooltips();
                    }

                    if (isPlpShopRoot(pdpActiveRoot)) {
                        initPlpShopAccordionState(pdpActiveRoot);
                        updatePlpShopAccordion();
                    }

                    runWhenCartReady(function () {
                        updateKeyedAlikeMenu(getActiveVariant());
                    });
                });

                pdpActiveRoot = $('.pdpMain').first();

                if (isMultiPdp) {
                    initFromUrl(urlVariantId, urlPath);
                    pdpActiveRoot = $('.pdpMain--multi').first();
                    syncActiveVariant();
                    updateAllOptionRowTooltips();
                }
            }

            initPdp();
    
            $('.pdpAccordion__header').on('click', function(){
                var parent = $(this).parent();
                parent.toggleClass('pdpAccordion--active');
                parent.find('.pdpAccordion__shelf').slideToggle();
            });

            $(document).on('click', '.plpInteractive__tabButton', function () {
                var $section = $(this).closest('[data-plp-interactive]');
                var dataIndex = $(this).attr('data-index');

                if ($(this).closest('.plpInteractive__tab').hasClass('plpInteractive__tab--active')) {
                    return;
                }

                $section.find('.plpInteractive__tab').removeClass('plpInteractive__tab--active');
                $(this).closest('.plpInteractive__tab').addClass('plpInteractive__tab--active');

                $section.find('.plpInteractive__image').removeClass('plpInteractive__image--active');
                $section
                    .find('.plpInteractive__image[data-index="' + dataIndex + '"]')
                    .addClass('plpInteractive__image--active');

                $section.find('.plpInteractive__mobileImage').removeClass('plpInteractive__mobileImage--active');
                $section
                    .find('.plpInteractive__mobileImage[data-index="' + dataIndex + '"]')
                    .addClass('plpInteractive__mobileImage--active');
            });

            function initPlpLifestyleSections() {
                $('[data-plp-lifestyle]').each(function () {
                    var $section = $(this);
                    var $swiperEl = $section.find('.plpLifestyle__swiper');

                    if (!$swiperEl.length || typeof Swiper === 'undefined' || $section.data('lifestyleSwiper')) {
                        return;
                    }

                    var swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1.12,
                        spaceBetween: 16,
                        watchOverflow: true,
                        navigation: {
                            nextEl: $section.find('.plpLifestyle__navButton--next')[0],
                            prevEl: $section.find('.plpLifestyle__navButton--prev')[0]
                        },
                        on: {
                            init: function (instance) {
                                updatePlpLifestyleProgress($section, instance);
                            },
                            progress: function (instance, progress) {
                                updatePlpLifestyleProgress($section, instance, progress);
                            },
                            resize: function (instance) {
                                updatePlpLifestyleProgress($section, instance);
                            }
                        }
                    });

                    $section.data('lifestyleSwiper', swiper);
                });
            }

            function updatePlpLifestyleProgress($section, swiper, progress) {
                var fillWidth = 0;

                if (typeof progress === 'number') {
                    fillWidth = Math.max(0, Math.min(100, progress * 100));
                } else if (swiper && swiper.progress !== undefined) {
                    fillWidth = Math.max(0, Math.min(100, swiper.progress * 100));
                }

                $section.find('.plpLifestyle__progressFill').css('width', fillWidth + '%');
            }

            initPlpLifestyleSections();

            function initPlpFeaturesSections() {
                $('[data-plp-features]').each(function () {
                    var $section = $(this);
                    var $swiperEl = $section.find('.plpFeatures__swiper');

                    if (!$swiperEl.length || typeof Swiper === 'undefined' || $section.data('featuresSwiper')) {
                        return;
                    }

                    var swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1,
                        navigation: {
                            nextEl: $section.find('.plpFeatures__navButton--next')[0],
                            prevEl: $section.find('.plpFeatures__navButton--prev')[0]
                        },
                        on: {
                            init: function (instance) {
                                updatePlpFeaturesProgress($section, instance);
                            },
                            progress: function (instance, progress) {
                                updatePlpFeaturesProgress($section, instance, progress);
                            },
                            resize: function (instance) {
                                updatePlpFeaturesProgress($section, instance);
                            }
                        }
                    });

                    $section.data('featuresSwiper', swiper);
                });
            }

            function updatePlpFeaturesProgress($section, swiper, progress) {
                var fillWidth = 0;

                if (typeof progress === 'number') {
                    fillWidth = Math.max(0, Math.min(100, progress * 100));
                } else if (swiper && swiper.progress !== undefined) {
                    fillWidth = Math.max(0, Math.min(100, swiper.progress * 100));
                }

                $section.find('.plpFeatures__progressFill').css('width', fillWidth + '%');
            }

            initPlpFeaturesSections();

            function initPlpAppGridSections() {
                $('[data-plp-app-grid]').each(function () {
                    var $section = $(this);
                    var $swiperEl = $section.find('.plpAppGrid__swiper');

                    if (!$swiperEl.length || typeof Swiper === 'undefined' || $section.data('appGridSwiper')) {
                        return;
                    }

                    var swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                        watchOverflow: true,
                        navigation: {
                            nextEl: $section.find('.plpAppGrid__navButton--next')[0],
                            prevEl: $section.find('.plpAppGrid__navButton--prev')[0]
                        },
                        on: {
                            init: function (instance) {
                                updatePlpAppGridProgress($section, instance);
                            },
                            progress: function (instance, progress) {
                                updatePlpAppGridProgress($section, instance, progress);
                            },
                            resize: function (instance) {
                                updatePlpAppGridProgress($section, instance);
                            }
                        }
                    });

                    $section.data('appGridSwiper', swiper);
                });
            }

            function updatePlpAppGridProgress($section, swiper, progress) {
                var fillWidth = 0;

                if (typeof progress === 'number') {
                    fillWidth = Math.max(0, Math.min(100, progress * 100));
                } else if (swiper && swiper.progress !== undefined) {
                    fillWidth = Math.max(0, Math.min(100, swiper.progress * 100));
                }

                $section.find('.plpAppGrid__progressFill').css('width', fillWidth + '%');
            }

            initPlpAppGridSections();
    
            function updateQtyInputs(newQty, $root) {
                newQty = parseInt(newQty, 10);

                if (isNaN(newQty) || newQty < 1) {
                    newQty = 1;
                }

                var $scope = getPdpRoot($root);
                $scope.find('.pdpMain__qty').val(newQty);

                // Sticky qty lives outside .pdpMain on true PDPs
                if (!$scope.hasClass('pdpMain--plp')) {
                    $('.pdpMain__qty--sticky').val(newQty);
                }
            }

            $(document).on('click', '.pdpMain__qtyPlus', function () {
                pdpActiveRoot = resolvePdpRootFromEl($(this));
                var currentQty = parseInt(getPdpRoot().find(selectors.mainQty).val(), 10);

                if (isNaN(currentQty)) {
                    currentQty = 1;
                }

                updateQtyInputs(currentQty + 1, pdpActiveRoot);
            });

            $(document).on('click', '.pdpMain__qtyMinus', function () {
                pdpActiveRoot = resolvePdpRootFromEl($(this));
                var currentQty = parseInt(getPdpRoot().find(selectors.mainQty).val(), 10);

                if (isNaN(currentQty)) {
                    currentQty = 1;
                }

                updateQtyInputs(Math.max(1, currentQty - 1), pdpActiveRoot);
            });

            $(document).on('input change', '.pdpMain__qty', function () {
                pdpActiveRoot = resolvePdpRootFromEl($(this));
                updateQtyInputs($(this).val(), pdpActiveRoot);
            });
    
            $(document).on('click input change', '.pdpMain__qtyPlus, .pdpMain__qtyMinus, .pdpMain__qty', function () {
                setTimeout(function () {
                    updateKeyedAlikeMenu(getActiveVariant());
                }, 0);
            });
    
            function normalizeKeyedType(type) {
                if (type === 'Smart Lock') return 'smart-lock';
                return 'standard-lock';
            }
    
            function cartHasMatchingKeyedItems(productType) {
                var targetType = normalizeKeyedType(productType);
                var count = 0;
    
                if (!CartJS || !CartJS.cart || !CartJS.cart.items) return 0;
    
                for (var i = 0; i < CartJS.cart.items.length; i++) {
                    var item = CartJS.cart.items[i];
    
                    if (
                        item.properties &&
                        item.properties._keyed_alike_available === 'true' &&
                        normalizeKeyedType(item.product_type) === targetType
                    ) {
                        count += item.quantity * 1;
                    }
                }
    
                return count;
            }
    
            function updateKeyedAlikeMenu($variant) {
                var $ka = $pdp('.pdpMain__pdpKA');
    
                if (!$variant || !$variant.length) {
                    $ka.hide();
                    return;
                }
    
                var variantQualifies = $variant.attr('data-keyed-alike') === 'true';
                var productType = $variant.attr('data-product-type');
                var selectedQty = parseInt(getPdpRoot().find(selectors.mainQty).val(), 10);
    
                if (isNaN(selectedQty) || selectedQty < 1) {
                    selectedQty = 1;
                }
    
                if (!variantQualifies) {
                    $ka.hide();
                    $pdp('.pdpMain__pdpKACheckbox').prop('checked', false);
                    return;
                }
    
                var matchingCartQty = cartHasMatchingKeyedItems(productType);
                var totalMatchingQtyAfterAdd = matchingCartQty + selectedQty;
    
                if (totalMatchingQtyAfterAdd >= 2) {
                    $ka.show().attr('data-type', productType);
                } else {
                    $ka.hide();
                    $pdp('.pdpMain__pdpKACheckbox').prop('checked', false);
                }
            }
    
            $(document).on('click', '.pdpVideo__playButton', function () {
                var $button = $(this);
    
                var videoType = $button.attr('data-video-type');
                var hostedVideo = $button.attr('data-hosted-video');
                var externalVideo = $button.attr('data-external-video');
    
                var videoHtml = '';
    
                if (videoType === 'hosted' && hostedVideo) {
                    videoHtml =
                        '<video class="pdpVideoModal__video" controls autoplay playsinline>' +
                            '<source src="' + hostedVideo + '" type="video/mp4">' +
                        '</video>';
                }
    
                if (videoType === 'external' && externalVideo) {
                    var embedUrl = externalVideo;
    
                    // YouTube
                    if (externalVideo.indexOf('youtube.com/watch') > -1) {
                        embedUrl = externalVideo.replace('watch?v=', 'embed/');
                    }
    
                    if (externalVideo.indexOf('youtu.be/') > -1) {
                        embedUrl = externalVideo.replace(
                            'youtu.be/',
                            'www.youtube.com/embed/'
                        );
                    }
    
                    // Vimeo
                    if (externalVideo.indexOf('vimeo.com/') > -1) {
                        var vimeoMatch = externalVideo.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-zA-Z0-9]+))?/);
    
                        if (vimeoMatch) {
                            embedUrl = 'https://player.vimeo.com/video/' + vimeoMatch[1];
    
                            if (vimeoMatch[2]) {
                                embedUrl += '?h=' + vimeoMatch[2];
                            }
                        }
                    }
    
                    var joinCharacter = embedUrl.indexOf('?') > -1 ? '&' : '?';
    
                    videoHtml =
                        '<iframe ' +
                            'class="pdpVideoModal__iframe" ' +
                            'src="' + embedUrl + joinCharacter + 'autoplay=1" ' +
                            'frameborder="0" ' +
                            'allow="autoplay; fullscreen; picture-in-picture" ' +
                            'allowfullscreen>' +
                        '</iframe>';
                }
    
                $('.pdpVideoModal__bucket').html(videoHtml);
    
                $('.pdpVideoModal').fadeIn();
            });
    
            function closePdpVideoModal() {
                $('.pdpVideoModal').fadeOut(function () {
                    $('.pdpVideoModal__bucket').empty();
                });
            }
    
            $(document).on(
                'click',
                '.pdpVideoModal__close, .pdpVideoModal__background',
                function () {
                    closePdpVideoModal();
                }
            );
    
            $('.pdpCompare__toggleButton').on('click', function(){
                var techTarget = 'wifi'
                if ($(this).hasClass('pdpCompare__toggleButton--bluetooth')){
                    techTarget = "bluetooth"
                }
                var head = $(this).closest('.pdpCompare__productHead');
                if (!head.length) return; // mobile toggles are handled separately
                var position = "left";
                if (head.hasClass('pdpCompare__productHead--Center')){
                    position = "center";
                }
                else if (head.hasClass('pdpCompare__productHead--Right')){
                    position = "right";
                }

                setDesktopCompareTech(position, techTarget);
            });
    
            function mobilePDPInit(){
                $('.pdpMain').each(function () {
                    var $root = $(this);
                    var upperHTML = $root.find('.pdpMain__textUpperGroup').html();
                    $root.find('.pdpMain__mobileContentCopyBucket').html(upperHTML || '');

                    var lowerHTML = '';
                    var $worksWithTitle = $root.find('.pdpMain__worksWithTitle');
                    var $worksWithWrapper = $root.find('.pdpMain__worksWithWrapper');
                    var $formSocialRow = $root.find('.pdpMain__formSocialRow');
                    var $prodNumberRow = $root.find('.pdpMain__prodNumberRow');

                    if ($worksWithTitle.length) {
                        lowerHTML += $worksWithTitle[0].outerHTML;
                    }
                    if ($worksWithWrapper.length) {
                        lowerHTML += $worksWithWrapper[0].outerHTML;
                    }
                    if ($formSocialRow.length) {
                        lowerHTML += $formSocialRow[0].outerHTML;
                    }
                    if ($prodNumberRow.length) {
                        lowerHTML += $prodNumberRow[0].outerHTML;
                    }

                    $root.find('.pdpMain__mobileWorksWithCopyBucket').html(lowerHTML);
                });
            }
            if ($('.pdpMain__textUpperGroup').length > 0){
                mobilePDPInit();
            }
            
    
            function getMobileCompareData() {
                var items = [];
    
                $('.pdpCompare__mobileData option').each(function (i) {
                    var $option = $(this);
    
                    items.push({
                        index: i,
                        id: $option.val(),
                        title: $option.attr('data-title'),
                        image: $option.attr('data-image'),
                        icon: $option.attr('data-icon'),
                        price: $option.attr('data-price'),
                        link: $option.attr('data-link'),
                        current: $option.attr('data-current') === 'true',
                        $option: $option
                    });
                });
    
                return items;
            }
    
            function populateMobileCompareSelectors() {
                var items = getMobileCompareData();
    
                $('.pdpCompare__mobileSelector').each(function (columnIndex) {
                    var $select = $(this);
    
                    $select.empty();
    
                    $.each(items, function (i, item) {
                        $select.append(
                            '<option value="' + i + '">' + item.title + '</option>'
                        );
                    });
    
                    $select.val(columnIndex);
                });
            }
    
            function equalizeMobileCompareCellHeights() {
                var indexes = [];
    
                $('.pdpCompare__mobileCell[data-index]').each(function () {
                    var index = $(this).attr('data-index');
    
                    if (indexes.indexOf(index) === -1) {
                        indexes.push(index);
                    }
                });
    
                $.each(indexes, function (i, index) {
                    var $cells = $('.pdpCompare__mobileCell[data-index="' + index + '"]');
    
                    $cells.css('height', 'auto');
    
                    var tallest = 0;
    
                    $cells.each(function () {
                        var height = $(this).outerHeight();
    
                        if (height > tallest) {
                            tallest = height;
                        }
                    });
    
                    $cells.css('height', tallest + 'px');
                });
            }
        
            function getMobileCompareTech($column) {
                if ($column.find('.pdpCompare__toggle').hasClass('pdpCompare__toggle--bluetooth')) {
                    return 'bluetooth';
                }
                return 'wifi';
            }
    
            function updateMobileCompareColumn($select) {
                var selectedIndex = $select.val();
                var $dataOption = $('.pdpCompare__mobileData option').eq(selectedIndex);
                var $column = $select.closest('.pdpCompare__mobileColumn');
    
                if (!$dataOption.length || !$column.length) return;
    
                $column.find('.pdpCompare__icons')
                    .attr('src', $dataOption.attr('data-icon') || '')
                    .attr('alt', $dataOption.attr('data-title') || '');

                var tech = getMobileCompareTech($column);
                var price =
                    $dataOption.attr('data-' + tech + '-price') ||
                    $dataOption.attr('data-price') ||
                    '';
                $column.find('.pdpCompare__mobilePrice').text(price);

                $column.find('.pdpComapre__mobileLink')
                    .attr('href', $dataOption.attr('data-link') || '');

                // The hidden data option's text is its position ("Left"/"Center"/"Right"),
                // which lets us pull both wifi and bluetooth text from the desktop cells.
                var positionMap = { Left: 'left', Center: 'center', Right: 'right' };
                var position = positionMap[$.trim($dataOption.text())] || 'left';

                $column.find('.pdpCompare__mobileCell').each(function () {
                    var index = $(this).attr('data-index');
                    var $inner = $(this).find('.pdpCompare__mobileCellInner');
                    var $desktopText = $('.pdpCompare__desktopRow')
                        .eq(index)
                        .find('.pdpCompare__desktopCell--' + position + ' .pdpCompare__desktopCellText');

                    var wifiText = $desktopText.attr('data-wifi') || $dataOption.attr('data-' + index) || '';
                    var bluetoothText = $desktopText.attr('data-bluetooth') || wifiText;

                    $inner
                        .attr('data-wifi', wifiText)
                        .attr('data-bluetooth', bluetoothText)
                        .text(tech === 'bluetooth' ? bluetoothText : wifiText);
                });
    
                updateComparisonCurrentState();
    
                setTimeout(function () {
                    equalizeMobileCompareCellHeights();
                }, 0);
            }

            $(document).on('click', '.pdpCompare__mobileColumn .pdpCompare__toggleButton', function () {
                var $column = $(this).closest('.pdpCompare__mobileColumn');
                var tech = $(this).hasClass('pdpCompare__toggleButton--bluetooth') ? 'bluetooth' : 'wifi';

                setMobileCompareTech($column, tech);

                setTimeout(function () {
                    equalizeMobileCompareCellHeights();
                }, 0);
            });
    
            $(window).on('resize', function () {
                equalizeMobileCompareCellHeights();
            });
    
            function updateMobileCompareCurrentState() {
                var currentModel = getSelectedModel();
    
                var currentMap = {
                    Standard: 0,
                    Touch: 1,
                    Plus: 2
                };
    
                var currentIndex = currentMap[currentModel];
    
                $('.pdpCompare__mobileColumn').removeClass('pdpCompare__mobileColumn--current');
    
                if (typeof currentIndex === 'undefined') return;
    
                $('.pdpCompare__mobileSelector').each(function () {
                    var $select = $(this);
                    var selectedIndex = parseInt($select.val(), 10);
    
                    if (selectedIndex === currentIndex) {
                        $select
                            .closest('.pdpCompare__mobileColumn')
                            .addClass('pdpCompare__mobileColumn--current');
                    }
                });
            }
    
            function initMobileCompare() {
                if (!$('.pdpCompare__mobile').length) return;

                populateMobileCompareSelectors();
    
                $('.pdpCompare__mobileSelector').each(function () {
                    updateMobileCompareColumn($(this));
                });
    
                updateComparisonCurrentState();
            }
    
            $(document).on('change', '.pdpCompare__mobileSelector', function () {
                updateMobileCompareColumn($(this));
            });
    
            initMobileCompare();
    
            function getCurrentCompareIndex() {
                var activeTitle = getActiveVariantSelector().attr('data-title') || '';
                var currentModel = getSelectedModel();
    
                var titleWords = activeTitle.split(/\s+/);
    
                if (titleWords.includes('Plus') || currentModel === 'Plus') {
                    return 2;
                }
    
                if (titleWords.includes('Touch') || currentModel === 'Touch') {
                    return 1;
                }
    
                return 0;
            }
    
            function updateComparisonCurrentState() {
                var currentIndex = getCurrentCompareIndex();
                var positions = ['left', 'center', 'right'];
                var headPositions = ['Left', 'Center', 'Right'];
                var currentPosition = positions[currentIndex];
                var currentHeadPosition = headPositions[currentIndex];
    
                // Mobile
                $('.pdpCompare__mobileColumn').removeClass('pdpCompare__mobileColumn--current');
    
                $('.pdpCompare__mobileSelector').each(function () {
                    if (parseInt($(this).val(), 10) === currentIndex) {
                        $(this)
                            .closest('.pdpCompare__mobileColumn')
                            .addClass('pdpCompare__mobileColumn--current');
                    }
                });
    
                // Desktop heads
                $('.pdpCompare__productHead').removeClass('pdpCompare__productHead--current');
                $('.pdpCompare__productHead--' + currentHeadPosition)
                    .addClass('pdpCompare__productHead--current');
    
                // Desktop cells
                $('.pdpCompare__desktopCell').removeClass('pdpCompare__desktopCell--current');
                $('.pdpCompare__desktopCell--' + currentPosition)
                    .addClass('pdpCompare__desktopCell--current');
            }
    
            updateComparisonCurrentState();
    
            function updateStickyPdpVisibility() {
                var $atc = $('.pdpMain__atcInner').first();
                var $sticky = $('.pdpMain__sticky');
    
                if (!$atc.length || !$sticky.length) return;
    
                if ($(window).width() > 999) {
                    $sticky.removeClass('pdpMain__sticky--visible');
                    return;
                }
    
                var buttonBottom =
                    $atc.offset().top +
                    $atc.outerHeight();
    
                var scrollTop = $(window).scrollTop();
    
                if (scrollTop < buttonBottom) {
                    $sticky.removeClass('pdpMain__sticky--visible');
                } else {
                    $sticky.addClass('pdpMain__sticky--visible');
                }
            }
    
            $(window).on('scroll resize', function () {
                updateStickyPdpVisibility();
            });
    
            updateStickyPdpVisibility();
    
            if (!$('.pdpMain--multi').length) {
                $('.pdpMain__optionFlex').each(function () {
                    var optionCount = $(this).find('.pdpMain__optionButton').length;
    
                    if (optionCount === 1) {
                        $(this)
                            .find('.pdpMain__optionButton')
                            .addClass('pdpMain__optionButton--only');
                    }
                });
            }
    
            if ($('.pdpAccordion__downloadButton').length < 1 && $('.pdpAccordion__downloadsWrapper .video-wrapper-1').length < 1){
                $('.pdpAccordion--downloads').hide();
            }

            if ($('.pdpAccordion__featuresContent').length > 0){
                
                if ($('.pdpAccordion__featuresContent').text().length < 1){
                    $('.pdpAccordion--features').hide();
                }
            }

            $('.mfhRes__accordionButton').on('click', function(){
			var parent = $(this).parent();
			if (parent.hasClass('mfhRes__item--open')){
				parent.removeClass('mfhRes__item--open');
				parent.find('.mfhRes__accordionShelf').slideUp();
			}
			else{
				parent.addClass('mfhRes__item--open');
				parent.find('.mfhRes__accordionShelf').slideDown();
			}
		});
    
        });
        $(window).on('load', function () {
            function preloadVariantImagesAsync() {
                var imageAttrs = [
                    'data-image-one',
                    'data-image-two',
                    'data-image-three',
                    'data-image-four',
                    'data-image-five',
                    'data-image-six'
                ];
    
                var imageQueue = [];
                var seen = {};
                var activeLoads = 0;
                var maxConcurrentLoads = 3;
    
                $('.pdpMain__variantSelector option').each(function () {
                    var $variant = $(this);
    
                    $.each(imageAttrs, function (i, attr) {
                        var imageSrc = $variant.attr(attr);
    
                        if (!imageSrc || seen[imageSrc]) return;
    
                        seen[imageSrc] = true;
                        imageQueue.push(imageSrc);
                    });
                });
    
                function loadNext() {
                    if (!imageQueue.length || activeLoads >= maxConcurrentLoads) return;
    
                    activeLoads++;
    
                    var img = new Image();
    
                    img.onload = img.onerror = function () {
                        activeLoads--;
                        loadNext();
                    };
    
                    img.src = imageQueue.shift();
    
                    loadNext();
                }
    
                loadNext();
            }
    
            setTimeout(preloadVariantImagesAsync, 250);
        });
    })(jQuery, this);
    
    
    